import { CommonModule, DOCUMENT } from '@angular/common';
import { Directive, Input, Component, ViewEncapsulation, NgModule, EventEmitter, Output, ContentChildren, HostBinding, Renderer2, ChangeDetectorRef, Inject, ViewChild, ContentChild, ElementRef, Self, Optional, HostListener, ApplicationRef, ChangeDetectionStrategy, forwardRef, Host, ViewChildren, TemplateRef, ViewContainerRef } from '@angular/core';
import { style, animation, group, query, animate, trigger, transition, useAnimation, state } from '@angular/animations';
import { Subject, merge, fromEvent, defer } from 'rxjs';
import { filter, map, startWith, switchMap, takeUntil, take, debounceTime } from 'rxjs/operators';
import { CdkOverlayOrigin, Overlay, CdkConnectedOverlay, OverlayModule, OverlayPositionBuilder, ScrollDispatcher, OverlayContainer } from '@angular/cdk/overlay';
import { HammerGestureConfig } from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { NgControl, NG_VALUE_ACCESSOR, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ObserversModule } from '@angular/cdk/observers';
import { Platform } from '@angular/cdk/platform';
import { ComponentPortal } from '@angular/cdk/portal';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/cdk/overlay';
import * as ɵngcc3 from '@angular/cdk/a11y';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@angular/cdk/observers';
import * as ɵngcc6 from '@angular/cdk/platform';

const _c0 = function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11) { return { "voxel-icon--small": a0, "voxel-icon--large": a1, "voxel-icon--xlarge": a2, "voxel-icon--variant": a3, "voxel-icon--disabled": a4, "voxel-icon--error": a5, "voxel-icon--positive": a6, "voxel-icon--negative": a7, "voxel-icon--primary": a8, "voxel-icon--secondary": a9, "voxel-icon--light": a10, "voxel-icon--dark": a11 }; };
const _c1 = ["*"];
function VoxelAccordionComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1, " , ");
    ɵngcc0.ɵɵelementEnd();
} }
function VoxelAccordionComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.description, " ");
} }
const _c2 = [[["voxel-icon"], ["voxel-avatar"]], [["", 8, "content"]]];
const _c3 = ["voxel-icon, voxel-avatar", ".content"];
const _c4 = [[["voxel-accordion"]]];
const _c5 = ["voxel-accordion"];
const _c6 = ["draggableArea"];
const _c7 = ["toggleButton"];
const _c8 = function (a0) { return { initialHeight: a0 }; };
const _c9 = function (a1) { return { value: true, params: a1 }; };
function VoxelActionSheetComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "section", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2, 3);
    ɵngcc0.ɵɵelementStart(3, "button", 4, 5);
    ɵngcc0.ɵɵlistener("click", function VoxelActionSheetComponent_ng_template_0_Template_button_click_3_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.toggleState(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "header", 6);
    ɵngcc0.ɵɵprojection(6);
    ɵngcc0.ɵɵelementStart(7, "button", 7);
    ɵngcc0.ɵɵlistener("click", function VoxelActionSheetComponent_ng_template_0_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.close(); });
    ɵngcc0.ɵɵelementStart(8, "voxel-icon");
    ɵngcc0.ɵɵtext(9, "fechar");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 8);
    ɵngcc0.ɵɵprojection(11, 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(12, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@inOut", ɵngcc0.ɵɵpureFunction1(9, _c9, ɵngcc0.ɵɵpureFunction1(7, _c8, ctx_r0.actionSheetHeight)));
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r0.ariaLabelledby);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.dragIndicatorLabel)("aria-live", ctx_r0.platform.os === "IOS" ? null : "polite");
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵattribute("aria-label", ctx_r0.closeLabel);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵclassProp("voxel-action-sheet__body--suspended-footer", (ctx_r0.footer == null ? null : ctx_r0.footer.voxelActionSheetFooter) === "suspended");
} }
const _c10 = [[["", "voxelActionSheetPresentation", ""]], "*", [["", "voxelActionSheetFooter", ""]]];
const _c11 = ["[voxelActionSheetPresentation]", "*", "[voxelActionSheetFooter]"];
function VoxelAvatarComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.icon, " ");
} }
function VoxelAvatarComponent_ng_template_4_ng_container_1_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const word_r7 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(word_r7.slice(0, 1));
} }
function VoxelAvatarComponent_ng_template_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, VoxelAvatarComponent_ng_template_4_ng_container_1_span_1_Template, 2, 1, "span", 8);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const first_r8 = ctx.first;
    const last_r9 = ctx.last;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", first_r8 || last_r9);
} }
function VoxelAvatarComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 6);
    ɵngcc0.ɵɵtemplate(1, VoxelAvatarComponent_ng_template_4_ng_container_1_Template, 2, 1, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.text.split(" "));
} }
function VoxelAvatarComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 9);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("src", ctx_r5.photoPath, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵattribute("alt", ctx_r5.photoAlt);
} }
const _c12 = ["wrapper"];
const _c13 = ["voxelButton", ""];
function VoxelButtonComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelement(1, "voxel-loading-circle", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("type", ctx_r1.loadingCircleType);
} }
const _c14 = [[["voxel-icon"]]];
const _c15 = ["voxel-icon"];
const _c16 = ["badgeValue"];
function VoxelNumberBadgeComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.accessibleValue + ctx_r1.a11yLabel);
} }
const _c17 = function (a0) { return { "voxel-chips-group__legend--onDark": a0 }; };
function VoxelChipsComponent_legend_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "legend", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpureFunction1(3, _c17, ctx_r0.contrast === "onDark"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.label);
} }
function VoxelChipsComponent_div_3_voxel_icon_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("disabled", option_r2.disabled)("type", option_r2.iconType);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r2.icon, " ");
} }
function VoxelChipsComponent_div_3_voxel_number_badge_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-number-badge", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("secondary", ctx_r4.contrast === "default")("onDark", option_r2.iconType === "dark")("neutral", option_r2.iconType === "light" || option_r2.iconType === "dark");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r2.badgeValue, " ");
} }
const _c18 = function (a0, a1, a2) { return { "voxel-chips--withIcon": a0, "voxel-chips--on-light": a1, "voxel-chips--on-dark": a2 }; };
function VoxelChipsComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "input", 7);
    ɵngcc0.ɵɵlistener("change", function VoxelChipsComponent_div_3_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.changeOptions($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "div", 8);
    ɵngcc0.ɵɵelementStart(4, "label", 9);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, VoxelChipsComponent_div_3_voxel_icon_6_Template, 2, 3, "voxel-icon", 10);
    ɵngcc0.ɵɵtemplate(7, VoxelChipsComponent_div_3_voxel_number_badge_7_Template, 2, 4, "voxel-number-badge", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(ɵngcc0.ɵɵpureFunction3(11, _c18, option_r2.icon, ctx_r1.contrast === "onLight", ctx_r1.contrast === "onDark"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", option_r2.id)("value", option_r2.value)("disabled", option_r2.disabled || ctx_r1.disabled)("name", option_r2.name)("checked", option_r2.selected);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("for", option_r2.id);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r2.label, " ");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !option_r2.badgeValue && ctx_r1.type === "selection");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", option_r2.badgeValue);
} }
function VoxelDotIndicatorComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 5);
} if (rf & 2) {
    const dot_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("voxel-dot-indicator__item--selected", ctx_r0.current === dot_r1 + 1);
} }
function VoxelFavoriteComponent_voxel_icon_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.checked ? _r2.innerText : !ctx_r0.uncheckedIcon ? _r2.innerText + "_outline" : ctx_r0.uncheckedIcon);
} }
function VoxelFavoriteComponent_voxel_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.icon);
} }
function VoxelFormFieldComponent_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 8);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("errorMsgId", ctx_r1.describedById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.msgErr, " ");
} }
function VoxelFormFieldComponent_ng_template_12_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("hintFieldId", ctx_r4.describedById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r4.description, " ");
} }
function VoxelFormFieldComponent_ng_template_12_ng_template_1_span_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 13);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("hintFieldId", ctx_r7.describedById);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r7.description, " ");
} }
function VoxelFormFieldComponent_ng_template_12_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VoxelFormFieldComponent_ng_template_12_ng_template_1_span_0_Template, 2, 2, "span", 12);
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.description);
} }
function VoxelFormFieldComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, VoxelFormFieldComponent_ng_template_12_span_0_Template, 2, 2, "span", 9);
    ɵngcc0.ɵɵtemplate(1, VoxelFormFieldComponent_ng_template_12_ng_template_1_Template, 1, 1, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r5 = ɵngcc0.ɵɵreference(2);
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.field.nativeElement.type === "textarea" && ctx_r3.description && ctx_r3.field.nativeElement.maxLength - ctx_r3.field.value.toString().length <= ctx_r3.a11yPoliteThresold)("ngIfElse", _r5);
} }
const _c19 = [[["", "voxelPrefix", ""]], "*", [["voxel-icon"], ["voxel-datepicker"], ["", "voxelSuffix", ""]]];
const _c20 = function (a1) { return { "voxel-form-field__content": true, "voxel-form-field__content--suffix": a1 }; };
const _c21 = ["[voxelPrefix]", "*", "voxel-icon, voxel-datepicker, [voxelSuffix]"];
function VoxelFormSelectionComponent_voxel_icon_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.input.iconClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.input.icon, " ");
} }
const _c22 = [[["input"]], "*", [["voxel-form-status"]]];
const _c23 = ["input", "*", "voxel-form-status"];
const _c24 = [[["legend"]], [["voxel-form-selection"]], [["voxel-form-status"]]];
const _c25 = ["legend", "voxel-form-selection", "voxel-form-status"];
const _c26 = ["headerEl"];
const _c27 = ["headerTitle"];
function VoxelHeaderComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8, 9);
    ɵngcc0.ɵɵprojection(2, 2);
    ɵngcc0.ɵɵelementEnd();
} }
const _c28 = [[["", "voxelHeaderAction", ""]], [["", "voxelHeaderControls", ""]], [["", "voxelHeaderPresentation", ""]]];
const _c29 = ["[voxelHeaderAction]", "[voxelHeaderControls]", "[voxelHeaderPresentation]"];
function VoxelIndicatorComponent_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function VoxelIndicatorComponent_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.previous(); });
    ɵngcc0.ɵɵelementStart(1, "voxel-icon");
    ɵngcc0.ɵɵtext(2, "seta_esquerda");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tabindex", ctx_r0.current === 1 ? -1 : 0)("aria-label", ctx_r0.previousLiteral)("contrast", ctx_r0.onDark ? "dark" : "");
    ɵngcc0.ɵɵattribute("aria-disabled", ctx_r0.current === 1);
} }
function VoxelIndicatorComponent_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 6);
    ɵngcc0.ɵɵlistener("click", function VoxelIndicatorComponent_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.next(); });
    ɵngcc0.ɵɵelementStart(1, "voxel-icon");
    ɵngcc0.ɵɵtext(2, "seta_direita");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("tabindex", ctx_r1.current === ctx_r1.quantity ? -1 : 0)("aria-label", ctx_r1.nextLiteral)("contrast", ctx_r1.onDark ? "dark" : "");
    ɵngcc0.ɵɵattribute("aria-disabled", ctx_r1.current === ctx_r1.quantity);
} }
function VoxelLikertComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵlistener("click", function VoxelLikertComponent_button_4_Template_button_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r13); const option_r11 = restoredCtx.$implicit; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.emitValue(option_r11); })("focus", function VoxelLikertComponent_button_4_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.onFocus(); })("blur", function VoxelLikertComponent_button_4_Template_button_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.onBlur(); });
    ɵngcc0.ɵɵelementContainer(1, 10);
    ɵngcc0.ɵɵelementStart(2, "span", 11);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r11 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(6);
    const _r3 = ɵngcc0.ɵɵreference(8);
    const _r5 = ɵngcc0.ɵɵreference(10);
    const _r7 = ɵngcc0.ɵɵreference(12);
    const _r9 = ɵngcc0.ɵɵreference(14);
    ɵngcc0.ɵɵclassProp("voxel-likert__button--selected", (ctx_r0.value == null ? null : ctx_r0.value.key) === (option_r11 == null ? null : option_r11.key));
    ɵngcc0.ɵɵproperty("id", ctx_r0.id + "-" + option_r11.key);
    ɵngcc0.ɵɵattribute("aria-checked", option_r11 === ctx_r0.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", option_r11.key === "bad" ? _r1 : option_r11.key === "dislike" ? _r3 : option_r11.key === "neutral" ? _r5 : option_r11.key === "like" ? _r7 : _r9);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", option_r11.value, " ");
} }
function VoxelLikertComponent_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 12);
} }
function VoxelLikertComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 13);
} }
function VoxelLikertComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 14);
} }
function VoxelLikertComponent_ng_template_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 15);
} }
function VoxelLikertComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 16);
} }
const _c30 = [[["voxel-icon"], ["img"]], "*", [["voxel-list-descr"]]];
const _c31 = function (a0) { return { "voxel-list__content-simple--no-border": a0 }; };
const _c32 = ["voxel-icon, img", "*", "voxel-list-descr"];
const _c33 = [[["voxel-list-icon"]], "*", [["voxel-list-descr"]], [["voxel-list-detail"]], [["voxel-icon"]]];
const _c34 = ["voxel-list-icon", "*", "voxel-list-descr", "voxel-list-detail", "voxel-icon"];
const _c35 = [[["voxel-list-descr"]], [["voxel-list-text"]]];
const _c36 = ["voxel-list-descr", "voxel-list-text"];
const _c37 = ["*", [["voxel-list-descr"]], [["voxel-list-detail"]]];
const _c38 = ["*", "voxel-list-descr", "voxel-list-detail"];
function VoxelListComponent_ul_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 2);
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r0.listId);
} }
function VoxelListComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵprojection(1, 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("id", ctx_r1.listId);
} }
const _c39 = [[["li", "voxelListSimple", ""], ["li", "voxel-list-simple", ""], ["li", "voxelListAction", ""], ["li", "voxel-list-action", ""], ["li", "voxelListInfo", ""], ["li", "voxel-list-info", ""], ["li", "voxelListColumn", ""], ["li", "voxel-list-column", ""]], [["dl", "voxelListDefinition", ""], ["dl", "voxel-list-definition", ""]]];
const _c40 = ["\n    li[voxelListSimple],\n    li[voxel-list-simple],\n    li[voxelListAction],\n    li[voxel-list-action],\n    li[voxelListInfo],\n    li[voxel-list-info],\n    li[voxelListColumn],\n    li[voxel-list-column]", "\n    dl[voxelListDefinition],\n    dl[voxel-list-definition]"];
const _c41 = function (a0) { return { filled: a0 }; };
function VoxelProgressBarComponent_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@crescentAnimation", ɵngcc0.ɵɵpureFunction1(3, _c9, ɵngcc0.ɵɵpureFunction1(1, _c41, ctx_r0.fill)));
} }
function VoxelProgressBarComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 3);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@decrescentAnimation", ɵngcc0.ɵɵpureFunction1(3, _c9, ɵngcc0.ɵɵpureFunction1(1, _c41, ctx_r2.fill)));
} }
const _c42 = ["select"];
const _c43 = ["panel"];
function VoxelSelectComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5, 6);
    ɵngcc0.ɵɵlistener("keydown", function VoxelSelectComponent_ng_template_7_Template_div_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.handleKeydown($event); });
    ɵngcc0.ɵɵprojection(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("max-height", !ctx_r2.isMobile ? ctx_r2.visibleOptions * 3 : "", "rem");
    ɵngcc0.ɵɵproperty("id", ctx_r2.panelId);
    ɵngcc0.ɵɵattribute("aria-labelledby", ctx_r2.labelId)("aria-hidden", !ctx_r2.panelOpen);
} }
const _c44 = [[["voxel-option"]]];
const _c45 = function (a0) { return { "voxel-select--disabled": a0 }; };
const _c46 = function (a1, a2) { return { "voxel-select__icon": true, "voxel-select__icon--disabled": a1, "voxel-select__icon--open": a2 }; };
const _c47 = ["voxel-option"];
const _c48 = ["viewContainer"];
const _c49 = ["tabListEl"];
const _c50 = ["tabEl"];
function VoxelTabsComponent_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 4, 5);
    ɵngcc0.ɵɵlistener("focus", function VoxelTabsComponent_button_2_Template_button_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const _r5 = ɵngcc0.ɵɵreference(1); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.scrollIntoView(_r5); })("keydown", function VoxelTabsComponent_button_2_Template_button_keydown_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const index_r4 = restoredCtx.index; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.onKeyDown($event, index_r4); })("mousedown", function VoxelTabsComponent_button_2_Template_button_mousedown_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const index_r4 = restoredCtx.index; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.selectTab($event, index_r4); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r3 = ctx.$implicit;
    const index_r4 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("voxel-tabs__item--selected", tab_r3.selected);
    ɵngcc0.ɵɵproperty("id", ctx_r1.id + "-" + (index_r4 + 1));
    ɵngcc0.ɵɵattribute("aria-selected", tab_r3.selected)("aria-controls", tab_r3.selected ? ctx_r1.panelId : null)("aria-disabled", tab_r3.disabled || null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", tab_r3.name, " ");
} }
function VoxelTooltipComponent_voxel_icon_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "voxel-icon", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.tooltipIcon, " ");
} }
const _c51 = function (a0) { return { "transform": a0 }; };
export { VoxelMaskDirective, VoxelMaskModule, VoxelMaskPipe, VoxelMaskService } from '@voxel/components';

const DURATION_VALUE = 200;
const SELECTOR = '[data-voxel-animation="wrapper"]';
const CONTENT_SELECTOR = '[data-voxel-animation="content"]';
const DURATION = `${DURATION_VALUE}ms`;
const CONTENT_DURATION = `${DURATION_VALUE / 2}ms`;
const EASING = 'cubic-bezier(0.4, 0.0, 0.2, 1)';
const transform_initial = 'translate(0)';
const opacity_initial = 1;
const opacity = 0;
const STYLE_INITIAL = style({ transform: transform_initial, opacity: opacity_initial });
const NEW_STYLE = style({ transform: '{{ transform }}', opacity });
const transitionIn = animation(group([
    query(SELECTOR, [
        NEW_STYLE,
        group([
            animate(`${DURATION} ${EASING}`, style({ transform: transform_initial })),
            animate(DURATION, style({ opacity: opacity_initial })),
        ]),
    ]),
    query(CONTENT_SELECTOR, [
        NEW_STYLE,
        group([
            animate(`${CONTENT_DURATION} ${CONTENT_DURATION} ${EASING}`, style({ transform: transform_initial })),
            animate(`${CONTENT_DURATION} ${CONTENT_DURATION}`, style({ opacity: opacity_initial })),
        ]),
    ]),
]));
const transitionOut = animation(group([
    query(SELECTOR, [
        STYLE_INITIAL,
        group([
            animate(`${DURATION} ${EASING}`, style({ transform: '{{ transform }}' })),
            animate(DURATION, style({ opacity })),
        ]),
    ]),
    query(CONTENT_SELECTOR, [
        STYLE_INITIAL,
        group([
            animate(`${CONTENT_DURATION} ${EASING}`, style({ transform: '{{ transform }}' })),
            animate(CONTENT_DURATION, style({ opacity })),
        ]),
    ]),
]));
const TRANSFORM_FROM_TOP = 'translateY(-100%)';
const TRANSFORM_FROM_BOTTOM = 'translateY(100%)';
const TRANSFORM_FROM_LEFT = 'translateX(-100%)';
const TRANSFORM_FROM_RIGHT = 'translateX(100%)';
const IN_OUT_ANIMATION_FROM_TOP = trigger('inOut', [
    transition(':enter', useAnimation(transitionIn, { params: { transform: TRANSFORM_FROM_TOP } })),
    transition(':leave', useAnimation(transitionOut, { params: { transform: TRANSFORM_FROM_TOP } })),
]);
const IN_OUT_ANIMATION_FROM_BOTTOM = trigger('inOut', [
    transition(':enter', useAnimation(transitionIn, { params: { transform: TRANSFORM_FROM_BOTTOM } })),
    transition(':leave', useAnimation(transitionOut, { params: { transform: TRANSFORM_FROM_BOTTOM } })),
]);
const IN_OUT_ANIMATION_FROM_LEFT = trigger('inOut', [
    transition(':enter', useAnimation(transitionIn, { params: { transform: TRANSFORM_FROM_LEFT } })),
    transition(':leave', useAnimation(transitionOut, { params: { transform: TRANSFORM_FROM_LEFT } })),
]);
const IN_OUT_ANIMATION_FROM_RIGHT = trigger('inOut', [
    transition(':enter', useAnimation(transitionIn, { params: { transform: TRANSFORM_FROM_RIGHT } })),
    transition(':leave', useAnimation(transitionOut, { params: { transform: TRANSFORM_FROM_RIGHT } })),
]);

const hasDefaultAttribute = (element, attribute) => element.getAttribute(`data-setted-${attribute}`) !== 'true';
const ɵ0$3 = hasDefaultAttribute;
/**
 * Este método tem a função de colocar um atributo em um elemento HTML e além
 * disso já deixar marcado com [data-setted-{ATRIBUTO}] para quando for preciso
 * remover
 */
const setAttribute = (element, attribute, value = 'true') => {
    if (element.hasAttribute(attribute)) {
        return;
    }
    element.setAttribute(attribute, value);
    element.setAttribute(`data-setted-${attribute}`, 'true');
};
/**
 * Este método tem a função de remover os atributos HTML que foram adicionados
 * pelo "setAttribute"
 */
const removeSettedAttribute = (element, attribute) => {
    if (!hasDefaultAttribute(element, attribute)) {
        element.removeAttribute(`data-setted-${attribute}`);
        element.removeAttribute(attribute);
    }
};

const toggleMobileFocusTrap = ({ element = document.querySelector('.cdk-overlay-container'), add = true, }) => {
    // o focustrap com aria-hidden não é necessário para desktop e causa efeitos
    // colaterais no NVDA na leitura do botão de origem quando fecha o modal.
    if (!element) {
        return;
    }
    const elExceptionList = Array.from(document.querySelectorAll('.cdk-live-announcer-element'));
    const exec = (currentElement) => {
        var _a, _b;
        const siblingEls = Array.from((_b = (_a = currentElement.parentElement) === null || _a === void 0 ? void 0 : _a.children) !== null && _b !== void 0 ? _b : []);
        const elementsToHide = siblingEls.filter((siblingEl) => siblingEl !== currentElement &&
            !elExceptionList.some((el) => el.isEqualNode(siblingEl)) &&
            siblingEl.tagName !== 'SCRIPT' &&
            siblingEl.tagName !== 'STYLE' &&
            siblingEl.tagName !== 'LINK' &&
            siblingEl.tagName !== 'HEAD');
        elementsToHide.forEach((elementToHide) => {
            if (add) {
                setAttribute(elementToHide, 'aria-hidden', 'true');
                return;
            }
            removeSettedAttribute(elementToHide, 'aria-hidden');
        });
        if (currentElement.parentElement) {
            exec(currentElement.parentElement);
        }
    };
    exec(element);
};

/**
 * @internal
 */
const focusNext = (element) => {
    const next = element.nextElementSibling;
    focus(next);
};
/**
 * @internal
 */
const focus = (element) => {
    setTabindex(element);
    element.focus();
    removeTabindex(element);
};
/**
 * @internal
 */
const hasTabindex = (element) => element.getAttribute('tabindex');
const ɵ0$2 = hasTabindex;
/**
 * @internal
 */
const setTabindex = (element) => {
    if (!hasTabindex(element)) {
        element.setAttribute('tabindex', '0');
        element.setAttribute('data-setted-tabindex', 'true');
    }
};
const ɵ1$1 = setTabindex;
/**
 * @internal
 */
const hasDefaultTabindex = (element) => element.getAttribute('data-setted-tabindex') !== 'true';
const ɵ2$1 = hasDefaultTabindex;
/**
 * @internal
 */
const removeTabindex = (element) => {
    if (hasDefaultTabindex(element)) {
        return;
    }
    setTimeout(() => {
        element.removeAttribute('data-setted-tabindex');
        element.removeAttribute('tabindex');
    }, 100);
};
const ɵ3 = removeTabindex;
/**
 * @internal
 */
const setVoiceOverFocus = (element) => {
    const focusInterval = 10;
    const focusTotalRepetitions = 10;
    element.setAttribute('tabindex', '0');
    element.blur();
    let focusRepetitions = 0;
    const interval = setInterval(() => {
        element.focus();
        focusRepetitions++;
        if (focusRepetitions >= focusTotalRepetitions) {
            clearInterval(interval);
        }
    }, focusInterval);
};

/**
 * Força um valor (normalmente uma string) para boolean.
 * Normalmente utilizado para converter valores recebidos de
 *
 * @Inputs dos componentes para boolean.
 *
 * @internal
 */
const enforceBoolean = (value) => value != null && `${value}` !== 'false';
/**
 * função que verifica se o parâmetro passado é um número e devolve um booleano
 *
 * @internal
 */
const isNumber = (value) => !isNaN(parseFloat(value)) && !isNaN(Number(value));
/**
 * recebe um valor 'any' e força que o retorno seja um número
 *
 * @internal
 */
const enforceNumber = (value, defaultValue = 0) => isNumber(value) ? Number(value) : defaultValue;
/**
 * Algoritmo para verificar se os valores sao iguais
 * Polyfill para a função: https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 *
 * @internal
 */
const objectIs = (x, y) => {
    if (x === y) {
        // Passos 1-5, 7-10
        // Passos 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
    }
    // Passo 6.a: NaN == NaN
    return x !== x && y !== y;
};

/**
 * @internal
 */
const noop = (...args) => args;
const ɵ0$1 = noop;
/**
 * @internal
 */
const FormAcessorMixin = (base) => {
    class FormAcessor extends base {
        constructor(...args) {
            super(...args);
            this.formState = new Subject();
            this._disabled = false;
            this._focused = false;
            this._active = false;
            this._updateFirstOnBlur = false;
            this.formAcessorChanged = noop;
            this.formAcessorTouched = noop;
            this._destroy = new Subject();
            if (this.ngControl) {
                this.ngControl.valueAccessor = this;
            }
            this.errorState = this.formState.pipe(filter(() => Boolean(this.ngControl)), map(() => Boolean((this.ngControl.touched || this.ngControl.dirty) &&
                this.ngControl.invalid &&
                (!this.updateFirstOnBlur || (this.updateFirstOnBlur && this.ngControl.touched)))));
        }
        /**
         * @internal
         */
        ngOnDestroy() {
            this._destroy.complete();
            this.formState.complete();
        }
        /**
         * Valor do componente
         *
         * *Value of the component*
         */
        set value(newValue) {
            if (newValue !== this._value) {
                this._value = newValue;
                this.formAcessorChanged(newValue);
            }
        }
        get value() {
            return this._value;
        }
        /**
         * Desabilita a edição do campo
         *
         * *Disables the field editing*
         */
        set disabled(disabled) {
            this._disabled = enforceBoolean(disabled);
        }
        get disabled() {
            return this._disabled;
        }
        set focused(focused) {
            this._focused = focused;
        }
        get focused() {
            return this._focused;
        }
        set active(active) {
            this._active = active;
        }
        get active() {
            return this._active;
        }
        set updateFirstOnBlur(updateFirstOnBlur) {
            this._updateFirstOnBlur = updateFirstOnBlur;
        }
        get updateFirstOnBlur() {
            return this._updateFirstOnBlur;
        }
        formAcessorHandleChange() {
            // TODO: Implementar uma melhor forma de validar as mudanças asyncronas
            setTimeout(() => {
                this.formState.next();
            }, 0);
        }
        formAcessorHandleFocus() {
            this.focused = true;
            this.formState.next();
        }
        formAcessorHandleBlur() {
            this.focused = false;
            this.active = false;
            this.formAcessorTouched();
            this.formState.next();
        }
        writeValue(newValue) {
            if (newValue !== this._value) {
                this._value = newValue;
                this.elementRef.nativeElement.value = newValue;
                this.formAcessorTouched();
            }
        }
        registerOnChange(fn) {
            this.formAcessorChanged = (value) => {
                if (this.focused) {
                    this.active = true;
                }
                fn(value);
                this.formState.next();
            };
        }
        registerOnTouched(fn) {
            this.formAcessorTouched = fn;
        }
        setDisabledState(isDisabled) {
            this._disabled = isDisabled;
            this.formState.next();
        }
    }
    FormAcessor.decorators = [
        { type: Directive }
    ];
    FormAcessor.ctorParameters = () => [
        { type: Array }
    ];
    FormAcessor.propDecorators = {
        value: [{ type: Input }],
        disabled: [{ type: Input }]
    };
    return FormAcessor;
};

class VoxelOverlayOriginDirective extends CdkOverlayOrigin {
}
VoxelOverlayOriginDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelOverlayOriginDirective_BaseFactory; return function VoxelOverlayOriginDirective_Factory(t) { return (ɵVoxelOverlayOriginDirective_BaseFactory || (ɵVoxelOverlayOriginDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelOverlayOriginDirective)))(t || VoxelOverlayOriginDirective); }; }();
VoxelOverlayOriginDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelOverlayOriginDirective, selectors: [["", "voxelOverlayOrigin", ""]], exportAs: ["voxelOverlayOrigin"], features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelOverlayOriginDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelOverlayOrigin]',
                exportAs: 'voxelOverlayOrigin'
            }]
    }], null, null); })();

/**
 * Componente de ícone usado em elementos de interface, disponibilizado nos tamanhos pequeno "S", médio "M" e grande "L"
 *
 * *Icon component used in interface elements, available as small "S", medium "M" and large "L".*
 *
 * **Module:**
 *
 * `import { VoxelIconModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/#/portfolio/icon?componentOnly=true</example-url>
 *
 * @example
 * <voxel-icon>
 *    nome_do_ícone
 * </voxel-icon>
 *
 * @example Leitor de tela habilitado
 * <voxel-icon
 *  a11yHidden="false"
 *  a11yLabel="Descrição do ícone">
 *    nome_do_ícone
 * </voxel-icon>
 *
 * @example Ícone com alteração de tamanho
 * <voxel-icon
 *  size="S">
 *    nome_do_ícone
 * </voxel-icon>
 *
 */
class VoxelIconComponent {
    constructor() {
        /**
         * Desabilitar Leitor de Tela para o ícone
         *
         * *Disable screen reader for the icon*
         */
        this.a11yHidden = true;
    }
    /**
     * Define se o icone está desabilitado ou não
     *
     * *sets whether the icon is disabled or not*
     */
    set disabled(disabled) {
        this._disabled = enforceBoolean(disabled);
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Define se o icone é variante ou não
     *
     * *sets whether the icon is variant or not*
     */
    set variant(variant) {
        this._variant = enforceBoolean(variant);
    }
    get variant() {
        return this._variant;
    }
}
VoxelIconComponent.ɵfac = function VoxelIconComponent_Factory(t) { return new (t || VoxelIconComponent)(); };
VoxelIconComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelIconComponent, selectors: [["voxel-icon"]], inputs: { a11yHidden: "a11yHidden", disabled: "disabled", variant: "variant", size: "size", a11yLabel: "a11yLabel", type: "type" }, ngContentSelectors: _c1, decls: 3, vars: 16, consts: [["role", "img", 1, "voxel-icon", 3, "ngClass"], ["aria-hidden", "true"]], template: function VoxelIconComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunctionV(3, _c0, [ctx.size === "S", ctx.size === "L", ctx.size === "XL", ctx.variant, ctx.disabled, ctx.type === "error", ctx.type === "positive", ctx.type === "negative", ctx.type === "primary", ctx.type === "secondary", ctx.type === "light", ctx.type === "dark"]));
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.a11yHidden)("aria-label", ctx.a11yLabel);
    } }, directives: [ɵngcc1.NgClass], styles: [".voxel-icon{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_icon_medium);-webkit-font-feature-settings:\"liga\",\"dlig\";font-feature-settings:\"liga\",\"dlig\";-webkit-font-smoothing:antialiased;font-style:normal;-webkit-font-variant-ligatures:discretionary-ligatures;font-variant-ligatures:discretionary-ligatures;letter-spacing:0;margin:auto;text-rendering:optimizeLegibility}.voxel-icon--variant{color:var(--ids_color_action_neutral_variant)}.voxel-icon--variant.voxel-icon--primary{color:var(--ids_color_action_primary_variant)}.voxel-icon--variant.voxel-icon--secondary{color:var(--ids_color_action_secondary_variant)}.voxel-icon--variant.voxel-icon--light,.voxel-icon--variant.voxel-icon--dark{opacity:var(--ids_opacity_strong)}.voxel-icon--disabled{color:var(--ids_color_action_disabled_variant)}.voxel-icon--disabled.voxel-icon--light,.voxel-icon--disabled.voxel-icon--dark{opacity:var(--ids_opacity_medium)}.voxel-icon--error{color:var(--ids_color_feedback_error)}.voxel-icon--positive{color:var(--ids_color_feedback_success)}.voxel-icon--negative{color:var(--ids_color_feedback_alert)}.voxel-icon--primary{color:var(--ids_color_action_primary_base)}.voxel-icon--secondary{color:var(--ids_color_action_secondary_base)}.voxel-icon--light{color:var(--ids_color_contrast_onLight)}.voxel-icon--dark{color:var(--ids_color_contrast_onDark)}.voxel-icon--small{font:var(--ids_textStyle_icon_small)}.voxel-icon--large{font:var(--ids_textStyle_icon_large)}.voxel-icon--xlarge{font:var(--ids_textStyle_icon_xLarge)}.voxel-icon--ids{margin:0;margin:initial}\n"], encapsulation: 2 });
/**
 * @internal
 */
VoxelIconComponent.selector = 'voxel-icon';
VoxelIconComponent.propDecorators = {
    size: [{ type: Input }],
    a11yHidden: [{ type: Input }],
    a11yLabel: [{ type: Input }],
    type: [{ type: Input }],
    disabled: [{ type: Input }],
    variant: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelIconComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-icon',
                template: "<div\n  class=\"voxel-icon\"\n  role=\"img\"\n  [attr.aria-hidden]=\"a11yHidden\"\n  [attr.aria-label]=\"a11yLabel\"\n  [ngClass]=\"{\n    'voxel-icon--small': size === 'S',\n    'voxel-icon--large': size === 'L',\n    'voxel-icon--xlarge': size === 'XL',\n    'voxel-icon--variant': variant,\n    'voxel-icon--disabled': disabled,\n    'voxel-icon--error': type === 'error',\n    'voxel-icon--positive': type === 'positive',\n    'voxel-icon--negative': type === 'negative',\n    'voxel-icon--primary': type === 'primary',\n    'voxel-icon--secondary': type === 'secondary',\n    'voxel-icon--light': type === 'light',\n    'voxel-icon--dark': type === 'dark'\n  }\"\n>\n  <span\n    aria-hidden=\"true\"\n  >\n    <ng-content></ng-content>\n  </span>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-icon{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_icon_medium);-webkit-font-feature-settings:\"liga\",\"dlig\";font-feature-settings:\"liga\",\"dlig\";-webkit-font-smoothing:antialiased;font-style:normal;-webkit-font-variant-ligatures:discretionary-ligatures;font-variant-ligatures:discretionary-ligatures;letter-spacing:0;margin:auto;text-rendering:optimizeLegibility}.voxel-icon--variant{color:var(--ids_color_action_neutral_variant)}.voxel-icon--variant.voxel-icon--primary{color:var(--ids_color_action_primary_variant)}.voxel-icon--variant.voxel-icon--secondary{color:var(--ids_color_action_secondary_variant)}.voxel-icon--variant.voxel-icon--light,.voxel-icon--variant.voxel-icon--dark{opacity:var(--ids_opacity_strong)}.voxel-icon--disabled{color:var(--ids_color_action_disabled_variant)}.voxel-icon--disabled.voxel-icon--light,.voxel-icon--disabled.voxel-icon--dark{opacity:var(--ids_opacity_medium)}.voxel-icon--error{color:var(--ids_color_feedback_error)}.voxel-icon--positive{color:var(--ids_color_feedback_success)}.voxel-icon--negative{color:var(--ids_color_feedback_alert)}.voxel-icon--primary{color:var(--ids_color_action_primary_base)}.voxel-icon--secondary{color:var(--ids_color_action_secondary_base)}.voxel-icon--light{color:var(--ids_color_contrast_onLight)}.voxel-icon--dark{color:var(--ids_color_contrast_onDark)}.voxel-icon--small{font:var(--ids_textStyle_icon_small)}.voxel-icon--large{font:var(--ids_textStyle_icon_large)}.voxel-icon--xlarge{font:var(--ids_textStyle_icon_xLarge)}.voxel-icon--ids{margin:0;margin:initial}\n"]
            }]
    }], function () { return []; }, { a11yHidden: [{
            type: Input
        }], disabled: [{
            type: Input
        }], variant: [{
            type: Input
        }], size: [{
            type: Input
        }], a11yLabel: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

class VoxelIconModule {
}
VoxelIconModule.ɵfac = function VoxelIconModule_Factory(t) { return new (t || VoxelIconModule)(); };
VoxelIconModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelIconModule });
VoxelIconModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelIconModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelIconComponent],
                exports: [VoxelIconComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelIconModule, { declarations: function () { return [VoxelIconComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelIconComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID$i = 0;
/**
 * Lista de tópicos que podem ser expandidos ou contraidos
 *
 * *List of topics that can be expanded or collapsed*
 *
 * **Module:**
 *
 * `import { VoxelAccordionModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/accordion?componentOnly=true</example-url>
 *
 * @example Simples
 * <voxel-accordion
 *   accordionTitle="accordion"
 * >
 *   <ng-container class="content">
 *     content
 *   </ng-container>
 * </voxel-accordion>
 *
 * @example Ícone
 *   <voxel-accordion
 *     accordionTitle="accordion1"
 *   >
 *     <voxel-icon>inovacao_outline</voxel-icon>
 *     <ng-container class="content">
 *       content1
 *     </ng-container>
 *   </voxel-accordion>
 *
 * @example Descrição
 *   <voxel-accordion
 *     accordionTitle="accordion2"
 *     description="descrição teste"
 *   >
 *     <ng-container class="content">
 *       content2
 *     </ng-container>
 *   </voxel-accordion>
 *
 * @example  Descrição e ícone
 *   <voxel-accordion
 *     accordionTitle="accordion1"
 *     description="descrição teste"
 *   >
 *     <voxel-icon>inovacao_outline</voxel-icon>
 *     <ng-container class="content">
 *       content3
 *     </ng-container>
 *   </voxel-accordion>
 *
 * @example Agrupado
 * <voxel-accordion-group>
 *   <voxel-accordion
 *     accordionTitle="accordion1"
 *   >
 *     <ng-container class="content">
 *       content1
 *     </ng-container>
 *   </voxel-accordion>
 *   <voxel-accordion
 *     accordionTitle="accordion2"
 *   >
 *     <ng-container class="content">
 *       content2
 *     </ng-container>
 *   </voxel-accordion>
 * </voxel-accordion-group>
 *
 *  * @example Agrupado com descrição e ícone
 * <voxel-accordion-group>
 *   <voxel-accordion
 *     accordionTitle="accordion1"
 *     description="descrição teste"
 *   >
 *     <voxel-icon>inovacao_outline</voxel-icon>
 *     <ng-container class="content">
 *       content1
 *     </ng-container>
 *   </voxel-accordion>
 *   <voxel-accordion
 *     accordionTitle="accordion2"
 *     description="descrição teste2"
 *   >
 *     <voxel-icon>inovacao_outline</voxel-icon>
 *     <ng-container class="content">
 *       content2
 *     </ng-container>
 *   </voxel-accordion>
 * </voxel-accordion-group>
 */
class VoxelAccordionComponent {
    constructor() {
        /**
         * @internal
         */
        this._isOpened = false;
        /**
         * Id do componente de accordion
         *
         * *Accordion id*
         */
        this.accordionId = `voxel-accordion-${NEXT_ID$i++}`;
        /**
         * Nível de cabeçalho do accordion (Evitar)
         *
         * *Accordion heading level (Avoid)*
         */
        this.ariaLevel = null;
        /**
         * Emite eventos de clique no accordion
         *
         * *Click event emitter on Accordion*
         */
        this.toggle = new EventEmitter();
    }
    /**
     * Estado de exibição inicial do componente
     *
     * *Component's initial display state*
     */
    set isOpened(isOpened) {
        this._isOpened = enforceBoolean(isOpened);
    }
    get isOpened() {
        return this._isOpened;
    }
    /**
     * @internal
     */
    toggleCollapse(_event) {
        this.toggle.emit(this.createEmit(_event));
        this._isOpened = !this._isOpened;
    }
    /**
     * @internal
     */
    createEmit(_event) {
        return {
            _event,
            id: this.accordionId,
        };
    }
}
VoxelAccordionComponent.ɵfac = function VoxelAccordionComponent_Factory(t) { return new (t || VoxelAccordionComponent)(); };
VoxelAccordionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelAccordionComponent, selectors: [["voxel-accordion"]], inputs: { accordionId: "accordionId", ariaLevel: "ariaLevel", isOpened: "isOpened", accordionTitle: "accordionTitle", description: "description" }, outputs: { toggle: "toggle" }, ngContentSelectors: _c3, decls: 14, vars: 18, consts: [[1, "voxel-accordion"], [1, "voxel-accordion__trigger", 3, "click"], [1, "voxel-accordion__main"], [1, "voxel-accordion__title"], ["class", "voxel-accordion__interval", 4, "ngIf"], ["class", "voxel-accordion__description", 4, "ngIf"], [1, "voxel-accordion__icon"], [1, "voxel-accordion__content", 3, "id"], [1, "voxel-accordion__interval"], [1, "voxel-accordion__description"]], template: function VoxelAccordionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c2);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "button", 1);
        ɵngcc0.ɵɵlistener("click", function VoxelAccordionComponent_Template_button_click_2_listener($event) { return ctx.toggleCollapse($event); });
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementStart(5, "span", 3);
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵtemplate(7, VoxelAccordionComponent_span_7_Template, 2, 0, "span", 4);
        ɵngcc0.ɵɵtemplate(8, VoxelAccordionComponent_span_8_Template, 2, 1, "span", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(9, "div", 6);
        ɵngcc0.ɵɵelementStart(10, "voxel-icon");
        ɵngcc0.ɵɵtext(11, "seta_baixo");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵprojection(13, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("role", ctx.ariaLevel !== null ? "heading" : null)("aria-level", ctx.ariaLevel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("voxel-accordion__trigger--expanded", ctx.isOpened)("voxel-accordion__trigger--double-line", ctx.description);
        ɵngcc0.ɵɵattribute("id", ctx.accordionId)("aria-controls", "content-" + ctx.accordionId)("aria-expanded", ctx.isOpened);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("voxel-accordion__title--description", ctx.description);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.accordionTitle, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.description);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.description);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵclassProp("voxel-accordion__content--hide", !ctx.isOpened);
        ɵngcc0.ɵɵproperty("id", "content-" + ctx.accordionId);
        ɵngcc0.ɵɵattribute("aria-hidden", !ctx.isOpened);
    } }, directives: [ɵngcc1.NgIf, VoxelIconComponent], styles: [".voxel-accordion{background-color:var(--ids_color_bg_base)}.voxel-accordion__icon{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_neutral_base);padding:var(--ids_size_general_12x);-webkit-transition:-webkit-transform .5s;transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.voxel-accordion__title{color:var(--ids_color_action_neutral_variant);font:var(--ids_textStyle_label_medium_regular);text-align:left}.voxel-accordion__title--description{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.voxel-accordion__trigger{background-color:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);color:var(--ids_color_text_body_01);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:var(--ids_size_general_64x);overflow:hidden;width:100%}.voxel-accordion__trigger:hover{background-color:var(--ids_color_action_neutral_base_soft)}.voxel-accordion__trigger--double-line{min-height:var(--ids_size_general_84x)}.voxel-accordion__trigger--expanded{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium)}.voxel-accordion__trigger--expanded .voxel-accordion__title{font:var(--ids_textStyle_label_medium_bold)}.voxel-accordion__trigger--expanded .voxel-accordion__icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.voxel-accordion__main{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center;display:-webkit-box;display:-ms-flexbox;display:flex}.voxel-accordion__main .voxel-icon,.voxel-accordion__main voxel-avatar{padding-right:var(--ids_size_general_12x)}.voxel-accordion__interval{border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.voxel-accordion__description{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_label_small_regular)}.voxel-accordion__content{-webkit-animation:fadeIn .5s;animation:fadeIn .5s;font:var(--ids_textStyle_body_01_regular);margin:var(--ids_size_general_24x) 0;-webkit-transition:margin .5s,max-height .3s;transition:margin .5s,max-height .3s}.voxel-accordion__content--hide{-webkit-animation:fadeOut .5s;animation:fadeOut .5s;margin:0;max-height:0;overflow:hidden;visibility:hidden}@-webkit-keyframes fadeIn{0%{opacity:var(--ids_opacity_empty)}to{opacity:var(--ids_opacity_none)}}@keyframes fadeIn{0%{opacity:var(--ids_opacity_empty)}to{opacity:var(--ids_opacity_none)}}@-webkit-keyframes fadeOut{0%{opacity:var(--ids_opacity_none)}to{opacity:var(--ids_opacity_empty)}}@keyframes fadeOut{0%{opacity:var(--ids_opacity_none)}to{opacity:var(--ids_opacity_empty)}}\n"], encapsulation: 2 });
VoxelAccordionComponent.propDecorators = {
    accordionId: [{ type: Input }],
    accordionTitle: [{ type: Input }],
    description: [{ type: Input }],
    ariaLevel: [{ type: Input }],
    isOpened: [{ type: Input }],
    toggle: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAccordionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-accordion',
                template: "<div class=\"voxel-accordion\">\n  <div\n    [attr.role]=\"ariaLevel !== null ? 'heading' : null\"\n    [attr.aria-level]=\"ariaLevel\"\n  >\n    <button\n      class=\"voxel-accordion__trigger\"\n      [class.voxel-accordion__trigger--expanded]=\"isOpened\"\n      [class.voxel-accordion__trigger--double-line]=\"description\"\n      [attr.id]=\"accordionId\"\n      [attr.aria-controls]=\"'content-' + accordionId\"\n      [attr.aria-expanded]=\"isOpened\"\n      (click)=\"toggleCollapse($event)\"\n    >\n      <div class=\"voxel-accordion__main\">\n        <ng-content select=\"voxel-icon, voxel-avatar\"></ng-content>\n        <span\n          class=\"voxel-accordion__title\"\n          [class.voxel-accordion__title--description]=\"description\"\n        >\n          {{ accordionTitle }}\n          <span\n            *ngIf=\"description\"\n            class=\"voxel-accordion__interval\"\n          >\n            ,\n          </span>\n          <span\n            *ngIf=\"description\"\n            class=\"voxel-accordion__description\"\n          >\n            {{ description }}\n          </span>\n        </span>\n      </div>\n      <div class=\"voxel-accordion__icon\">\n        <voxel-icon>seta_baixo</voxel-icon>\n      </div>\n    </button>\n  </div>\n  <div\n    [id]=\"'content-' + accordionId\"\n    class=\"voxel-accordion__content\"\n    [class.voxel-accordion__content--hide]=\"!isOpened\"\n    [attr.aria-hidden]=\"!isOpened\"\n  >\n    <ng-content select=\".content\"></ng-content>\n  </div>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-accordion{background-color:var(--ids_color_bg_base)}.voxel-accordion__icon{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_neutral_base);padding:var(--ids_size_general_12x);-webkit-transition:-webkit-transform .5s;transition:-webkit-transform .5s;transition:transform .5s;transition:transform .5s,-webkit-transform .5s}.voxel-accordion__title{color:var(--ids_color_action_neutral_variant);font:var(--ids_textStyle_label_medium_regular);text-align:left}.voxel-accordion__title--description{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.voxel-accordion__trigger{background-color:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);color:var(--ids_color_text_body_01);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;min-height:var(--ids_size_general_64x);overflow:hidden;width:100%}.voxel-accordion__trigger:hover{background-color:var(--ids_color_action_neutral_base_soft)}.voxel-accordion__trigger--double-line{min-height:var(--ids_size_general_84x)}.voxel-accordion__trigger--expanded{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium)}.voxel-accordion__trigger--expanded .voxel-accordion__title{font:var(--ids_textStyle_label_medium_bold)}.voxel-accordion__trigger--expanded .voxel-accordion__icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.voxel-accordion__main{-webkit-box-align:center;-ms-flex-align:center;align-items:center;-ms-flex-item-align:center;align-self:center;display:-webkit-box;display:-ms-flexbox;display:flex}.voxel-accordion__main .voxel-icon,.voxel-accordion__main voxel-avatar{padding-right:var(--ids_size_general_12x)}.voxel-accordion__interval{border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.voxel-accordion__description{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_label_small_regular)}.voxel-accordion__content{-webkit-animation:fadeIn .5s;animation:fadeIn .5s;font:var(--ids_textStyle_body_01_regular);margin:var(--ids_size_general_24x) 0;-webkit-transition:margin .5s,max-height .3s;transition:margin .5s,max-height .3s}.voxel-accordion__content--hide{-webkit-animation:fadeOut .5s;animation:fadeOut .5s;margin:0;max-height:0;overflow:hidden;visibility:hidden}@-webkit-keyframes fadeIn{0%{opacity:var(--ids_opacity_empty)}to{opacity:var(--ids_opacity_none)}}@keyframes fadeIn{0%{opacity:var(--ids_opacity_empty)}to{opacity:var(--ids_opacity_none)}}@-webkit-keyframes fadeOut{0%{opacity:var(--ids_opacity_none)}to{opacity:var(--ids_opacity_empty)}}@keyframes fadeOut{0%{opacity:var(--ids_opacity_none)}to{opacity:var(--ids_opacity_empty)}}\n"]
            }]
    }], function () { return []; }, { accordionId: [{
            type: Input
        }], ariaLevel: [{
            type: Input
        }], toggle: [{
            type: Output
        }], isOpened: [{
            type: Input
        }], accordionTitle: [{
            type: Input
        }], description: [{
            type: Input
        }] }); })();

/** @internal */
class VoxelAccordionGroupComponent {
    constructor() {
        /** @internal */
        this._destroy = new Subject();
        /**
         * Atributo booleano para definir se o accordion group permitirá um único accordion expandir por vez
         * Valor default: true
         *
         * *Boolean value to define if the accordion group will permit only one accordion to expand at a time*
         * *Default value: true*
         */
        this.expandOne = true;
    }
    /** @internal */
    ngAfterContentInit() {
        this.accordionList.changes
            .pipe(startWith(null), switchMap(() => merge(...this.accordionList.map((item) => item.toggle))), takeUntil(this._destroy))
            .subscribe((accordionEvent) => {
            if (accordionEvent.id) {
                this.accordionList.forEach((accordion) => {
                    if (accordion.accordionId !== accordionEvent.id && this.expandOne) {
                        accordion.isOpened = false;
                    }
                });
            }
        });
    }
    /** @internal */
    ngOnDestroy() {
        this._destroy.complete();
    }
}
VoxelAccordionGroupComponent.ɵfac = function VoxelAccordionGroupComponent_Factory(t) { return new (t || VoxelAccordionGroupComponent)(); };
VoxelAccordionGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelAccordionGroupComponent, selectors: [["voxel-accordion-group"]], contentQueries: function VoxelAccordionGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelAccordionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.accordionList = _t);
    } }, inputs: { expandOne: "expandOne" }, ngContentSelectors: _c5, decls: 1, vars: 0, template: function VoxelAccordionGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c4);
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
VoxelAccordionGroupComponent.propDecorators = {
    accordionList: [{ type: ContentChildren, args: [VoxelAccordionComponent,] }],
    expandOne: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAccordionGroupComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-accordion-group',
                template: "<ng-content select=\"voxel-accordion\"></ng-content>"
            }]
    }], function () { return []; }, { expandOne: [{
            type: Input
        }], accordionList: [{
            type: ContentChildren,
            args: [VoxelAccordionComponent]
        }] }); })();

class VoxelAccordionModule {
}
VoxelAccordionModule.ɵfac = function VoxelAccordionModule_Factory(t) { return new (t || VoxelAccordionModule)(); };
VoxelAccordionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelAccordionModule });
VoxelAccordionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAccordionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelAccordionComponent, VoxelAccordionGroupComponent],
                exports: [VoxelAccordionComponent, VoxelAccordionGroupComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelAccordionModule, { declarations: function () { return [VoxelAccordionComponent, VoxelAccordionGroupComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelAccordionComponent, VoxelAccordionGroupComponent]; } }); })();

const getOs = () => {
    var _a, _b, _c;
    // o iPad 13 vem descrito como Mac OS no seu sistema operacional, porém é
    // possível diferenciar pelos pontos de toque na tela
    const isIPad = navigator.userAgent.includes('Mac OS') && navigator.maxTouchPoints > 1;
    if (((_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.platform) === 'Windows' ||
        navigator.userAgent.includes('Windows NT')) {
        return 'Windows';
    }
    if (((_b = navigator.userAgentData) === null || _b === void 0 ? void 0 : _b.platform) === 'Android' || navigator.userAgent.includes('Android')) {
        return 'Android';
    }
    if (navigator.platform === 'iPhone' || navigator.userAgent.includes('iPhone') || isIPad) {
        return 'IOS';
    }
    if (((_c = navigator.userAgentData) === null || _c === void 0 ? void 0 : _c.platform) === 'macOS' ||
        navigator.userAgent.includes('Mac OS') ||
        navigator.platform === 'MacIntel') {
        return 'MacOS';
    }
    return 'Windows';
};
const ɵ0 = getOs;
const getIsMobile = () => {
    var _a;
    const os = getOs();
    if (((_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.mobile) || os === 'Android' || os === 'IOS') {
        return true;
    }
    return false;
};
const ɵ1 = getIsMobile;
const getUserAgent = () => {
    var _a, _b, _c, _d;
    // A única informação que difere o Chrome do Safari no IOS é a descrição CriOS
    // https://chromium.googlesource.com/chromium/src.git/+/HEAD/docs/ios/user_agent.md
    const isIphoneChrome = navigator.userAgent.includes('CriOS');
    // Contando que existe apenas Chrome e Safari no iPhone, excluindo Chrome,
    // sobra Safari
    const isIphoneSafari = !isIphoneChrome && navigator.platform === 'iPhone';
    const isMacSafari = navigator.vendor === 'Apple Computer, Inc' &&
        (navigator.platform === 'MacIntel' || navigator.userAgent.includes('Macintosh'));
    if ((_b = (_a = navigator.userAgentData) === null || _a === void 0 ? void 0 : _a.brands) === null || _b === void 0 ? void 0 : _b.some(({ brand }) => brand === 'Microsoft Edge')) {
        return 'Edge';
    }
    if (isIphoneChrome ||
        ((_d = (_c = navigator.userAgentData) === null || _c === void 0 ? void 0 : _c.brands) === null || _d === void 0 ? void 0 : _d.some(({ brand }) => brand === 'Google Chrome'))) {
        return 'Chrome';
    }
    if (navigator.userAgent.includes('Firefox/')) {
        return 'Firefox';
    }
    if (isIphoneSafari || isMacSafari) {
        return 'Safari';
    }
    return 'Internet Explorer';
};
const ɵ2 = getUserAgent;
/**
 * todas as informações da plataforma estão disponíveis no objeto Platform
 */
const platform = {
    get isMobile() {
        return getIsMobile();
    },
    get os() {
        return getOs();
    },
    get userAgent() {
        return getUserAgent();
    },
};

class VoxelActionSheetPresentationDirective {
    constructor() {
        this.class = 'voxel-action-sheet__presentation';
    }
}
VoxelActionSheetPresentationDirective.ɵfac = function VoxelActionSheetPresentationDirective_Factory(t) { return new (t || VoxelActionSheetPresentationDirective)(); };
VoxelActionSheetPresentationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelActionSheetPresentationDirective, selectors: [["", "voxelActionSheetPresentation", ""]], hostVars: 2, hostBindings: function VoxelActionSheetPresentationDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelActionSheetPresentationDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelActionSheetPresentationDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelActionSheetPresentation]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
class VoxelActionSheetFooterDirective {
    constructor() {
        this.class = 'voxel-action-sheet__footer';
        /**
         * Define se o footer ficará suspenso. Ou seja, se o conteúdo do Action Sheet irá ficar
         * atrás do footer
         */
        this.voxelActionSheetFooter = '';
    }
}
VoxelActionSheetFooterDirective.ɵfac = function VoxelActionSheetFooterDirective_Factory(t) { return new (t || VoxelActionSheetFooterDirective)(); };
VoxelActionSheetFooterDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelActionSheetFooterDirective, selectors: [["", "voxelActionSheetFooter", ""]], hostVars: 2, hostBindings: function VoxelActionSheetFooterDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { voxelActionSheetFooter: "voxelActionSheetFooter" } });
VoxelActionSheetFooterDirective.propDecorators = {
    class: [{ type: HostBinding }],
    voxelActionSheetFooter: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelActionSheetFooterDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelActionSheetFooter]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], voxelActionSheetFooter: [{
            type: Input
        }] }); })();
const EXPANDED_DRAG_INDICATOR_LABEL = 'tela cheia, recolher conteúdo';
const CONTRACTED_DRAG_INDICATOR_LABEL = 'meia tela, expandir conteúdo';
/**
 * O action sheet tem um comportamento de scroll onde o seu header fica fixo quando o scroll top
 * do sheet chega a uma determinada porcentagem de altura dentro do viewport.
 *
 * *The action sheet has a scrolling behavior where its header is fixed when the top scroll of*
 * *the sheet reaches a certain percentage of height within the viewport.*
 *
 * **Module:**
 *
 * `import { VoxelActionSheetModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/#/portfolio/action-sheet?componentOnly=true</example-url>
 */
class VoxelActionSheetComponent extends HammerGestureConfig {
    constructor(_overlay, _renderer, _cdRef, _document) {
        super();
        this._overlay = _overlay;
        this._renderer = _renderer;
        this._cdRef = _cdRef;
        this._document = _document;
        this._expanded = false;
        this.scrollStrategy = this._overlay.scrollStrategies.block();
        this.overrides = { pan: { enable: true, direction: Hammer.DIRECTION_VERTICAL, threshold: 5 } };
        this.dragIndicatorLabel = CONTRACTED_DRAG_INDICATOR_LABEL;
        this.platform = platform;
        this._open = false;
        /**
         * Label do botão fechar para ser lido por leitores de tela
         *
         * *Close button label to be read by screen readers*
         */
        this.closeLabel = 'fechar';
        /**
         * Evento emitido ao alterar o valor da propriedade open
         *
         * *Event emitted when changing open property value*
         */
        this.openChange = new EventEmitter();
        /**
         * Evento emitido sempre que o componente é aberto
         *
         * *Evento emitido sempre que o componente é aberto*
         */
        this.opened = new EventEmitter();
        /**
         * Evento emitido sempre que o componente é fechado
         *
         * *Event emitted whenever the component is closed*
         */
        this.closed = new EventEmitter();
        this.hostClass = null;
        this.hostAriaLabelledby = null;
    }
    get classes() {
        const defaultClass = 'voxel-action-sheet';
        return this.class ? [defaultClass, ...this.class.split(' ')] : defaultClass;
    }
    get overlayElement() {
        return this.cdkConnectedOverlay.overlayRef.overlayElement;
    }
    get initialPercentage() {
        return this._initialPercentage;
    }
    get actionSheetHeight() {
        return this._actionSheetHeight;
    }
    /**
     * Alterna o estado do componente entre aberto e fechado
     *
     * *Toggles component state between open and closed*
     */
    get open() {
        return this._open;
    }
    set open(value) {
        const shouldDestroy = this._open && !value;
        const shouldEmit = this._open !== value;
        this._open = value;
        if (shouldDestroy) {
            this._destroyHammerAndFocus();
        }
        if (shouldEmit) {
            this._emitStateEvent(this._open);
        }
    }
    _createHammerInstance() {
        this._hammer = this.buildHammer(this.draggableAreaRef.nativeElement);
        this._createHammerObserver();
    }
    _createHammerObserver() {
        /* istanbul ignore next */
        this._hammer.on('panup pandown panend', (event) => {
            if (event.type === 'panend') {
                this._onPanEnd();
                return;
            }
            this._onPan(event);
        });
    }
    _destroyHammerAndFocus() {
        if (this._hammer.destroy) {
            this._hammer.destroy();
        }
        toggleMobileFocusTrap({ add: false });
        this._detachOverlay();
        if (platform.os === 'IOS') {
            setVoiceOverFocus(this.origin.elementRef.nativeElement);
            return;
        }
        this.origin.elementRef.nativeElement.focus();
    }
    // É preciso remover o overlay manualmente já que existe uma animação e o cdk overlay
    // aguarda até o fim dessa animação para destruir o overlay. E nesse caso, ele não está
    // removendo de forma automática
    _detachOverlay() {
        let count = 1;
        const interval = setInterval(() => {
            // Apenas remover se o "open" estiver falso. Se o usuário clicar muito rápido
            // no abrir e fechar, a nova instância do action sheet pode ser removida ao abrir
            if (!this.open) {
                this.cdkConnectedOverlay.overlayRef.detach();
            }
            if (count === 100 || !this._document.querySelector('.voxel-action-sheet') || this.open) {
                clearInterval(interval);
            }
            count++;
        }, 250);
    }
    _emitStateEvent(open) {
        if (open) {
            this.opened.emit();
            return;
        }
        this.closed.emit();
    }
    _getCurrentActionSheetSize(percentage) {
        return (window.innerHeight * percentage) / 100;
    }
    /* istanbul ignore next */
    _onPan(event) {
        const windowHeight = window.innerHeight;
        const percentage = Number((((this._actionSheetHeight - event.deltaY) / windowHeight) * 100).toFixed());
        this._heightPercentage = percentage > 100 ? 100 : percentage;
        this._setOverlayHeight(`${this._heightPercentage}%`);
    }
    /* istanbul ignore next */
    _onPanEnd() {
        if (this._heightPercentage <= 15) {
            this._actionSheetHeight =
                this._heightPercentage < 0 ? 0 : this._getCurrentActionSheetSize(this._heightPercentage);
            this._cdRef.detectChanges();
            this.close();
            return;
        }
        if (this._heightPercentage > 70) {
            this._actionSheetHeight = window.innerHeight;
            this._expanded = true;
            this._setOverlayHeight('100%');
            return;
        }
        this._setOverlayHeight(`${this._initialPercentage}%`);
        this._actionSheetHeight = this._getCurrentActionSheetSize(this._initialPercentage);
        this._expanded = false;
    }
    _setOverlayHeight(height) {
        this._renderer.setStyle(this.overlayElement, 'height', height);
    }
    _startHammerAndFocus() {
        this._cdRef.detectChanges();
        this._createHammerInstance();
        toggleMobileFocusTrap({});
        if (platform.os === 'IOS') {
            setVoiceOverFocus(this.toggleButtonRef.nativeElement);
            return;
        }
        this.toggleButtonRef.nativeElement.focus();
    }
    _validateInitialHeight() {
        const windowHeight = window.innerHeight;
        const percentage = Number((this._actionSheetHeight / windowHeight) * 100);
        const maxHeightPercentage = 60;
        if (percentage > maxHeightPercentage) {
            this._actionSheetHeight = this._getCurrentActionSheetSize(maxHeightPercentage);
            this._initialPercentage = maxHeightPercentage;
            this._setOverlayHeight(`${maxHeightPercentage}%`);
            return;
        }
        this._initialPercentage = percentage;
        this._setOverlayHeight(`${this._initialPercentage}%`);
    }
    attach() {
        const positionStrategy = this._overlay.position().global().centerHorizontally().bottom();
        this.cdkConnectedOverlay.overlayRef.updatePositionStrategy(positionStrategy);
        this._actionSheetHeight = this.overlayElement.offsetHeight;
        this._expanded = false;
        this.dragIndicatorLabel = CONTRACTED_DRAG_INDICATOR_LABEL;
        this._validateInitialHeight();
        this._startHammerAndFocus();
    }
    close() {
        this.open = false;
        this.openChange.emit(this.open);
    }
    toggleState() {
        this._expanded = !this._expanded;
        if (this._expanded) {
            this.dragIndicatorLabel = EXPANDED_DRAG_INDICATOR_LABEL;
            this._actionSheetHeight = window.innerHeight;
            this._setOverlayHeight('100%');
            return;
        }
        this.dragIndicatorLabel = CONTRACTED_DRAG_INDICATOR_LABEL;
        this._actionSheetHeight = this._getCurrentActionSheetSize(this._initialPercentage);
        this._setOverlayHeight(`${this._initialPercentage}%`);
    }
}
VoxelActionSheetComponent.ɵfac = function VoxelActionSheetComponent_Factory(t) { return new (t || VoxelActionSheetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
VoxelActionSheetComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelActionSheetComponent, selectors: [["voxel-action-sheet"]], contentQueries: function VoxelActionSheetComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelActionSheetFooterDirective, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footer = _t.first);
    } }, viewQuery: function VoxelActionSheetComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(CdkConnectedOverlay, 7);
        ɵngcc0.ɵɵviewQuery(_c6, 5);
        ɵngcc0.ɵɵviewQuery(_c7, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.cdkConnectedOverlay = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.draggableAreaRef = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.toggleButtonRef = _t.first);
    } }, hostVars: 2, hostBindings: function VoxelActionSheetComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.hostClass)("aria-labelledby", ctx.hostAriaLabelledby);
    } }, inputs: { closeLabel: "closeLabel", open: "open", origin: "origin", class: "class", ariaLabelledby: ["aria-labelledby", "ariaLabelledby"] }, outputs: { openChange: "openChange", opened: "opened", closed: "closed" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c11, decls: 1, vars: 4, consts: [["cdkConnectedOverlay", "", "cdkConnectedOverlayHasBackdrop", "", "cdkConnectedOverlayBackdropClass", "voxel-action-sheet-backdrop", 3, "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayScrollStrategy", "attach"], ["role", "dialog", 1, "voxel-action-sheet__content"], [1, "voxel-action-sheet__draggable-area"], ["draggableArea", ""], [1, "voxel-action-sheet__toggle-indicator", 3, "click"], ["toggleButton", ""], [1, "voxel-action-sheet__header"], [1, "voxel-action-sheet__close-button", 3, "click"], [1, "voxel-action-sheet__body"]], template: function VoxelActionSheetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c10);
        ɵngcc0.ɵɵtemplate(0, VoxelActionSheetComponent_ng_template_0_Template, 13, 11, "ng-template", 0);
        ɵngcc0.ɵɵlistener("attach", function VoxelActionSheetComponent_Template_ng_template_attach_0_listener() { return ctx.attach(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayOrigin", ctx.origin)("cdkConnectedOverlayOpen", ctx.open)("cdkConnectedOverlayPanelClass", ctx.classes)("cdkConnectedOverlayScrollStrategy", ctx.scrollStrategy);
    } }, directives: [ɵngcc2.CdkConnectedOverlay, VoxelIconComponent], styles: [".voxel-action-sheet{-webkit-transition:height .1s ease-out;transition:height .1s ease-out;width:100%}.voxel-action-sheet-backdrop{background-color:var(--ids_color_contrast_onLight_medium)}.voxel-action-sheet__content{background-color:var(--ids_color_bg_base);border-radius:var(--ids_size_general_16x) var(--ids_size_general_16x) 0 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}.voxel-action-sheet__toggle-indicator{background-color:var(--ids_color_action_disabled_base);border:none;border-radius:var(--ids_size_general_16x);cursor:pointer;display:block;height:var(--ids_size_general_5x);margin:var(--ids_size_general_8x) auto var(--ids_size_general_12x);width:var(--ids_size_general_44x)}.voxel-action-sheet__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 var(--ids_size_general_8x) var(--ids_size_general_12x) var(--ids_size_general_24x)}.voxel-action-sheet__presentation{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;font:var(--ids_textStyle_overline);-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-action-sheet__presentation>*{font:var(--ids_textStyle_overline)}.voxel-action-sheet__close-button,.voxel-action-sheet__presentation>button{background-color:transparent;border:none;cursor:pointer;padding:var(--ids_size_general_12x)}.voxel-action-sheet__footer{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_16x);gap:var(--ids_size_general_16x);padding:var(--ids_size_general_24x)}.voxel-action-sheet__body{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow-y:auto;padding:0 var(--ids_size_general_24x)}.voxel-action-sheet__body:last-child{padding-bottom:var(--ids_size_general_24x)}.voxel-action-sheet__body--suspended-footer:after{content:\"\";display:block;height:var(--ids_size_general_96x)}.voxel-action-sheet__body--suspended-footer+.voxel-action-sheet__footer{background-color:var(--ids_color_bg_base);bottom:0;outline:var(--ids_size_border_small) solid var(--ids_color_action_disabled_base);position:fixed;width:100%}\n"], encapsulation: 2, data: { animation: [
            trigger('inOut', [
                transition(':enter', [
                    style({ transform: 'translateY(100%)' }),
                    animate('200ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'),
                ]),
                transition(':leave', [
                    style({ height: '{{initialHeight}}px' }),
                    animate('150ms ease-out', style({ transform: 'translateY(100%)' })),
                ]),
            ]),
        ] } });
VoxelActionSheetComponent.ctorParameters = () => [
    { type: Overlay },
    { type: Renderer2 },
    { type: ChangeDetectorRef },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
VoxelActionSheetComponent.propDecorators = {
    origin: [{ type: Input }],
    open: [{ type: Input }],
    class: [{ type: Input }],
    ariaLabelledby: [{ type: Input, args: ['aria-labelledby',] }],
    closeLabel: [{ type: Input }],
    openChange: [{ type: Output }],
    opened: [{ type: Output }],
    closed: [{ type: Output }],
    hostClass: [{ type: HostBinding, args: ['attr.class',] }],
    hostAriaLabelledby: [{ type: HostBinding, args: ['attr.aria-labelledby',] }],
    cdkConnectedOverlay: [{ type: ViewChild, args: [CdkConnectedOverlay, { static: true },] }],
    draggableAreaRef: [{ type: ViewChild, args: ['draggableArea',] }],
    toggleButtonRef: [{ type: ViewChild, args: ['toggleButton',] }],
    footer: [{ type: ContentChild, args: [VoxelActionSheetFooterDirective,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelActionSheetComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-action-sheet',
                template: "<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"voxel-action-sheet-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"open\"\n  [cdkConnectedOverlayPanelClass]=\"classes\"\n  [cdkConnectedOverlayScrollStrategy]=\"scrollStrategy\"\n  (attach)=\"attach()\"\n>\n  <section\n    class=\"voxel-action-sheet__content\"\n    role=\"dialog\"\n    [attr.aria-labelledby]=\"ariaLabelledby\"\n    [@inOut]=\"{ value: true, params: { initialHeight: actionSheetHeight }}\"\n  >\n    <div class=\"voxel-action-sheet__draggable-area\" #draggableArea>\n      <button\n        #toggleButton\n        [attr.aria-label]=\"dragIndicatorLabel\"\n        [attr.aria-live]=\"platform.os === 'IOS' ? null : 'polite'\"\n        class=\"voxel-action-sheet__toggle-indicator\"\n        (click)=\"toggleState()\"\n      ></button>\n\n      <header class=\"voxel-action-sheet__header\">\n        <ng-content select=\"[voxelActionSheetPresentation]\"></ng-content>\n        <button\n          class=\"voxel-action-sheet__close-button\"\n          [attr.aria-label]=\"closeLabel\"\n          (click)=\"close()\"\n        >\n          <voxel-icon>fechar</voxel-icon>\n        </button>\n      </header>\n    </div>\n\n    <div\n      class=\"voxel-action-sheet__body\"\n      [class.voxel-action-sheet__body--suspended-footer]=\"footer?.voxelActionSheetFooter === 'suspended'\"\n    >\n      <ng-content></ng-content>\n    </div>\n\n    <ng-content select=\"[voxelActionSheetFooter]\"></ng-content>\n  </section>\n</ng-template>\n",
                animations: [
                    trigger('inOut', [
                        transition(':enter', [
                            style({ transform: 'translateY(100%)' }),
                            animate('200ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'),
                        ]),
                        transition(':leave', [
                            style({ height: '{{initialHeight}}px' }),
                            animate('150ms ease-out', style({ transform: 'translateY(100%)' })),
                        ]),
                    ]),
                ],
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-action-sheet{-webkit-transition:height .1s ease-out;transition:height .1s ease-out;width:100%}.voxel-action-sheet-backdrop{background-color:var(--ids_color_contrast_onLight_medium)}.voxel-action-sheet__content{background-color:var(--ids_color_bg_base);border-radius:var(--ids_size_general_16x) var(--ids_size_general_16x) 0 0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}.voxel-action-sheet__toggle-indicator{background-color:var(--ids_color_action_disabled_base);border:none;border-radius:var(--ids_size_general_16x);cursor:pointer;display:block;height:var(--ids_size_general_5x);margin:var(--ids_size_general_8x) auto var(--ids_size_general_12x);width:var(--ids_size_general_44x)}.voxel-action-sheet__header{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:0 var(--ids_size_general_8x) var(--ids_size_general_12x) var(--ids_size_general_24x)}.voxel-action-sheet__presentation{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;font:var(--ids_textStyle_overline);-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-action-sheet__presentation>*{font:var(--ids_textStyle_overline)}.voxel-action-sheet__close-button,.voxel-action-sheet__presentation>button{background-color:transparent;border:none;cursor:pointer;padding:var(--ids_size_general_12x)}.voxel-action-sheet__footer{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_16x);gap:var(--ids_size_general_16x);padding:var(--ids_size_general_24x)}.voxel-action-sheet__body{-webkit-box-flex:1;-ms-flex:1;flex:1;overflow-y:auto;padding:0 var(--ids_size_general_24x)}.voxel-action-sheet__body:last-child{padding-bottom:var(--ids_size_general_24x)}.voxel-action-sheet__body--suspended-footer:after{content:\"\";display:block;height:var(--ids_size_general_96x)}.voxel-action-sheet__body--suspended-footer+.voxel-action-sheet__footer{background-color:var(--ids_color_bg_base);bottom:0;outline:var(--ids_size_border_small) solid var(--ids_color_action_disabled_base);position:fixed;width:100%}\n"]
            }]
    }], function () { return [{ type: ɵngcc2.Overlay }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { closeLabel: [{
            type: Input
        }], openChange: [{
            type: Output
        }], opened: [{
            type: Output
        }], closed: [{
            type: Output
        }], hostClass: [{
            type: HostBinding,
            args: ['attr.class']
        }], hostAriaLabelledby: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], open: [{
            type: Input
        }], origin: [{
            type: Input
        }], class: [{
            type: Input
        }], ariaLabelledby: [{
            type: Input,
            args: ['aria-labelledby']
        }], cdkConnectedOverlay: [{
            type: ViewChild,
            args: [CdkConnectedOverlay, { static: true }]
        }], draggableAreaRef: [{
            type: ViewChild,
            args: ['draggableArea']
        }], toggleButtonRef: [{
            type: ViewChild,
            args: ['toggleButton']
        }], footer: [{
            type: ContentChild,
            args: [VoxelActionSheetFooterDirective]
        }] }); })();

class VoxelActionSheetModule {
}
VoxelActionSheetModule.ɵfac = function VoxelActionSheetModule_Factory(t) { return new (t || VoxelActionSheetModule)(); };
VoxelActionSheetModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelActionSheetModule });
VoxelActionSheetModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[OverlayModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelActionSheetModule, [{
        type: NgModule,
        args: [{
                imports: [OverlayModule, VoxelIconModule],
                declarations: [
                    VoxelActionSheetComponent,
                    VoxelActionSheetFooterDirective,
                    VoxelActionSheetPresentationDirective,
                    VoxelOverlayOriginDirective,
                ],
                exports: [
                    VoxelActionSheetComponent,
                    VoxelActionSheetFooterDirective,
                    VoxelActionSheetPresentationDirective,
                    VoxelOverlayOriginDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelActionSheetModule, { declarations: function () { return [VoxelActionSheetComponent, VoxelActionSheetFooterDirective, VoxelActionSheetPresentationDirective, VoxelOverlayOriginDirective]; }, imports: function () { return [OverlayModule, VoxelIconModule]; }, exports: function () { return [VoxelActionSheetComponent, VoxelActionSheetFooterDirective, VoxelActionSheetPresentationDirective, VoxelOverlayOriginDirective]; } }); })();

/**
 * Componente de avatar, utilizado para representar perfis usuário e/ou contatos.
 * Pode ser utilizado dentro de outro componente ou avulso no layout.
 *
 * *Avatar component, used to represent profiles and/or contacts.*
 * *It can be used inside another component or in its own in the layout.*
 *
 * **Module:**
 *
 * `import { VoxelAvatarModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/#/portfolio/avatar?componentOnly=true</example-url>
 *
 * @example Com ícone e invísivel para leitores de tela
 * <voxel-avatar></voxel-avatar>
 *
 * @example Invisível para leitores de tela e texto
 * <voxel-avatar
 *   text="Alberto Antunes"
 * >
 * </voxel-avatar>
 *
 * @example Com alteração de tamanho, foto e visível para leitores de tela
 * <voxel-avatar
 *   size="L"
 *   a11yHidden="false"
 *   photoPath="assets/minha-foto.jpg"
 *   photoAlt="texto alternativo da minha imagem"
 * >
 * </voxel-avatar>
 */
class VoxelAvatarComponent {
    constructor() {
        /**
         * @internal
         */
        this._a11yHidden = true;
        /**
         * Nome do ícone
         *
         * *Icon name*
         */
        this.icon = 'usuario_outline';
    }
    set round(a11yHidden) {
        this._round = enforceBoolean(a11yHidden);
    }
    get round() {
        return this._round;
    }
    /**
     * Seleciona o modo marca
     *
     * *sets up brand avatar mode*
     */
    set brand(brand) {
        this._brand = brand;
        this.photoPath = this._brand;
        this.icon = 'empresas_outline';
    }
    get brand() {
        return this._brand;
    }
    /**
     * Oculta o componente para os leitores de tela
     *
     * *Hide the component from screen readers*
     */
    set a11yHidden(a11yHidden) {
        this._a11yHidden = enforceBoolean(a11yHidden);
    }
    get a11yHidden() {
        return this._a11yHidden;
    }
    /**
     * Habilita o modo dark
     *
     * *Enables dark mode*
     */
    set dark(dark) {
        this._dark = enforceBoolean(dark);
    }
    get dark() {
        return this._dark;
    }
}
VoxelAvatarComponent.ɵfac = function VoxelAvatarComponent_Factory(t) { return new (t || VoxelAvatarComponent)(); };
VoxelAvatarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelAvatarComponent, selectors: [["voxel-avatar"]], inputs: { icon: "icon", round: "round", brand: "brand", photoPath: "photoPath", a11yHidden: "a11yHidden", dark: "dark", size: "size", text: "text", photoAlt: "photoAlt", a11yLabel: "a11yLabel" }, decls: 8, vars: 16, consts: [[1, "voxel-avatar"], [3, "ngTemplateOutlet"], ["iconTemplate", ""], ["textTemplate", ""], ["photoTemplate", ""], [1, "voxel-avatar__icon"], [1, "voxel-avatar__text"], [4, "ngFor", "ngForOf"], [4, "ngIf"], [1, "voxel-avatar__photo", 3, "src"]], template: function VoxelAvatarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementContainer(1, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(2, VoxelAvatarComponent_ng_template_2_Template, 2, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, VoxelAvatarComponent_ng_template_4_Template, 2, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(6, VoxelAvatarComponent_ng_template_6_Template, 1, 2, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(3);
        const _r2 = ɵngcc0.ɵɵreference(5);
        const _r4 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵclassProp("voxel-avatar--size-small", ctx.size === "S")("voxel-avatar--size-large", ctx.size === "L")("voxel-avatar--size-huge", ctx.size === "H")("voxel-avatar--on-dark", ctx.dark)("voxel-avatar--brand", ctx.brand)("voxel-avatar--round", ctx.round);
        ɵngcc0.ɵɵattribute("role", !ctx.photoPath ? "img" : null)("aria-hidden", ctx.a11yHidden)("aria-label", ctx.a11yLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.text ? _r2 : ctx.photoPath ? _r4 : _r0);
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf, ɵngcc1.NgIf], styles: [".voxel-avatar[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_text_body_01);border:var(--ids_size_border_small) solid var(--ids_color_contrast_onLight);border-radius:50%;color:var(--ids_color_contrast_onDark);display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_32x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1;overflow:hidden;text-align:center;width:var(--ids_size_general_32x)}.voxel-avatar--brand[_ngcontent-%COMP%]{background:none;border:none;border-radius:0}.voxel-avatar--round[_ngcontent-%COMP%]{border-radius:50%}.voxel-avatar--on-dark[_ngcontent-%COMP%]{background-color:var(--ids_color_contrast_onDark);border-color:#fff;color:var(--ids_color_text_body_01)}.voxel-avatar__icon[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_small)}.voxel-avatar__text[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_small_regular)}.voxel-avatar__photo[_ngcontent-%COMP%]{height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.voxel-avatar--size-small[_ngcontent-%COMP%]{height:var(--ids_size_general_24x);width:var(--ids_size_general_24x)}.voxel-avatar--size-small[_ngcontent-%COMP%]   .voxel-avatar__icon[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_small)}.voxel-avatar--size-small[_ngcontent-%COMP%]   .voxel-avatar__text[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_xsmall_regular)}.voxel-avatar--size-large[_ngcontent-%COMP%]{height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.voxel-avatar--size-large[_ngcontent-%COMP%]   .voxel-avatar__icon[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_medium)}.voxel-avatar--size-large[_ngcontent-%COMP%]   .voxel-avatar__text[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_large_regular)}.voxel-avatar--size-huge[_ngcontent-%COMP%]{height:var(--ids_size_general_64x);width:var(--ids_size_general_64x)}.voxel-avatar--size-huge[_ngcontent-%COMP%]   .voxel-avatar__icon[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_large)}.voxel-avatar--size-huge[_ngcontent-%COMP%]   .voxel-avatar__text[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_xlarge_regular)}"] });
VoxelAvatarComponent.propDecorators = {
    size: [{ type: Input }],
    icon: [{ type: Input }],
    text: [{ type: Input }],
    photoPath: [{ type: Input }],
    photoAlt: [{ type: Input }],
    round: [{ type: Input }],
    brand: [{ type: Input }],
    a11yHidden: [{ type: Input }],
    a11yLabel: [{ type: Input }],
    dark: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAvatarComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-avatar',
                template: "<div\n  class=\"voxel-avatar\"\n  [class.voxel-avatar--size-small]=\"size === 'S'\"\n  [class.voxel-avatar--size-large]=\"size === 'L'\"\n  [class.voxel-avatar--size-huge]=\"size === 'H'\"\n  [class.voxel-avatar--on-dark]=\"dark\"\n  [class.voxel-avatar--brand]=\"brand\"\n  [class.voxel-avatar--round]=\"round\"\n  [attr.role]=\"!photoPath ? 'img' : null\"\n  [attr.aria-hidden]=\"a11yHidden\"\n  [attr.aria-label]=\"a11yLabel\"\n>\n  <ng-container\n    [ngTemplateOutlet]=\"text ? textTemplate : photoPath ? photoTemplate : iconTemplate\"\n  ></ng-container>\n</div>\n\n<ng-template #iconTemplate>\n  <span class=\"voxel-avatar__icon\">\n    {{ icon }}\n  </span>\n</ng-template>\n\n<ng-template #textTemplate>\n  <span class=\"voxel-avatar__text\">\n    <ng-container *ngFor=\"let word of text.split(' '); first as first; last as last\">\n      <span *ngIf=\"first || last\">{{ word.slice(0, 1) }}</span>\n    </ng-container>\n  </span>\n</ng-template>\n\n<ng-template #photoTemplate>\n  <img\n    class=\"voxel-avatar__photo\"\n    [src]=\"photoPath\"\n    [attr.alt]=\"photoAlt\"\n  >\n</ng-template>\n",
                styles: [".voxel-avatar{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_text_body_01);border:var(--ids_size_border_small) solid var(--ids_color_contrast_onLight);border-radius:50%;color:var(--ids_color_contrast_onDark);display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_32x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;line-height:1;overflow:hidden;text-align:center;width:var(--ids_size_general_32x)}.voxel-avatar--brand{background:none;border:none;border-radius:0}.voxel-avatar--round{border-radius:50%}.voxel-avatar--on-dark{background-color:var(--ids_color_contrast_onDark);border-color:#fff;color:var(--ids_color_text_body_01)}.voxel-avatar__icon{font:var(--ids_textStyle_icon_small)}.voxel-avatar__text{font:var(--ids_textStyle_label_small_regular)}.voxel-avatar__photo{height:100%;-o-object-fit:cover;object-fit:cover;width:100%}.voxel-avatar--size-small{height:var(--ids_size_general_24x);width:var(--ids_size_general_24x)}.voxel-avatar--size-small .voxel-avatar__icon{font:var(--ids_textStyle_icon_small)}.voxel-avatar--size-small .voxel-avatar__text{font:var(--ids_textStyle_label_xsmall_regular)}.voxel-avatar--size-large{height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.voxel-avatar--size-large .voxel-avatar__icon{font:var(--ids_textStyle_icon_medium)}.voxel-avatar--size-large .voxel-avatar__text{font:var(--ids_textStyle_label_large_regular)}.voxel-avatar--size-huge{height:var(--ids_size_general_64x);width:var(--ids_size_general_64x)}.voxel-avatar--size-huge .voxel-avatar__icon{font:var(--ids_textStyle_icon_large)}.voxel-avatar--size-huge .voxel-avatar__text{font:var(--ids_textStyle_label_xlarge_regular)}\n"]
            }]
    }], function () { return []; }, { icon: [{
            type: Input
        }], round: [{
            type: Input
        }], brand: [{
            type: Input
        }], photoPath: [{
            type: Input
        }], a11yHidden: [{
            type: Input
        }], dark: [{
            type: Input
        }], size: [{
            type: Input
        }], text: [{
            type: Input
        }], photoAlt: [{
            type: Input
        }], a11yLabel: [{
            type: Input
        }] }); })();

class VoxelAvatarModule {
}
VoxelAvatarModule.ɵfac = function VoxelAvatarModule_Factory(t) { return new (t || VoxelAvatarModule)(); };
VoxelAvatarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelAvatarModule });
VoxelAvatarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelAvatarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelAvatarComponent],
                exports: [VoxelAvatarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelAvatarModule, { declarations: function () { return [VoxelAvatarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelAvatarComponent]; } }); })();

/**
 * Os botões permitem que o usuário realize ações e façam escolhas com um único toque.
 *
 * *Buttons allow the user to perform actions and make choices with a single tap.*
 *
 * **Module:**
 *
 * `import { VoxelButtonModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/button?componentOnly=true</example-url>
 *
 */
class VoxelButtonComponent {
    constructor(_elementRef, la) {
        this._elementRef = _elementRef;
        this.la = la;
        this._voxelButtonContextual = false;
        this._voxelButtonAction = false;
        this._voxelButtonMenu = false;
        this._justIcon = false;
        this._loading = false;
        this._full = false;
        this._fullWithIcon = false;
        /**
         * Informa o tom de fundo em que o botão será posicionado. Padrão: branco
         *
         * *Informs the background tone in which the button will be positioned. Default: white*
         */
        this.contrast = '';
        /**
         * Define a variante. Padrão: primária.
         *
         * *Define the variant. Default: primary*
         */
        this.variant = '';
        /**
         * Define o tamanho. Padrão: médio.
         *
         * *Define the size. Default: medium*
         */
        this.size = '';
    }
    /**
     * Define se o botão é contextual
     *
     * *Defines whether the button is contextual*
     */
    set voxelButtonContextual(value) {
        this._voxelButtonContextual = enforceBoolean(value);
    }
    /**
     * Define se o botão é de ação
     *
     * *Defines whether the button is action*
     */
    set voxelButtonAction(value) {
        this._voxelButtonAction = enforceBoolean(value);
    }
    /**
     * Define se o botão é de menu
     *
     * *Defines whether the button is menu*
     */
    set voxelButtonMenu(value) {
        this._voxelButtonMenu = enforceBoolean(value);
    }
    /**
     * Define se o botão é full
     *
     * *Defines whether the button is full*
     */
    set full(value) {
        this._full = enforceBoolean(value);
    }
    /**
     * Define se é um botão de load
     *
     * *Set whether it's a load button*
     */
    set loading(value) {
        if (value !== this._loading && !value) {
            this.la.announce(this._elementRef.nativeElement.textContent.trim(), 1000);
        }
        this._loading = enforceBoolean(value);
        // Primary light e dark
        if (this.variant === '' && (this.contrast === 'dark' || this.contrast === 'light')) {
            return;
        }
        // Secondary light
        if (this.variant === 'secondary' && this.contrast === 'light') {
            this.loadingCircleType = 'light';
            return;
        }
        // Primary e secondary dark
        if ((this.variant === '' && this.contrast === '') ||
            (this.variant === 'secondary' && this.contrast === 'dark')) {
            this.loadingCircleType = 'dark';
            return;
        }
        // Secondary
        if (this.variant === 'secondary') {
            this.loadingCircleType = 'secondary';
            return;
        }
    }
    get loading() {
        return this._loading;
    }
    get ariaLabelValue() {
        var _a;
        return this._loading ? 'carregando' : (_a = this.ariaLabel) !== null && _a !== void 0 ? _a : null;
    }
    /** @internal */
    get cssClasses() {
        const sizes = {
            large: 'voxel-button--large',
            small: 'voxel-button--small',
            '': '',
        };
        const contrasts = {
            light: 'voxel-button--on-light',
            dark: 'voxel-button--on-dark',
            '': '',
        };
        const variants = {
            neutral: 'voxel-button--neutral',
            secondary: 'voxel-button--secondary',
            '': '',
        };
        let type = this._voxelButtonAction ? 'voxel-button--action' : '';
        type = this._voxelButtonMenu ? 'voxel-button--menu' : type;
        type = this._voxelButtonContextual ? 'voxel-button--contextual' : type;
        const loading = this._loading ? 'voxel-button--loading' : '';
        const justIcon = this._justIcon ? 'voxel-button--icon' : '';
        type = this._full ? 'voxel-button--full' : type;
        const fullWithIcon = this._full && this._fullWithIcon ? 'voxel-button--full-icon' : '';
        return `voxel-button ${type} ${sizes[this.size]} ${contrasts[this.contrast]} ${variants[this.variant]} ${loading} ${justIcon} ${fullWithIcon} `;
    }
    ngAfterViewInit() {
        const nativeElement = this.wrapperRef.nativeElement;
        Promise.resolve().then(() => {
            this._justIcon =
                nativeElement.childNodes.length <= 1 &&
                    nativeElement.childNodes[0].nodeName.toLowerCase() === 'voxel-icon';
            this._fullWithIcon = Boolean(nativeElement.childNodes.length > 1 &&
                Array.from(nativeElement.childNodes).find((node) => node.nodeName.toLowerCase().includes('voxel-icon')));
        });
    }
}
VoxelButtonComponent.ɵfac = function VoxelButtonComponent_Factory(t) { return new (t || VoxelButtonComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.LiveAnnouncer)); };
VoxelButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelButtonComponent, selectors: [["a", "voxelButton", ""], ["a", "voxelButtonAction", ""], ["a", "voxelButtonMenu", ""], ["a", "voxelButtonContextual", ""], ["button", "voxelButton", ""], ["button", "voxelButtonAction", ""], ["button", "voxelButtonMenu", ""], ["button", "voxelButtonContextual", ""]], viewQuery: function VoxelButtonComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c12, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.wrapperRef = _t.first);
    } }, hostVars: 3, hostBindings: function VoxelButtonComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabelValue);
        ɵngcc0.ɵɵclassMap(ctx.cssClasses);
    } }, inputs: { contrast: "contrast", variant: "variant", size: "size", voxelButtonContextual: "voxelButtonContextual", voxelButtonAction: "voxelButtonAction", voxelButtonMenu: "voxelButtonMenu", full: "full", loading: "loading", ariaLabel: ["aria-label", "ariaLabel"] }, attrs: _c13, ngContentSelectors: _c1, decls: 4, vars: 2, consts: [[1, "voxel-button__wrapper"], ["wrapper", ""], ["class", "voxel-button__loader", "aria-hidden", "true", 4, "ngIf"], ["aria-hidden", "true", 1, "voxel-button__loader"], ["size", "S", 3, "type"]], template: function VoxelButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0, 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, VoxelButtonComponent_div_3_Template, 2, 1, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-live", !ctx.loading ? null : "polite");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loading);
    } }, directives: function () { return [ɵngcc1.NgIf, VoxelLoadingCircleComponent]; }, styles: [".voxel-button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:var(--ids_color_action_primary_base);border-color:var(--ids_color_action_primary_variant);border-radius:var(--ids_size_cornerRadius_button);border-style:solid;border-width:var(--ids_size_border_small);color:var(--ids_color_contrast_onDark);cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font:var(--ids_textStyle_body_01_regular);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:var(--ids_size_general_48x);padding:var(--ids_size_general_7x) var(--ids_size_general_24x);text-decoration:none}.voxel-button:disabled,.voxel-button[aria-disabled=true]{border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.voxel-button:disabled:not(.voxel-button--secondary,.voxel-button--action,.voxel-button--contextual),.voxel-button[aria-disabled=true]:not(.voxel-button--secondary,.voxel-button--action,.voxel-button--contextual){background-color:var(--ids_color_action_disabled_base)}.voxel-button:hover:not(:disabled,.voxel-button--action,[aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}.voxel-button .voxel-icon{color:currentColor;font-size:inherit;line-height:inherit}.voxel-button__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_8x);gap:var(--ids_size_general_8x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-button--full-icon .voxel-button__wrapper{-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-button__loader{position:absolute}.voxel-button--loading .voxel-button__wrapper{visibility:hidden}.voxel-button--icon{min-width:var(--ids_size_general_48x);padding:var(--ids_size_general_7x) var(--ids_size_general_8x)}.voxel-button--on-dark,.voxel-button--on-light{border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_action_primary_base)}.voxel-button--on-dark:not(.voxel-button--menu,.voxel-button--action,.voxel-button--secondary,.voxel-button--contextual),.voxel-button--on-light:not(.voxel-button--menu,.voxel-button--action,.voxel-button--secondary,.voxel-button--contextual){background-color:var(--ids_color_contrast_onDark)}.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]),.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]){border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_action_primary_variant)}.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action,.voxel-button--neutral),.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action,.voxel-button--neutral){background-color:var(--ids_color_contrast_onDark_strong)}.voxel-button--action,.voxel-button--contextual,.voxel-button--menu.voxel-button--small{font:var(--ids_textStyle_body_02_regular)}.voxel-button--contextual{min-height:var(--ids_size_general_32x);padding:var(--ids_size_general_5x) var(--ids_size_general_16x)}.voxel-button--menu{border-radius:var(--ids_size_cornerRadius_card_01);padding:0;position:relative;text-align:left;width:100%}.voxel-button--menu:before{content:\"\";display:block;padding-bottom:100%}.voxel-button--menu .voxel-icon>span{font:var(--ids_textStyle_icon_large)}.voxel-button--menu .voxel-button__wrapper{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;left:0;padding:var(--ids_size_general_16x);position:absolute;top:0;width:100%}.voxel-button--menu.voxel-button--small .voxel-button__wrapper{padding:var(--ids_size_general_10x)}.voxel-button--menu.voxel-button--small .voxel-icon>span{font:var(--ids_textStyle_icon_medium)}.voxel-button--menu.voxel-button--large:before{padding-bottom:calc(50% - 1px)}.voxel-button--menu.voxel-button--secondary{background-color:var(--ids_color_action_secondary_base);border-color:var(--ids_color_action_secondary_variant)}.voxel-button--menu.voxel-button--secondary:hover{background-color:var(--ids_color_action_secondary_variant)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]){background-color:transparent;color:var(--ids_color_action_neutral_base)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]):not(.voxel-button--action){border-color:var(--ids_color_action_neutral_base)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]):hover{color:var(--ids_color_action_neutral_variant)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]):not(.voxel-button--action):hover{background-color:var(--ids_color_action_neutral_base_soft);border-color:var(--ids_color_action_neutral_variant)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]).voxel-button--on-dark{border-color:var(--ids_color_contrast_onDark)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]).voxel-button--on-light{border-color:var(--ids_color_contrast_onLight);color:var(--ids_color_contrast_onLight)}.voxel-button--menu.voxel-button--on-dark,.voxel-button--action,.voxel-button--contextual,.voxel-button--secondary:not(.voxel-button--menu){background-color:transparent}.voxel-button--contextual,.voxel-button--secondary:not(.voxel-button--menu){color:var(--ids_color_action_secondary_base)}.voxel-button--contextual:disabled,.voxel-button--contextual[aria-disabled=true],.voxel-button--secondary:not(.voxel-button--menu):disabled,.voxel-button--secondary:not(.voxel-button--menu)[aria-disabled=true]{color:var(--ids_color_action_disabled_variant)}.voxel-button--contextual:not(:disabled,[aria-disabled=true]),.voxel-button--secondary:not(.voxel-button--menu):not(:disabled,[aria-disabled=true]){border-color:currentColor}.voxel-button--contextual:hover:not(:disabled,[aria-disabled=true]),.voxel-button--secondary:not(.voxel-button--menu):hover:not(:disabled,[aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}.voxel-button--contextual:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action,.voxel-button--menu),.voxel-button--secondary:not(.voxel-button--menu):hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action,.voxel-button--menu){background-color:var(--ids_color_action_secondary_base_soft)}.voxel-button--secondary.voxel-button--on-light,.voxel-button--action.voxel-button--on-light,.voxel-button--contextual.voxel-button--on-light{color:var(--ids_color_contrast_onLight)}.voxel-button--secondary.voxel-button--on-light:disabled,.voxel-button--secondary.voxel-button--on-light[aria-disabled=true],.voxel-button--action.voxel-button--on-light:disabled,.voxel-button--action.voxel-button--on-light[aria-disabled=true],.voxel-button--contextual.voxel-button--on-light:disabled,.voxel-button--contextual.voxel-button--on-light[aria-disabled=true]{border-color:var(--ids_color_contrast_onLight_medium);color:var(--ids_color_contrast_onLight_medium)}.voxel-button--secondary.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]),.voxel-button--action.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]),.voxel-button--contextual.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]){border-color:currentColor;color:var(--ids_color_contrast_onLight)}.voxel-button--secondary.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--action.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--contextual.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action){background-color:var(--ids_color_contrast_onLight_soft)}.voxel-button--secondary.voxel-button--on-dark,.voxel-button--action.voxel-button--on-dark,.voxel-button--contextual.voxel-button--on-dark,.voxel-button--menu.voxel-button--on-dark{border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onDark)}.voxel-button--secondary.voxel-button--on-dark:disabled,.voxel-button--secondary.voxel-button--on-dark[aria-disabled=true],.voxel-button--action.voxel-button--on-dark:disabled,.voxel-button--action.voxel-button--on-dark[aria-disabled=true],.voxel-button--contextual.voxel-button--on-dark:disabled,.voxel-button--contextual.voxel-button--on-dark[aria-disabled=true],.voxel-button--menu.voxel-button--on-dark:disabled,.voxel-button--menu.voxel-button--on-dark[aria-disabled=true]{border-color:var(--ids_color_contrast_onDark_medium);color:var(--ids_color_contrast_onDark_medium)}.voxel-button--secondary.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]),.voxel-button--action.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]),.voxel-button--contextual.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]),.voxel-button--menu.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]){border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onDark)}.voxel-button--secondary.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--action.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--contextual.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--menu.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action){background-color:var(--ids_color_contrast_onDark_soft)}.voxel-button--action{border:0;color:var(--ids_color_action_primary_base)}.voxel-button--action.voxel-button--secondary:not(:disabled,[aria-disabled=true]){color:var(--ids_color_action_secondary_base)}.voxel-button--action:hover:not(:disabled,[aria-disabled=true]){font-weight:bold}.voxel-button--full{width:100%}@media (min-width: 768px){.voxel-button:not(.voxel-button--contextual,.voxel-button--action,.voxel-button--menu){font:var(--ids_textStyle_label_large_regular);font-weight:700}.voxel-button.voxel-button--action{font:var(--ids_textStyle_body_01_regular)}}\n"], encapsulation: 2 });
VoxelButtonComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: LiveAnnouncer }
];
VoxelButtonComponent.propDecorators = {
    voxelButtonContextual: [{ type: Input }],
    voxelButtonAction: [{ type: Input }],
    voxelButtonMenu: [{ type: Input }],
    full: [{ type: Input }],
    contrast: [{ type: Input }],
    variant: [{ type: Input }],
    size: [{ type: Input }],
    loading: [{ type: Input }],
    wrapperRef: [{ type: ViewChild, args: ['wrapper',] }],
    ariaLabel: [{ type: Input, args: ['aria-label',] }],
    ariaLabelValue: [{ type: HostBinding, args: ['attr.aria-label',] }],
    cssClasses: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelButtonComponent, [{
        type: Component,
        args: [{
                // eslint-disable-next-line @angular-eslint/component-selector
                selector: `
    a[voxelButton], a[voxelButtonAction], a[voxelButtonMenu], a[voxelButtonContextual],
    button[voxelButton], button[voxelButtonAction], button[voxelButtonMenu], button[voxelButtonContextual]
  `,
                template: "<span class=\"voxel-button__wrapper\" [attr.aria-live]=\"!loading ? null : 'polite'\" #wrapper>\n  <ng-content></ng-content>\n</span>\n\n<div class=\"voxel-button__loader\" *ngIf=\"loading\" aria-hidden=\"true\">\n  <voxel-loading-circle size=\"S\" [type]=\"loadingCircleType\"></voxel-loading-circle>\n</div>\n\n\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:var(--ids_color_action_primary_base);border-color:var(--ids_color_action_primary_variant);border-radius:var(--ids_size_cornerRadius_button);border-style:solid;border-width:var(--ids_size_border_small);color:var(--ids_color_contrast_onDark);cursor:pointer;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;font:var(--ids_textStyle_body_01_regular);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-height:var(--ids_size_general_48x);padding:var(--ids_size_general_7x) var(--ids_size_general_24x);text-decoration:none}.voxel-button:disabled,.voxel-button[aria-disabled=true]{border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.voxel-button:disabled:not(.voxel-button--secondary,.voxel-button--action,.voxel-button--contextual),.voxel-button[aria-disabled=true]:not(.voxel-button--secondary,.voxel-button--action,.voxel-button--contextual){background-color:var(--ids_color_action_disabled_base)}.voxel-button:hover:not(:disabled,.voxel-button--action,[aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}.voxel-button .voxel-icon{color:currentColor;font-size:inherit;line-height:inherit}.voxel-button__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_8x);gap:var(--ids_size_general_8x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-button--full-icon .voxel-button__wrapper{-webkit-box-flex:1;-ms-flex:1;flex:1;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-button__loader{position:absolute}.voxel-button--loading .voxel-button__wrapper{visibility:hidden}.voxel-button--icon{min-width:var(--ids_size_general_48x);padding:var(--ids_size_general_7x) var(--ids_size_general_8x)}.voxel-button--on-dark,.voxel-button--on-light{border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_action_primary_base)}.voxel-button--on-dark:not(.voxel-button--menu,.voxel-button--action,.voxel-button--secondary,.voxel-button--contextual),.voxel-button--on-light:not(.voxel-button--menu,.voxel-button--action,.voxel-button--secondary,.voxel-button--contextual){background-color:var(--ids_color_contrast_onDark)}.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]),.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]){border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_action_primary_variant)}.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action,.voxel-button--neutral),.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action,.voxel-button--neutral){background-color:var(--ids_color_contrast_onDark_strong)}.voxel-button--action,.voxel-button--contextual,.voxel-button--menu.voxel-button--small{font:var(--ids_textStyle_body_02_regular)}.voxel-button--contextual{min-height:var(--ids_size_general_32x);padding:var(--ids_size_general_5x) var(--ids_size_general_16x)}.voxel-button--menu{border-radius:var(--ids_size_cornerRadius_card_01);padding:0;position:relative;text-align:left;width:100%}.voxel-button--menu:before{content:\"\";display:block;padding-bottom:100%}.voxel-button--menu .voxel-icon>span{font:var(--ids_textStyle_icon_large)}.voxel-button--menu .voxel-button__wrapper{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;left:0;padding:var(--ids_size_general_16x);position:absolute;top:0;width:100%}.voxel-button--menu.voxel-button--small .voxel-button__wrapper{padding:var(--ids_size_general_10x)}.voxel-button--menu.voxel-button--small .voxel-icon>span{font:var(--ids_textStyle_icon_medium)}.voxel-button--menu.voxel-button--large:before{padding-bottom:calc(50% - 1px)}.voxel-button--menu.voxel-button--secondary{background-color:var(--ids_color_action_secondary_base);border-color:var(--ids_color_action_secondary_variant)}.voxel-button--menu.voxel-button--secondary:hover{background-color:var(--ids_color_action_secondary_variant)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]){background-color:transparent;color:var(--ids_color_action_neutral_base)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]):not(.voxel-button--action){border-color:var(--ids_color_action_neutral_base)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]):hover{color:var(--ids_color_action_neutral_variant)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]):not(.voxel-button--action):hover{background-color:var(--ids_color_action_neutral_base_soft);border-color:var(--ids_color_action_neutral_variant)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]).voxel-button--on-dark{border-color:var(--ids_color_contrast_onDark)}.voxel-button--neutral:not(:disabled,[aria-disabled=true]).voxel-button--on-light{border-color:var(--ids_color_contrast_onLight);color:var(--ids_color_contrast_onLight)}.voxel-button--menu.voxel-button--on-dark,.voxel-button--action,.voxel-button--contextual,.voxel-button--secondary:not(.voxel-button--menu){background-color:transparent}.voxel-button--contextual,.voxel-button--secondary:not(.voxel-button--menu){color:var(--ids_color_action_secondary_base)}.voxel-button--contextual:disabled,.voxel-button--contextual[aria-disabled=true],.voxel-button--secondary:not(.voxel-button--menu):disabled,.voxel-button--secondary:not(.voxel-button--menu)[aria-disabled=true]{color:var(--ids_color_action_disabled_variant)}.voxel-button--contextual:not(:disabled,[aria-disabled=true]),.voxel-button--secondary:not(.voxel-button--menu):not(:disabled,[aria-disabled=true]){border-color:currentColor}.voxel-button--contextual:hover:not(:disabled,[aria-disabled=true]),.voxel-button--secondary:not(.voxel-button--menu):hover:not(:disabled,[aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}.voxel-button--contextual:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action,.voxel-button--menu),.voxel-button--secondary:not(.voxel-button--menu):hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action,.voxel-button--menu){background-color:var(--ids_color_action_secondary_base_soft)}.voxel-button--secondary.voxel-button--on-light,.voxel-button--action.voxel-button--on-light,.voxel-button--contextual.voxel-button--on-light{color:var(--ids_color_contrast_onLight)}.voxel-button--secondary.voxel-button--on-light:disabled,.voxel-button--secondary.voxel-button--on-light[aria-disabled=true],.voxel-button--action.voxel-button--on-light:disabled,.voxel-button--action.voxel-button--on-light[aria-disabled=true],.voxel-button--contextual.voxel-button--on-light:disabled,.voxel-button--contextual.voxel-button--on-light[aria-disabled=true]{border-color:var(--ids_color_contrast_onLight_medium);color:var(--ids_color_contrast_onLight_medium)}.voxel-button--secondary.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]),.voxel-button--action.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]),.voxel-button--contextual.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]){border-color:currentColor;color:var(--ids_color_contrast_onLight)}.voxel-button--secondary.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--action.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--contextual.voxel-button--on-light:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action){background-color:var(--ids_color_contrast_onLight_soft)}.voxel-button--secondary.voxel-button--on-dark,.voxel-button--action.voxel-button--on-dark,.voxel-button--contextual.voxel-button--on-dark,.voxel-button--menu.voxel-button--on-dark{border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onDark)}.voxel-button--secondary.voxel-button--on-dark:disabled,.voxel-button--secondary.voxel-button--on-dark[aria-disabled=true],.voxel-button--action.voxel-button--on-dark:disabled,.voxel-button--action.voxel-button--on-dark[aria-disabled=true],.voxel-button--contextual.voxel-button--on-dark:disabled,.voxel-button--contextual.voxel-button--on-dark[aria-disabled=true],.voxel-button--menu.voxel-button--on-dark:disabled,.voxel-button--menu.voxel-button--on-dark[aria-disabled=true]{border-color:var(--ids_color_contrast_onDark_medium);color:var(--ids_color_contrast_onDark_medium)}.voxel-button--secondary.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]),.voxel-button--action.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]),.voxel-button--contextual.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]),.voxel-button--menu.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]){border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onDark)}.voxel-button--secondary.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--action.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--contextual.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action),.voxel-button--menu.voxel-button--on-dark:hover:not(:disabled,[aria-disabled=true]):not(.voxel-button--action){background-color:var(--ids_color_contrast_onDark_soft)}.voxel-button--action{border:0;color:var(--ids_color_action_primary_base)}.voxel-button--action.voxel-button--secondary:not(:disabled,[aria-disabled=true]){color:var(--ids_color_action_secondary_base)}.voxel-button--action:hover:not(:disabled,[aria-disabled=true]){font-weight:bold}.voxel-button--full{width:100%}@media (min-width: 768px){.voxel-button:not(.voxel-button--contextual,.voxel-button--action,.voxel-button--menu){font:var(--ids_textStyle_label_large_regular);font-weight:700}.voxel-button.voxel-button--action{font:var(--ids_textStyle_body_01_regular)}}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc3.LiveAnnouncer }]; }, { contrast: [{
            type: Input
        }], variant: [{
            type: Input
        }], size: [{
            type: Input
        }], voxelButtonContextual: [{
            type: Input
        }], voxelButtonAction: [{
            type: Input
        }], voxelButtonMenu: [{
            type: Input
        }], full: [{
            type: Input
        }], loading: [{
            type: Input
        }], ariaLabelValue: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], cssClasses: [{
            type: HostBinding,
            args: ['class']
        }], wrapperRef: [{
            type: ViewChild,
            args: ['wrapper']
        }], ariaLabel: [{
            type: Input,
            args: ['aria-label']
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$h = 0;
/**
 * O loading circular indica ao usuário o status de um processo que está sendo realizado,
 * exclusivo para o carregamento interno de uma sessão específica dentro da página.
 *
 * *The circular loading indicates to the user the status of a process that is being carried out,*
 * *exclusive for the internal loading of a specific session within the page.*
 *
 * **Module:**
 *
 * `import { VoxelLoadingCircleModule, VoxelIconModule } from '@voxel/components/ids';`
 */
class VoxelLoadingCircleComponent {
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        /* @internal */
        this._circleRadiusValues = {
            XS: 8,
            S: 12,
            L: 32,
            XL: 64,
        };
        /* @internal */
        this.circleRadius = 16;
        /* @internal */
        this.inOutAnimation = true;
        /**
         * Id do componente voxel-loading-circle
         *
         * *Voxel-loading-circle component id*
         */
        this.loadingCircleId = `voxel-loading-circle-${NEXT_ID$h++}`;
        /**
         * aria-hidden / esconde o elemento do leitor de telas.
         *
         * *aria-hidden / hides element from screen reader.*
         */
        this.a11yHidden = false;
        /**
         * aria-label / leitura acessível.
         *
         * *aria-label / accessible reading*
         */
        this.a11yLabel = 'carregando';
    }
    /**
     * Tamanho do loading.
     *
     * size = 'XS'
     *
     * size = 'S'
     *
     * size = 'L'
     *
     * size = 'XL'
     *
     * *Loading size*
     *
     * *size = 'XS'*
     * *size = 'S'*
     * *size = 'L'*
     * *size = 'XL'*
     */
    set size(value) {
        this._size = value;
        this.circleRadius = this._circleRadiusValues[value];
    }
    get size() {
        return this._size;
    }
    ngAfterViewInit() {
        if (this.a11yAriaLive) {
            this.liveAnnouncer.announce(this.a11yLabel, this.a11yAriaLive);
        }
    }
}
VoxelLoadingCircleComponent.ɵfac = function VoxelLoadingCircleComponent_Factory(t) { return new (t || VoxelLoadingCircleComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.LiveAnnouncer)); };
VoxelLoadingCircleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelLoadingCircleComponent, selectors: [["voxel-loading-circle"]], hostVars: 1, hostBindings: function VoxelLoadingCircleComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@inOut", ctx.inOutAnimation);
    } }, inputs: { loadingCircleId: "loadingCircleId", a11yHidden: "a11yHidden", a11yLabel: "a11yLabel", size: "size", a11yAriaLive: "a11yAriaLive", a11yRole: "a11yRole", type: "type" }, ngContentSelectors: _c15, decls: 8, vars: 20, consts: [[1, "voxel-loading-circle"], ["xmlns", "http://www.w3.org/2000/svg", "role", "img", 1, "voxel-loading-circle__svg"], ["cx", "50%", "cy", "50%", 1, "voxel-loading-circle__circle-ring"], ["cx", "50%", "cy", "50%", 1, "voxel-loading-circle__circle-spinner"], [1, "voxel-loading-circle__icon"]], template: function VoxelLoadingCircleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c14);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(1, "svg", 1);
        ɵngcc0.ɵɵelementStart(2, "title");
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "circle", 2);
        ɵngcc0.ɵɵelement(5, "circle", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵprojection(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-loading-circle--xsmall", ctx.size === "XS")("voxel-loading-circle--small", ctx.size === "S")("voxel-loading-circle--large", ctx.size === "L")("voxel-loading-circle--xlarge", ctx.size === "XL")("voxel-loading-circle--dark", ctx.type === "dark")("voxel-loading-circle--light", ctx.type === "light")("voxel-loading-circle--secondary", ctx.type === "secondary");
        ɵngcc0.ɵɵattribute("id", ctx.loadingCircleId)("aria-hidden", ctx.a11yHidden ? ctx.a11yHidden : null)("role", ctx.a11yRole);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.a11yLabel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("r", ctx.circleRadius);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("r", ctx.circleRadius);
    } }, styles: ["@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.voxel-loading-circle[_ngcontent-%COMP%]{display:inline-block;height:calc(var(--ids_size_general_32x) + (var(--ids_size_general_3x) * 2));position:relative;width:calc(var(--ids_size_general_32x) + (var(--ids_size_general_3x) * 2))}.voxel-loading-circle__svg[_ngcontent-%COMP%]{-webkit-animation:spin .8s linear infinite;animation:spin .8s linear infinite;height:calc(var(--ids_size_general_32x) + (var(--ids_size_general_3x) * 2));width:calc(var(--ids_size_general_32x) + (var(--ids_size_general_3x) * 2))}.voxel-loading-circle__circle-ring[_ngcontent-%COMP%]{fill:transparent;opacity:var(--ids_opacity_soft);stroke:var(--ids_color_action_primary_base);stroke-width:var(--ids_size_general_3x)}.voxel-loading-circle__circle-spinner[_ngcontent-%COMP%]{--spin-value: var(--ids_size_general_3x);fill:transparent;stroke:var(--ids_color_action_primary_base);stroke-dasharray:100.5309649149;stroke-dashoffset:75.3982236862;stroke-linecap:round;stroke-width:var(--ids_size_general_3x)}.voxel-loading-circle__icon[_ngcontent-%COMP%]{left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.voxel-loading-circle--xsmall[_ngcontent-%COMP%]{height:calc(var(--ids_size_general_16x) + (var(--ids_size_general_2x) * 2));width:calc(var(--ids_size_general_16x) + (var(--ids_size_general_2x) * 2))}.voxel-loading-circle--xsmall[_ngcontent-%COMP%]   .voxel-loading-circle__svg[_ngcontent-%COMP%]{height:calc(var(--ids_size_general_16x) + (var(--ids_size_general_2x) * 2));width:calc(var(--ids_size_general_16x) + (var(--ids_size_general_2x) * 2))}.voxel-loading-circle--xsmall[_ngcontent-%COMP%]   .voxel-loading-circle__circle-ring[_ngcontent-%COMP%]{stroke-width:var(--ids_size_general_2x)}.voxel-loading-circle--xsmall[_ngcontent-%COMP%]   .voxel-loading-circle__circle-spinner[_ngcontent-%COMP%]{--spin-value: var(--ids_size_general_2x);stroke-dasharray:50.2654824574;stroke-dashoffset:37.6991118431;stroke-width:var(--ids_size_general_2x)}.voxel-loading-circle--small[_ngcontent-%COMP%]{height:calc(var(--ids_size_general_24x) + (var(--ids_size_general_2x) * 2));width:calc(var(--ids_size_general_24x) + (var(--ids_size_general_2x) * 2))}.voxel-loading-circle--small[_ngcontent-%COMP%]   .voxel-loading-circle__svg[_ngcontent-%COMP%]{height:calc(var(--ids_size_general_24x) + (var(--ids_size_general_2x) * 2));width:calc(var(--ids_size_general_24x) + (var(--ids_size_general_2x) * 2))}.voxel-loading-circle--small[_ngcontent-%COMP%]   .voxel-loading-circle__circle-ring[_ngcontent-%COMP%]{stroke-width:var(--ids_size_general_2x)}.voxel-loading-circle--small[_ngcontent-%COMP%]   .voxel-loading-circle__circle-spinner[_ngcontent-%COMP%]{--spin-value: var(--ids_size_general_2x);stroke-dasharray:75.3982236862;stroke-dashoffset:56.5486677646;stroke-width:var(--ids_size_general_2x)}.voxel-loading-circle--large[_ngcontent-%COMP%]{height:calc(var(--ids_size_general_64x) + (var(--ids_size_general_4x) * 2));width:calc(var(--ids_size_general_64x) + (var(--ids_size_general_4x) * 2))}.voxel-loading-circle--large[_ngcontent-%COMP%]   .voxel-loading-circle__svg[_ngcontent-%COMP%]{height:calc(var(--ids_size_general_64x) + (var(--ids_size_general_4x) * 2));width:calc(var(--ids_size_general_64x) + (var(--ids_size_general_4x) * 2))}.voxel-loading-circle--large[_ngcontent-%COMP%]   .voxel-loading-circle__circle-ring[_ngcontent-%COMP%]{stroke-width:var(--ids_size_general_4x)}.voxel-loading-circle--large[_ngcontent-%COMP%]   .voxel-loading-circle__circle-spinner[_ngcontent-%COMP%]{--spin-value: var(--ids_size_general_4x);stroke-dasharray:201.0619298297;stroke-dashoffset:150.7964473723;stroke-width:var(--ids_size_general_4x)}.voxel-loading-circle--xlarge[_ngcontent-%COMP%]{height:calc(var(--ids_size_general_128x) + (var(--ids_size_general_5x) * 2));width:calc(var(--ids_size_general_128x) + (var(--ids_size_general_5x) * 2))}.voxel-loading-circle--xlarge[_ngcontent-%COMP%]   .voxel-loading-circle__svg[_ngcontent-%COMP%]{height:calc(var(--ids_size_general_128x) + (var(--ids_size_general_5x) * 2));width:calc(var(--ids_size_general_128x) + (var(--ids_size_general_5x) * 2))}.voxel-loading-circle--xlarge[_ngcontent-%COMP%]   .voxel-loading-circle__circle-ring[_ngcontent-%COMP%]{stroke-width:var(--ids_size_general_5x)}.voxel-loading-circle--xlarge[_ngcontent-%COMP%]   .voxel-loading-circle__circle-spinner[_ngcontent-%COMP%]{--spin-value: var(--ids_size_general_5x);stroke-dasharray:402.1238596595;stroke-dashoffset:301.5928947446;stroke-width:var(--ids_size_general_5x)}.voxel-loading-circle--dark[_ngcontent-%COMP%]   .voxel-loading-circle__circle-ring[_ngcontent-%COMP%], .voxel-loading-circle--dark[_ngcontent-%COMP%]   .voxel-loading-circle__circle-spinner[_ngcontent-%COMP%]{stroke:var(--ids_color_contrast_onDark)}.voxel-loading-circle--light[_ngcontent-%COMP%]   .voxel-loading-circle__circle-ring[_ngcontent-%COMP%], .voxel-loading-circle--light[_ngcontent-%COMP%]   .voxel-loading-circle__circle-spinner[_ngcontent-%COMP%]{stroke:var(--ids_color_contrast_onLight)}.voxel-loading-circle--secondary[_ngcontent-%COMP%]   .voxel-loading-circle__circle-ring[_ngcontent-%COMP%], .voxel-loading-circle--secondary[_ngcontent-%COMP%]   .voxel-loading-circle__circle-spinner[_ngcontent-%COMP%]{stroke:var(--ids_color_action_secondary_base)}"], data: { animation: [
            trigger('inOut', [
                transition(':enter', [
                    query('.voxel-loading-circle', [
                        style({ opacity: '0' }),
                        animate('200ms ease-in-out', style({ opacity: '1' })),
                    ]),
                ]),
                transition(':leave', [
                    query('.voxel-loading-circle', [animate('250ms ease-in-out', style({ opacity: '0' }))]),
                ]),
            ]),
        ] } });
VoxelLoadingCircleComponent.ctorParameters = () => [
    { type: LiveAnnouncer }
];
VoxelLoadingCircleComponent.propDecorators = {
    inOutAnimation: [{ type: HostBinding, args: ['@inOut',] }],
    loadingCircleId: [{ type: Input }],
    a11yHidden: [{ type: Input }],
    a11yLabel: [{ type: Input }],
    a11yAriaLive: [{ type: Input }],
    a11yRole: [{ type: Input }],
    type: [{ type: Input }],
    size: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLoadingCircleComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-loading-circle',
                template: "<div\n  class=\"voxel-loading-circle\"\n  [class.voxel-loading-circle--xsmall]=\"size === 'XS'\"\n  [class.voxel-loading-circle--small]=\"size === 'S'\"\n  [class.voxel-loading-circle--large]=\"size === 'L'\"\n  [class.voxel-loading-circle--xlarge]=\"size === 'XL'\"\n  [class.voxel-loading-circle--dark]=\"type === 'dark'\"\n  [class.voxel-loading-circle--light]=\"type === 'light'\"\n  [class.voxel-loading-circle--secondary]=\"type === 'secondary'\"\n  [attr.id]=\"loadingCircleId\"\n  [attr.aria-hidden]=\"a11yHidden ? a11yHidden : null\"\n  [attr.role]=\"a11yRole\"\n>\n  <svg\n    xmlns=\"http://www.w3.org/2000/svg\"\n    class=\"voxel-loading-circle__svg\"\n    role=\"img\"\n  >\n    <title>{{ a11yLabel }}</title>\n    <circle\n      class=\"voxel-loading-circle__circle-ring\"\n      cx=\"50%\"\n      cy=\"50%\"\n      [attr.r]=\"circleRadius\"\n    />\n    <circle\n      class=\"voxel-loading-circle__circle-spinner\"\n      cx=\"50%\"\n      cy=\"50%\"\n      [attr.r]=\"circleRadius\"\n    />\n  </svg>\n  <div class=\"voxel-loading-circle__icon\">\n    <ng-content select=\"voxel-icon\"></ng-content>\n  </div>\n</div>\n\n",
                animations: [
                    trigger('inOut', [
                        transition(':enter', [
                            query('.voxel-loading-circle', [
                                style({ opacity: '0' }),
                                animate('200ms ease-in-out', style({ opacity: '1' })),
                            ]),
                        ]),
                        transition(':leave', [
                            query('.voxel-loading-circle', [animate('250ms ease-in-out', style({ opacity: '0' }))]),
                        ]),
                    ]),
                ],
                styles: ["@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.voxel-loading-circle{display:inline-block;height:calc(var(--ids_size_general_32x) + (var(--ids_size_general_3x) * 2));position:relative;width:calc(var(--ids_size_general_32x) + (var(--ids_size_general_3x) * 2))}.voxel-loading-circle__svg{-webkit-animation:spin .8s linear infinite;animation:spin .8s linear infinite;height:calc(var(--ids_size_general_32x) + (var(--ids_size_general_3x) * 2));width:calc(var(--ids_size_general_32x) + (var(--ids_size_general_3x) * 2))}.voxel-loading-circle__circle-ring{fill:transparent;opacity:var(--ids_opacity_soft);stroke:var(--ids_color_action_primary_base);stroke-width:var(--ids_size_general_3x)}.voxel-loading-circle__circle-spinner{--spin-value: var(--ids_size_general_3x);fill:transparent;stroke:var(--ids_color_action_primary_base);stroke-dasharray:100.5309649149;stroke-dashoffset:75.3982236862;stroke-linecap:round;stroke-width:var(--ids_size_general_3x)}.voxel-loading-circle__icon{left:50%;position:absolute;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.voxel-loading-circle--xsmall{height:calc(var(--ids_size_general_16x) + (var(--ids_size_general_2x) * 2));width:calc(var(--ids_size_general_16x) + (var(--ids_size_general_2x) * 2))}.voxel-loading-circle--xsmall .voxel-loading-circle__svg{height:calc(var(--ids_size_general_16x) + (var(--ids_size_general_2x) * 2));width:calc(var(--ids_size_general_16x) + (var(--ids_size_general_2x) * 2))}.voxel-loading-circle--xsmall .voxel-loading-circle__circle-ring{stroke-width:var(--ids_size_general_2x)}.voxel-loading-circle--xsmall .voxel-loading-circle__circle-spinner{--spin-value: var(--ids_size_general_2x);stroke-dasharray:50.2654824574;stroke-dashoffset:37.6991118431;stroke-width:var(--ids_size_general_2x)}.voxel-loading-circle--small{height:calc(var(--ids_size_general_24x) + (var(--ids_size_general_2x) * 2));width:calc(var(--ids_size_general_24x) + (var(--ids_size_general_2x) * 2))}.voxel-loading-circle--small .voxel-loading-circle__svg{height:calc(var(--ids_size_general_24x) + (var(--ids_size_general_2x) * 2));width:calc(var(--ids_size_general_24x) + (var(--ids_size_general_2x) * 2))}.voxel-loading-circle--small .voxel-loading-circle__circle-ring{stroke-width:var(--ids_size_general_2x)}.voxel-loading-circle--small .voxel-loading-circle__circle-spinner{--spin-value: var(--ids_size_general_2x);stroke-dasharray:75.3982236862;stroke-dashoffset:56.5486677646;stroke-width:var(--ids_size_general_2x)}.voxel-loading-circle--large{height:calc(var(--ids_size_general_64x) + (var(--ids_size_general_4x) * 2));width:calc(var(--ids_size_general_64x) + (var(--ids_size_general_4x) * 2))}.voxel-loading-circle--large .voxel-loading-circle__svg{height:calc(var(--ids_size_general_64x) + (var(--ids_size_general_4x) * 2));width:calc(var(--ids_size_general_64x) + (var(--ids_size_general_4x) * 2))}.voxel-loading-circle--large .voxel-loading-circle__circle-ring{stroke-width:var(--ids_size_general_4x)}.voxel-loading-circle--large .voxel-loading-circle__circle-spinner{--spin-value: var(--ids_size_general_4x);stroke-dasharray:201.0619298297;stroke-dashoffset:150.7964473723;stroke-width:var(--ids_size_general_4x)}.voxel-loading-circle--xlarge{height:calc(var(--ids_size_general_128x) + (var(--ids_size_general_5x) * 2));width:calc(var(--ids_size_general_128x) + (var(--ids_size_general_5x) * 2))}.voxel-loading-circle--xlarge .voxel-loading-circle__svg{height:calc(var(--ids_size_general_128x) + (var(--ids_size_general_5x) * 2));width:calc(var(--ids_size_general_128x) + (var(--ids_size_general_5x) * 2))}.voxel-loading-circle--xlarge .voxel-loading-circle__circle-ring{stroke-width:var(--ids_size_general_5x)}.voxel-loading-circle--xlarge .voxel-loading-circle__circle-spinner{--spin-value: var(--ids_size_general_5x);stroke-dasharray:402.1238596595;stroke-dashoffset:301.5928947446;stroke-width:var(--ids_size_general_5x)}.voxel-loading-circle--dark .voxel-loading-circle__circle-ring,.voxel-loading-circle--dark .voxel-loading-circle__circle-spinner{stroke:var(--ids_color_contrast_onDark)}.voxel-loading-circle--light .voxel-loading-circle__circle-ring,.voxel-loading-circle--light .voxel-loading-circle__circle-spinner{stroke:var(--ids_color_contrast_onLight)}.voxel-loading-circle--secondary .voxel-loading-circle__circle-ring,.voxel-loading-circle--secondary .voxel-loading-circle__circle-spinner{stroke:var(--ids_color_action_secondary_base)}\n"]
            }]
    }], function () { return [{ type: ɵngcc3.LiveAnnouncer }]; }, { inOutAnimation: [{
            type: HostBinding,
            args: ['@inOut']
        }], loadingCircleId: [{
            type: Input
        }], a11yHidden: [{
            type: Input
        }], a11yLabel: [{
            type: Input
        }], size: [{
            type: Input
        }], a11yAriaLive: [{
            type: Input
        }], a11yRole: [{
            type: Input
        }], type: [{
            type: Input
        }] }); })();

class VoxelLoadingCircleModule {
}
VoxelLoadingCircleModule.ɵfac = function VoxelLoadingCircleModule_Factory(t) { return new (t || VoxelLoadingCircleModule)(); };
VoxelLoadingCircleModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelLoadingCircleModule });
VoxelLoadingCircleModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLoadingCircleModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelLoadingCircleComponent],
                exports: [VoxelLoadingCircleComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelLoadingCircleModule, { declarations: function () { return [VoxelLoadingCircleComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelLoadingCircleComponent]; } }); })();

class VoxelButtonModule {
}
VoxelButtonModule.ɵfac = function VoxelButtonModule_Factory(t) { return new (t || VoxelButtonModule)(); };
VoxelButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelButtonModule });
VoxelButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelLoadingCircleModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelLoadingCircleModule],
                declarations: [VoxelButtonComponent],
                exports: [VoxelButtonComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelButtonModule, { declarations: function () { return [VoxelButtonComponent]; }, imports: function () { return [CommonModule, VoxelLoadingCircleModule]; }, exports: function () { return [VoxelButtonComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID$g = 1;
/**
 * @internal
 */
// Desabilitado esse lint pois obriga a classe a ter o sufixo do selector da diretiva
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class VoxelFormSelectionBase {
    constructor(ngControl, elementRef) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.state = '';
        this.labelId = `voxel-form-selection-label-${NEXT_ID$g}`;
        /**
         * @internal
         */
        this._isFocused = false;
        this._rtlDirection = false;
        this._ariaHiddenLabel = false;
        /**
         * @internal
         */
        this.controlId = `voxel-${this.selectorType}-${NEXT_ID$g++}`;
        this._onDark = false;
        /**
         * @internal
         */
        this.inputClasses = `voxel-form-selection__input--${this.selectorType}`;
    }
    /** @internal */
    get rtlDirection() {
        return this._rtlDirection;
    }
    /** @internal */
    get ariaHiddenLabel() {
        return this._ariaHiddenLabel;
    }
    get ariaDescribedBy() {
        return this._ariaDescribedBy;
    }
    set ariaDescribedBy(ariaDescribedBy) {
        this._ariaDescribedBy = ariaDescribedBy;
    }
    set onDark(onDark) {
        this._onDark = enforceBoolean(onDark);
    }
    get onDark() {
        return this._onDark;
    }
    /**
     * @internal
     */
    /* istanbul ignore next */
    onFocus() {
        this._isFocused = true;
    }
    /**
     * @internal
     */
    /* istanbul ignore next */
    onFocusout() {
        this._isFocused = false;
    }
    /**
     * @internal
     */
    get selectorType() {
        return 'selector-base';
    }
    /**
     * @internal
     */
    get icon() {
        return '';
    }
    /**
     * @internal
     */
    get iconClasses() {
        return '';
    }
    /**
     * @internal
     */
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    /**
     * @internal
     */
    get control() {
        var _a;
        return (_a = this.ngControl) === null || _a === void 0 ? void 0 : _a.control;
    }
    /**
     * @internal
     */
    handleDescribedBy(messageId) {
        const ariaDescribedBy = messageId.length > 0 ? (Array.isArray(messageId) ? messageId.join(' ') : messageId) : null;
        this.ariaDescribedBy = ariaDescribedBy;
    }
}
VoxelFormSelectionBase.ɵfac = function VoxelFormSelectionBase_Factory(t) { return new (t || VoxelFormSelectionBase)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelFormSelectionBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelFormSelectionBase, selectors: [["do-not-use-voxel-form-selection-base"]], hostVars: 3, hostBindings: function VoxelFormSelectionBase_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("focus", function VoxelFormSelectionBase_focus_HostBindingHandler() { return ctx.onFocus(); })("focusout", function VoxelFormSelectionBase_focusout_HostBindingHandler() { return ctx.onFocusout(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.controlId)("class", ctx.inputClasses)("aria-describedby", ctx.ariaDescribedBy);
    } }, inputs: { ariaDescribedBy: ["aria-describedby", "ariaDescribedBy"], onDark: "onDark" } });
VoxelFormSelectionBase.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef }
];
VoxelFormSelectionBase.propDecorators = {
    controlId: [{ type: HostBinding, args: ['attr.id',] }],
    ariaDescribedBy: [{ type: HostBinding, args: ['attr.aria-describedby',] }, { type: Input, args: ['aria-describedby',] }],
    onDark: [{ type: Input }],
    inputClasses: [{ type: HostBinding, args: ['attr.class',] }],
    onFocus: [{ type: HostListener, args: ['focus',] }],
    onFocusout: [{ type: HostListener, args: ['focusout',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormSelectionBase, [{
        type: Directive,
        args: [{
                // é uma diretiva que não pode ser usada, é apenas a base do checkbox, radio e switch
                // precisa ser declarada como diretiva por conta do ngControl, HostBinding e HostListener
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: 'do-not-use-voxel-form-selection-base'
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { controlId: [{
            type: HostBinding,
            args: ['attr.id']
        }], inputClasses: [{
            type: HostBinding,
            args: ['attr.class']
        }], ariaDescribedBy: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }, {
            type: Input,
            args: ['aria-describedby']
        }], onDark: [{
            type: Input
        }], 
    /**
     * @internal
     */
    /* istanbul ignore next */
    onFocus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /**
     * @internal
     */
    /* istanbul ignore next */
    onFocusout: [{
            type: HostListener,
            args: ['focusout']
        }] }); })();

/**
 * Diretiva para utilização do Checkbox dentro do componente form-selection
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelCheckboxModule } from '@voxel/components/ids';`
 *
 * * <example-url>../../demo/index.html#/portfolio/checkbox?componentOnly=true</example-url>
 *
 *  **Acessibilidade:**
 *
 *  A marcação de checkbox indeterminado não é lida pelo Android Talkback e no iOS VoiceOver
 *  é verbalizado como "marcado". No entanto, para o NVDA é bem suportado. Use esse caso apenas
 *  se estritamente necessário, até que ele haja melhor compatibilidade com as tecnologias assistivas citadas.
 *
 * @example Checkbox simples
 *  <voxel-form-selection>
 *             <input type="checkbox" formControlName="simple" voxelCheckbox />
 *             simples
 *  </voxel-form-selection>
 *
 * @example Checkbox selecionado
 *  <voxel-form-selection>
 *             <input type="checkbox" formControlName="selected" voxelCheckbox checked />
 *             selecionado
 *  </voxel-form-selection>
 *
 * @example Checkbox Group
 * <voxel-form-selection *ngFor="let item of checkboxItems.items; let i = index">
 *             <input type="checkbox" [value]="item.value" [name]="checkboxItems.name" voxelCheckbox />
 *             {{ item.label }}
 * </voxel-form-selection>
 */
class VoxelCheckboxDirective extends VoxelFormSelectionBase {
    /**
     * @internal
     */
    get selectorType() {
        return 'checkbox';
    }
    /**
     * @internal
     */
    get icon() {
        return this.nativeElement.indeterminate
            ? 'checkbox_indeterminado'
            : this.nativeElement.checked
                ? 'checkbox'
                : 'checkbox_vazio';
    }
    /**
     * @internal
     */
    get iconClasses() {
        return {
            'voxel-form-selection__checkbox': true,
            'voxel-form-selection__checkbox--checked': this.nativeElement.checked,
            'voxel-form-selection__checkbox--indeterminate': this.nativeElement.indeterminate,
            'voxel-form-selection__checkbox--empty': !this.nativeElement.indeterminate && !this.nativeElement.checked,
            'voxel-form-selection__checkbox--disabled': this.nativeElement.disabled,
            'voxel-form-selection__checkbox--focus': this._isFocused,
            'voxel-form-selection__checkbox--invalid': this.state === 'invalid',
        };
    }
}
VoxelCheckboxDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelCheckboxDirective_BaseFactory; return function VoxelCheckboxDirective_Factory(t) { return (ɵVoxelCheckboxDirective_BaseFactory || (ɵVoxelCheckboxDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelCheckboxDirective)))(t || VoxelCheckboxDirective); }; }();
VoxelCheckboxDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelCheckboxDirective, selectors: [["", "voxelCheckbox", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: VoxelFormSelectionBase, useExisting: VoxelCheckboxDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelCheckboxDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelCheckbox]',
                providers: [{ provide: VoxelFormSelectionBase, useExisting: VoxelCheckboxDirective }]
            }]
    }], null, null); })();

class VoxelCheckboxModule {
}
VoxelCheckboxModule.ɵfac = function VoxelCheckboxModule_Factory(t) { return new (t || VoxelCheckboxModule)(); };
VoxelCheckboxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelCheckboxModule });
VoxelCheckboxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelCheckboxModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelCheckboxDirective],
                exports: [VoxelCheckboxDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelCheckboxModule, { declarations: function () { return [VoxelCheckboxDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelCheckboxDirective]; } }); })();

/**
 * O Number Badge é um componente usado para representar números que precisam de destaque.
 * Pode ser exibido em elementos como ícones ou cards para notificar que existem
 * solicitações pendentes.
 *
 * *Number Badge is used to represent number that need highlight.
 * *Can be displayed on elements like icons or cards to notify that there are*
 * *pending requests*
 *
 * **Module:**
 *
 * `import { VoxelNumberBadgeModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/numberbadge?componentOnly=true</example-url>
 *
 */
class VoxelNumberBadgeComponent {
    constructor(_cdr) {
        this._cdr = _cdr;
        /** @internal */
        this._accessibleValue = '';
        this._max = 99;
        /**
         * Variável utilizada para tornar dinâmico o conteúdo à frente do valor
         *
         * *Variable used to make content ahead of value dynamic*
         */
        this.maxSymbol = '+';
        this._neutral = false;
        this._onDark = false;
        this._secondary = false;
        this._value = '0';
    }
    get accessibleValue() {
        return this._accessibleValue;
    }
    /**
     * Valor máximo a ser exibido
     *
     * *Maximum value to display*
     */
    set max(value) {
        this._max = enforceNumber(value);
    }
    get max() {
        return this._max;
    }
    /**
     * Define se o badge é o tipo neutro
     *
     * *Sets whether the badge is neutral*
     */
    set neutral(value) {
        this._neutral = enforceBoolean(value);
    }
    get neutral() {
        return this._neutral;
    }
    /**
     * Define se o badge é on-dark
     *
     * *Sets whether the badge is on-dark*
     */
    set onDark(value) {
        this._onDark = enforceBoolean(value);
    }
    get onDark() {
        return this._onDark;
    }
    /**
     * Define se o badge é o tipo secundário
     *
     * *Sets whether the badge is secondary*
     */
    set secondary(value) {
        this._secondary = enforceBoolean(value);
    }
    get secondary() {
        return this._secondary;
    }
    /** @internal */
    set value(value) {
        this._value = value;
    }
    get value() {
        return this._value;
    }
    ngAfterViewInit() {
        this.value = this.convertBadge(this.badgeValue.nativeElement.innerText);
        this._cdr.detectChanges();
    }
    /**
     * @internal
     */
    convertBadge(value = '') {
        const valueNumber = Math.abs(enforceNumber(value));
        this._accessibleValue = `${valueNumber} `;
        if (valueNumber > this.max) {
            this._accessibleValue = `mais de ${this.max} `;
            return `${this.max}${this.maxSymbol}`;
        }
        return valueNumber.toString();
    }
    onContentChange([{ target: { textContent }, },]) {
        this.value = this.convertBadge(textContent !== null && textContent !== void 0 ? textContent : '');
    }
}
VoxelNumberBadgeComponent.ɵfac = function VoxelNumberBadgeComponent_Factory(t) { return new (t || VoxelNumberBadgeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
VoxelNumberBadgeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelNumberBadgeComponent, selectors: [["voxel-number-badge"], ["", "voxelNumberBadge", ""]], viewQuery: function VoxelNumberBadgeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c16, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.badgeValue = _t.first);
    } }, inputs: { maxSymbol: "maxSymbol", max: "max", neutral: "neutral", onDark: "onDark", secondary: "secondary", a11yLabel: "a11yLabel" }, ngContentSelectors: _c1, decls: 7, vars: 11, consts: [[1, "voxel-number-badge"], [1, "voxel-number-badge__content-hidden", 3, "cdkObserveContent"], ["badgeValue", ""], [1, "voxel-number-badge__number-formatted"], ["class", "voxel-number-badge__hidden-aria-label", 4, "ngIf"], [1, "voxel-number-badge__hidden-aria-label"]], template: function VoxelNumberBadgeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "span", 1, 2);
        ɵngcc0.ɵɵlistener("cdkObserveContent", function VoxelNumberBadgeComponent_Template_span_cdkObserveContent_1_listener($event) { return ctx.onContentChange($event); });
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span", 3);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(6, VoxelNumberBadgeComponent_span_6_Template, 2, 1, "span", 4);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-number-badge--neutral", ctx.neutral)("voxel-number-badge--secondary", ctx.secondary)("voxel-number-badge--on-dark", ctx.onDark);
        ɵngcc0.ɵɵattribute("data-max", ctx.max);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-hidden", true);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.a11yLabel ? true : false);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.value, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.a11yLabel);
    } }, directives: [ɵngcc5.CdkObserveContent, ɵngcc1.NgIf], styles: [".voxel-number-badge[_ngcontent-%COMP%]{background-color:var(--ids_color_action_primary_base);border-radius:var(--ids_size_cornerRadius_layout_01);-webkit-box-sizing:border-box;box-sizing:border-box;color:var(--ids_color_contrast_onDark);display:inline-block;font:var(--ids_textStyle_label_large_bold);height:var(--ids_size_general_24x);line-height:1;min-width:var(--ids_size_general_24x);padding:.0625rem var(--ids_size_general_6x);position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (max-width: 63.99rem){.voxel-number-badge[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_small_bold);height:var(--ids_size_general_20x);line-height:1.2;min-width:var(--ids_size_general_20x)}}.voxel-number-badge--neutral[_ngcontent-%COMP%]{background-color:var(--ids_color_action_neutral_variant)}.voxel-number-badge--secondary[_ngcontent-%COMP%]{background-color:var(--ids_color_action_secondary_base)}.voxel-number-badge--on-dark[_ngcontent-%COMP%]{background-color:var(--ids_color_contrast_onDark);color:var(--ids_color_action_primary_base)}.voxel-number-badge--on-dark.voxel-number-badge--neutral[_ngcontent-%COMP%]{color:var(--ids_color_action_neutral_base)}.voxel-number-badge--on-dark.voxel-number-badge--secondary[_ngcontent-%COMP%]{color:var(--ids_color_action_secondary_base)}.voxel-number-badge__content-hidden[_ngcontent-%COMP%]{display:none}.voxel-number-badge__hidden-aria-label[_ngcontent-%COMP%]{display:block;height:1.5625rem;left:0;-webkit-line-clamp:2;opacity:0;overflow:hidden;position:absolute;text-overflow:ellipsis;top:0;width:2.1875rem}"] });
VoxelNumberBadgeComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
VoxelNumberBadgeComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    max: [{ type: Input }],
    maxSymbol: [{ type: Input }],
    neutral: [{ type: Input }],
    onDark: [{ type: Input }],
    secondary: [{ type: Input }],
    badgeValue: [{ type: ViewChild, args: ['badgeValue',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelNumberBadgeComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-number-badge, [voxelNumberBadge]',
                template: "<span\n  class=\"voxel-number-badge\"\n  [class.voxel-number-badge--neutral]=\"neutral\"\n  [class.voxel-number-badge--secondary]=\"secondary\"\n  [class.voxel-number-badge--on-dark]=\"onDark\"\n  [attr.data-max]=\"max\"\n>\n  <span #badgeValue\n    [attr.aria-hidden]=\"true\"\n    class=\"voxel-number-badge__content-hidden\"\n    (cdkObserveContent)=\"onContentChange($event)\">\n    <ng-content></ng-content>\n  </span>\n  <span class=\"voxel-number-badge__number-formatted\" [attr.aria-hidden]=\"a11yLabel ? true : false\">\n    {{ value }}\n  </span>\n  <span *ngIf=\"a11yLabel\" class=\"voxel-number-badge__hidden-aria-label\">{{ accessibleValue + a11yLabel }}</span>\n</span>\n",
                styles: [".voxel-number-badge{background-color:var(--ids_color_action_primary_base);border-radius:var(--ids_size_cornerRadius_layout_01);-webkit-box-sizing:border-box;box-sizing:border-box;color:var(--ids_color_contrast_onDark);display:inline-block;font:var(--ids_textStyle_label_large_bold);height:var(--ids_size_general_24x);line-height:1;min-width:var(--ids_size_general_24x);padding:.0625rem var(--ids_size_general_6x);position:relative;text-align:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}@media (max-width: 63.99rem){.voxel-number-badge{font:var(--ids_textStyle_label_small_bold);height:var(--ids_size_general_20x);line-height:1.2;min-width:var(--ids_size_general_20x)}}.voxel-number-badge--neutral{background-color:var(--ids_color_action_neutral_variant)}.voxel-number-badge--secondary{background-color:var(--ids_color_action_secondary_base)}.voxel-number-badge--on-dark{background-color:var(--ids_color_contrast_onDark);color:var(--ids_color_action_primary_base)}.voxel-number-badge--on-dark.voxel-number-badge--neutral{color:var(--ids_color_action_neutral_base)}.voxel-number-badge--on-dark.voxel-number-badge--secondary{color:var(--ids_color_action_secondary_base)}.voxel-number-badge__content-hidden{display:none}.voxel-number-badge__hidden-aria-label{display:block;height:1.5625rem;left:0;-webkit-line-clamp:2;opacity:0;overflow:hidden;position:absolute;text-overflow:ellipsis;top:0;width:2.1875rem}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { maxSymbol: [{
            type: Input
        }], max: [{
            type: Input
        }], neutral: [{
            type: Input
        }], onDark: [{
            type: Input
        }], secondary: [{
            type: Input
        }], a11yLabel: [{
            type: Input
        }], badgeValue: [{
            type: ViewChild,
            args: ['badgeValue']
        }] }); })();

class VoxelNumberBadgeModule {
}
VoxelNumberBadgeModule.ɵfac = function VoxelNumberBadgeModule_Factory(t) { return new (t || VoxelNumberBadgeModule)(); };
VoxelNumberBadgeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelNumberBadgeModule });
VoxelNumberBadgeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ObserversModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelNumberBadgeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, ObserversModule],
                declarations: [VoxelNumberBadgeComponent],
                exports: [VoxelNumberBadgeComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelNumberBadgeModule, { declarations: function () { return [VoxelNumberBadgeComponent]; }, imports: function () { return [CommonModule, ObserversModule]; }, exports: function () { return [VoxelNumberBadgeComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID$f = 0;
/**
 * @internal
 */
let NEXT_OPTION_ID = 0;
/**
 * Chips são elementos  que representam uma entrada, como uma escolha de categorias,
 * ou filtros dentre múltiplas opções
 *
 * *Chips are elements that represents an input, like a choice of categories,*
 * *or filters between multiple options*
 *
 * **Module:**
 *
 * `import { VoxelChipsModule } from '@voxel/components/ids';`
 *
 *  <example-url>../../demo/#/portfolio/chips?componentOnly=true</example-url>
 *
 * @example selection
 * <voxel-chips
 *             label="Selecione um ou mais filtros"
 *             type="selection"
 *             [options]="[
 *                { label: 'opção 1', value: 'opt1', icon: favorito },
 *                { label: 'opção 2', value: 'opt2', disabled: true },
 *                { label: 'opção 3', value: 'opt3' },
 *             ]"
 * ></voxel-chips>
 *
 * @example action
 * <voxel-chips
 *             label="Escolha uma opção"
 *             type="action"
 *             [options]="[
 *               { label: 'opção 1', value: 'opt1' },
 *               { label: 'opção 2', value: 'opt2' },
 *               { label: 'opção 3', value: 'opt3' },
 *             ]"
 * ></voxel-chips>
 *
 */
class VoxelChipsComponent {
    constructor() {
        this.optionsView = [];
        this._options = [];
        this._disabled = false;
        this._contrast = 'default';
        /**
         * Id do componente
         *
         * *Chips id*
         */
        this.controlId = `voxel-chips-${NEXT_ID$f++}`;
        /**
         * Label do grupo de opções
         *
         * *Label (legend)*
         */
        this.label = '';
        /**
         * Evento disparado ao alterar o valor(es) selecionados
         *
         * *Fired event when change selected values*
         */
        this.changeChips = new EventEmitter();
    }
    /**
     * Tipo do componente
     *
     * *Type of the component*
     *
     * Variações:
     *
     * *Variations:*
     *
     * * selection;
     * * action;
     *
     * Observação:
     * O selection é utilizado quando se necessita de um ícone ou um número adicional, o action não possui nenhum adicional
     *
     * *Note:*
     * *The selection is used when you need an additional icon or a number, action has no additional information*
     *
     */
    set type(value) {
        this._type = value;
    }
    get type() {
        return this._type;
    }
    /**
     * Opções que serão exibidas
     *
     * Nesta propriedade deve ser definido um array de objetos que implementam a interface VoxelChipsOption
     *
     * *Chips options*
     *
     * *In this property must be defined an object array that implements VoxelChipsOption interface*
     */
    set options(options) {
        this._options = options !== null && options !== void 0 ? options : [];
        this.removeDuplicatedOptions();
        this.handleOptions(this._options);
    }
    get options() {
        return this._options;
    }
    /**
     * Desabilita todos os itens do chips
     *
     * *Disable all chips items*
     *
     */
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Seleciona esquema de cores do chips
     *
     *  *chooses chips color scheme*
     */
    set contrast(value) {
        this._contrast = value;
    }
    get contrast() {
        return this._contrast;
    }
    /**
     * @internal
     */
    removeDuplicatedOptions() {
        this.options.forEach((option, index) => {
            const duplicatedIndex = this.options.findIndex((optionFind) => optionFind.value === option.value) === index;
            if (!duplicatedIndex) {
                this.options.splice(this.options.indexOf(option), 1);
            }
        });
    }
    chooseIconType(option) {
        if (option.disabled) {
            return;
        }
        const colorContrast = {
            default: option.selected ? 'dark' : 'secondary',
            onLight: option.selected ? 'dark' : 'light',
            onDark: option.selected ? 'light' : 'dark',
        };
        return colorContrast[this.contrast];
    }
    /**
     * @internal
     */
    handleOptions(optionsList) {
        this.optionsView = optionsList.map((option) => (Object.assign(Object.assign({}, option), { id: `voxel-chips-option-${NEXT_OPTION_ID++}`, name: `${this.controlId}-${this.type}`, selected: Boolean(option.selected), disabled: Boolean(option.disabled), iconType: this.chooseIconType(option), icon: this.type === 'selection' ? 'seta_baixo' : '' })));
    }
    /**
     * @internal
     * Dispara o evento com a opção/opções que foi/foram alteradas
     */
    changeOptions(_event) {
        const options = this.optionsView;
        const target = _event.target;
        const targetOption = options.find((option) => option.id === target.id);
        if (!targetOption) {
            return;
        }
        this.optionsView.forEach((option) => {
            if (option.id === target.id) {
                option.selected = target.checked;
                option.iconType = this.chooseIconType(option);
            }
        });
        this.changeChips.emit(options);
        return;
    }
}
VoxelChipsComponent.ɵfac = function VoxelChipsComponent_Factory(t) { return new (t || VoxelChipsComponent)(); };
VoxelChipsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelChipsComponent, selectors: [["voxel-chips"]], inputs: { controlId: "controlId", label: "label", type: "type", options: "options", disabled: "disabled", contrast: "contrast" }, outputs: { changeChips: "changeChips" }, decls: 4, vars: 3, consts: [[1, "voxel-chips-group", 3, "id"], ["class", "voxel-chips-group__legend", 3, "class", 4, "ngIf"], [1, "voxel-chips-group__options"], ["class", "voxel-chips-group__item", 4, "ngFor", "ngForOf"], [1, "voxel-chips-group__legend"], [1, "voxel-chips-group__item"], [1, "voxel-chips"], ["type", "checkbox", 1, "voxel-chips__input", 3, "id", "value", "disabled", "name", "checked", "change"], [1, "voxel-chips__content"], [1, "voxel-chips__label", 3, "for"], ["class", "voxel-chips__icon", "size", "S", 3, "disabled", "type", 4, "ngIf"], ["class", "voxel-chips__badge", 3, "secondary", "onDark", "neutral", 4, "ngIf"], ["size", "S", 1, "voxel-chips__icon", 3, "disabled", "type"], [1, "voxel-chips__badge", 3, "secondary", "onDark", "neutral"]], template: function VoxelChipsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "fieldset", 0);
        ɵngcc0.ɵɵtemplate(1, VoxelChipsComponent_legend_1_Template, 2, 5, "legend", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, VoxelChipsComponent_div_3_Template, 8, 15, "div", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.controlId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.label);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.optionsView);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, VoxelIconComponent, VoxelNumberBadgeComponent], styles: [".voxel-chips[_ngcontent-%COMP%]{height:100%;position:relative}.voxel-chips[_ngcontent-%COMP%]   .voxel-icon[_ngcontent-%COMP%]{color:inherit}.voxel-chips__content[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_tags_02);color:var(--ids_color_action_secondary_base);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);grid-gap:var(--ids_size_general_8x);gap:var(--ids_size_general_8x);height:100%;padding:var(--ids_size_general_6x) var(--ids_size_general_16x);-webkit-transition:background-color .2s linear;transition:background-color .2s linear;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}.voxel-chips__icon[_ngcontent-%COMP%], .voxel-chips__badge[_ngcontent-%COMP%]{pointer-events:none}.voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_action_secondary_base);font:var(--ids_textStyle_label_small_regular);line-height:var(--ids_size_general_20x);-webkit-transition:color .2s linear;transition:color .2s linear}.voxel-chips--withIcon[_ngcontent-%COMP%]   .voxel-chips__content[_ngcontent-%COMP%]{padding-right:var(--ids_size_general_12x)}.voxel-chips__input[_ngcontent-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;cursor:pointer;height:100%;position:absolute;width:100%}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__content[_ngcontent-%COMP%]{background-color:transparent;border:var(--ids_size_border_small) solid var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onDark)}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__content[_ngcontent-%COMP%]{background-color:transparent;border:var(--ids_size_border_small) solid var(--ids_color_contrast_onLight);color:var(--ids_color_contrast_onLight)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onLight)}.voxel-chips__input[_ngcontent-%COMP%]:disabled{cursor:not-allowed}.voxel-chips__input[_ngcontent-%COMP%]:checked + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_action_secondary_base);border-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_contrast_onDark)}.voxel-chips__input[_ngcontent-%COMP%]:checked + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-chips__input[_ngcontent-%COMP%]:disabled + .voxel-chips__content[_ngcontent-%COMP%]{background-color:transparent;border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant)}.voxel-chips__input[_ngcontent-%COMP%]:disabled + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_action_disabled_variant)}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:checked + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_contrast_onDark);border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onLight)}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:checked + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onLight)}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:disabled + .voxel-chips__content[_ngcontent-%COMP%]{border-color:var(--ids_color_contrast_onDark_medium)}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:disabled + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark_medium)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:checked + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_contrast_onLight);border-color:var(--ids_color_contrast_onLight);color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:checked + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:disabled + .voxel-chips__content[_ngcontent-%COMP%]{border-color:var(--ids_color_contrast_onLight_medium)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:disabled + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onLight_medium)}.voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled) + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_action_secondary_variant);border-color:var(--ids_color_action_secondary_variant)}.voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled):not(:checked) + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_action_secondary_base_soft);border-color:var(--ids_color_action_secondary_variant)}.voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled):not(:checked) + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_action_secondary_variant)}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled) + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_contrast_onDark_strong);border-color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled) + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_contrast_onLight_strong);border-color:var(--ids_color_contrast_onLight)}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled):not(:checked) + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_contrast_onDark_soft)}.voxel-chips--on-dark[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled):not(:checked) + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled):not(:checked) + .voxel-chips__content[_ngcontent-%COMP%]{background-color:var(--ids_color_contrast_onLight_soft)}.voxel-chips--on-light[_ngcontent-%COMP%]   .voxel-chips__input[_ngcontent-%COMP%]:hover:not(:disabled):not(:checked) + .voxel-chips__content[_ngcontent-%COMP%]   .voxel-chips__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onLight)}.voxel-chips-group__legend[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_medium_regular);margin-bottom:var(--ids_size_general_8x)}.voxel-chips-group__legend--onDark[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-chips-group__options[_ngcontent-%COMP%]{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_8x);gap:var(--ids_size_general_8x)}"] });
VoxelChipsComponent.propDecorators = {
    type: [{ type: Input }],
    controlId: [{ type: Input }],
    label: [{ type: Input }],
    options: [{ type: Input }],
    disabled: [{ type: Input }],
    contrast: [{ type: Input }],
    changeChips: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelChipsComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-chips',
                template: "<fieldset [id]=\"controlId\" class=\"voxel-chips-group\">\n  <legend class=\"voxel-chips-group__legend\" [class]=\"{ 'voxel-chips-group__legend--onDark' : contrast === 'onDark' }\" *ngIf=\"label\">{{ label }}</legend>\n  <div class=\"voxel-chips-group__options\">\n    <div *ngFor=\"let option of optionsView\" class=\"voxel-chips-group__item\">\n      <div class=\"voxel-chips\"\n        [class]=\"{\n          'voxel-chips--withIcon': option.icon,\n          'voxel-chips--on-light': contrast === 'onLight',\n          'voxel-chips--on-dark': contrast === 'onDark'\n        }\"\n      >\n        <input class=\"voxel-chips__input\"\n          [id]=\"option.id\"\n          type=\"checkbox\"\n          [value]=\"option.value\"\n          [disabled]=\"option.disabled || disabled\"\n          [name]=\"option.name\"\n          [checked]=\"option.selected\"\n          (change)=\"changeOptions($event)\"\n        />\n        <div class=\"voxel-chips__content\">\n          <label class=\"voxel-chips__label\" [for]=\"option.id\">\n            {{ option.label }}\n          </label>\n          <voxel-icon *ngIf=\"!option.badgeValue && this.type === 'selection'\"\n            class=\"voxel-chips__icon\"\n            [disabled]=\"option.disabled\"\n            [type]=\"option.iconType\"\n            size=\"S\"\n          >\n            {{ option.icon }}\n          </voxel-icon>\n            <voxel-number-badge\n              *ngIf=\"option.badgeValue\"\n              class=\"voxel-chips__badge\"\n              [secondary]=\"contrast === 'default'\"\n              [onDark]=\"option.iconType === 'dark'\"\n              [neutral]=\"option.iconType === 'light' || option.iconType === 'dark'\"\n            >\n              {{ option.badgeValue }}\n            </voxel-number-badge>\n        </div>\n      </div>\n    </div>\n  </div>\n</fieldset>\n",
                styles: [".voxel-chips{height:100%;position:relative}.voxel-chips .voxel-icon{color:inherit}.voxel-chips__content{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_tags_02);color:var(--ids_color_action_secondary_base);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);grid-gap:var(--ids_size_general_8x);gap:var(--ids_size_general_8x);height:100%;padding:var(--ids_size_general_6x) var(--ids_size_general_16x);-webkit-transition:background-color .2s linear;transition:background-color .2s linear;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:nowrap}.voxel-chips__icon,.voxel-chips__badge{pointer-events:none}.voxel-chips__label{color:var(--ids_color_action_secondary_base);font:var(--ids_textStyle_label_small_regular);line-height:var(--ids_size_general_20x);-webkit-transition:color .2s linear;transition:color .2s linear}.voxel-chips--withIcon .voxel-chips__content{padding-right:var(--ids_size_general_12x)}.voxel-chips__input{-webkit-appearance:none;-moz-appearance:none;appearance:none;border:0;cursor:pointer;height:100%;position:absolute;width:100%}.voxel-chips--on-dark .voxel-chips__content{background-color:transparent;border:var(--ids_size_border_small) solid var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onDark)}.voxel-chips--on-dark .voxel-chips__label{color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light .voxel-chips__content{background-color:transparent;border:var(--ids_size_border_small) solid var(--ids_color_contrast_onLight);color:var(--ids_color_contrast_onLight)}.voxel-chips--on-light .voxel-chips__label{color:var(--ids_color_contrast_onLight)}.voxel-chips__input:disabled{cursor:not-allowed}.voxel-chips__input:checked+.voxel-chips__content{background-color:var(--ids_color_action_secondary_base);border-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_contrast_onDark)}.voxel-chips__input:checked+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_contrast_onDark)}.voxel-chips__input:disabled+.voxel-chips__content{background-color:transparent;border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant)}.voxel-chips__input:disabled+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_action_disabled_variant)}.voxel-chips--on-dark .voxel-chips__input:checked+.voxel-chips__content{background-color:var(--ids_color_contrast_onDark);border-color:var(--ids_color_contrast_onDark);color:var(--ids_color_contrast_onLight)}.voxel-chips--on-dark .voxel-chips__input:checked+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_contrast_onLight)}.voxel-chips--on-dark .voxel-chips__input:disabled+.voxel-chips__content{border-color:var(--ids_color_contrast_onDark_medium)}.voxel-chips--on-dark .voxel-chips__input:disabled+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_contrast_onDark_medium)}.voxel-chips--on-light .voxel-chips__input:checked+.voxel-chips__content{background-color:var(--ids_color_contrast_onLight);border-color:var(--ids_color_contrast_onLight);color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light .voxel-chips__input:checked+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light .voxel-chips__input:disabled+.voxel-chips__content{border-color:var(--ids_color_contrast_onLight_medium)}.voxel-chips--on-light .voxel-chips__input:disabled+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_contrast_onLight_medium)}.voxel-chips__input:hover:not(:disabled)+.voxel-chips__content{background-color:var(--ids_color_action_secondary_variant);border-color:var(--ids_color_action_secondary_variant)}.voxel-chips__input:hover:not(:disabled):not(:checked)+.voxel-chips__content{background-color:var(--ids_color_action_secondary_base_soft);border-color:var(--ids_color_action_secondary_variant)}.voxel-chips__input:hover:not(:disabled):not(:checked)+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_action_secondary_variant)}.voxel-chips--on-dark .voxel-chips__input:hover:not(:disabled)+.voxel-chips__content{background-color:var(--ids_color_contrast_onDark_strong);border-color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light .voxel-chips__input:hover:not(:disabled)+.voxel-chips__content{background-color:var(--ids_color_contrast_onLight_strong);border-color:var(--ids_color_contrast_onLight)}.voxel-chips--on-dark .voxel-chips__input:hover:not(:disabled):not(:checked)+.voxel-chips__content{background-color:var(--ids_color_contrast_onDark_soft)}.voxel-chips--on-dark .voxel-chips__input:hover:not(:disabled):not(:checked)+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_contrast_onDark)}.voxel-chips--on-light .voxel-chips__input:hover:not(:disabled):not(:checked)+.voxel-chips__content{background-color:var(--ids_color_contrast_onLight_soft)}.voxel-chips--on-light .voxel-chips__input:hover:not(:disabled):not(:checked)+.voxel-chips__content .voxel-chips__label{color:var(--ids_color_contrast_onLight)}.voxel-chips-group__legend{font:var(--ids_textStyle_label_medium_regular);margin-bottom:var(--ids_size_general_8x)}.voxel-chips-group__legend--onDark{color:var(--ids_color_contrast_onDark)}.voxel-chips-group__options{-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_8x);gap:var(--ids_size_general_8x)}\n"]
            }]
    }], function () { return []; }, { controlId: [{
            type: Input
        }], label: [{
            type: Input
        }], changeChips: [{
            type: Output
        }], type: [{
            type: Input
        }], options: [{
            type: Input
        }], disabled: [{
            type: Input
        }], contrast: [{
            type: Input
        }] }); })();

class VoxelChipsModule {
}
VoxelChipsModule.ɵfac = function VoxelChipsModule_Factory(t) { return new (t || VoxelChipsModule)(); };
VoxelChipsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelChipsModule });
VoxelChipsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule, VoxelNumberBadgeModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelChipsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule, VoxelNumberBadgeModule],
                declarations: [VoxelChipsComponent],
                exports: [VoxelChipsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelChipsModule, { declarations: function () { return [VoxelChipsComponent]; }, imports: function () { return [CommonModule, VoxelIconModule, VoxelNumberBadgeModule]; }, exports: function () { return [VoxelChipsComponent]; } }); })();

let NEXT_ID$e = 0;
class VoxelDotIndicatorComponent {
    constructor(_liveAnnouncer, _platform, _appRef) {
        this._liveAnnouncer = _liveAnnouncer;
        this._platform = _platform;
        this._appRef = _appRef;
        this.dots = [];
        this.isAndroid = this._platform.ANDROID;
        this._current = 1;
        this._currentLiteral = `item ${this.current} selecionado`;
        /**
         * Identificação do componente
         *
         * *Identification of the component*
         */
        this.id = `voxel-dot-indicator-${NEXT_ID$e++}`;
        this._quantity = 2;
        this._nextLiteral = 'próximo item';
        this._onDark = false;
        this._previousLiteral = 'item anterior';
        this.currentChange = new EventEmitter();
    }
    /**
     * Define o dot selecionado/atual
     *
     * *Defines current/selected dot*
     */
    set current(value) {
        const currentValue = Math.abs(enforceNumber(value)) || 1;
        this._current = currentValue;
        if (this.quantity > 2) {
            this._current = currentValue > this.quantity ? this.quantity : currentValue;
        }
    }
    get current() {
        return this._current;
    }
    /**
     * Define a literal para o dot selecionado/atual. Exemplo: Primeira imagem selecionada.
     *
     * *Defines selected/current dot literal *
     */
    set currentLiteral(value) {
        this._currentLiteral = value !== null && value !== void 0 ? value : this._currentLiteral;
    }
    get currentLiteral() {
        const currentLiteral = this._currentLiteral.split(' ');
        const isDefaultBeingUsed = currentLiteral[0] === 'item' && currentLiteral[2] === 'selecionado';
        return isDefaultBeingUsed ? `item ${this.current} selecionado` : this._currentLiteral;
    }
    set dotsLiteral(value) {
        this._dotsLiteral = `${this.quantity} ${value !== null && value !== void 0 ? value : 'itens'}`;
    }
    get dotsLiteral() {
        if (this._dotsLiteral) {
            return `${this._dotsLiteral}, ${this.currentLiteral}`;
        }
        return `${this.quantity} itens, ${this.currentLiteral}`;
    }
    /**
     * Define a quantidade de dots
     *
     * *Defines how many dots*
     */
    set quantity(value) {
        this._quantity = Math.abs(enforceNumber(value));
    }
    get quantity() {
        return this._quantity;
    }
    /**
     * Define a literal do botão próximo (aria-label). Exemplo: Próxima Imagem, Próximo Cartão.
     *
     * *Defines next button's literal (aria-label)*
     */
    set nextLiteral(value) {
        this._nextLiteral = value !== null && value !== void 0 ? value : this._nextLiteral;
    }
    get nextLiteral() {
        return this._nextLiteral;
    }
    /**
     * Define se a cor do indicator seguirá a cor para fundos escuros
     *
     * *Defines whether the indicator's color will follow the dark background color*
     */
    set onDark(value) {
        this._onDark = enforceBoolean(value);
    }
    get onDark() {
        return this._onDark;
    }
    /**
     * Define a literal do botão anterior (aria-label). Exemplo: Imagem anterior, Cartão anterior.
     *
     * *Defines previous button's literal (aria-label)*
     */
    set previousLiteral(value) {
        this._previousLiteral = value !== null && value !== void 0 ? value : this._previousLiteral;
    }
    get previousLiteral() {
        return this._previousLiteral;
    }
    ngOnInit() {
        this.dots = Array.from(Array(this.quantity).keys());
        this.current = this.current <= this.quantity ? this.current : this.quantity;
    }
    next() {
        if (this.current === this.quantity) {
            return;
        }
        this.current = this.current + 1;
        this.currentChange.emit(this.current);
        this.announceValue();
    }
    previous() {
        if (this.current === 1) {
            return;
        }
        this.current = this.current - 1;
        this.currentChange.emit(this.current);
        this.announceValue();
    }
    announceValue() {
        this._appRef.tick();
        if (this.isAndroid && (this.current === 1 || this.current === this.quantity)) {
            this.handleShowSrText();
            return;
        }
        this._liveAnnouncer.announce(this.currentLiteral, 1000);
    }
    handleShowSrText() {
        const literal = this.current === 1 ? this.previousLiteral : this.nextLiteral;
        this._liveAnnouncer.announce(`${literal}, botão, desativado. ${this.currentLiteral}`, 1000);
    }
}
VoxelDotIndicatorComponent.ɵfac = function VoxelDotIndicatorComponent_Factory(t) { return new (t || VoxelDotIndicatorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.LiveAnnouncer), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Platform), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ApplicationRef)); };
VoxelDotIndicatorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelDotIndicatorComponent, selectors: [["voxel-dot-indicator"]], inputs: { id: "id", current: "current", currentLiteral: "currentLiteral", dotsLiteral: "dotsLiteral", quantity: "quantity", nextLiteral: "nextLiteral", onDark: "onDark", previousLiteral: "previousLiteral" }, outputs: { currentChange: "currentChange" }, decls: 9, vars: 13, consts: [[1, "voxel-dot-indicator", 3, "id"], ["voxelButtonAction", "", "variant", "neutral", 1, "voxel-dot-indicator__arrow", 3, "tabindex", "aria-label", "contrast", "click"], ["size", "S"], ["role", "text", 1, "voxel-dot-indicator__dots"], ["class", "voxel-dot-indicator__item", 3, "voxel-dot-indicator__item--selected", 4, "ngFor", "ngForOf"], [1, "voxel-dot-indicator__item"]], template: function VoxelDotIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function VoxelDotIndicatorComponent_Template_button_click_1_listener() { return ctx.previous(); });
        ɵngcc0.ɵɵelementStart(2, "voxel-icon", 2);
        ɵngcc0.ɵɵtext(3, "seta_esquerda");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, VoxelDotIndicatorComponent_div_5_Template, 1, 2, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 1);
        ɵngcc0.ɵɵlistener("click", function VoxelDotIndicatorComponent_Template_button_click_6_listener() { return ctx.next(); });
        ɵngcc0.ɵɵelementStart(7, "voxel-icon", 2);
        ɵngcc0.ɵɵtext(8, "seta_direita");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-dot-indicator--on-dark", ctx.onDark);
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("tabindex", ctx.current === 1 ? -1 : 0)("aria-label", ctx.previousLiteral)("contrast", ctx.onDark ? "dark" : "");
        ɵngcc0.ɵɵattribute("aria-disabled", ctx.current === 1);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵattribute("aria-label", ctx.dotsLiteral);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.dots);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("tabindex", ctx.current === ctx.quantity ? -1 : 0)("aria-label", ctx.nextLiteral)("contrast", ctx.onDark ? "dark" : "");
        ɵngcc0.ɵɵattribute("aria-disabled", ctx.current === ctx.quantity);
    } }, directives: [VoxelButtonComponent, VoxelIconComponent, ɵngcc1.NgForOf], styles: [".voxel-dot-indicator[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_6x);gap:var(--ids_size_general_6x)}.voxel-dot-indicator__dots[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_4x);gap:var(--ids_size_general_4x);pointer-events:none}.voxel-dot-indicator__item[_ngcontent-%COMP%]{-ms-flex-item-align:center;align-self:center;border:var(--ids_size_border_small) solid var(--ids_color_action_neutral_base);border-radius:50%;height:var(--ids_size_general_6x);opacity:var(--ids_opacity_none);-webkit-transition:background-color 175ms ease-in,opacity 175ms ease-in;transition:background-color 175ms ease-in,opacity 175ms ease-in;width:var(--ids_size_general_6x)}.voxel-dot-indicator__item--selected[_ngcontent-%COMP%]{background:var(--ids_color_action_neutral_variant);border:var(--ids_size_border_small) solid var(--ids_color_action_neutral_variant);-webkit-transition:background-color 175ms ease-in,opacity 175ms ease-in;transition:background-color 175ms ease-in,opacity 175ms ease-in}.voxel-dot-indicator--on-dark[_ngcontent-%COMP%]   .voxel-dot-indicator__item[_ngcontent-%COMP%]{border-color:var(--ids_color_contrast_onDark);opacity:var(--ids_opacity_strong)}.voxel-dot-indicator--on-dark[_ngcontent-%COMP%]   .voxel-dot-indicator__item--selected[_ngcontent-%COMP%]{background:var(--ids_color_contrast_onDark);opacity:var(--ids_opacity_none)}.voxel-dot-indicator--on-light[_ngcontent-%COMP%]   .voxel-dot-indicator__item[_ngcontent-%COMP%]{border-color:var(--ids_color_contrast_onLight);opacity:var(--ids_opacity_strong)}.voxel-dot-indicator--on-light[_ngcontent-%COMP%]   .voxel-dot-indicator__item--selected[_ngcontent-%COMP%]{background:var(--ids_color_contrast_onLight);opacity:var(--ids_opacity_none)}"] });
VoxelDotIndicatorComponent.ctorParameters = () => [
    { type: LiveAnnouncer },
    { type: Platform },
    { type: ApplicationRef }
];
VoxelDotIndicatorComponent.propDecorators = {
    current: [{ type: Input }],
    currentLiteral: [{ type: Input }],
    dotsLiteral: [{ type: Input }],
    id: [{ type: Input }],
    quantity: [{ type: Input }],
    nextLiteral: [{ type: Input }],
    onDark: [{ type: Input }],
    previousLiteral: [{ type: Input }],
    currentChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelDotIndicatorComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-dot-indicator',
                template: "<div\n  [id]=\"id\"\n  class=\"voxel-dot-indicator\"\n  [class.voxel-dot-indicator--on-dark]=\"onDark\">\n\n  <button voxelButtonAction\n    class=\"voxel-dot-indicator__arrow\"\n    [tabindex]=\"current === 1 ? -1 : 0\"\n    [attr.aria-disabled]=\"current === 1\"\n    variant=\"neutral\"\n    [aria-label]=\"previousLiteral\"\n    [contrast]=\"onDark ? 'dark' : ''\"\n    (click)=\"previous()\"\n  >\n    <voxel-icon size=\"S\">seta_esquerda</voxel-icon>\n  </button>\n  <div class=\"voxel-dot-indicator__dots\" role=\"text\" [attr.aria-label]=\"dotsLiteral\">\n    <div\n      class=\"voxel-dot-indicator__item\"\n      [class.voxel-dot-indicator__item--selected]=\"current === (dot + 1)\"\n      *ngFor=\"let dot of dots\"\n    ></div>\n  </div>\n  <button voxelButtonAction\n    class=\"voxel-dot-indicator__arrow\"\n    [tabindex]=\"current === quantity ? -1 : 0\"\n    [attr.aria-disabled]=\"current === quantity\"\n    variant=\"neutral\"\n    [aria-label]=\"nextLiteral\"\n    [contrast]=\"onDark ? 'dark' : ''\"\n    (click)=\"next()\"\n  >\n    <voxel-icon size=\"S\">seta_direita</voxel-icon>\n  </button>\n </div>\n",
                styles: [".voxel-dot-indicator{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_6x);gap:var(--ids_size_general_6x)}.voxel-dot-indicator__dots{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_4x);gap:var(--ids_size_general_4x);pointer-events:none}.voxel-dot-indicator__item{-ms-flex-item-align:center;align-self:center;border:var(--ids_size_border_small) solid var(--ids_color_action_neutral_base);border-radius:50%;height:var(--ids_size_general_6x);opacity:var(--ids_opacity_none);-webkit-transition:background-color 175ms ease-in,opacity 175ms ease-in;transition:background-color 175ms ease-in,opacity 175ms ease-in;width:var(--ids_size_general_6x)}.voxel-dot-indicator__item--selected{background:var(--ids_color_action_neutral_variant);border:var(--ids_size_border_small) solid var(--ids_color_action_neutral_variant);-webkit-transition:background-color 175ms ease-in,opacity 175ms ease-in;transition:background-color 175ms ease-in,opacity 175ms ease-in}.voxel-dot-indicator--on-dark .voxel-dot-indicator__item{border-color:var(--ids_color_contrast_onDark);opacity:var(--ids_opacity_strong)}.voxel-dot-indicator--on-dark .voxel-dot-indicator__item--selected{background:var(--ids_color_contrast_onDark);opacity:var(--ids_opacity_none)}.voxel-dot-indicator--on-light .voxel-dot-indicator__item{border-color:var(--ids_color_contrast_onLight);opacity:var(--ids_opacity_strong)}.voxel-dot-indicator--on-light .voxel-dot-indicator__item--selected{background:var(--ids_color_contrast_onLight);opacity:var(--ids_opacity_none)}\n"]
            }]
    }], function () { return [{ type: ɵngcc3.LiveAnnouncer }, { type: ɵngcc6.Platform }, { type: ɵngcc0.ApplicationRef }]; }, { id: [{
            type: Input
        }], currentChange: [{
            type: Output
        }], current: [{
            type: Input
        }], currentLiteral: [{
            type: Input
        }], dotsLiteral: [{
            type: Input
        }], quantity: [{
            type: Input
        }], nextLiteral: [{
            type: Input
        }], onDark: [{
            type: Input
        }], previousLiteral: [{
            type: Input
        }] }); })();

class VoxelDotIndicatorModule {
}
VoxelDotIndicatorModule.ɵfac = function VoxelDotIndicatorModule_Factory(t) { return new (t || VoxelDotIndicatorModule)(); };
VoxelDotIndicatorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelDotIndicatorModule });
VoxelDotIndicatorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelButtonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelDotIndicatorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelButtonModule, VoxelIconModule],
                declarations: [VoxelDotIndicatorComponent],
                exports: [VoxelDotIndicatorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelDotIndicatorModule, { declarations: function () { return [VoxelDotIndicatorComponent]; }, imports: function () { return [CommonModule, VoxelButtonModule, VoxelIconModule]; }, exports: function () { return [VoxelDotIndicatorComponent]; } }); })();

class VoxelFavoriteComponent {
    constructor() {
        this.userPlatform = platform;
        /**
         * texto que será lido por leitores de tela quando marcado
         *
         * *text that will be read by screen readers when checked*
         */
        this.checkedLabel = 'desfavoritar';
        /**
         * texto que será lido por leitores de tela quando não marcado
         *
         * *text that will be read by screen readers when unchecked*
         */
        this.uncheckedLabel = 'favoritar';
        this._invalid = false;
        this._checked = false;
        this._disabled = false;
        /**
         * emite o evento quando o componente tem seu status alterado
         *
         * *emits the event when the component has its status changed*
         */
        this.checkedChange = new EventEmitter();
        /** @internal */
        this.hostDescribedby = null;
    }
    /**
     * define o estado do componente como inválido
     *
     * *define component state to invalid*
     */
    set invalid(value) {
        this._invalid = enforceBoolean(value);
    }
    get invalid() {
        return this._invalid;
    }
    /**
     * define o estado do componente como marcado
     *
     * *define component state to checked*
     */
    set checked(value) {
        this._checked = enforceBoolean(value);
        this.setIconAndLabel();
    }
    get checked() {
        return this._checked;
    }
    /**
     * define o estado do componente como desabilitado
     *
     * *define component state to disabled*
     */
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    get disabled() {
        return this._disabled;
    }
    /** @internal */
    ngOnInit() {
        this.setIconAndLabel();
    }
    /** @internal */
    select() {
        this.checked = !this.checked;
        this.checkedChange.emit(this.checked);
    }
    /** @internal */
    setIconAndLabel() {
        this.icon = this.checked
            ? this.checkedIcon
                ? this.checkedIcon
                : 'favorito'
            : this.uncheckedIcon
                ? this.uncheckedIcon
                : 'favorito_outline';
        this.ariaLabel = this.checked ? this.checkedLabel : this.uncheckedLabel;
    }
}
VoxelFavoriteComponent.ɵfac = function VoxelFavoriteComponent_Factory(t) { return new (t || VoxelFavoriteComponent)(); };
VoxelFavoriteComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFavoriteComponent, selectors: [["voxel-favorite"]], hostVars: 1, hostBindings: function VoxelFavoriteComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-describedby", ctx.hostDescribedby);
    } }, inputs: { checkedLabel: "checkedLabel", uncheckedLabel: "uncheckedLabel", invalid: "invalid", checked: "checked", disabled: "disabled", checkedIcon: "checkedIcon", uncheckedIcon: "uncheckedIcon", ariaDescribedby: ["aria-describedby", "ariaDescribedby"] }, outputs: { checkedChange: "checkedChange" }, ngContentSelectors: _c1, decls: 6, vars: 9, consts: [[1, "voxel-favorite", 3, "disabled", "click"], [4, "ngIf"], ["hidden", ""], ["content", ""]], template: function VoxelFavoriteComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function VoxelFavoriteComponent_Template_button_click_0_listener() { return ctx.select(); });
        ɵngcc0.ɵɵtemplate(1, VoxelFavoriteComponent_voxel_icon_1_Template, 2, 1, "voxel-icon", 1);
        ɵngcc0.ɵɵtemplate(2, VoxelFavoriteComponent_voxel_icon_2_Template, 2, 1, "voxel-icon", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "span", 2, 3);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(4);
        ɵngcc0.ɵɵclassProp("voxel-favorite--checked", ctx.checked);
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled || ctx.invalid);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel)("aria-describedby", ctx.ariaDescribedby)("aria-invalid", ctx.invalid)("aria-live", ctx.userPlatform.os === "Android" ? "polite" : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.checkedIcon && _r2.innerText);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.checkedIcon || !_r2.innerText);
    } }, directives: [ɵngcc1.NgIf, VoxelIconComponent], styles: [".voxel-favorite{background-color:transparent;border:0;cursor:pointer}.voxel-favorite .voxel-icon{color:inherit}.voxel-favorite:disabled{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.voxel-favorite[aria-invalid=true]{color:var(--ids_color_feedback_error)}.voxel-favorite--checked{color:var(--ids_color_action_primary_base)}.voxel-favorite:hover:not(:disabled):not([aria-invalid=true]){color:var(--ids_color_action_neutral_variant)}.voxel-favorite--checked:hover:not(:disabled):not([aria-invalid=true]){color:var(--ids_color_action_primary_variant)}\n"], encapsulation: 2 });
VoxelFavoriteComponent.propDecorators = {
    checkedLabel: [{ type: Input }],
    uncheckedLabel: [{ type: Input }],
    checkedIcon: [{ type: Input }],
    uncheckedIcon: [{ type: Input }],
    ariaDescribedby: [{ type: Input, args: ['aria-describedby',] }],
    invalid: [{ type: Input }],
    checked: [{ type: Input }],
    disabled: [{ type: Input }],
    checkedChange: [{ type: Output }],
    hostDescribedby: [{ type: HostBinding, args: ['attr.aria-describedby',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFavoriteComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-favorite',
                template: "<button\n  class=\"voxel-favorite\"\n  [attr.aria-label]=\"ariaLabel\"\n  [attr.aria-describedby]=\"ariaDescribedby\"\n  (click)=\"select()\"\n  [disabled]=\"disabled || invalid\"\n  [attr.aria-invalid]=\"invalid\"\n  [class.voxel-favorite--checked]=\"checked\"\n  [attr.aria-live]=\"userPlatform.os === 'Android' ? 'polite' : null\"\n>\n  <voxel-icon *ngIf=\"!checkedIcon && content.innerText\">{{ checked ? content.innerText  : !uncheckedIcon ? content.innerText+'_outline' : uncheckedIcon }}</voxel-icon>\n  <voxel-icon *ngIf=\"checkedIcon || !content.innerText\">{{ icon }}</voxel-icon>\n</button>\n\n<span hidden #content>\n  <ng-content></ng-content>\n</span>",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-favorite{background-color:transparent;border:0;cursor:pointer}.voxel-favorite .voxel-icon{color:inherit}.voxel-favorite:disabled{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.voxel-favorite[aria-invalid=true]{color:var(--ids_color_feedback_error)}.voxel-favorite--checked{color:var(--ids_color_action_primary_base)}.voxel-favorite:hover:not(:disabled):not([aria-invalid=true]){color:var(--ids_color_action_neutral_variant)}.voxel-favorite--checked:hover:not(:disabled):not([aria-invalid=true]){color:var(--ids_color_action_primary_variant)}\n"]
            }]
    }], function () { return []; }, { checkedLabel: [{
            type: Input
        }], uncheckedLabel: [{
            type: Input
        }], checkedChange: [{
            type: Output
        }], hostDescribedby: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }], invalid: [{
            type: Input
        }], checked: [{
            type: Input
        }], disabled: [{
            type: Input
        }], checkedIcon: [{
            type: Input
        }], uncheckedIcon: [{
            type: Input
        }], ariaDescribedby: [{
            type: Input,
            args: ['aria-describedby']
        }] }); })();

class VoxelFavoriteModule {
}
VoxelFavoriteModule.ɵfac = function VoxelFavoriteModule_Factory(t) { return new (t || VoxelFavoriteModule)(); };
VoxelFavoriteModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelFavoriteModule });
VoxelFavoriteModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFavoriteModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelFavoriteComponent],
                exports: [VoxelFavoriteComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelFavoriteModule, { declarations: function () { return [VoxelFavoriteComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelFavoriteComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID_PREFIX = 0;
class VoxelPrefixDirective {
    constructor() {
        this.classes = true;
        this.id = `voxel-prefix-${NEXT_ID_PREFIX++}`;
    }
}
VoxelPrefixDirective.ɵfac = function VoxelPrefixDirective_Factory(t) { return new (t || VoxelPrefixDirective)(); };
VoxelPrefixDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelPrefixDirective, selectors: [["", "voxelPrefix", ""]], hostVars: 3, hostBindings: function VoxelPrefixDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.id);
        ɵngcc0.ɵɵclassProp("voxel-form-field__prefix", ctx.classes);
    } }, inputs: { id: "id" }, exportAs: ["voxelPrefix"] });
VoxelPrefixDirective.propDecorators = {
    classes: [{ type: HostBinding, args: ['class.voxel-form-field__prefix',] }],
    id: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelPrefixDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelPrefix]',
                exportAs: 'voxelPrefix'
            }]
    }], function () { return []; }, { classes: [{
            type: HostBinding,
            args: ['class.voxel-form-field__prefix']
        }], id: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }] }); })();
class VoxelSuffixDirective {
}
VoxelSuffixDirective.ɵfac = function VoxelSuffixDirective_Factory(t) { return new (t || VoxelSuffixDirective)(); };
VoxelSuffixDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelSuffixDirective, selectors: [["", "voxelSuffix", ""]], exportAs: ["voxelSuffix"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSuffixDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelSuffix]',
                exportAs: 'voxelSuffix'
            }]
    }], null, null); })();

/**
 * @internal
 */
let NEXT_ID$d = 0;
/**
 * Componente/diretiva de mensagem de erro. Deve ser utilizado em conjunto com inputs.
 *
 * *Component/Directive of error message. Must be used in conjunction with input elements*
 *
 * @example basico
 * <span *ngIf="isFormInvalid" voxel-error-msg>
 *  Campo Obrigatório!
 * </span>
 *
 * <example-url>../../demo/index.html#/portfolio/input?componentOnly=true</example-url>
 */
class VoxelErrorMessageComponent {
    constructor() {
        this.errorMsgId = `voxel-error-msg-${NEXT_ID$d++}`;
        this.errorMsgClasses = 'voxel-error-message';
        this.errorMsgAriaLive = 'polite';
    }
}
VoxelErrorMessageComponent.ɵfac = function VoxelErrorMessageComponent_Factory(t) { return new (t || VoxelErrorMessageComponent)(); };
VoxelErrorMessageComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelErrorMessageComponent, selectors: [["voxel-error-msg"], ["", "voxel-error-msg", ""], ["", "voxelErrorMsg", ""]], hostVars: 3, hostBindings: function VoxelErrorMessageComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.errorMsgId)("class", ctx.errorMsgClasses)("aria-live", ctx.errorMsgAriaLive);
    } }, inputs: { errorMsgId: "errorMsgId", errorMsgClasses: "errorMsgClasses", errorMsgAriaLive: "errorMsgAriaLive" }, exportAs: ["voxelErrorMsg"], ngContentSelectors: _c1, decls: 4, vars: 0, consts: [[1, "voxel-error-message-icon"], ["size", "S"]], template: function VoxelErrorMessageComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "voxel-icon", 1);
        ɵngcc0.ɵɵtext(2, "aviso_outline");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(3);
    } }, directives: [VoxelIconComponent], styles: [".voxel-error-message{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--ids_color_feedback_error);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-error-message voxel-icon{margin-right:var(--ids_size_general_8x)}.voxel-error-message voxel-icon .voxel-icon{color:var(--ids_color_feedback_error)}.voxel-error-message-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}\n"], encapsulation: 2, changeDetection: 0 });
VoxelErrorMessageComponent.propDecorators = {
    errorMsgId: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }],
    errorMsgClasses: [{ type: Input }, { type: HostBinding, args: ['attr.class',] }],
    errorMsgAriaLive: [{ type: Input }, { type: HostBinding, args: ['attr.aria-live',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelErrorMessageComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-error-msg, [voxel-error-msg], [voxelErrorMsg]',
                exportAs: 'voxelErrorMsg',
                template: `
    <div class="voxel-error-message-icon">
      <voxel-icon size="S">aviso_outline</voxel-icon>
    </div>
    <ng-content></ng-content>
  `,
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".voxel-error-message{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--ids_color_feedback_error);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-error-message voxel-icon{margin-right:var(--ids_size_general_8x)}.voxel-error-message voxel-icon .voxel-icon{color:var(--ids_color_feedback_error)}.voxel-error-message-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}\n"]
            }]
    }], function () { return []; }, { errorMsgId: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], errorMsgClasses: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.class']
        }], errorMsgAriaLive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-live']
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$c = 0;
class VoxelHintFieldDirective {
    constructor() {
        this.hintFieldId = `voxel-hint-field-${NEXT_ID$c++}`;
        this.hintFieldClasses = 'voxel-hint-field';
        this.hintMsgAriaLive = 'off';
    }
}
VoxelHintFieldDirective.ɵfac = function VoxelHintFieldDirective_Factory(t) { return new (t || VoxelHintFieldDirective)(); };
VoxelHintFieldDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHintFieldDirective, selectors: [["voxel-hint-field"], ["", "voxel-hint-field", ""], ["", "voxelHintField", ""]], hostVars: 3, hostBindings: function VoxelHintFieldDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.hintFieldId)("class", ctx.hintFieldClasses)("aria-live", ctx.hintMsgAriaLive);
    } }, inputs: { hintFieldId: "hintFieldId", hintFieldClasses: "hintFieldClasses", hintMsgAriaLive: "hintMsgAriaLive" }, exportAs: ["voxelHintField"] });
VoxelHintFieldDirective.propDecorators = {
    hintFieldId: [{ type: Input }, { type: HostBinding, args: ['attr.id',] }],
    hintFieldClasses: [{ type: Input }, { type: HostBinding, args: ['attr.class',] }],
    hintMsgAriaLive: [{ type: Input }, { type: HostBinding, args: ['attr.aria-live',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHintFieldDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-hint-field, [voxel-hint-field], [voxelHintField]',
                exportAs: 'voxelHintField'
            }]
    }], function () { return []; }, { hintFieldId: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.id']
        }], hintFieldClasses: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.class']
        }], hintMsgAriaLive: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.aria-live']
        }] }); })();

/**
 * @internal
 */
class VoxelFieldBase {
    constructor(ngControl, elementRef, errorState) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.errorState = errorState;
    }
}
/**
 * @internal
 */
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class VoxelFieldMixinBase extends FormAcessorMixin(VoxelFieldBase) {
    constructor(ngControl, elementRef) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this._controlAriaInvalid = null;
        this.controlDescribedBy = null;
        this.ariaLabelledby = null;
    }
    get controlAriaInvalid() {
        return this._controlAriaInvalid;
    }
    set controlAriaInvalid(value) {
        this._controlAriaInvalid = value;
    }
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    a11yHandler(described, describedId) {
        this.controlDescribedBy = described ? null : describedId;
    }
    onErrorStatusChange(hasDescription, describedById, state) {
        this.controlDescribedBy = null;
        this.controlAriaInvalid = null;
        if (hasDescription) {
            this.controlDescribedBy = describedById;
        }
        if (state) {
            this.controlDescribedBy = describedById;
            this.controlAriaInvalid = state;
        }
    }
}
VoxelFieldMixinBase.ɵfac = function VoxelFieldMixinBase_Factory(t) { return new (t || VoxelFieldMixinBase)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelFieldMixinBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelFieldMixinBase, selectors: [["do-not-use-voxel-field-mixin-base"]], hostVars: 3, hostBindings: function VoxelFieldMixinBase_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-describedby", ctx.controlDescribedBy)("aria-labelledby", ctx.ariaLabelledby)("aria-invalid", ctx.controlAriaInvalid);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelFieldMixinBase.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef }
];
VoxelFieldMixinBase.propDecorators = {
    controlDescribedBy: [{ type: HostBinding, args: ['attr.aria-describedby',] }],
    ariaLabelledby: [{ type: HostBinding, args: ['attr.aria-labelledby',] }],
    controlAriaInvalid: [{ type: HostBinding, args: ['attr.aria-invalid',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFieldMixinBase, [{
        type: Directive,
        args: [{
                // eslint-disable-next-line @angular-eslint/directive-selector
                selector: 'do-not-use-voxel-field-mixin-base'
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { controlDescribedBy: [{
            type: HostBinding,
            args: ['attr.aria-describedby']
        }], ariaLabelledby: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], controlAriaInvalid: [{
            type: HostBinding,
            args: ['attr.aria-invalid']
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$b = 0;
/**
 * Os formulários reativos fornecem uma abordagem orientada a modelo para lidar com entradas de formulário
 * cujo valores mudam ao longo do tempo. Este guia mostra como criar e atualizar um controle de formulário simples e
 * validar valores do formulário.
 *
 * **Module:**
 *
 * `import { VoxelInputModule, VoxelFormFieldModule, VoxelIconModule } from '@voxel/components/ids';`
 *
 * Este modulo possui todas as diretivas de criação de formulários do tipo formulário reativo.
 *
 * `import { ReactiveFormsModule } from '@angular/forms';`
 *
 * **Component.ts:**
 *
 *  Este import disponibiliza os recursos Angular para criar o formulário reativo.
 *
 * `import { FormControl, Validators, FormGroup } from '@angular/forms';`
 *
 * <example-url>../../demo/index.html#/portfolio/input?componentOnly=true</example-url>
 *
 * @example component.ts
 *  form = new FormGroup({
 *    simple: new FormControl(''),
 *    withErrornHelper: new FormControl('', [Validators.required]),
 *    disabled: new FormControl({ value: '', disabled: true }),
 *    disabledWithValue: new FormControl({ value: 'teste', disabled: true }),
 *  });
 *
 * @example component.html
 *  <form [formGroup]="form">
 *     <voxel-form-field label="nome">
 *        <input
 *          voxelInput
 *          formControlName="simple">
 *     </voxel-form-field>
 *     <voxel-form-field
 *       label="nome"
 *       description="informe o nome completo"
 *       msgErr="o preenchimento do nome é obrigatório"
 *     >
 *       <input
 *         voxelInput
 *         formControlName="withErrornHelper"
 *       >
 *     </voxel-form-field>
 *     <voxel-form-field label="nome">
 *       <input
 *         voxelInput
 *         formControlName="disabled"
 *       >
 *     </voxel-form-field>
 *     <voxel-form-field label="nome">
 *       <input
 *         voxelInput
 *         formControlName="disabledWithValue"
 *       >
 *     </voxel-form-field>
 *     <voxel-form-field label="nome">
 *       <input
 *         voxelInput
 *       >
 *       <voxel-icon>editar</voxel-icon>
 *     </voxel-form-field>
 *     <voxel-form-field label="nome">
 *       <input
 *         voxelInput
 *       >
 *       <voxel-icon>editar_outline</voxel-icon>
 *     </voxel-form-field>
 * </form>
 *
 * @example component.html
 *  <form [formGroup]="form">
 *    <voxel-form-field
 *       label="nome"
 *        >
 *        <textarea
 *            voxelInput
 *            rows="4"
 *            cols="30"
 *            formControlName="simple"
 *        ></textarea>
 *    </voxel-form-field>
 *
 *    <voxel-form-field
 *      label="nome"
 *    >
 *      <textarea
 *        voxelInput
 *        maxlength="144"
 *        rows="4"
 *        cols="30"
 *        formControlName="withCounter"
 *      ></textarea>
 *    </voxel-form-field>
 *
 *    <voxel-form-field
 *      label="nome"
 *      msgErr="o preenchimento do nome é obrigatório"
 *    >
 *      <textarea
 *        voxelInput
 *        rows="4"
 *        cols="30"
 *        formControlName="withError"
 *        required
 *      ></textarea>
 *    </voxel-form-field>
 *
 *    <voxel-form-field
 *      label="nome"
 *      msgErr="o preenchimento do nome é obrigatório"
 *    >
 *      <textarea
 *        voxelInput
 *        maxlength="144"
 *        rows="4"
 *        cols="30"
 *        formControlName="withErrornCounter"
 *        required
 *      ></textarea>
 *    </voxel-form-field>
 *
 *    <voxel-form-field
 *      label="nome"
 *    >
 *      <textarea
 *        voxelInput
 *        rows="4"
 *        cols="30"
 *        formControlName="disabled"
 *      ></textarea>
 *    </voxel-form-field>
 *  </form>
 */
class VoxelFormFieldComponent {
    constructor() {
        /** @internal */
        this._showError = false;
        /** @internal */
        this.COMPONENT_NOT_FOUND = 'VoxelComponents: Não foi possível encontrar a diretiva voxelInput, nem o componente <voxel-select> dentro de <voxel-form-field>.';
        /** @internal */
        this.selector = 'VoxelFormFieldComponent';
        /** @internal */
        this.describedById = `voxel-describedby-${NEXT_ID$b}`;
        /** @internal */
        this._destroy = new Subject();
        /**
         * Variavel que define o id do form field
         *
         * *Variable that define the id of form field*
         */
        this.formFieldId = `voxel-form-field-${NEXT_ID$b++}`;
        /**
         * label do campo
         *
         * *field label*
         */
        this.label = 'default';
        /**
         * limite que determina quando o polite estará ativo
         *
         * *threshold that states when the polite will be active*
         */
        this.a11yPoliteThresold = 15;
        this._msgErr = 'o preenchimento do [rótulo do campo] é obrigatório';
        /**
         * Mensagem plural/singular para caracteres que faltam
         *
         * *Singular/Plural message for remaining characters*
         */
        this.charactersRemainingLabel = {
            singular: 'caracter restante',
            plural: 'caracteres restantes',
        };
    }
    /** @internal */
    get showError() {
        return this._showError;
    }
    /** @internal */
    set showError(value) {
        this._showError = value;
    }
    /** @internal */
    get formFielClasses() {
        return this.field
            ? {
                'voxel-form-field__container': true,
                'voxel-form-field__container--error': this.showError,
                'voxel-form-field__container--value': this.field.value || this.field.nativeElement.value,
                'voxel-form-field__container--placeholder': this.field.nativeElement.placeholder,
                'voxel-form-field__container--focus': this.isFocused,
                'voxel-form-field__container--disabled': this.field.disabled || this.field.nativeElement.disabled,
            }
            : '';
    }
    /** @internal */
    get isFocused() {
        return ((this.field.focused || document.activeElement === this.field.nativeElement) &&
            !(this.field.disabled || this.field.nativeElement.disabled));
    }
    /**
     * mensagem de erro para ser exibida quando o campo é inválido
     *
     * *error message to shown when the field to be invalid*
     */
    get msgErr() {
        return this._msgErr;
    }
    set msgErr(msg) {
        this._msgErr = msg;
    }
    /** @internal */
    countCharacter() {
        const remainingCharacters = this.field.nativeElement.maxLength - this.field.value.toString().length;
        const pluralLabel = `${remainingCharacters} ${this.charactersRemainingLabel.plural} `;
        const singularLabel = `${remainingCharacters} ${this.charactersRemainingLabel.singular} `;
        this.description = remainingCharacters > 1 ? pluralLabel : singularLabel;
    }
    /** @internal */
    describedHandler() {
        return (this.field.active || !this.field.focused) && !this.showError;
    }
    updateAriaLabelWithPrefix() {
        if (this.prefix) {
            this.field.ariaLabelledby = `${this.field.controlId} ${this.prefix.id}`;
        }
    }
    ngAfterContentInit() {
        if (!this.field) {
            throw new Error(this.COMPONENT_NOT_FOUND);
        }
        this.field.errorState.pipe(startWith(false), takeUntil(this._destroy)).subscribe((state) => {
            this.showError = state;
            if (this.field.nativeElement.type === 'textarea' && this.field.nativeElement.maxLength >= 0) {
                this.countCharacter();
                if (platform.os === 'Windows') {
                    this.field.onErrorStatusChange(!!this.description, this.describedById, state);
                    this.field.a11yHandler(this.describedHandler(), this.describedById);
                    return;
                }
            }
            this.field.onErrorStatusChange(!!this.description, this.describedById, state);
        });
        this.updateAriaLabelWithPrefix();
    }
    /** @internal */
    ngOnDestroy() {
        this._destroy.complete();
    }
}
VoxelFormFieldComponent.ɵfac = function VoxelFormFieldComponent_Factory(t) { return new (t || VoxelFormFieldComponent)(); };
VoxelFormFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFormFieldComponent, selectors: [["voxel-form-field"]], contentQueries: function VoxelFormFieldComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFieldMixinBase, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelPrefixDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.field = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.prefix = _t.first);
    } }, inputs: { formFieldId: "formFieldId", label: "label", a11yPoliteThresold: "a11yPoliteThresold", charactersRemainingLabel: "charactersRemainingLabel", msgErr: "msgErr", description: "description" }, ngContentSelectors: _c21, decls: 14, vars: 14, consts: [[1, "voxel-form-field", 3, "id"], [3, "ngClass"], [1, "voxel-form-field__label", 3, "for"], [1, "voxel-form-field__suffix"], ["suffix", ""], [1, "voxel-form-field__status-message"], ["voxelErrorMsg", "", 3, "errorMsgId", 4, "ngIf", "ngIfElse"], ["descTemplate", ""], ["voxelErrorMsg", "", 3, "errorMsgId"], ["voxelHintField", "", "hintMsgAriaLive", "polite", 3, "hintFieldId", 4, "ngIf", "ngIfElse"], ["descriptionTemplate", ""], ["voxelHintField", "", "hintMsgAriaLive", "polite", 3, "hintFieldId"], ["voxelHintField", "", 3, "hintFieldId", 4, "ngIf"], ["voxelHintField", "", 3, "hintFieldId"]], template: function VoxelFormFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c19);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "label", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵprojection(5);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementStart(7, "div", 3, 4);
        ɵngcc0.ɵɵprojection(9, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 5);
        ɵngcc0.ɵɵtemplate(11, VoxelFormFieldComponent_span_11_Template, 2, 2, "span", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, VoxelFormFieldComponent_ng_template_12_Template, 3, 2, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(8);
        const _r2 = ɵngcc0.ɵɵreference(13);
        ɵngcc0.ɵɵclassProp("voxel-form-field--prefix", ctx.prefix)("voxel-form-field--affix", ctx.prefix || _r0);
        ɵngcc0.ɵɵproperty("id", ctx.formFieldId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.formFielClasses);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("for", ctx.field == null ? null : ctx.field.controlId);
        ɵngcc0.ɵɵattribute("id", (ctx.field == null ? null : ctx.field.labelId) ? ctx.field == null ? null : ctx.field.labelId : null);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.label, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c20, _r0.innerHTML.trim() ? true : false));
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showError && (!ctx.isFocused || ctx.isFocused && !ctx.description))("ngIfElse", _r2);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, VoxelErrorMessageComponent, VoxelHintFieldDirective], styles: ["voxel-form-field{display:block}voxel-form-field .voxel-input{outline:0}.voxel-form-field__prefix{-ms-flex-item-align:end;align-self:flex-end;color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_body_01_regular);white-space:nowrap}.voxel-form-field__prefix .voxel-icon{font-size:20px;line-height:1}.voxel-form-field__label{color:var(--ids_color_action_neutral_base);display:block;font:var(--ids_textStyle_label_medium_regular);min-height:var(--ids_size_general_24x);-webkit-transform:translateY(calc(var(--ids_size_general_32x) - var(--ids_size_general_2x)));transform:translateY(calc(var(--ids_size_general_32x) - var(--ids_size_general_2x)));-webkit-transition:font .25s,-webkit-transform .25s;transition:font .25s,-webkit-transform .25s;transition:transform .25s,font .25s;transition:transform .25s,font .25s,-webkit-transform .25s}.voxel-form-field__input{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;min-height:var(--ids_size_general_32x);position:relative}.voxel-form-field__suffix{visibility:hidden}.voxel-form-field__content{padding-top:var(--ids_size_general_4x)}.voxel-form-field__content--suffix .voxel-form-field__input{padding-right:var(--ids_size_general_40x)}.voxel-form-field--prefix .voxel-form-field__label{-webkit-transform:none;transform:none}.voxel-form-field__status-message{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;color:var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);min-height:var(--ids_size_general_24x);padding-top:var(--ids_spacing_1x)}.voxel-form-field__container{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);-webkit-box-sizing:border-box;box-sizing:border-box;min-height:var(--ids_size_general_64x);outline-offset:3px;padding:0 var(--ids_size_general_8x);position:relative;width:100%}.voxel-form-field__container:before{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);content:\"\";height:100%;left:0;margin-left:auto;margin-right:auto;margin-top:var(--ids_size_general_2x);opacity:0;pointer-events:none;position:absolute;right:0;-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transition:opacity .25s,-webkit-transform .25s;transition:opacity .25s,-webkit-transform .25s;transition:transform .25s,opacity .25s;transition:transform .25s,opacity .25s,-webkit-transform .25s}.voxel-form-field__container--focus .voxel-form-field__label,.voxel-form-field__container--value .voxel-form-field__label,.voxel-form-field__container--placeholder .voxel-form-field__label{font:var(--ids_textStyle_label_small_regular);-webkit-transform:none;transform:none;-webkit-transition:-webkit-transform 175ms;transition:-webkit-transform 175ms;transition:transform 175ms;transition:transform 175ms,-webkit-transform 175ms}.voxel-form-field__container--focus .voxel-form-field__suffix,.voxel-form-field__container--value .voxel-form-field__suffix,.voxel-form-field__container--placeholder .voxel-form-field__suffix{visibility:visible}.voxel-form-field__container--focus{outline:5px auto Highlight;outline:5px auto -webkit-focus-ring-color}.voxel-form-field__container--focus:before{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transition:opacity .25s,-webkit-transform .25s;transition:opacity .25s,-webkit-transform .25s;transition:transform .25s,opacity .25s;transition:transform .25s,opacity .25s,-webkit-transform .25s}.voxel-form-field__container--focus .voxel-form-field__label{font:var(--ids_textStyle_label_small_bold)}.voxel-form-field__container--disabled{background-color:var(--ids_color_action_disabled_variant_soft);border-color:var(--ids_color_border_soft);border-radius:var(--ids_size_cornerRadius_tooltip) var(--ids_size_cornerRadius_tooltip) 0 0;color:var(--ids_color_action_disabled_variant)}.voxel-form-field__container--disabled+.voxel-form-field__status-message,.voxel-form-field__container--disabled .voxel-icon,.voxel-form-field__container--disabled .voxel-form-field__label{color:var(--ids_color_action_disabled_variant)}.voxel-form-field__container--error:not(.voxel-form-field__container--focus) .voxel-form-field__label{color:var(--ids_color_feedback_error);font:var(--ids_textStyle_label_small_bold)}.voxel-form-field--affix .voxel-form-field__content{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_4x);gap:var(--ids_size_general_4x)}.voxel-input{background:transparent;border:none;caret-color:var(--ids_color_action_primary_base);color:var(--ids_color_action_neutral_variant);display:block;font:var(--ids_textStyle_label_large_regular);resize:vertical;width:100%}.voxel-input:-moz-read-only{color:var(--ids_color_action_neutral_base);resize:none}.voxel-input:read-only,.voxel-input:disabled{color:var(--ids_color_action_neutral_base);resize:none}\n"], encapsulation: 2 });
VoxelFormFieldComponent.propDecorators = {
    formFieldId: [{ type: Input }],
    label: [{ type: Input }],
    a11yPoliteThresold: [{ type: Input }],
    msgErr: [{ type: Input }],
    description: [{ type: Input }],
    field: [{ type: ContentChild, args: [VoxelFieldMixinBase, { static: true },] }],
    prefix: [{ type: ContentChild, args: [VoxelPrefixDirective, { static: true },] }],
    charactersRemainingLabel: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormFieldComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-form-field',
                template: "<div\n  class=\"voxel-form-field\"\n  [id]=\"formFieldId\" [class.voxel-form-field--prefix]=\"prefix\"\n  [class.voxel-form-field--affix]=\"prefix || suffix\"\n>\n  <div [ngClass]=\"formFielClasses\">\n    <label\n      [for]=\"field?.controlId\"\n      class=\"voxel-form-field__label\"\n      [attr.id]=\"field?.labelId ? field?.labelId : null\"\n    >\n      {{ label }}\n    </label>\n    <div\n    [ngClass]=\"{\n        'voxel-form-field__content': true,\n        'voxel-form-field__content--suffix': suffix.innerHTML.trim() ? true : false\n      }\"\n    >\n      <ng-content select=\"[voxelPrefix]\"></ng-content>\n\n      <ng-content></ng-content>\n\n      <div #suffix class=\"voxel-form-field__suffix\">\n        <ng-content select=\"voxel-icon, voxel-datepicker, [voxelSuffix]\"></ng-content>\n      </div>\n    </div>\n  </div>\n  <div class=\"voxel-form-field__status-message\">\n    <span\n      *ngIf=\"showError && (!isFocused || isFocused && !description); else descTemplate\"\n      voxelErrorMsg\n      [errorMsgId]=\"describedById\"\n    >\n      {{ msgErr }}\n    </span>\n  </div>\n  <ng-template #descTemplate>\n    <span\n      *ngIf=\"field.nativeElement.type === 'textarea'\n        && description\n        && (field.nativeElement.maxLength - field.value.toString().length <= a11yPoliteThresold); else descriptionTemplate\"\n      voxelHintField\n      [hintFieldId]=\"describedById\"\n      hintMsgAriaLive=\"polite\"\n    >\n      {{ description }}\n    </span>\n    <ng-template #descriptionTemplate>\n      <span\n        *ngIf=\"description\"\n        voxelHintField\n        [hintFieldId]=\"describedById\"\n      >\n        {{ description }}\n      </span>\n    </ng-template>\n  </ng-template>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                styles: ["voxel-form-field{display:block}voxel-form-field .voxel-input{outline:0}.voxel-form-field__prefix{-ms-flex-item-align:end;align-self:flex-end;color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_body_01_regular);white-space:nowrap}.voxel-form-field__prefix .voxel-icon{font-size:20px;line-height:1}.voxel-form-field__label{color:var(--ids_color_action_neutral_base);display:block;font:var(--ids_textStyle_label_medium_regular);min-height:var(--ids_size_general_24x);-webkit-transform:translateY(calc(var(--ids_size_general_32x) - var(--ids_size_general_2x)));transform:translateY(calc(var(--ids_size_general_32x) - var(--ids_size_general_2x)));-webkit-transition:font .25s,-webkit-transform .25s;transition:font .25s,-webkit-transform .25s;transition:transform .25s,font .25s;transition:transform .25s,font .25s,-webkit-transform .25s}.voxel-form-field__input{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;min-height:var(--ids_size_general_32x);position:relative}.voxel-form-field__suffix{visibility:hidden}.voxel-form-field__content{padding-top:var(--ids_size_general_4x)}.voxel-form-field__content--suffix .voxel-form-field__input{padding-right:var(--ids_size_general_40x)}.voxel-form-field--prefix .voxel-form-field__label{-webkit-transform:none;transform:none}.voxel-form-field__status-message{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;color:var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);min-height:var(--ids_size_general_24x);padding-top:var(--ids_spacing_1x)}.voxel-form-field__container{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);-webkit-box-sizing:border-box;box-sizing:border-box;min-height:var(--ids_size_general_64x);outline-offset:3px;padding:0 var(--ids_size_general_8x);position:relative;width:100%}.voxel-form-field__container:before{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);content:\"\";height:100%;left:0;margin-left:auto;margin-right:auto;margin-top:var(--ids_size_general_2x);opacity:0;pointer-events:none;position:absolute;right:0;-webkit-transform:scaleX(.8);transform:scaleX(.8);-webkit-transition:opacity .25s,-webkit-transform .25s;transition:opacity .25s,-webkit-transform .25s;transition:transform .25s,opacity .25s;transition:transform .25s,opacity .25s,-webkit-transform .25s}.voxel-form-field__container--focus .voxel-form-field__label,.voxel-form-field__container--value .voxel-form-field__label,.voxel-form-field__container--placeholder .voxel-form-field__label{font:var(--ids_textStyle_label_small_regular);-webkit-transform:none;transform:none;-webkit-transition:-webkit-transform 175ms;transition:-webkit-transform 175ms;transition:transform 175ms;transition:transform 175ms,-webkit-transform 175ms}.voxel-form-field__container--focus .voxel-form-field__suffix,.voxel-form-field__container--value .voxel-form-field__suffix,.voxel-form-field__container--placeholder .voxel-form-field__suffix{visibility:visible}.voxel-form-field__container--focus{outline:5px auto Highlight;outline:5px auto -webkit-focus-ring-color}.voxel-form-field__container--focus:before{opacity:1;-webkit-transform:scaleX(1);transform:scaleX(1);-webkit-transition:opacity .25s,-webkit-transform .25s;transition:opacity .25s,-webkit-transform .25s;transition:transform .25s,opacity .25s;transition:transform .25s,opacity .25s,-webkit-transform .25s}.voxel-form-field__container--focus .voxel-form-field__label{font:var(--ids_textStyle_label_small_bold)}.voxel-form-field__container--disabled{background-color:var(--ids_color_action_disabled_variant_soft);border-color:var(--ids_color_border_soft);border-radius:var(--ids_size_cornerRadius_tooltip) var(--ids_size_cornerRadius_tooltip) 0 0;color:var(--ids_color_action_disabled_variant)}.voxel-form-field__container--disabled+.voxel-form-field__status-message,.voxel-form-field__container--disabled .voxel-icon,.voxel-form-field__container--disabled .voxel-form-field__label{color:var(--ids_color_action_disabled_variant)}.voxel-form-field__container--error:not(.voxel-form-field__container--focus) .voxel-form-field__label{color:var(--ids_color_feedback_error);font:var(--ids_textStyle_label_small_bold)}.voxel-form-field--affix .voxel-form-field__content{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_4x);gap:var(--ids_size_general_4x)}.voxel-input{background:transparent;border:none;caret-color:var(--ids_color_action_primary_base);color:var(--ids_color_action_neutral_variant);display:block;font:var(--ids_textStyle_label_large_regular);resize:vertical;width:100%}.voxel-input:-moz-read-only{color:var(--ids_color_action_neutral_base);resize:none}.voxel-input:read-only,.voxel-input:disabled{color:var(--ids_color_action_neutral_base);resize:none}\n"]
            }]
    }], function () { return []; }, { formFieldId: [{
            type: Input
        }], label: [{
            type: Input
        }], a11yPoliteThresold: [{
            type: Input
        }], charactersRemainingLabel: [{
            type: Input
        }], msgErr: [{
            type: Input
        }], description: [{
            type: Input
        }], field: [{
            type: ContentChild,
            args: [VoxelFieldMixinBase, { static: true }]
        }], prefix: [{
            type: ContentChild,
            args: [VoxelPrefixDirective, { static: true }]
        }] }); })();

const formFieldComponents = [
    VoxelErrorMessageComponent,
    VoxelFormFieldComponent,
    VoxelHintFieldDirective,
    VoxelPrefixDirective,
    VoxelSuffixDirective,
    VoxelFieldMixinBase,
];
class VoxelFormFieldModule {
}
VoxelFormFieldModule.ɵfac = function VoxelFormFieldModule_Factory(t) { return new (t || VoxelFormFieldModule)(); };
VoxelFormFieldModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelFormFieldModule });
VoxelFormFieldModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormFieldModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: formFieldComponents,
                exports: formFieldComponents
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelFormFieldModule, { declarations: function () { return [VoxelErrorMessageComponent, VoxelFormFieldComponent, VoxelHintFieldDirective, VoxelPrefixDirective, VoxelSuffixDirective, VoxelFieldMixinBase]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelErrorMessageComponent, VoxelFormFieldComponent, VoxelHintFieldDirective, VoxelPrefixDirective, VoxelSuffixDirective, VoxelFieldMixinBase]; } }); })();

/**
 * @internal
 */
let NEXT_ID$a = 0;
/**
 * O voxelFormStatus foi desenvolvido para ser utilizado em conjunto com os componentes de seleção como checkbox,
 * radiobutton e switch (wip).
 *
 * **Module:**
 *
 * `import { VoxelFormStatusModule } from '@voxel/components/ids';`
 *
 * Este modulo possui todas as declarações dos componentes citados acima.
 *
 * @example VoxelFormStatus
 * <voxel-form-status *ngIf="form.touched && form.invalid">
 *             seleciona uma opção para prosseguir
 * </voxel-form-status>
 *
 * @example Checkbox
 * <div>
 *             <voxel-form-selection>
 *               <input type="checkbox" formControlName="simple" voxelCheckbox />
 *               simples
 *             </voxel-form-selection>
 *             <voxel-form-status *ngIf="form.touched && form.invalid">
 *               seleciona uma opção para prosseguir
 *             </voxel-form-status>
 * </div>
 *
 * @example RadioButton
 * <div>
 *             <voxel-form-selection>
 *               <input type="radio" name="withError" formControlName="withError" voxelRadioButton />
 *                 Sim, aceito receber email :)
 *             </voxel-form-selection>
 *             <voxel-form-selection>
 *               <input type="radio" name="withError" formControlName="withError" voxelRadioButton />
 *                 Não aceito receber email.
 *             </voxel-form-selection>
 *             <voxel-form-status *ngIf="form.touched && form.invalid">
 *               seleciona uma opção para prosseguir
 *             </voxel-form-status>
 * </div>
 */
class VoxelFormStatusComponent {
    constructor() {
        /**
         * Variavel que define o id do form status
         *
         * *Variable that define the id of form status*
         */
        this.errorMsgId = `voxel-form-status-${++NEXT_ID$a}`;
        /**
         * Aria-live: indica em que momento a leitura da mensagem é feita.
         * Por padrão usamos o polite que não interrompe a leitura atual
         * mas pode-se inserir ```assertive```, que lê a mensagem assim que a mesma
         * aparece em tela.
         *
         */
        this.errorMsgAriaLive = 'polite';
    }
}
VoxelFormStatusComponent.ɵfac = function VoxelFormStatusComponent_Factory(t) { return new (t || VoxelFormStatusComponent)(); };
VoxelFormStatusComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFormStatusComponent, selectors: [["voxel-form-status"]], inputs: { errorMsgId: "errorMsgId", errorMsgAriaLive: "errorMsgAriaLive" }, ngContentSelectors: _c1, decls: 5, vars: 2, consts: [[1, "voxel-form-status"], ["size", "S"], [3, "id"]], template: function VoxelFormStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "voxel-icon", 1);
        ɵngcc0.ɵɵtext(2, "aviso_outline");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "span", 2);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("id", ctx.errorMsgId);
        ɵngcc0.ɵɵattribute("aria-live", ctx.errorMsgAriaLive);
    } }, directives: [VoxelIconComponent], styles: [".voxel-error-message[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--ids_color_feedback_error);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-error-message[_ngcontent-%COMP%]   voxel-icon[_ngcontent-%COMP%]{margin-right:var(--ids_size_general_8x)}.voxel-error-message[_ngcontent-%COMP%]   voxel-icon[_ngcontent-%COMP%]   .voxel-icon[_ngcontent-%COMP%]{color:var(--ids_color_feedback_error)}.voxel-error-message-icon[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}"] });
VoxelFormStatusComponent.propDecorators = {
    errorMsgId: [{ type: Input }],
    errorMsgAriaLive: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormStatusComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-form-status',
                template: "<div class=\"voxel-form-status\">\n  <voxel-icon size=\"S\">aviso_outline</voxel-icon>\n  <span [id]=\"errorMsgId\" [attr.aria-live]=\"errorMsgAriaLive\">\n    <ng-content></ng-content>\n  </span>\n</div>\n",
                styles: [".voxel-error-message{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--ids_color_feedback_error);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular)}.voxel-error-message voxel-icon{margin-right:var(--ids_size_general_8x)}.voxel-error-message voxel-icon .voxel-icon{color:var(--ids_color_feedback_error)}.voxel-error-message-icon{display:-webkit-box;display:-ms-flexbox;display:flex;margin-top:var(--ids_size_general_4x)}\n"]
            }]
    }], function () { return []; }, { errorMsgId: [{
            type: Input
        }], errorMsgAriaLive: [{
            type: Input
        }] }); })();

class VoxelFormStatusModule {
}
VoxelFormStatusModule.ɵfac = function VoxelFormStatusModule_Factory(t) { return new (t || VoxelFormStatusModule)(); };
VoxelFormStatusModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelFormStatusModule });
VoxelFormStatusModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormStatusModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule],
                declarations: [VoxelFormStatusComponent],
                exports: [VoxelFormStatusComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelFormStatusModule, { declarations: function () { return [VoxelFormStatusComponent]; }, imports: function () { return [CommonModule, VoxelIconModule]; }, exports: function () { return [VoxelFormStatusComponent]; } }); })();

/**
 * O Selector foi desenvolvido para ser utilizado em componentes de seleção como checkbox,
 * radiobutton e switch (wip).
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelCheckboxModule } from '@voxel/components/ids';`
 *
 * Este modulo possui todas as declarações dos componentes citados acima.
 *
 * @example Checkbox
 *  <voxel-form-selection>
 *    <input type="checkbox" formControlName="simple" voxelCheckbox />
 *     simples
 *  </voxel-form-selection>
 *
 * @example Radio Button
 *  <voxel-form-selection>
 *    <input type="radio" formControlName="radio-simple" voxelRadioButton />
 *    simples
 *  </voxel-form-selection>
 *
 */
class VoxelFormSelectionComponent {
    constructor() {
        /**
         * @internal
         */
        this._destroy = new Subject();
        /**
         * @internal
         */
        this.COMPONENT_NOT_FOUND = 'VoxelComponents: Não foi possível encontrar a diretiva voxelCheckbox ou voxelRadioButton, nem o input type="checkbox" ou type="radio" dentro do voxel-form-selection.';
        this._onDark = false;
    }
    set onDark(onDark) {
        this._onDark = enforceBoolean(onDark);
    }
    get onDark() {
        return this._onDark;
    }
    handleFormStatus() {
        let messageIds = [];
        this.status.changes.pipe(startWith(null), takeUntil(this._destroy)).subscribe(() => {
            messageIds = [];
            messageIds.push(...this.status.map((message) => message.errorMsgId));
            this.input.handleDescribedBy(messageIds);
            this.input.state = messageIds.length > 0 ? 'invalid' : '';
        });
    }
    ngAfterContentInit() {
        if (!this.input) {
            throw new Error(this.COMPONENT_NOT_FOUND);
        }
        this.input.onDark = this._onDark;
        this.handleFormStatus();
    }
    ngOnDestroy() {
        this._destroy.complete();
    }
}
VoxelFormSelectionComponent.ɵfac = function VoxelFormSelectionComponent_Factory(t) { return new (t || VoxelFormSelectionComponent)(); };
VoxelFormSelectionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFormSelectionComponent, selectors: [["voxel-form-selection"]], contentQueries: function VoxelFormSelectionComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFormSelectionBase, 7);
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFormStatusComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.status = _t);
    } }, inputs: { onDark: "onDark" }, ngContentSelectors: _c23, decls: 6, vars: 10, consts: [[1, "voxel-form-selection"], [3, "ngClass", 4, "ngIf"], [3, "id", "for"], [3, "ngClass"]], template: function VoxelFormSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c22);
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵtemplate(2, VoxelFormSelectionComponent_voxel_icon_2_Template, 2, 2, "voxel-icon", 1);
        ɵngcc0.ɵɵelementStart(3, "label", 2);
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(5, 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-form-selection--on-dark", ctx.onDark)("voxel-form-selection--rtl", ctx.input.rtlDirection);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.input.icon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMap("voxel-form-selection__label--" + ctx.input.selectorType);
        ɵngcc0.ɵɵproperty("id", ctx.input.labelId)("for", ctx.input.controlId);
        ɵngcc0.ɵɵattribute("aria-hidden", ctx.input.ariaHiddenLabel ? ctx.input.ariaHiddenLabel : null);
    } }, directives: [ɵngcc1.NgIf, VoxelIconComponent, ɵngcc1.NgClass], styles: [".voxel-form-selection{display:-webkit-box;display:-ms-flexbox;display:flex;padding:var(--ids_size_general_8x) 0;position:relative}.voxel-form-selection__checkbox--checked:not(.voxel-form-selection__checkbox--disabled):not(.voxel-form-selection__checkbox--invalid){color:var(--ids_color_action_primary_base)}.voxel-form-selection__radio:not(.voxel-form-selection__radio--disabled){color:var(--ids_color_action_primary_base)}.voxel-form-selection--rtl{direction:rtl;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.voxel-form-selection__label--checkbox{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);margin-left:var(--ids_size_general_8x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__checkbox{color:var(--ids_color_text_body_01);pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__checkbox .voxel-icon{color:var(--ids_color_action_neutral_base)}.voxel-form-selection__checkbox--invalid .voxel-icon{color:var(--ids_color_feedback_error)}.voxel-form-selection__checkbox--invalid~.voxel-form-selection__label--checkbox{font:var(--ids_textStyle_label_medium_bold)}.voxel-form-selection__checkbox--checked .voxel-icon,.voxel-form-selection__checkbox--inderteminate .voxel-icon{color:var(--ids_color_action_primary_base)}.voxel-form-selection__checkbox--disabled .voxel-icon{color:var(--ids_color_action_disabled_base)}.voxel-form-selection__checkbox--focus .voxel-icon{outline:auto -webkit-focus-ring-color}.voxel-form-selection__input--checkbox{height:var(--ids_size_general_22x);left:0;margin:var(--ids_size_general_1x);opacity:0;position:absolute;width:var(--ids_size_general_22x)}.voxel-form-selection__input--checkbox:disabled{color:var(--ids_color_action_disabled_variant)}.voxel-form-selection__input--checkbox:checked+.voxel-form-selection__checkbox .voxel-icon{color:var(--ids_color_action_primary_base)}.voxel-form-selection__input--checkbox:disabled~.voxel-form-selection__label--checkbox,.voxel-form-selection__input--checkbox:disabled+.voxel-form-selection__checkbox .voxel-icon{color:var(--ids_color_action_disabled_variant)}.voxel-form-selection:hover .voxel-form-selection__input--checkbox:not(:disabled)+.voxel-form-selection__checkbox:not(.voxel-form-selection__checkbox--invalid) .voxel-icon{color:var(--ids_color_action_neutral_variant)}.voxel-form-selection:hover .voxel-form-selection__input--checkbox:checked:not(:disabled)+.voxel-form-selection__checkbox--checked .voxel-icon,.voxel-form-selection:hover .voxel-form-selection__input--checkbox:indeterminate:not(:disabled)+.voxel-form-selection__checkbox:not(.voxel-form-selection__checkbox--invalid) .voxel-icon{color:var(--ids_color_action_primary_variant)}.voxel-form-selection{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.voxel-form-selection__label--radio{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);margin-left:var(--ids_size_general_8x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__radio{color:var(--ids_color_text_body_01);pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__radio--invalid .voxel-icon{color:var(--ids_color_feedback_error)}.voxel-form-selection__radio--invalid~.voxel-form-selection__label--radio{color:var(--ids_textStyle_label_medium_bold)}.voxel-form-selection__radio--focus .voxel-icon{outline:auto -webkit-focus-ring-color}.voxel-form-selection__input--radio{height:var(--ids_size_general_22x);left:0;margin:var(--ids_size_general_1x);opacity:var(--ids_opacity_empty);position:absolute;width:var(--ids_size_general_22x)}.voxel-form-selection__input--radio:checked+.voxel-form-selection__radio .voxel-icon{color:var(--ids_color_action_primary_base)}.voxel-form-selection__input--radio:disabled~.voxel-form-selection__label--radio,.voxel-form-selection__input--radio:disabled+.voxel-form-selection__radio .voxel-icon{color:var(--ids_color_action_disabled_variant)}.voxel-form-selection:hover .voxel-form-selection__input--radio:not(:disabled)+.voxel-form-selection__radio:not(.voxel-form-selection__radio--invalid) .voxel-icon{color:var(--ids_color_action_neutral_variant)}.voxel-form-selection:hover .voxel-form-selection__input--radio:checked:not(:disabled)+.voxel-form-selection__radio--checked .voxel-icon{color:var(--ids_color_action_primary_variant)}.voxel-form-selection__switch{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border:var(--ids_size_border_small) solid var(--ids_color_action_neutral_base);border-radius:.875rem;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:var(--ids_size_general_24x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:var(--ids_size_general_40x);position:relative;-webkit-transition:background-color .2s,-webkit-transform .2s;transition:background-color .2s,-webkit-transform .2s;transition:transform .2s,background-color .2s;transition:transform .2s,background-color .2s,-webkit-transform .2s}.voxel-form-selection__switch:before{background-color:var(--ids_color_action_neutral_base);border-radius:50%;content:\"\";height:var(--ids_size_general_18x);left:var(--ids_size_general_2x);position:absolute;-webkit-transition:background-color .2s,-webkit-transform .2s;transition:background-color .2s,-webkit-transform .2s;transition:transform .2s,background-color .2s;transition:transform .2s,background-color .2s,-webkit-transform .2s;width:var(--ids_size_general_18x)}.voxel-form-selection__switch--disabled{border-color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-form-selection__switch--disabled:before{background-color:var(--ids_color_action_disabled_base)}.voxel-form-selection__switch--checked{background-color:var(--ids_color_action_primary_base);border-color:var(--ids_color_action_primary_base)}.voxel-form-selection__switch--checked.voxel-form-selection__switch--disabled{background-color:var(--ids_color_action_disabled_base);border-color:var(--ids_color_action_disabled_base)}.voxel-form-selection__switch--checked:before{background-color:var(--ids_color_contrast_onDark);-webkit-transform:translateX(1rem);transform:translate(1rem)}.voxel-form-selection__switch--on-dark{background-color:transparent;border-color:var(--ids_color_contrast_onDark)}.voxel-form-selection__switch--on-dark:before{background-color:var(--ids_color_contrast_onDark)}.voxel-form-selection__switch--disabled.voxel-form-selection__switch--on-dark{background-color:transparent;opacity:var(--ids_opacity_medium)}.voxel-form-selection__switch--disabled.voxel-form-selection__switch--on-dark.voxel-form-selection__switch--checked{background-color:var(--ids_color_contrast_onDark_medium);border-color:var(--ids_color_contrast_onDark_soft);opacity:var(--ids_opacity_strong)}.voxel-form-selection__switch--disabled.voxel-form-selection__switch--on-dark.voxel-form-selection__switch--checked:before{background-color:var(--ids_color_contrast_onDark_strong)}.voxel-form-selection__switch--checked.voxel-form-selection__switch--on-dark:not(.voxel-form-selection__switch--disabled){background-color:var(--ids_color_contrast_onDark);border-color:var(--ids_color_contrast_onDark)}.voxel-form-selection__switch--checked.voxel-form-selection__switch--on-dark:not(.voxel-form-selection__switch--disabled):before{background-color:var(--ids_color_action_primary_base)}.voxel-form-selection__label--switch{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);margin-right:var(--ids_size_general_12x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__label--switch:empty{display:none}.voxel-form-selection--on-dark .voxel-form-selection__label--switch{color:var(--ids_color_contrast_onDark)}\n"], encapsulation: 2 });
VoxelFormSelectionComponent.propDecorators = {
    onDark: [{ type: Input }],
    input: [{ type: ContentChild, args: [VoxelFormSelectionBase, { static: true },] }],
    status: [{ type: ContentChildren, args: [VoxelFormStatusComponent,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormSelectionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-form-selection',
                template: "<span\n  class=\"voxel-form-selection\"\n  [class.voxel-form-selection--on-dark]=\"onDark\"\n  [class.voxel-form-selection--rtl]=\"input.rtlDirection\"\n>\n  <ng-content select=\"input\"></ng-content>\n  <voxel-icon *ngIf=\"input.icon\" [ngClass]=\"input.iconClasses\">\n    {{ input.icon }}\n  </voxel-icon>\n  <label\n    [id]=\"input.labelId\"\n    [for]=\"input.controlId\"\n    [class]=\"'voxel-form-selection__label--' + input.selectorType\"\n    [attr.aria-hidden]=\"input.ariaHiddenLabel ? input.ariaHiddenLabel : null\"\n  >\n    <ng-content></ng-content>\n  </label>\n</span>\n<ng-content select=\"voxel-form-status\"></ng-content>\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-form-selection{display:-webkit-box;display:-ms-flexbox;display:flex;padding:var(--ids_size_general_8x) 0;position:relative}.voxel-form-selection__checkbox--checked:not(.voxel-form-selection__checkbox--disabled):not(.voxel-form-selection__checkbox--invalid){color:var(--ids_color_action_primary_base)}.voxel-form-selection__radio:not(.voxel-form-selection__radio--disabled){color:var(--ids_color_action_primary_base)}.voxel-form-selection--rtl{direction:rtl;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.voxel-form-selection__label--checkbox{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);margin-left:var(--ids_size_general_8x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__checkbox{color:var(--ids_color_text_body_01);pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__checkbox .voxel-icon{color:var(--ids_color_action_neutral_base)}.voxel-form-selection__checkbox--invalid .voxel-icon{color:var(--ids_color_feedback_error)}.voxel-form-selection__checkbox--invalid~.voxel-form-selection__label--checkbox{font:var(--ids_textStyle_label_medium_bold)}.voxel-form-selection__checkbox--checked .voxel-icon,.voxel-form-selection__checkbox--inderteminate .voxel-icon{color:var(--ids_color_action_primary_base)}.voxel-form-selection__checkbox--disabled .voxel-icon{color:var(--ids_color_action_disabled_base)}.voxel-form-selection__checkbox--focus .voxel-icon{outline:auto -webkit-focus-ring-color}.voxel-form-selection__input--checkbox{height:var(--ids_size_general_22x);left:0;margin:var(--ids_size_general_1x);opacity:0;position:absolute;width:var(--ids_size_general_22x)}.voxel-form-selection__input--checkbox:disabled{color:var(--ids_color_action_disabled_variant)}.voxel-form-selection__input--checkbox:checked+.voxel-form-selection__checkbox .voxel-icon{color:var(--ids_color_action_primary_base)}.voxel-form-selection__input--checkbox:disabled~.voxel-form-selection__label--checkbox,.voxel-form-selection__input--checkbox:disabled+.voxel-form-selection__checkbox .voxel-icon{color:var(--ids_color_action_disabled_variant)}.voxel-form-selection:hover .voxel-form-selection__input--checkbox:not(:disabled)+.voxel-form-selection__checkbox:not(.voxel-form-selection__checkbox--invalid) .voxel-icon{color:var(--ids_color_action_neutral_variant)}.voxel-form-selection:hover .voxel-form-selection__input--checkbox:checked:not(:disabled)+.voxel-form-selection__checkbox--checked .voxel-icon,.voxel-form-selection:hover .voxel-form-selection__input--checkbox:indeterminate:not(:disabled)+.voxel-form-selection__checkbox:not(.voxel-form-selection__checkbox--invalid) .voxel-icon{color:var(--ids_color_action_primary_variant)}.voxel-form-selection{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.voxel-form-selection__label--radio{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);margin-left:var(--ids_size_general_8x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__radio{color:var(--ids_color_text_body_01);pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__radio--invalid .voxel-icon{color:var(--ids_color_feedback_error)}.voxel-form-selection__radio--invalid~.voxel-form-selection__label--radio{color:var(--ids_textStyle_label_medium_bold)}.voxel-form-selection__radio--focus .voxel-icon{outline:auto -webkit-focus-ring-color}.voxel-form-selection__input--radio{height:var(--ids_size_general_22x);left:0;margin:var(--ids_size_general_1x);opacity:var(--ids_opacity_empty);position:absolute;width:var(--ids_size_general_22x)}.voxel-form-selection__input--radio:checked+.voxel-form-selection__radio .voxel-icon{color:var(--ids_color_action_primary_base)}.voxel-form-selection__input--radio:disabled~.voxel-form-selection__label--radio,.voxel-form-selection__input--radio:disabled+.voxel-form-selection__radio .voxel-icon{color:var(--ids_color_action_disabled_variant)}.voxel-form-selection:hover .voxel-form-selection__input--radio:not(:disabled)+.voxel-form-selection__radio:not(.voxel-form-selection__radio--invalid) .voxel-icon{color:var(--ids_color_action_neutral_variant)}.voxel-form-selection:hover .voxel-form-selection__input--radio:checked:not(:disabled)+.voxel-form-selection__radio--checked .voxel-icon{color:var(--ids_color_action_primary_variant)}.voxel-form-selection__switch{-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:transparent;border:var(--ids_size_border_small) solid var(--ids_color_action_neutral_base);border-radius:.875rem;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:var(--ids_size_general_24x);-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:var(--ids_size_general_40x);position:relative;-webkit-transition:background-color .2s,-webkit-transform .2s;transition:background-color .2s,-webkit-transform .2s;transition:transform .2s,background-color .2s;transition:transform .2s,background-color .2s,-webkit-transform .2s}.voxel-form-selection__switch:before{background-color:var(--ids_color_action_neutral_base);border-radius:50%;content:\"\";height:var(--ids_size_general_18x);left:var(--ids_size_general_2x);position:absolute;-webkit-transition:background-color .2s,-webkit-transform .2s;transition:background-color .2s,-webkit-transform .2s;transition:transform .2s,background-color .2s;transition:transform .2s,background-color .2s,-webkit-transform .2s;width:var(--ids_size_general_18x)}.voxel-form-selection__switch--disabled{border-color:var(--ids_color_action_disabled_base);cursor:not-allowed}.voxel-form-selection__switch--disabled:before{background-color:var(--ids_color_action_disabled_base)}.voxel-form-selection__switch--checked{background-color:var(--ids_color_action_primary_base);border-color:var(--ids_color_action_primary_base)}.voxel-form-selection__switch--checked.voxel-form-selection__switch--disabled{background-color:var(--ids_color_action_disabled_base);border-color:var(--ids_color_action_disabled_base)}.voxel-form-selection__switch--checked:before{background-color:var(--ids_color_contrast_onDark);-webkit-transform:translateX(1rem);transform:translate(1rem)}.voxel-form-selection__switch--on-dark{background-color:transparent;border-color:var(--ids_color_contrast_onDark)}.voxel-form-selection__switch--on-dark:before{background-color:var(--ids_color_contrast_onDark)}.voxel-form-selection__switch--disabled.voxel-form-selection__switch--on-dark{background-color:transparent;opacity:var(--ids_opacity_medium)}.voxel-form-selection__switch--disabled.voxel-form-selection__switch--on-dark.voxel-form-selection__switch--checked{background-color:var(--ids_color_contrast_onDark_medium);border-color:var(--ids_color_contrast_onDark_soft);opacity:var(--ids_opacity_strong)}.voxel-form-selection__switch--disabled.voxel-form-selection__switch--on-dark.voxel-form-selection__switch--checked:before{background-color:var(--ids_color_contrast_onDark_strong)}.voxel-form-selection__switch--checked.voxel-form-selection__switch--on-dark:not(.voxel-form-selection__switch--disabled){background-color:var(--ids_color_contrast_onDark);border-color:var(--ids_color_contrast_onDark)}.voxel-form-selection__switch--checked.voxel-form-selection__switch--on-dark:not(.voxel-form-selection__switch--disabled):before{background-color:var(--ids_color_action_primary_base)}.voxel-form-selection__label--switch{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular);margin-right:var(--ids_size_general_12x);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.voxel-form-selection__label--switch:empty{display:none}.voxel-form-selection--on-dark .voxel-form-selection__label--switch{color:var(--ids_color_contrast_onDark)}\n"]
            }]
    }], function () { return []; }, { onDark: [{
            type: Input
        }], input: [{
            type: ContentChild,
            args: [VoxelFormSelectionBase, { static: true }]
        }], status: [{
            type: ContentChildren,
            args: [VoxelFormStatusComponent]
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$9 = 0;
/**
 * O Form Selection Group foi desenvolvido para agrupar componentes de seleção como checkbox,
 * radiobutton e switch (wip).
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelCheckboxModule } from '@voxel/components/ids';`
 *
 * Este modulo possui todas as declarações dos componentes citados acima.
 *
 * @example Checkbox
 *  <voxel-form-selection-group>
 *             <legend>Aceito receber:</legend>
 *             <voxel-form-selection>
 *               <input type="checkbox" name="receiveSMS" formControlName="sms" voxelCheckbox required/>
 *               SMS
 *             </voxel-form-selection>
 *             <voxel-form-selection>
 *               <input type="checkbox" name="receiveWhatsapp" formControlName="whatsapp" voxelCheckbox required/>
 *               Whatsapp
 *             </voxel-form-selection>
 *  </voxel-form-selection-group>
 *
 */
class VoxelFormSelectionGroupComponent {
    constructor() {
        /**
         * @internal
         */
        this.controlId = `voxel-form-selection-group-${++NEXT_ID$9}`;
        /**
         * @internal
         */
        this._inline = false;
        /**
         * @internal
         */
        this._destroy = new Subject();
    }
    /**
     * Indica se o grupo vai estar disposto em linha
     *
     * *Indicates if the group will be inline*
     */
    set inline(inline) {
        this._inline = enforceBoolean(inline);
    }
    get inline() {
        return this._inline;
    }
    ngAfterContentInit() {
        this.handleFormStatus();
    }
    ngOnDestroy() {
        this._destroy.complete();
    }
    /**
     * @internal
     */
    handleFormStatus() {
        let messageIds = [];
        this.status.changes.pipe(startWith(null), takeUntil(this._destroy)).subscribe(() => {
            messageIds = [];
            messageIds.push(...this.status.map((message) => message.errorMsgId));
            const state = messageIds.length > 0 ? 'invalid' : '';
            this.formSelectionList.forEach((formSelection) => {
                formSelection.input.handleDescribedBy(messageIds);
                formSelection.input.state = state;
            });
        });
    }
}
VoxelFormSelectionGroupComponent.ɵfac = function VoxelFormSelectionGroupComponent_Factory(t) { return new (t || VoxelFormSelectionGroupComponent)(); };
VoxelFormSelectionGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelFormSelectionGroupComponent, selectors: [["voxel-form-selection-group"]], contentQueries: function VoxelFormSelectionGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFormSelectionComponent, 4);
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelFormStatusComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.formSelectionList = _t);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.status = _t);
    } }, inputs: { inline: "inline" }, ngContentSelectors: _c25, decls: 4, vars: 3, consts: [[1, "voxel-form-selection-group", 3, "id"]], template: function VoxelFormSelectionGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c24);
        ɵngcc0.ɵɵelementStart(0, "fieldset", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵprojection(2, 1);
        ɵngcc0.ɵɵprojection(3, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-form-selection-group--inline", ctx.inline);
        ɵngcc0.ɵɵproperty("id", ctx.controlId);
    } }, styles: [".voxel-form-selection-group--inline[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_48x);gap:var(--ids_size_general_48x);width:100%}.voxel-form-selection-group--inline[_ngcontent-%COMP%]     .voxel-form-selection{margin-right:var(--ids_size_general_16x)}.voxel-form-selection-group[_ngcontent-%COMP%]     legend{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_label_small_regular)}"] });
VoxelFormSelectionGroupComponent.propDecorators = {
    formSelectionList: [{ type: ContentChildren, args: [VoxelFormSelectionComponent,] }],
    status: [{ type: ContentChildren, args: [VoxelFormStatusComponent,] }],
    inline: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormSelectionGroupComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-form-selection-group',
                template: "<fieldset [id]=\"controlId\" class=\"voxel-form-selection-group\"\n  [class.voxel-form-selection-group--inline]=\"inline\">\n  <ng-content select=\"legend\"></ng-content>\n  <ng-content select=\"voxel-form-selection\"></ng-content>\n  <ng-content select=\"voxel-form-status\"></ng-content>\n</fieldset>\n",
                styles: [".voxel-form-selection-group--inline{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;grid-gap:var(--ids_size_general_48x);gap:var(--ids_size_general_48x);width:100%}.voxel-form-selection-group--inline ::ng-deep .voxel-form-selection{margin-right:var(--ids_size_general_16x)}.voxel-form-selection-group ::ng-deep legend{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_label_small_regular)}\n"]
            }]
    }], function () { return []; }, { inline: [{
            type: Input
        }], formSelectionList: [{
            type: ContentChildren,
            args: [VoxelFormSelectionComponent]
        }], status: [{
            type: ContentChildren,
            args: [VoxelFormStatusComponent]
        }] }); })();

class VoxelFormSelectionModule {
}
VoxelFormSelectionModule.ɵfac = function VoxelFormSelectionModule_Factory(t) { return new (t || VoxelFormSelectionModule)(); };
VoxelFormSelectionModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelFormSelectionModule });
VoxelFormSelectionModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule, VoxelIconModule, VoxelFormStatusModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelFormSelectionModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelIconModule, VoxelFormStatusModule],
                declarations: [
                    VoxelFormSelectionBase,
                    VoxelFormSelectionComponent,
                    VoxelFormSelectionGroupComponent,
                ],
                exports: [VoxelFormSelectionComponent, VoxelFormSelectionGroupComponent],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelFormSelectionModule, { declarations: function () { return [VoxelFormSelectionBase, VoxelFormSelectionComponent, VoxelFormSelectionGroupComponent]; }, imports: function () { return [CommonModule, VoxelIconModule, VoxelFormStatusModule]; }, exports: function () { return [VoxelFormSelectionComponent, VoxelFormSelectionGroupComponent]; } }); })();

class VoxelHeaderActionContentDirective {
    constructor() {
        this.class = 'voxel-header__button';
    }
}
VoxelHeaderActionContentDirective.ɵfac = function VoxelHeaderActionContentDirective_Factory(t) { return new (t || VoxelHeaderActionContentDirective)(); };
VoxelHeaderActionContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHeaderActionContentDirective, selectors: [["", "voxelHeaderAction", ""]], hostVars: 2, hostBindings: function VoxelHeaderActionContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelHeaderActionContentDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderActionContentDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelHeaderAction]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
class VoxelHeaderPresentationContentDirective {
    constructor() {
        this.class = 'voxel-header__outer-title';
    }
}
VoxelHeaderPresentationContentDirective.ɵfac = function VoxelHeaderPresentationContentDirective_Factory(t) { return new (t || VoxelHeaderPresentationContentDirective)(); };
VoxelHeaderPresentationContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHeaderPresentationContentDirective, selectors: [["", "voxelHeaderPresentation", ""]], hostVars: 2, hostBindings: function VoxelHeaderPresentationContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelHeaderPresentationContentDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderPresentationContentDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelHeaderPresentation]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
class VoxelHeaderControlsContentDirective {
    constructor() {
        this.class = 'voxel-header__button';
    }
}
VoxelHeaderControlsContentDirective.ɵfac = function VoxelHeaderControlsContentDirective_Factory(t) { return new (t || VoxelHeaderControlsContentDirective)(); };
VoxelHeaderControlsContentDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelHeaderControlsContentDirective, selectors: [["", "voxelHeaderControls", ""]], hostVars: 2, hostBindings: function VoxelHeaderControlsContentDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelHeaderControlsContentDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderControlsContentDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelHeaderControls]'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * O Header exibe informações e ações relacionadas à página atual. É usado para orientar qual página o
 * cliente está, permitindo a navegação e o filtro, no caso do tipo completo de Header.
 *
 * *The Header displays information and actions related to the current page. It is used to guide which*
 * *page the client is on, allowing navigation and filtering, in the case of the full Header type.*
 *
 * **Module:**
 *
 * `import { VoxelHeaderModule } from '@voxel/components/ids';`
 *
 *  <example-url>../../demo/index.html#/portfolio/header?componentOnly=true</example-url>
 */
class VoxelHeaderComponent {
    constructor(_document) {
        this._document = _document;
        this._destroy = new Subject();
        this.collapsed = false;
        this._fixedTitle = false;
        this.class = 'voxel-header';
    }
    get headingText() {
        return this.headingElement
            ? this.headingElement.textContent
            : this.outerTitle
                ? this.outerTitle.nativeElement.textContent
                : '';
    }
    get elementWithScroll() {
        return this.scrollElement || this._document;
    }
    /**
     * Fixa o título no componente, ignorando a rolagem da página.
     *
     * *Pins the title to the component, ignoring page scrolling*
     */
    set fixedTitle(value) {
        this._fixedTitle = enforceBoolean(value);
    }
    get fixedTitle() {
        return this._fixedTitle;
    }
    ngAfterViewInit() {
        if (this.fixedTitle) {
            return;
        }
        this._listenToScrollEvent();
        // timeout para aguardar toda a tela ser carregada para então definir o
        // o posicionamento correto.
        setTimeout(() => {
            this._setPosition();
        });
    }
    ngOnDestroy() {
        this._destroy.complete();
    }
    _isElementBottomUnderReferenceBottom(target, reference) {
        const { bottom } = target.getBoundingClientRect();
        const { bottom: referenceBottom } = reference.getBoundingClientRect();
        return bottom <= referenceBottom;
    }
    _listenToScrollEvent() {
        fromEvent(this.elementWithScroll, 'scroll')
            .pipe(takeUntil(this._destroy))
            .subscribe(() => {
            const previousCollapsedStatus = this.collapsed;
            const headingEl = this.headingElement || this.outerTitle.nativeElement;
            this.collapsed = this._isElementBottomUnderReferenceBottom(headingEl, this.headerEl.nativeElement);
            if (this.collapsed) {
                if (!previousCollapsedStatus) {
                    this._setPosition(true);
                }
                return;
            }
            this._setPosition();
        });
    }
    _setPosition(reset = false) {
        const headingTitleDOMRect = this.headingElement
            ? this.headingElement.getBoundingClientRect()
            : this.outerTitle.nativeElement.getBoundingClientRect();
        const headerTitleStyle = this.headerTitle.nativeElement.style;
        headerTitleStyle.top = reset ? '' : `${headingTitleDOMRect.top}px`;
        headerTitleStyle.right = reset ? '' : `${headingTitleDOMRect.right}px`;
        headerTitleStyle.bottom = reset ? '' : `${headingTitleDOMRect.bottom}px`;
        headerTitleStyle.left = reset ? '' : `${headingTitleDOMRect.left}px`;
        headerTitleStyle.width = reset ? '' : `${headingTitleDOMRect.width}px`;
        headerTitleStyle.height = reset ? '' : `${headingTitleDOMRect.height}px`;
        headerTitleStyle.position = reset ? '' : 'absolute';
    }
}
VoxelHeaderComponent.ɵfac = function VoxelHeaderComponent_Factory(t) { return new (t || VoxelHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(DOCUMENT)); };
VoxelHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelHeaderComponent, selectors: [["voxel-header"]], contentQueries: function VoxelHeaderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelHeaderPresentationContentDirective, 5, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.outerTitle = _t.first);
    } }, viewQuery: function VoxelHeaderComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c26, 5);
        ɵngcc0.ɵɵviewQuery(_c27, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTitle = _t.first);
    } }, hostVars: 2, hostBindings: function VoxelHeaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { fixedTitle: "fixedTitle", headerContrast: "headerContrast", scrollElement: "scrollElement", headingElement: "headingElement" }, ngContentSelectors: _c29, decls: 10, vars: 8, consts: [[1, "voxel-header__container"], ["headerEl", ""], [1, "voxel-header__actions"], [1, "voxel-header__presentation"], [1, "voxel-header__title", 3, "textContent"], ["headerTitle", ""], [1, "voxel-header__controls"], ["aria-hidden", "true", "class", "voxel-header__outer-section", 4, "ngIf"], ["aria-hidden", "true", 1, "voxel-header__outer-section"], ["outerContent", ""]], template: function VoxelHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c28);
        ɵngcc0.ɵɵelementStart(0, "header", 0, 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵprojection(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵelement(5, "h1", 4, 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 6);
        ɵngcc0.ɵɵprojection(8, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, VoxelHeaderComponent_div_9_Template, 3, 0, "div", 7);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-header--on-dark", ctx.headerContrast === "dark")("voxel-header--on-light", ctx.headerContrast === "light")("voxel-header--collapsed", ctx.collapsed || ctx.fixedTitle);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("textContent", ctx.headingText);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.headingElement && !ctx.fixedTitle);
    } }, directives: [ɵngcc1.NgIf], styles: [".voxel-header{background-color:inherit;display:block}.voxel-header button,.voxel-header .voxel-icon{color:inherit}.voxel-header__container{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:inherit;border-bottom:var(--ids_size_border_small) solid transparent;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;left:0;min-height:var(--ids_size_general_72x);padding:0 var(--ids_spacing_2x);position:fixed;top:0;width:100%;z-index:1000}.voxel-header__title{font:var(--ids_textStyle_overline);margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.voxel-header__presentation{opacity:0;overflow:hidden}.voxel-header__controls{display:-webkit-box;display:-ms-flexbox;display:flex}.voxel-header__outer-section{padding-top:var(--ids_size_general_100x)}.voxel-header__button{background-color:transparent;border:none;height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.voxel-header__outer-title{font:var(--ids_textStyle_title_01_base)}.voxel-header--collapsed{border-color:var(--ids_color_border_soft)}.voxel-header--collapsed .voxel-header__presentation{-webkit-box-flex:1;-ms-flex:auto;flex:auto;margin-left:var(--ids_spacing_2x);opacity:1;-webkit-transition:opacity .25s ease-in;transition:opacity .25s ease-in}.voxel-header--on-dark{color:var(--ids_color_contrast_onDark)}.voxel-header--on-light{color:var(--ids_color_contrast_onLight)}.voxel-theme-empresas .voxel-header__container:not(.voxel-header--on-light):not(.voxel-header--on-dark){background:var(--ids_color_bg_brand_gradient);color:var(--ids_color_contrast_onDark)}\n"], encapsulation: 2 });
VoxelHeaderComponent.ctorParameters = () => [
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] }
];
VoxelHeaderComponent.propDecorators = {
    headerContrast: [{ type: Input }],
    fixedTitle: [{ type: Input }],
    scrollElement: [{ type: Input }],
    headingElement: [{ type: Input }],
    class: [{ type: HostBinding }],
    headerEl: [{ type: ViewChild, args: ['headerEl',] }],
    headerTitle: [{ type: ViewChild, args: ['headerTitle',] }],
    outerTitle: [{ type: ContentChild, args: [VoxelHeaderPresentationContentDirective, { read: ElementRef },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-header',
                template: "<header\n  class=\"voxel-header__container\"\n  [class.voxel-header--on-dark]=\"headerContrast === 'dark'\"\n  [class.voxel-header--on-light]=\"headerContrast === 'light'\"\n  [class.voxel-header--collapsed]=\"collapsed || fixedTitle\"\n  #headerEl\n>\n  <div class=\"voxel-header__actions\">\n    <ng-content select=\"[voxelHeaderAction]\"></ng-content>\n  </div>\n\n  <div class=\"voxel-header__presentation\">\n    <h1 #headerTitle class=\"voxel-header__title\" [textContent]=\"headingText\"></h1>\n  </div>\n\n  <div class=\"voxel-header__controls\">\n    <ng-content select=\"[voxelHeaderControls]\"></ng-content>\n  </div>\n</header>\n\n<div\n  *ngIf=\"!headingElement && !fixedTitle\"\n  #outerContent\n  aria-hidden=\"true\"\n  class=\"voxel-header__outer-section\"\n>\n  <ng-content select=\"[voxelHeaderPresentation]\"></ng-content>\n</div>",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-header{background-color:inherit;display:block}.voxel-header button,.voxel-header .voxel-icon{color:inherit}.voxel-header__container{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:inherit;border-bottom:var(--ids_size_border_small) solid transparent;-webkit-box-sizing:border-box;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;left:0;min-height:var(--ids_size_general_72x);padding:0 var(--ids_spacing_2x);position:fixed;top:0;width:100%;z-index:1000}.voxel-header__title{font:var(--ids_textStyle_overline);margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.voxel-header__presentation{opacity:0;overflow:hidden}.voxel-header__controls{display:-webkit-box;display:-ms-flexbox;display:flex}.voxel-header__outer-section{padding-top:var(--ids_size_general_100x)}.voxel-header__button{background-color:transparent;border:none;height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.voxel-header__outer-title{font:var(--ids_textStyle_title_01_base)}.voxel-header--collapsed{border-color:var(--ids_color_border_soft)}.voxel-header--collapsed .voxel-header__presentation{-webkit-box-flex:1;-ms-flex:auto;flex:auto;margin-left:var(--ids_spacing_2x);opacity:1;-webkit-transition:opacity .25s ease-in;transition:opacity .25s ease-in}.voxel-header--on-dark{color:var(--ids_color_contrast_onDark)}.voxel-header--on-light{color:var(--ids_color_contrast_onLight)}.voxel-theme-empresas .voxel-header__container:not(.voxel-header--on-light):not(.voxel-header--on-dark){background:var(--ids_color_bg_brand_gradient);color:var(--ids_color_contrast_onDark)}\n"]
            }]
    }], function () { return [{ type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { class: [{
            type: HostBinding
        }], fixedTitle: [{
            type: Input
        }], headerContrast: [{
            type: Input
        }], scrollElement: [{
            type: Input
        }], headingElement: [{
            type: Input
        }], headerEl: [{
            type: ViewChild,
            args: ['headerEl']
        }], headerTitle: [{
            type: ViewChild,
            args: ['headerTitle']
        }], outerTitle: [{
            type: ContentChild,
            args: [VoxelHeaderPresentationContentDirective, { read: ElementRef }]
        }] }); })();

class VoxelHeaderModule {
}
VoxelHeaderModule.ɵfac = function VoxelHeaderModule_Factory(t) { return new (t || VoxelHeaderModule)(); };
VoxelHeaderModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelHeaderModule });
VoxelHeaderModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelHeaderModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [
                    VoxelHeaderComponent,
                    VoxelHeaderActionContentDirective,
                    VoxelHeaderControlsContentDirective,
                    VoxelHeaderPresentationContentDirective,
                ],
                exports: [
                    VoxelHeaderComponent,
                    VoxelHeaderActionContentDirective,
                    VoxelHeaderControlsContentDirective,
                    VoxelHeaderPresentationContentDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelHeaderModule, { declarations: function () { return [VoxelHeaderComponent, VoxelHeaderActionContentDirective, VoxelHeaderControlsContentDirective, VoxelHeaderPresentationContentDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelHeaderComponent, VoxelHeaderActionContentDirective, VoxelHeaderControlsContentDirective, VoxelHeaderPresentationContentDirective]; } }); })();

let NEXT_ID$8 = 0;
class VoxelIndicatorComponent {
    constructor(_platform, _liveAnnouncer) {
        this._platform = _platform;
        this._liveAnnouncer = _liveAnnouncer;
        this.role = this._platform.ANDROID || this._platform.IOS ? 'progressbar' : 'img';
        this._ariaLabel = '';
        this.hostAriaLabel = null;
        /** @internal */
        this.id = `voxel-indicator-${NEXT_ID$8++}`;
        this.hostId = null;
        this._arrows = false;
        this._context = 'Item';
        this._current = 1;
        this._nextLiteral = 'próximo item';
        this._quantity = 1;
        this._previousLiteral = 'item anterior';
        this.currentChange = new EventEmitter();
        this._fill = 0;
    }
    /**
     * Define a label acessível para a barra de progresso
     *
     * *Defines accessible label for progress bar*
     */
    set ariaLabel(value) {
        this._ariaLabel = value;
    }
    get ariaLabel() {
        if (!this._ariaLabel) {
            return `${this.context} ${this.current} de ${this.quantity}. O progresso é de ${this.fill}%`;
        }
        return this._ariaLabel;
    }
    /**
     * Define se o indicator vai ter setas ou não
     *
     * *Defines if indicator will have arrows or not*
     */
    set arrows(value) {
        this._arrows = enforceBoolean(value);
    }
    get arrows() {
        return this._arrows;
    }
    /**
     * Define o contexto do indicator, se é imagem, card, item (padrão).
     *
     * *Defines indicator's contexto, if it is image, card, item (default)*
     */
    set context(value) {
        this._context = value !== null && value !== void 0 ? value : this._context;
    }
    get context() {
        return this._context;
    }
    /**
     * Define se a cor do indicator seguirá a cor para fundos escuros
     *
     * *Defines whether the indicator's color will follow the dark background color*
     */
    set onDark(value) {
        this._onDark = enforceBoolean(value);
    }
    get onDark() {
        return this._onDark;
    }
    /**
     * Define a página selecionada/atual
     *
     * *Defines current/selected page*
     */
    set current(value) {
        const currentValue = Math.abs(Math.round(enforceNumber(value))) || 1;
        this._current = currentValue;
        if (this.quantity > 1) {
            this._current = currentValue > this.quantity ? this.quantity : currentValue;
        }
        if (this._platform.ANDROID &&
            this.arrows &&
            (this._current === 1 || this._current === this.quantity)) {
            this.handleScreenReader();
        }
        this.calculateFill();
    }
    get current() {
        return this._current;
    }
    /**
     * Define a literal do botão próximo (aria-label). Exemplo: Próxima Imagem, Próximo Cartão.
     *
     * *Defines next button's literal (aria-label)*
     */
    set nextLiteral(value) {
        this._nextLiteral = value !== null && value !== void 0 ? value : this._nextLiteral;
    }
    get nextLiteral() {
        return this._nextLiteral;
    }
    /**
     * Define a quantidade de números do indicador
     *
     * *Defines indicator's number quantity*
     */
    set quantity(value) {
        this._quantity = Math.abs(Math.round(enforceNumber(value)));
        this.calculateFill();
    }
    get quantity() {
        return this._quantity;
    }
    /**
     * Define a literal do botão anterior (aria-label). Exemplo: Imagem anterior, Cartão anterior.
     *
     * *Defines previous button's literal (aria-label)*
     */
    set previousLiteral(value) {
        this._previousLiteral = value !== null && value !== void 0 ? value : this._previousLiteral;
    }
    get previousLiteral() {
        return this._previousLiteral;
    }
    set fill(value) {
        this._fill = value;
    }
    get fill() {
        return this._fill;
    }
    ngOnInit() {
        this.current = this.current <= this.quantity ? this.current : this.quantity;
        this.calculateFill();
    }
    /** @internal */
    calculateFill() {
        this.fill = (100 * this.current) / this.quantity;
    }
    /** @internal */
    announceValue() {
        setTimeout(() => {
            this._liveAnnouncer.announce(this.ariaLabel, 1000);
        }, 500);
    }
    next() {
        if (this.current === this.quantity) {
            return;
        }
        this.current = this.current + 1;
        this.currentChange.emit(this.current);
        this.announceValue();
    }
    previous() {
        if (this.current === 1) {
            return;
        }
        this.current = this.current - 1;
        this.currentChange.emit(this.current);
        this.announceValue();
    }
    handleScreenReader() {
        const literal = this.current === 1 ? this.previousLiteral : this.nextLiteral;
        this._liveAnnouncer.announce(`${literal}, botão, desativado`, 1000);
    }
}
VoxelIndicatorComponent.ɵfac = function VoxelIndicatorComponent_Factory(t) { return new (t || VoxelIndicatorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Platform), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.LiveAnnouncer)); };
VoxelIndicatorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelIndicatorComponent, selectors: [["voxel-indicator"]], hostVars: 2, hostBindings: function VoxelIndicatorComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.hostAriaLabel)("id", ctx.hostId);
    } }, inputs: { id: "id", ariaLabel: ["aria-label", "ariaLabel"], arrows: "arrows", context: "context", onDark: "onDark", current: "current", nextLiteral: "nextLiteral", quantity: "quantity", previousLiteral: "previousLiteral" }, outputs: { currentChange: "currentChange" }, decls: 9, vars: 16, consts: [[1, "voxel-indicator", 3, "id"], ["voxelButtonAction", "", "class", "voxel-indicator__arrow", "variant", "neutral", 3, "tabindex", "aria-label", "contrast", "click", 4, "ngIf"], [1, "voxel-indicator__main"], [1, "voxel-indicator__label", "voxel-indicator__label--bold"], [1, "voxel-indicator__progress-bar"], [1, "voxel-indicator__label"], ["voxelButtonAction", "", "variant", "neutral", 1, "voxel-indicator__arrow", 3, "tabindex", "aria-label", "contrast", "click"]], template: function VoxelIndicatorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, VoxelIndicatorComponent_button_1_Template, 3, 4, "button", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "div", 4);
        ɵngcc0.ɵɵelementStart(6, "span", 5);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, VoxelIndicatorComponent_button_8_Template, 3, 4, "button", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-indicator--on-dark", ctx.onDark);
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.arrows);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-label", ctx.ariaLabel)("aria-valuenow", ctx.role !== "img" ? ctx.current : undefined)("aria-valuemax", ctx.role !== "img" ? ctx.quantity : undefined)("aria-valuetext", ctx.role !== "img" ? ctx.context + " " + ctx.current + " selecionado." : undefined)("role", ctx.role);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.current);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleProp("background-size", ctx.fill + "%" + " 100%");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("voxel-indicator__label--bold", ctx.fill === 100);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.quantity, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.arrows);
    } }, directives: [ɵngcc1.NgIf, VoxelButtonComponent, VoxelIconComponent], styles: [".voxel-indicator[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_20x);gap:var(--ids_size_general_20x)}.voxel-indicator__arrow[_ngcontent-%COMP%]{font:var(--ids_textStyle_icon_medium);min-height:1.5rem;min-width:1.5rem;padding:0}.voxel-indicator__main[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_8x);gap:var(--ids_size_general_8x)}.voxel-indicator__label[_ngcontent-%COMP%]{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_label_xsmall_regular)}.voxel-indicator__label--bold[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_xsmall_bold)}.voxel-indicator__progress-bar[_ngcontent-%COMP%]{-ms-flex-item-align:center;align-self:center;background:-webkit-gradient(linear,left top,right top,from(var(--ids_color_action_neutral_variant)),to(var(--ids_color_action_neutral_variant)));background:linear-gradient(to right,var(--ids_color_action_neutral_variant) 0%,var(--ids_color_action_neutral_variant) 100%);background-color:var(--ids_color_action_neutral_base_soft);background-repeat:no-repeat;border-radius:var(--ids_size_general_4x);height:var(--ids_size_general_4x);-webkit-transition:background-size 175ms ease-in;transition:background-size 175ms ease-in;width:var(--ids_size_general_32x)}.voxel-indicator--on-dark[_ngcontent-%COMP%]   .voxel-indicator__label[_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark)}.voxel-indicator--on-dark[_ngcontent-%COMP%]   .voxel-indicator__progress-bar[_ngcontent-%COMP%]{background:-webkit-gradient(linear,left top,right top,from(var(--ids_color_contrast_onDark)),to(var(--ids_color_contrast_onDark)));background:linear-gradient(to right,var(--ids_color_contrast_onDark) 0%,var(--ids_color_contrast_onDark) 100%);background-color:var(--ids_color_contrast_onDark_soft);background-repeat:no-repeat}"] });
VoxelIndicatorComponent.ctorParameters = () => [
    { type: Platform },
    { type: LiveAnnouncer }
];
VoxelIndicatorComponent.propDecorators = {
    ariaLabel: [{ type: Input, args: ['aria-label',] }],
    hostAriaLabel: [{ type: HostBinding, args: ['attr.aria-label',] }],
    id: [{ type: Input }],
    hostId: [{ type: HostBinding, args: ['attr.id',] }],
    arrows: [{ type: Input }],
    context: [{ type: Input }],
    onDark: [{ type: Input }],
    current: [{ type: Input }],
    nextLiteral: [{ type: Input }],
    quantity: [{ type: Input }],
    previousLiteral: [{ type: Input }],
    currentChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelIndicatorComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-indicator',
                template: "<div class=\"voxel-indicator\"\n  [id]=\"id\"\n  [class.voxel-indicator--on-dark]=\"onDark\"\n>\n  <button *ngIf=\"arrows\"\n    voxelButtonAction\n    [tabindex]=\"current === 1 ? -1 : 0\"\n    class=\"voxel-indicator__arrow\"\n    [attr.aria-disabled]=\"current === 1\"\n    variant=\"neutral\"\n    [aria-label]=\"previousLiteral\"\n    [contrast]=\"onDark ? 'dark' : ''\"\n    (click)=\"previous()\"\n  >\n    <voxel-icon>seta_esquerda</voxel-icon>\n  </button>\n  <div class=\"voxel-indicator__main\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-valuenow]=\"role !== 'img' ? current : undefined\"\n    [attr.aria-valuemax]=\"role !== 'img' ? quantity : undefined\"\n    [attr.aria-valuetext]=\"role !== 'img' ? (context + ' ' + current + ' selecionado.') : undefined\"\n    [attr.role]=\"role\"\n  >\n    <span class=\"voxel-indicator__label voxel-indicator__label--bold\">{{ current }}</span>\n    <div class=\"voxel-indicator__progress-bar\" [style.backgroundSize]=\"fill + '%' + ' 100%'\"></div>\n    <span class=\"voxel-indicator__label\"\n      [class.voxel-indicator__label--bold]=\"fill === 100\"\n    >\n      {{ quantity }}\n    </span>\n  </div>\n  <button *ngIf=\"arrows\"\n    voxelButtonAction\n    [tabindex]=\"current === quantity ? -1 : 0\"\n    class=\"voxel-indicator__arrow\"\n    [attr.aria-disabled]=\"current === quantity\"\n    variant=\"neutral\"\n    [aria-label]=\"nextLiteral\"\n    [contrast]=\"onDark ? 'dark' : ''\"\n    (click)=\"next()\"\n    >\n    <voxel-icon>seta_direita</voxel-icon>\n  </button>\n</div>\n",
                styles: [".voxel-indicator{display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_20x);gap:var(--ids_size_general_20x)}.voxel-indicator__arrow{font:var(--ids_textStyle_icon_medium);min-height:1.5rem;min-width:1.5rem;padding:0}.voxel-indicator__main{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;grid-gap:var(--ids_size_general_8x);gap:var(--ids_size_general_8x)}.voxel-indicator__label{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_label_xsmall_regular)}.voxel-indicator__label--bold{font:var(--ids_textStyle_label_xsmall_bold)}.voxel-indicator__progress-bar{-ms-flex-item-align:center;align-self:center;background:-webkit-gradient(linear,left top,right top,from(var(--ids_color_action_neutral_variant)),to(var(--ids_color_action_neutral_variant)));background:linear-gradient(to right,var(--ids_color_action_neutral_variant) 0%,var(--ids_color_action_neutral_variant) 100%);background-color:var(--ids_color_action_neutral_base_soft);background-repeat:no-repeat;border-radius:var(--ids_size_general_4x);height:var(--ids_size_general_4x);-webkit-transition:background-size 175ms ease-in;transition:background-size 175ms ease-in;width:var(--ids_size_general_32x)}.voxel-indicator--on-dark .voxel-indicator__label{color:var(--ids_color_contrast_onDark)}.voxel-indicator--on-dark .voxel-indicator__progress-bar{background:-webkit-gradient(linear,left top,right top,from(var(--ids_color_contrast_onDark)),to(var(--ids_color_contrast_onDark)));background:linear-gradient(to right,var(--ids_color_contrast_onDark) 0%,var(--ids_color_contrast_onDark) 100%);background-color:var(--ids_color_contrast_onDark_soft);background-repeat:no-repeat}\n"]
            }]
    }], function () { return [{ type: ɵngcc6.Platform }, { type: ɵngcc3.LiveAnnouncer }]; }, { hostAriaLabel: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], id: [{
            type: Input
        }], hostId: [{
            type: HostBinding,
            args: ['attr.id']
        }], currentChange: [{
            type: Output
        }], ariaLabel: [{
            type: Input,
            args: ['aria-label']
        }], arrows: [{
            type: Input
        }], context: [{
            type: Input
        }], onDark: [{
            type: Input
        }], current: [{
            type: Input
        }], nextLiteral: [{
            type: Input
        }], quantity: [{
            type: Input
        }], previousLiteral: [{
            type: Input
        }] }); })();

class VoxelIndicatorModule {
}
VoxelIndicatorModule.ɵfac = function VoxelIndicatorModule_Factory(t) { return new (t || VoxelIndicatorModule)(); };
VoxelIndicatorModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelIndicatorModule });
VoxelIndicatorModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, VoxelButtonModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelIndicatorModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, VoxelButtonModule, VoxelIconModule],
                declarations: [VoxelIndicatorComponent],
                exports: [VoxelIndicatorComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelIndicatorModule, { declarations: function () { return [VoxelIndicatorComponent]; }, imports: function () { return [CommonModule, VoxelButtonModule, VoxelIconModule]; }, exports: function () { return [VoxelIndicatorComponent]; } }); })();

/** @internal */
let NEXT_ID$7 = 0;
/**
 * Diretiva para customização de input
 *
 * *Directive for customizing input*
 *
 * **Module:**
 *
 * `import { VoxelInputModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/input?componentOnly=true</example-url>
 *
 * @example <input voxelInput>
 *
 * @example <textarea voxelInput rows="4" cols="30"></textarea>
 */
/* istanbul ignore next */
class VoxelInputDirective extends VoxelFieldMixinBase {
    constructor() {
        super(...arguments);
        this._readonly = null;
        /** @internal */
        this.inputClasses = 'voxel-input';
        /** @internal */
        this.controlId = `voxel-input-${NEXT_ID$7++}`;
    }
    /**
     * Edição do campo só leitura
     *
     * *The field editing read only*
     */
    set readonly(readonly) {
        this._readonly = enforceBoolean(readonly);
    }
    get readonly() {
        return this._readonly;
    }
    get controlDisabled() {
        return (this.disabled && !this.controlValue) || null;
    }
    get controlReadOnly() {
        return (this.disabled && !!this.controlValue) || null || this.readonly;
    }
    get controlValue() {
        return this.value;
    }
    /** @internal */
    set type(type) {
        this._type = type;
    }
    get type() {
        if (platform.isMobile && this._type === 'number') {
            return 'text';
        }
        return this._type;
    }
    /** @internal */
    set inputmode(inputmode) {
        this._inputmode = inputmode;
    }
    get inputmode() {
        if (this._type === 'number') {
            return 'numeric';
        }
        return this._inputmode;
    }
    /** @internal */
    set pattern(pattern) {
        this._pattern = pattern;
    }
    get pattern() {
        if (this._type === 'number') {
            return '[0-9]*';
        }
        return this._pattern;
    }
    controlInput({ value, valueAsNumber }) {
        this.value = valueAsNumber || value;
    }
    controlChange(value) {
        this.value = value;
        this.formAcessorHandleChange();
    }
    controlFocus() {
        this.formAcessorHandleFocus();
    }
    controlBlur() {
        this.formAcessorHandleBlur();
    }
    /* implementado para verbalizar o texto da label + campo de edição o
    aria-labelledby tem o mesmo valor do atributo for da label. */
    /** @internal */
    handleArialabelledby() {
        if (platform.os === 'Windows') {
            this.ariaLabelledby = this.controlId;
        }
    }
    /** @internal */
    ngOnInit() {
        this.handleArialabelledby();
    }
    ngDoCheck() {
        if (this.ngControl && this.ngControl.touched && this.ngControl.invalid && !this.active) {
            this.formAcessorHandleBlur();
        }
    }
}
VoxelInputDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelInputDirective_BaseFactory; return function VoxelInputDirective_Factory(t) { return (ɵVoxelInputDirective_BaseFactory || (ɵVoxelInputDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelInputDirective)))(t || VoxelInputDirective); }; }();
VoxelInputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelInputDirective, selectors: [["", "voxelInput", ""]], hostVars: 8, hostBindings: function VoxelInputDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("input", function VoxelInputDirective_input_HostBindingHandler($event) { return ctx.controlInput($event.target); })("ngModelChange", function VoxelInputDirective_ngModelChange_HostBindingHandler($event) { return ctx.controlChange($event); })("focus", function VoxelInputDirective_focus_HostBindingHandler() { return ctx.controlFocus(); })("blur", function VoxelInputDirective_blur_HostBindingHandler() { return ctx.controlBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.inputClasses)("id", ctx.controlId)("disabled", ctx.controlDisabled)("readonly", ctx.controlReadOnly)("value", ctx.controlValue)("type", ctx.type)("inputmode", ctx.inputmode)("pattern", ctx.pattern);
    } }, inputs: { readonly: "readonly", type: "type", inputmode: "inputmode", pattern: "pattern" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: VoxelFieldMixinBase,
                useExisting: forwardRef(() => VoxelInputDirective)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelInputDirective.propDecorators = {
    readonly: [{ type: Input }],
    controlDisabled: [{ type: HostBinding, args: ['attr.disabled',] }],
    controlReadOnly: [{ type: HostBinding, args: ['attr.readonly',] }],
    controlValue: [{ type: HostBinding, args: ['attr.value',] }],
    inputClasses: [{ type: HostBinding, args: ['attr.class',] }],
    controlId: [{ type: HostBinding, args: ['attr.id',] }],
    type: [{ type: Input }, { type: HostBinding, args: ['attr.type',] }],
    inputmode: [{ type: Input }, { type: HostBinding, args: ['attr.inputmode',] }],
    pattern: [{ type: Input }, { type: HostBinding, args: ['attr.pattern',] }],
    controlInput: [{ type: HostListener, args: ['input', ['$event.target'],] }],
    controlChange: [{ type: HostListener, args: ['ngModelChange', ['$event'],] }],
    controlFocus: [{ type: HostListener, args: ['focus',] }],
    controlBlur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelInputDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelInput]',
                providers: [
                    {
                        provide: VoxelFieldMixinBase,
                        useExisting: forwardRef(() => VoxelInputDirective)
                    },
                ]
            }]
    }], null, { inputClasses: [{
            type: HostBinding,
            args: ['attr.class']
        }], controlId: [{
            type: HostBinding,
            args: ['attr.id']
        }], readonly: [{
            type: Input
        }], controlDisabled: [{
            type: HostBinding,
            args: ['attr.disabled']
        }], controlReadOnly: [{
            type: HostBinding,
            args: ['attr.readonly']
        }], controlValue: [{
            type: HostBinding,
            args: ['attr.value']
        }], type: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.type']
        }], inputmode: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.inputmode']
        }], pattern: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['attr.pattern']
        }], controlInput: [{
            type: HostListener,
            args: ['input', ['$event.target']]
        }], controlChange: [{
            type: HostListener,
            args: ['ngModelChange', ['$event']]
        }], controlFocus: [{
            type: HostListener,
            args: ['focus']
        }], controlBlur: [{
            type: HostListener,
            args: ['blur']
        }] }); })();

class VoxelInputModule {
}
VoxelInputModule.ɵfac = function VoxelInputModule_Factory(t) { return new (t || VoxelInputModule)(); };
VoxelInputModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelInputModule });
VoxelInputModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelInputModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelInputDirective],
                exports: [VoxelInputDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelInputModule, { declarations: function () { return [VoxelInputDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelInputDirective]; } }); })();

/**
 * @internal
 */
const LIKERT_OPTIONS_DEFAULT = [
    {
        key: 'bad',
        value: 'ruim',
        order: 1,
    },
    {
        key: 'dislike',
        value: 'não gostei',
        order: 2,
    },
    {
        key: 'neutral',
        value: 'neutro',
        order: 3,
    },
    {
        key: 'like',
        value: 'gostei',
        order: 4,
    },
    {
        key: 'love',
        value: 'adorei',
        order: 5,
    },
];
/**
 * @internal
 */
let NEXT_ID$6 = 1;
/**
 * Likert é um elemento baseado numa escala de pesquisa que combina estatística à psicologia,
 * para extrair insights qualitativos a partir de uma pergunta estruturada de forma quantitativa.
 * Utilizamos para avaliar a experiência do usuário referente a um fluxo.
 *
 * *Likert is an element based on a research scale that combines statistics with psychology*
 * *to extract qualitative insights from a quantitatively structured question.*
 * *We use it to assess the user experience for a flow.*
 *
 *  **Module:**
 *
 * `import { VoxelLikertModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/likert?componentOnly=true</example-url>
 *
 * @example componente simples
 * <voxel-likert
 *    (change)="responseLikert($event)">
 *    O que você achou dessa nova experiência?
 * </voxel-likert>
 *
 * @example enviando somente um nome para ser alterado.
 * <voxel-likert (change)="responseLikert($event)"
 *    [options]="[{ key:'love', value: 'amei' }]"
 * >
 *   O que você achou dessa nova experiência?
 * </voxel-likert>
 *
 * @example enviando lista completa.
 * <voxel-likert (change)="responseLikert($event)"
 *    [options]="[
 *    { key:'bad', value: 'péssimo' },
 *    { key:'dislike', value: 'ruim' },
 *    { key:'neutral', value: 'sei lá' },
 *    { key:'like', value: 'muito bom' },
 *    { key:'love', value: 'amei' }]"
 * >
 *
 *   O que achou dessa jornada?
 * </voxel-likert>
 */
class VoxelLikertComponent {
    constructor() {
        /**
         * @internal
         */
        this.optionsDefault = LIKERT_OPTIONS_DEFAULT;
        /**
         * lista com chave e valor (o nome da chave deve ser respeitado)
         *
         * *list with key and value (the key name must be respected)*
         *
         * [{key: "like", value: "gostei"}]
         */
        this.options = [];
        /**
         * Variavel que define o id do componente
         *
         * *Variable that defines the id of the component*
         */
        this.id = `voxel-likert-${NEXT_ID$6++}`;
        /**
         * Evento de resposta do likert
         *
         * *Likert response event*
         *
         * {key: "like", value: "gostei"}
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado com o focus no likert.
         *
         * *Event triggered with focus on likert.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado com o blur no likert.
         *
         * *Event triggered with blur on likert.*
         */
        this.blur = new EventEmitter();
        /**
         * @internal
         */
        // eslint-disable-next-line
        this._onChange = (_) => { };
        /**
         * @internal
         */
        // eslint-disable-next-line
        this._onTouched = () => { };
    }
    /**
     * @internal
     */
    ngOnInit() {
        this.fillAndOrderOptions();
    }
    /**
     * @internal
     */
    fillAndOrderOptions() {
        if (this.options.length) {
            this.optionsDefault.forEach((option) => this.addOption(option));
            this.options.forEach((option) => this.addOrder(option));
            this.options.sort((a, b) => {
                if (a.order && b.order) {
                    return a.order - b.order;
                }
                /* istanbul ignore next */
                return 0;
            });
            return;
        }
        this.options = this.optionsDefault;
    }
    /**
     * @internal
     */
    onFocus() {
        this.focus.emit(this.value);
    }
    /**
     * @internal
     */
    onBlur() {
        this._onTouched();
        this.blur.emit(this.value);
    }
    /**
     * @internal
     */
    emitValue(option) {
        this.value = option;
        this._onChange(this.value);
        this.change.emit(this.value);
    }
    /**
     * @internal
     */
    addOption(option) {
        const hasOption = this.options.some((item) => item.key === option.key);
        if (!hasOption) {
            this.options.push(option);
        }
    }
    /**
     * @internal
     */
    addOrder(option) {
        const likert = {
            bad: () => {
                option.order = 1;
            },
            dislike: () => {
                option.order = 2;
            },
            neutral: () => {
                option.order = 3;
            },
            like: () => {
                option.order = 4;
            },
            love: () => {
                option.order = 5;
            },
        };
        likert[option.key]();
    }
    /**
     * @internal
     */
    writeValue(value) {
        this.value = value;
    }
    /**
     * @internal
     */
    registerOnChange(fn) {
        this._onChange = fn;
    }
    /**
     * @internal
     */
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
}
VoxelLikertComponent.ɵfac = function VoxelLikertComponent_Factory(t) { return new (t || VoxelLikertComponent)(); };
VoxelLikertComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelLikertComponent, selectors: [["voxel-likert"]], inputs: { options: "options", id: "id", value: "value" }, outputs: { change: "change", focus: "focus", blur: "blur" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                multi: true,
                useExisting: VoxelLikertComponent
            },
        ])], ngContentSelectors: _c1, decls: 15, vars: 2, consts: [[1, "voxel-likert", 3, "id"], [1, "voxel-likert__label"], [1, "voxel-likert__content"], ["type", "button", "class", "voxel-likert__button", "role", "radio", 3, "voxel-likert__button--selected", "id", "click", "focus", "blur", 4, "ngFor", "ngForOf"], ["bad", ""], ["dislike", ""], ["neutral", ""], ["like", ""], ["love", ""], ["type", "button", "role", "radio", 1, "voxel-likert__button", 3, "id", "click", "focus", "blur"], [3, "ngTemplateOutlet"], [1, "voxel-likert__button__text"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3ClinearGradient x1='50%25' y1='-20.7957192%25' x2='50%25' y2='75.0698753%25' id='linearGradient-1'%3E%3Cstop stop-color='%23EC7000' offset='0%25'%3E%3C/stop%3E%3Cstop stop-color='%23FFD735' offset='100%25'%3E%3C/stop%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-167.000000, -198.000000)'%3E%3Cg id='Group-2' transform='translate(167.000000, 198.000000)'%3E%3Cpath d='M20,0 C8.95454424,0 0,8.95442431 0,20.0002679 L0,20.0002679 C0,31.0455757 8.95454424,40 20,40 L20,40 C31.0465272,40 40,31.0455757 40,20.0002679 L40,20.0002679 C40,8.95442431 31.0465272,0 20,0 Z' id='Fill-1' fill='url(%23linearGradient-1)'%3E%3C/path%3E%3Cpath d='M16,29 L16,29 C18.3925714,27.6666667 21.6074286,27.6666667 24,29' id='Stroke-4' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M28,22.9997596 C28,24.1047001 28.8952999,25 30.0002404,25 C31.1047001,25 32,24.1047001 32,22.9997596 C32,21.8952999 31.1047001,21 30.0002404,21 C28.8952999,21 28,21.8952999 28,22.9997596' id='Fill-10' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M32,19.3979764 C31.5385928,19.1470489 30.9795309,19 30.3773987,19 C29.3876333,19 28.5151386,19.3966273 28,20' id='Stroke-12' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M12,22.9997596 C12,24.1047001 11.1047001,25 9.99975959,25 C8.89529992,25 8,24.1047001 8,22.9997596 C8,21.8952999 8.89529992,21 9.99975959,21 C11.1047001,21 12,21.8952999 12,22.9997596' id='Fill-6' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M8,19.3979764 C8.46135806,19.1470489 9.0203603,19 9.62242831,19 C10.6120883,19 11.4844899,19.3966273 12,20' id='Stroke-8' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='41px' height='40px' viewBox='0 0 41 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-271.000000, -198.000000)'%3E%3Cg id='Group-2' transform='translate(271.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-8' fill='%23FFD735' cx='21' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M17,30 L17,30 C19.3925714,28.6666667 22.6074286,28.6666667 25,30' id='Stroke-3' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M6.82823035,24.8650074 L4.14275994,22.0597038 C4.06655533,21.9800987 3.93146533,21.9800987 3.85476588,22.0597038 L1.16979031,24.8650074 C-0.389930105,26.4943268 -0.389930105,29.1455894 1.16979031,30.7759427 C1.92589844,31.5647567 2.93041381,32 3.99876291,32 C6.25026288,32 8,30.0920628 8,27.8202166 C8,26.7036779 7.5833488,25.6538213 6.82823035,24.8650074' id='Fill-5' fill='%23106EB0'%3E%3C/path%3E%3Cpath d='M29,22.9997596 C29,24.1047001 29.8952999,25 30.9997596,25 C32.1047001,25 33,24.1047001 33,22.9997596 C33,21.8952999 32.1047001,21 30.9997596,21 C29.8952999,21 29,21.8952999 29,22.9997596' id='Fill-8' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M33,18.1994573 C32.4594054,18.7042062 31.8043967,19 31.0989258,19 C30.3045216,19 29.5750687,18.6255088 29,18' id='Stroke-10' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M13,22.9997596 C13,24.1047001 12.1048077,25 11,25 C9.89567308,25 9,24.1047001 9,22.9997596 C9,21.8952999 9.89567308,21 11,21 C12.1048077,21 13,21.8952999 13,22.9997596' id='Fill-12' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M9,18.1994573 C9.54052704,18.7042062 10.195454,19 10.9013363,19 C11.6951418,19 12.4245036,18.6255088 13,18' id='Stroke-14' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-375.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(375.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-7' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M12,22.9997596 C12,24.1047001 11.1047001,25 9.99975959,25 C8.89529992,25 8,24.1047001 8,22.9997596 C8,21.8952999 8.89529992,21 9.99975959,21 C11.1047001,21 12,21.8952999 12,22.9997596' id='Fill-3-Copy-2' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M32,22.9997596 C32,24.1047001 31.1047001,25 30.0002404,25 C28.8952999,25 28,24.1047001 28,22.9997596 C28,21.8952999 28.8952999,21 30.0002404,21 C31.1047001,21 32,21.8952999 32,22.9997596' id='Fill-5-Copy-2' fill='%23231D19'%3E%3C/path%3E%3Cpolyline id='Stroke-7-Copy-2' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round' points='16 30 21.478863 30 24 30'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-479.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(479.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-6' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M7.49285834,19.0780347 C7.37839458,19.384594 7.03130511,19.5424284 6.71761232,19.4305675 C6.40391953,19.3187067 6.24241249,18.9795101 6.35687625,18.6729507 C6.59489533,18.0354827 7.01764654,17.4819177 7.58593436,17.082183 C8.22762031,16.6313596 8.9910809,16.4222903 9.75734384,16.4743229 C10.0904645,16.4969433 10.3417479,16.7791874 10.3186012,17.1047328 C10.2954545,17.4302783 10.0066427,17.6758475 9.67352211,17.6532272 C9.18702517,17.6201919 8.70316854,17.7526932 8.29207472,18.0415116 C7.92339224,18.3008436 7.64878839,18.6604193 7.49285834,19.0780347 Z' id='Stroke-3-Copy' fill='%23231D19' fill-rule='nonzero' transform='translate(8.320080, 17.966527) rotate(-345.000000) translate(-8.320080, -17.966527) '%3E%3C/path%3E%3Cpath d='M30.4928583,19.0780347 C30.3783946,19.384594 30.0313051,19.5424284 29.7176123,19.4305675 C29.4039195,19.3187067 29.2424125,18.9795101 29.3568763,18.6729507 C29.5948953,18.0354827 30.0176465,17.4819177 30.5859344,17.082183 C31.2276203,16.6313596 31.9910809,16.4222903 32.7573438,16.4743229 C33.0904645,16.4969433 33.3417479,16.7791874 33.3186012,17.1047328 C33.2954545,17.4302783 33.0066427,17.6758475 32.6735221,17.6532272 C32.1870252,17.6201919 31.7031685,17.7526932 31.2920747,18.0415116 C30.9233922,18.3008436 30.6487884,18.6604193 30.4928583,19.0780347 Z' id='Stroke-3-Copy-2' fill='%23231D19' fill-rule='nonzero' transform='translate(31.320080, 17.966527) scale(-1, 1) rotate(-345.000000) translate(-31.320080, -17.966527) '%3E%3C/path%3E%3Cpath d='M11.9313297,22.4824008 C12.217328,23.5490421 11.5838057,24.6454859 10.517681,24.9314938 C9.45107552,25.217021 8.35466858,24.5839581 8.06867027,23.5173168 C7.78267197,22.4511562 8.41619426,21.3542317 9.48231904,21.0687045 C10.5489245,20.7826966 11.6453314,21.4157595 11.9313297,22.4824008' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M28.0687016,23.5175791 C28.3546977,24.5846926 29.4506152,25.2172698 30.5176928,24.9312641 C31.5838091,24.6457392 32.2173263,23.5493041 31.9313303,22.4826713 C31.6453343,21.4160385 30.5489361,20.7829807 29.4823391,21.0685056 C28.4157422,21.3545113 27.7827056,22.4509463 28.0687016,23.5175791' id='Fill-9-Copy' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M16,30 L16,30 C18.3925714,28.6666667 21.6074286,28.6666667 24,30' id='Stroke-3-Copy-3' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round' transform='translate(20.000000, 29.500000) rotate(-180.000000) translate(-20.000000, -29.500000) '%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"], ["aria-hidden", "true", "src", "data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3Cpath d='M7,7 C10.8659932,7 14,3.86599325 14,0 C14,0 0,0 0,0 C0,3.86599325 3.13400675,7 7,7 Z' id='path-1'%3E%3C/path%3E%3C/defs%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-583.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(583.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-2' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cg id='Rectangle-Copy-4' transform='translate(26.667347, 27.192474) rotate(-15.000000) translate(-26.667347, -27.192474) translate(19.667347, 23.692474)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cuse id='Mask' fill='%23EC7000' xlink:href='%23path-1'%3E%3C/use%3E%3Crect id='Rectangle' fill='%23FFFFFF' mask='url(%23mask-2)' x='-0.774094079' y='-0.974744871' width='15' height='3'%3E%3C/rect%3E%3C/g%3E%3Cg id='Group-Copy-8' transform='translate(11.000000, 17.000000)'%3E%3Cpath d='M0,2 C0.206174855,1.43496906 0.57399436,0.92648719 1.09009945,0.555010381 C1.67077334,0.137558719 2.34496066,-0.0385249671 3,0.00699013699' id='Stroke-3-Copy' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4.93132973,3.48240078 C5.21732803,4.54904208 4.58380574,5.64548589 3.51768096,5.9314938 C2.45107552,6.21702104 1.35466858,5.58395813 1.06867027,4.51731683 C0.78267197,3.45115622 1.41619426,2.35423172 2.48231904,2.06870449 C3.54892448,1.78269657 4.64533142,2.41575948 4.93132973,3.48240078' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3C/g%3E%3Cg id='Group-Copy-9' transform='translate(30.750173, 14.885095) scale(-1, 1) rotate(34.000000) translate(-30.750173, -14.885095) translate(28.250173, 11.885095)'%3E%3Cpath d='M-3.63797881e-12,2 C0.206174855,1.43496906 0.57399436,0.92648719 1.09009945,0.555010381 C1.67077334,0.137558719 2.34496066,-0.0385249671 3,0.00699013699' id='Stroke-3-Copy' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4.93132973,3.48240078 C5.21732803,4.54904208 4.58380574,5.64548589 3.51768096,5.9314938 C2.45107552,6.21702104 1.35466858,5.58395813 1.06867027,4.51731683 C0.78267197,3.45115622 1.41619426,2.35423172 2.48231904,2.06870449 C3.54892448,1.78269657 4.64533142,2.41575948 4.93132973,3.48240078' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E", 1, "voxel-likert__img"]], template: function VoxelLikertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "fieldset", 0);
        ɵngcc0.ɵɵelementStart(1, "legend", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, VoxelLikertComponent_button_4_Template, 4, 6, "button", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, VoxelLikertComponent_ng_template_5_Template, 1, 0, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(7, VoxelLikertComponent_ng_template_7_Template, 1, 0, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(9, VoxelLikertComponent_ng_template_9_Template, 1, 0, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(11, VoxelLikertComponent_ng_template_11_Template, 1, 0, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(13, VoxelLikertComponent_ng_template_13_Template, 1, 0, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.options);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], styles: [".voxel-likert[_ngcontent-%COMP%]{display:block;overflow:hidden}.voxel-likert__label[_ngcontent-%COMP%]{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular)}.voxel-likert__content[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin:var(--ids_size_general_28x) 0}.voxel-likert__img[_ngcontent-%COMP%]{border:var(--ids_size_border_medium) solid transparent;border-radius:50%;margin-bottom:var(--ids_size_general_8x);-webkit-transition:border-color .3s,-webkit-transform .3s;transition:border-color .3s,-webkit-transform .3s;transition:transform .3s,border-color .3s;transition:transform .3s,border-color .3s,-webkit-transform .3s}@media (max-width: 47.99rem){.voxel-likert__img[_ngcontent-%COMP%]{height:var(--ids_size_general_28x);width:var(--ids_size_general_28x)}}.voxel-likert__button[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:none;border:none;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font:var(--ids_textStyle_label_small_regular);-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.voxel-likert__button__text[_ngcontent-%COMP%]{margin:0 var(--ids_size_general_6x)}.voxel-likert__button--selected[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_small_bold);-webkit-transform:scale(1.25);transform:scale(1.25)}.voxel-likert__button--selected[_ngcontent-%COMP%]   .voxel-likert__img[_ngcontent-%COMP%]{border-color:var(--ids_color_action_neutral_variant)}.voxel-likert__button[_ngcontent-%COMP%]:hover:not(.voxel-likert__button--selected){font:var(--ids_textStyle_label_small_bold)}.voxel-likert__button[_ngcontent-%COMP%]:hover:not(.voxel-likert__button--selected)   .voxel-likert__img[_ngcontent-%COMP%]{-webkit-transform:translateY(-.625rem);transform:translateY(-.625rem)}"] });
VoxelLikertComponent.propDecorators = {
    value: [{ type: Input }],
    options: [{ type: Input }],
    id: [{ type: Input }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLikertComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-likert',
                template: "<fieldset\n  class=\"voxel-likert\"\n  [id]=\"id\"\n>\n  <legend class=\"voxel-likert__label\">\n    <ng-content></ng-content>\n  </legend>\n\n  <div class=\"voxel-likert__content\">\n    <button\n      *ngFor=\"let option of options\"\n      type=\"button\"\n      class=\"voxel-likert__button\"\n      [class.voxel-likert__button--selected]=\"value?.key === option?.key\"\n      [id]=\"id + '-' + option.key\"\n      role=\"radio\"\n      [attr.aria-checked]=\"option === value\"\n      (click)=\"emitValue(option)\"\n      (focus)=\"onFocus()\"\n      (blur)=\"onBlur()\"\n    >\n      <ng-container\n        [ngTemplateOutlet]=\"\n          option.key === 'bad' ?\n            bad\n            : option.key === 'dislike' ?\n              dislike\n              : option.key === 'neutral' ?\n                neutral\n                : option.key === 'like' ?\n                  like\n                  : love\n        \"\n      >\n      </ng-container>\n      <span class=\"voxel-likert__button__text\">\n        {{option.value}}\n      </span>\n    </button>\n  </div>\n</fieldset>\n\n<ng-template #bad>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3ClinearGradient x1='50%25' y1='-20.7957192%25' x2='50%25' y2='75.0698753%25' id='linearGradient-1'%3E%3Cstop stop-color='%23EC7000' offset='0%25'%3E%3C/stop%3E%3Cstop stop-color='%23FFD735' offset='100%25'%3E%3C/stop%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-167.000000, -198.000000)'%3E%3Cg id='Group-2' transform='translate(167.000000, 198.000000)'%3E%3Cpath d='M20,0 C8.95454424,0 0,8.95442431 0,20.0002679 L0,20.0002679 C0,31.0455757 8.95454424,40 20,40 L20,40 C31.0465272,40 40,31.0455757 40,20.0002679 L40,20.0002679 C40,8.95442431 31.0465272,0 20,0 Z' id='Fill-1' fill='url(%23linearGradient-1)'%3E%3C/path%3E%3Cpath d='M16,29 L16,29 C18.3925714,27.6666667 21.6074286,27.6666667 24,29' id='Stroke-4' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M28,22.9997596 C28,24.1047001 28.8952999,25 30.0002404,25 C31.1047001,25 32,24.1047001 32,22.9997596 C32,21.8952999 31.1047001,21 30.0002404,21 C28.8952999,21 28,21.8952999 28,22.9997596' id='Fill-10' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M32,19.3979764 C31.5385928,19.1470489 30.9795309,19 30.3773987,19 C29.3876333,19 28.5151386,19.3966273 28,20' id='Stroke-12' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M12,22.9997596 C12,24.1047001 11.1047001,25 9.99975959,25 C8.89529992,25 8,24.1047001 8,22.9997596 C8,21.8952999 8.89529992,21 9.99975959,21 C11.1047001,21 12,21.8952999 12,22.9997596' id='Fill-6' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M8,19.3979764 C8.46135806,19.1470489 9.0203603,19 9.62242831,19 C10.6120883,19 11.4844899,19.3966273 12,20' id='Stroke-8' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n\n<ng-template #dislike>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='41px' height='40px' viewBox='0 0 41 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-271.000000, -198.000000)'%3E%3Cg id='Group-2' transform='translate(271.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-8' fill='%23FFD735' cx='21' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M17,30 L17,30 C19.3925714,28.6666667 22.6074286,28.6666667 25,30' id='Stroke-3' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M6.82823035,24.8650074 L4.14275994,22.0597038 C4.06655533,21.9800987 3.93146533,21.9800987 3.85476588,22.0597038 L1.16979031,24.8650074 C-0.389930105,26.4943268 -0.389930105,29.1455894 1.16979031,30.7759427 C1.92589844,31.5647567 2.93041381,32 3.99876291,32 C6.25026288,32 8,30.0920628 8,27.8202166 C8,26.7036779 7.5833488,25.6538213 6.82823035,24.8650074' id='Fill-5' fill='%23106EB0'%3E%3C/path%3E%3Cpath d='M29,22.9997596 C29,24.1047001 29.8952999,25 30.9997596,25 C32.1047001,25 33,24.1047001 33,22.9997596 C33,21.8952999 32.1047001,21 30.9997596,21 C29.8952999,21 29,21.8952999 29,22.9997596' id='Fill-8' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M33,18.1994573 C32.4594054,18.7042062 31.8043967,19 31.0989258,19 C30.3045216,19 29.5750687,18.6255088 29,18' id='Stroke-10' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M13,22.9997596 C13,24.1047001 12.1048077,25 11,25 C9.89567308,25 9,24.1047001 9,22.9997596 C9,21.8952999 9.89567308,21 11,21 C12.1048077,21 13,21.8952999 13,22.9997596' id='Fill-12' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M9,18.1994573 C9.54052704,18.7042062 10.195454,19 10.9013363,19 C11.6951418,19 12.4245036,18.6255088 13,18' id='Stroke-14' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n\n<ng-template #neutral>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-375.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(375.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-7' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M12,22.9997596 C12,24.1047001 11.1047001,25 9.99975959,25 C8.89529992,25 8,24.1047001 8,22.9997596 C8,21.8952999 8.89529992,21 9.99975959,21 C11.1047001,21 12,21.8952999 12,22.9997596' id='Fill-3-Copy-2' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M32,22.9997596 C32,24.1047001 31.1047001,25 30.0002404,25 C28.8952999,25 28,24.1047001 28,22.9997596 C28,21.8952999 28.8952999,21 30.0002404,21 C31.1047001,21 32,21.8952999 32,22.9997596' id='Fill-5-Copy-2' fill='%23231D19'%3E%3C/path%3E%3Cpolyline id='Stroke-7-Copy-2' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round' points='16 30 21.478863 30 24 30'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n\n<ng-template #like>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-479.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(479.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-6' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cpath d='M7.49285834,19.0780347 C7.37839458,19.384594 7.03130511,19.5424284 6.71761232,19.4305675 C6.40391953,19.3187067 6.24241249,18.9795101 6.35687625,18.6729507 C6.59489533,18.0354827 7.01764654,17.4819177 7.58593436,17.082183 C8.22762031,16.6313596 8.9910809,16.4222903 9.75734384,16.4743229 C10.0904645,16.4969433 10.3417479,16.7791874 10.3186012,17.1047328 C10.2954545,17.4302783 10.0066427,17.6758475 9.67352211,17.6532272 C9.18702517,17.6201919 8.70316854,17.7526932 8.29207472,18.0415116 C7.92339224,18.3008436 7.64878839,18.6604193 7.49285834,19.0780347 Z' id='Stroke-3-Copy' fill='%23231D19' fill-rule='nonzero' transform='translate(8.320080, 17.966527) rotate(-345.000000) translate(-8.320080, -17.966527) '%3E%3C/path%3E%3Cpath d='M30.4928583,19.0780347 C30.3783946,19.384594 30.0313051,19.5424284 29.7176123,19.4305675 C29.4039195,19.3187067 29.2424125,18.9795101 29.3568763,18.6729507 C29.5948953,18.0354827 30.0176465,17.4819177 30.5859344,17.082183 C31.2276203,16.6313596 31.9910809,16.4222903 32.7573438,16.4743229 C33.0904645,16.4969433 33.3417479,16.7791874 33.3186012,17.1047328 C33.2954545,17.4302783 33.0066427,17.6758475 32.6735221,17.6532272 C32.1870252,17.6201919 31.7031685,17.7526932 31.2920747,18.0415116 C30.9233922,18.3008436 30.6487884,18.6604193 30.4928583,19.0780347 Z' id='Stroke-3-Copy-2' fill='%23231D19' fill-rule='nonzero' transform='translate(31.320080, 17.966527) scale(-1, 1) rotate(-345.000000) translate(-31.320080, -17.966527) '%3E%3C/path%3E%3Cpath d='M11.9313297,22.4824008 C12.217328,23.5490421 11.5838057,24.6454859 10.517681,24.9314938 C9.45107552,25.217021 8.35466858,24.5839581 8.06867027,23.5173168 C7.78267197,22.4511562 8.41619426,21.3542317 9.48231904,21.0687045 C10.5489245,20.7826966 11.6453314,21.4157595 11.9313297,22.4824008' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M28.0687016,23.5175791 C28.3546977,24.5846926 29.4506152,25.2172698 30.5176928,24.9312641 C31.5838091,24.6457392 32.2173263,23.5493041 31.9313303,22.4826713 C31.6453343,21.4160385 30.5489361,20.7829807 29.4823391,21.0685056 C28.4157422,21.3545113 27.7827056,22.4509463 28.0687016,23.5175791' id='Fill-9-Copy' fill='%23231D19'%3E%3C/path%3E%3Cpath d='M16,30 L16,30 C18.3925714,28.6666667 21.6074286,28.6666667 24,30' id='Stroke-3-Copy-3' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round' transform='translate(20.000000, 29.500000) rotate(-180.000000) translate(-20.000000, -29.500000) '%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n\n<ng-template #love>\n  <img\n  class=\"voxel-likert__img\"\n  aria-hidden=\"true\"\n  src=\"data:image/svg+xml;charset=UTF-8,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 58 (84663) - https://sketch.com --%3E%3Ctitle%3EGroup 3%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cdefs%3E%3Cpath d='M7,7 C10.8659932,7 14,3.86599325 14,0 C14,0 0,0 0,0 C0,3.86599325 3.13400675,7 7,7 Z' id='path-1'%3E%3C/path%3E%3C/defs%3E%3Cg id='Page-2' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='Artboard' transform='translate(-583.000000, -198.000000)'%3E%3Cg id='Group-3' transform='translate(583.000000, 198.000000)'%3E%3Ccircle id='Oval-Copy-2' fill='%23FFD735' cx='20' cy='20' r='20'%3E%3C/circle%3E%3Cg id='Rectangle-Copy-4' transform='translate(26.667347, 27.192474) rotate(-15.000000) translate(-26.667347, -27.192474) translate(19.667347, 23.692474)'%3E%3Cmask id='mask-2' fill='white'%3E%3Cuse xlink:href='%23path-1'%3E%3C/use%3E%3C/mask%3E%3Cuse id='Mask' fill='%23EC7000' xlink:href='%23path-1'%3E%3C/use%3E%3Crect id='Rectangle' fill='%23FFFFFF' mask='url(%23mask-2)' x='-0.774094079' y='-0.974744871' width='15' height='3'%3E%3C/rect%3E%3C/g%3E%3Cg id='Group-Copy-8' transform='translate(11.000000, 17.000000)'%3E%3Cpath d='M0,2 C0.206174855,1.43496906 0.57399436,0.92648719 1.09009945,0.555010381 C1.67077334,0.137558719 2.34496066,-0.0385249671 3,0.00699013699' id='Stroke-3-Copy' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4.93132973,3.48240078 C5.21732803,4.54904208 4.58380574,5.64548589 3.51768096,5.9314938 C2.45107552,6.21702104 1.35466858,5.58395813 1.06867027,4.51731683 C0.78267197,3.45115622 1.41619426,2.35423172 2.48231904,2.06870449 C3.54892448,1.78269657 4.64533142,2.41575948 4.93132973,3.48240078' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3C/g%3E%3Cg id='Group-Copy-9' transform='translate(30.750173, 14.885095) scale(-1, 1) rotate(34.000000) translate(-30.750173, -14.885095) translate(28.250173, 11.885095)'%3E%3Cpath d='M-3.63797881e-12,2 C0.206174855,1.43496906 0.57399436,0.92648719 1.09009945,0.555010381 C1.67077334,0.137558719 2.34496066,-0.0385249671 3,0.00699013699' id='Stroke-3-Copy' stroke='%23231D19' stroke-width='1.3' stroke-linecap='round' stroke-linejoin='round'%3E%3C/path%3E%3Cpath d='M4.93132973,3.48240078 C5.21732803,4.54904208 4.58380574,5.64548589 3.51768096,5.9314938 C2.45107552,6.21702104 1.35466858,5.58395813 1.06867027,4.51731683 C0.78267197,3.45115622 1.41619426,2.35423172 2.48231904,2.06870449 C3.54892448,1.78269657 4.64533142,2.41575948 4.93132973,3.48240078' id='Fill-5-Copy' fill='%23231D19'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E\">\n</ng-template>\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        multi: true,
                        useExisting: VoxelLikertComponent
                    },
                ],
                styles: [".voxel-likert{display:block;overflow:hidden}.voxel-likert__label{color:var(--ids_color_text_body_01);font:var(--ids_textStyle_label_medium_regular)}.voxel-likert__content{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around;margin:var(--ids_size_general_28x) 0}.voxel-likert__img{border:var(--ids_size_border_medium) solid transparent;border-radius:50%;margin-bottom:var(--ids_size_general_8x);-webkit-transition:border-color .3s,-webkit-transform .3s;transition:border-color .3s,-webkit-transform .3s;transition:transform .3s,border-color .3s;transition:transform .3s,border-color .3s,-webkit-transform .3s}@media (max-width: 47.99rem){.voxel-likert__img{height:var(--ids_size_general_28x);width:var(--ids_size_general_28x)}}.voxel-likert__button{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:none;border:none;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;font:var(--ids_textStyle_label_small_regular);-webkit-transition:-webkit-transform .3s;transition:-webkit-transform .3s;transition:transform .3s;transition:transform .3s,-webkit-transform .3s}.voxel-likert__button__text{margin:0 var(--ids_size_general_6x)}.voxel-likert__button--selected{font:var(--ids_textStyle_label_small_bold);-webkit-transform:scale(1.25);transform:scale(1.25)}.voxel-likert__button--selected .voxel-likert__img{border-color:var(--ids_color_action_neutral_variant)}.voxel-likert__button:hover:not(.voxel-likert__button--selected){font:var(--ids_textStyle_label_small_bold)}.voxel-likert__button:hover:not(.voxel-likert__button--selected) .voxel-likert__img{-webkit-transform:translateY(-.625rem);transform:translateY(-.625rem)}\n"]
            }]
    }], function () { return []; }, { options: [{
            type: Input
        }], id: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], value: [{
            type: Input
        }] }); })();

class VoxelLikertModule {
}
VoxelLikertModule.ɵfac = function VoxelLikertModule_Factory(t) { return new (t || VoxelLikertModule)(); };
VoxelLikertModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelLikertModule });
VoxelLikertModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, ReactiveFormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelLikertModule, [{
        type: NgModule,
        args: [{
                declarations: [VoxelLikertComponent],
                imports: [CommonModule, ReactiveFormsModule],
                exports: [VoxelLikertComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelLikertModule, { declarations: function () { return [VoxelLikertComponent]; }, imports: function () { return [CommonModule, ReactiveFormsModule]; }, exports: function () { return [VoxelLikertComponent]; } }); })();

/* eslint-disable @angular-eslint/directive-selector */
/**
 * @internal
 */
class VoxelListTextComponent {
    constructor() {
        this.class = 'voxel-list-text';
    }
}
VoxelListTextComponent.ɵfac = function VoxelListTextComponent_Factory(t) { return new (t || VoxelListTextComponent)(); };
VoxelListTextComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListTextComponent, selectors: [["voxel-list-text"]], hostVars: 2, hostBindings: function VoxelListTextComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [[1, "voxel-sr-only-a11y"]], template: function VoxelListTextComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelementStart(1, "span", 0);
        ɵngcc0.ɵɵtext(2, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
VoxelListTextComponent.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListTextComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-text',
                template: `
    <ng-content></ng-content>
    <span class="voxel-sr-only-a11y">&nbsp;</span>
  `
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListDescrComponent {
    constructor() {
        this.class = 'voxel-list-descr';
    }
}
VoxelListDescrComponent.ɵfac = function VoxelListDescrComponent_Factory(t) { return new (t || VoxelListDescrComponent)(); };
VoxelListDescrComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListDescrComponent, selectors: [["voxel-list-descr"]], hostVars: 2, hostBindings: function VoxelListDescrComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [[1, "voxel-sr-only-a11y"]], template: function VoxelListDescrComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelementStart(1, "span", 0);
        ɵngcc0.ɵɵtext(2, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
VoxelListDescrComponent.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListDescrComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-descr',
                template: `
    <ng-content></ng-content>
    <span class="voxel-sr-only-a11y">&nbsp;</span>
  `
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListInformationDirective {
    constructor() {
        this.class = 'voxel-list-information';
    }
}
VoxelListInformationDirective.ɵfac = function VoxelListInformationDirective_Factory(t) { return new (t || VoxelListInformationDirective)(); };
VoxelListInformationDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListInformationDirective, selectors: [["voxel-list-information"]], hostVars: 2, hostBindings: function VoxelListInformationDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListInformationDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListInformationDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-information'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListIconDirective {
    constructor() {
        this.class = 'voxel-list-icon';
    }
}
VoxelListIconDirective.ɵfac = function VoxelListIconDirective_Factory(t) { return new (t || VoxelListIconDirective)(); };
VoxelListIconDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListIconDirective, selectors: [["voxel-list-icon"]], hostVars: 2, hostBindings: function VoxelListIconDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListIconDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListIconDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-icon'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListNumberDirective {
    constructor() {
        this.class = 'voxel-list-number';
    }
}
VoxelListNumberDirective.ɵfac = function VoxelListNumberDirective_Factory(t) { return new (t || VoxelListNumberDirective)(); };
VoxelListNumberDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelListNumberDirective, selectors: [["voxel-list-number"]], hostVars: 2, hostBindings: function VoxelListNumberDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } } });
VoxelListNumberDirective.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListNumberDirective, [{
        type: Directive,
        args: [{
                selector: 'voxel-list-number'
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListDetailComponent {
    constructor() {
        this.class = 'voxel-list-detail';
    }
}
VoxelListDetailComponent.ɵfac = function VoxelListDetailComponent_Factory(t) { return new (t || VoxelListDetailComponent)(); };
VoxelListDetailComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListDetailComponent, selectors: [["voxel-list-detail"]], hostVars: 2, hostBindings: function VoxelListDetailComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, ngContentSelectors: _c1, decls: 3, vars: 0, consts: [[1, "voxel-sr-only-a11y"]], template: function VoxelListDetailComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
        ɵngcc0.ɵɵelementStart(1, "span", 0);
        ɵngcc0.ɵɵtext(2, "\u00A0");
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
VoxelListDetailComponent.propDecorators = {
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListDetailComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-detail',
                template: `
    <ng-content></ng-content>
    <span class="voxel-sr-only-a11y">&nbsp;</span>
  `
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }] }); })();
/**
 * @internal
 */
class VoxelListSimpleComponent {
    constructor() {
        this.class = 'voxel-list-simple';
    }
    /**
     * @internal
     */
    set icon(icon) {
        this.hasIcon = !!icon;
    }
    /**
     * @internal
     */
    get icon() {
        return !!this.hasIcon;
    }
}
VoxelListSimpleComponent.ɵfac = function VoxelListSimpleComponent_Factory(t) { return new (t || VoxelListSimpleComponent)(); };
VoxelListSimpleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListSimpleComponent, selectors: [["voxel-list-simple"], ["", "voxel-list-simple", ""], ["", "voxelListSimple", ""]], contentQueries: function VoxelListSimpleComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelIconComponent, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.icon = _t.first);
    } }, hostVars: 2, hostBindings: function VoxelListSimpleComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c32, decls: 7, vars: 4, consts: [[1, "voxel-list__content-simple", 3, "ngClass"]], template: function VoxelListSimpleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c30);
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div");
        ɵngcc0.ɵɵprojection(4, 1);
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c31, ctx.icon));
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, directives: [ɵngcc1.NgClass], encapsulation: 2 });
VoxelListSimpleComponent.propDecorators = {
    icon: [{ type: ContentChild, args: [VoxelIconComponent, { static: true },] }],
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListSimpleComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-simple, [voxel-list-simple], [voxelListSimple]',
                template: ` <div
    class="voxel-list__content-simple"
    [attr.aria-label]="a11yLabel"
    [ngClass]="{
      'voxel-list__content-simple--no-border': icon
    }"
  >
    <div>
      <ng-content select="voxel-icon, img"></ng-content>
    </div>
    <div>
      <ng-content></ng-content>
      <span>
        <ng-content select="voxel-list-descr"></ng-content>
      </span>
    </div>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], icon: [{
            type: ContentChild,
            args: [VoxelIconComponent, { static: true }]
        }], a11yLabel: [{
            type: Input
        }] }); })();
/**
 * @internal
 */
class VoxelListActionComponent {
    constructor() {
        this.class = 'voxel-list-action';
    }
}
VoxelListActionComponent.ɵfac = function VoxelListActionComponent_Factory(t) { return new (t || VoxelListActionComponent)(); };
VoxelListActionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListActionComponent, selectors: [["voxel-list-action"], ["", "voxel-list-action", ""], ["", "voxelListAction", ""]], hostVars: 2, hostBindings: function VoxelListActionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c34, decls: 16, vars: 5, consts: [[1, "voxel-list__content-action"], [1, "voxel-list-action__container"], [1, "voxel-list-action__text"], ["text", ""], [1, "voxel-list-action__description"], ["description", ""], ["detail", ""], [1, "voxel-list-action__icon"]], template: function VoxelListActionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c33);
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "button", 0);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2, 3);
        ɵngcc0.ɵɵprojection(6, 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 2);
        ɵngcc0.ɵɵelementStart(8, "span", 4, 5);
        ɵngcc0.ɵɵprojection(10, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "span", null, 6);
        ɵngcc0.ɵɵprojection(13, 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "div", 7);
        ɵngcc0.ɵɵprojection(15, 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(5);
        const _r1 = ɵngcc0.ɵɵreference(9);
        const _r2 = ɵngcc0.ɵɵreference(12);
        let tmp_2_0;
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("voxel-list__content-action--double-line", _r1.childNodes.length > 0 || _r2.childNodes.length > 0);
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
        ɵngcc0.ɵɵadvance(7);
        ɵngcc0.ɵɵclassProp("voxel-list-action__description--with-icon", ((tmp_2_0 = _r0.children[0] == null ? null : _r0.children[0].firstChild) == null ? null : tmp_2_0.tagName) === "VOXEL-ICON");
    } }, encapsulation: 2 });
VoxelListActionComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListActionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-action, [voxel-list-action], [voxelListAction]',
                template: ` <div>
    <button
      [attr.aria-label]="a11yLabel"
      class="voxel-list__content-action"
      [class.voxel-list__content-action--double-line]="
        description.childNodes.length > 0 || detail.childNodes.length > 0
      "
    >
      <ng-content select="voxel-list-icon"></ng-content>
      <div class="voxel-list-action__container">
        <div #text class="voxel-list-action__text">
          <ng-content></ng-content>
        </div>
        <div class="voxel-list-action__text">
          <span
            #description
            class="voxel-list-action__description"
            [class.voxel-list-action__description--with-icon]="
              $any(text.children[0]?.firstChild)?.tagName === 'VOXEL-ICON'
            "
          >
            <ng-content select="voxel-list-descr"></ng-content>
          </span>
          <span #detail>
            <ng-content select="voxel-list-detail"></ng-content>
          </span>
        </div>
      </div>

      <div class="voxel-list-action__icon">
        <ng-content select="voxel-icon"></ng-content>
      </div>
    </button>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
/**
 * @internal
 */
class VoxelListInfoComponent {
    constructor() {
        this.class = 'voxel-list-info';
    }
}
VoxelListInfoComponent.ɵfac = function VoxelListInfoComponent_Factory(t) { return new (t || VoxelListInfoComponent)(); };
VoxelListInfoComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListInfoComponent, selectors: [["voxel-list-info"], ["", "voxel-list-info", ""], ["", "voxelListInfo", ""]], hostVars: 2, hostBindings: function VoxelListInfoComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c1, decls: 2, vars: 1, consts: [[1, "voxel-list__content-info"]], template: function VoxelListInfoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListInfoComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListInfoComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-info, [voxel-list-info], [voxelListInfo]',
                template: ` <div class="voxel-list__content-info" [attr.aria-label]="a11yLabel">
    <ng-content></ng-content>
  </div>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
/**
 * @internal
 */
class VoxelListDefinitionComponent {
    constructor() {
        this.class = 'voxel-list-definition';
    }
}
VoxelListDefinitionComponent.ɵfac = function VoxelListDefinitionComponent_Factory(t) { return new (t || VoxelListDefinitionComponent)(); };
VoxelListDefinitionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListDefinitionComponent, selectors: [["voxel-list-definition"], ["", "voxel-list-definition", ""], ["", "voxelListDefinition", ""]], hostVars: 2, hostBindings: function VoxelListDefinitionComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c36, decls: 4, vars: 1, consts: [[1, "voxel-list__content-definition"]], template: function VoxelListDefinitionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c35);
        ɵngcc0.ɵɵelementStart(0, "dt", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "dd");
        ɵngcc0.ɵɵprojection(3, 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListDefinitionComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListDefinitionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-definition, [voxel-list-definition], [voxelListDefinition]',
                template: ` <dt class="voxel-list__content-definition" [attr.aria-label]="a11yLabel">
      <ng-content select="voxel-list-descr"></ng-content>
    </dt>
    <dd>
      <ng-content select="voxel-list-text"></ng-content>
    </dd>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();
class VoxelListColumnComponent {
    constructor() {
        this.class = 'voxel-list-column';
    }
}
VoxelListColumnComponent.ɵfac = function VoxelListColumnComponent_Factory(t) { return new (t || VoxelListColumnComponent)(); };
VoxelListColumnComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListColumnComponent, selectors: [["voxel-list-column"], ["", "voxel-list-column", ""], ["", "voxelListColumn", ""]], hostVars: 2, hostBindings: function VoxelListColumnComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.class);
    } }, inputs: { a11yLabel: "a11yLabel" }, ngContentSelectors: _c38, decls: 7, vars: 1, consts: [["role", "text", 1, "voxel-list__content-column"]], template: function VoxelListColumnComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c37);
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵelementStart(1, "span");
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(3, "br");
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵprojection(5, 1);
        ɵngcc0.ɵɵprojection(6, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel);
    } }, encapsulation: 2 });
VoxelListColumnComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    class: [{ type: HostBinding }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListColumnComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list-column, [voxel-list-column], [voxelListColumn]',
                template: ` <span class="voxel-list__content-column" role="text" [attr.aria-label]="a11yLabel">
    <span>
      <ng-content></ng-content>
    </span>
    <br />
    <span>
      <ng-content select="voxel-list-descr"></ng-content>

      <ng-content select="voxel-list-detail"></ng-content>
    </span>
  </span>`
            }]
    }], function () { return []; }, { class: [{
            type: HostBinding
        }], a11yLabel: [{
            type: Input
        }] }); })();

/**
 * @internal
 */
let NEXT_ID$5 = 0;
/**
 * Componente de List
 *
 * *List Component*
 *
 * **Module:**
 *
 * `import { VoxelListModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/list?componentOnly=true</example-url>
 *
 * A lista utiliza subcomponentes para especificar o tipo de item que será adicionado.
 * Também possui diretivas para a construção e customização desses itens.
 *
 * Sendo as diretivas:
 * * text: `<voxel-list-text></voxel-list-text>`*
 * * description: `<voxel-list-descr></voxel-list-descr>`*
 * * information: `<voxel-list-information></voxel-list-information>`*
 * * number: `<voxel-list-number></voxel-list-number>`*
 * * detail: `<voxel-list-detail></voxel-list-detail>`*
 *
 * E os subcomponentes:
 * * action: `voxel-list-action, voxelListAction`*
 * * simple: `voxel-list-simple, voxelListSimple`*
 * * info: `voxel-list-info, voxelListInfo`*
 * * definition: `voxel-list-definition, voxelListDefinition`*
 *
 * The list uses subcomponents to specify wich type of item will be added.*
 * It also has directives for the construction and customization of these items.*
 *
 * The directives are:*
 * * text: `<voxel-list-text></voxel-list-text>`*
 * * description: `<voxel-list-descr></voxel-list-descr>`*
 * * information: `<voxel-list-information></voxel-list-information>`*
 * * number: `<voxel-list-number></voxel-list-number>`*
 * * detail: `<voxel-list-detail></voxel-list-detail>`*
 *
 * And the subcomponents:*
 * * action: `voxel-list-action, voxelListAction`*
 * * simple: `voxel-list-simple, voxelListSimple`*
 * * info: `voxel-list-info, voxelListInfo`*
 * * definition: `voxel-list-definition, voxelListDefinition`*
 *
 * @example Exemplo de lista vazia / Example of empty list
 * <voxel-list></voxel-list>
 *
 * @example Exemplo de lista com item simples / Example of list with simple item
 * <voxel-list>
 *  <li voxelListSimple>
 *    <voxel-list-text>
 *      lorem ipsum dolor
 *    </voxel-list-text>
 *  </li>
 * </voxel-list>
 *
 * @example Exemplo de lista com aria-label customizável para / Example of list with customizable aria-label for accessibility
 * <voxel-list>
 *  <li voxelListSimple
 *  a11yLabel="texto customizado a ser lido pelo leitor de tela"
 * >
 *    <voxel-list-text>
 *      lorem ipsum dolor
 *    </voxel-list-text>
 *  </li>
 * </voxel-list>
 *
 * @example Exemplo de lista com descrição / Example list with description
 * <voxel-list>
 *    <li voxelListSimple>
 *      <voxel-list-text>
 *        lorem ipsum dolor sit
 *      </voxel-list-text>
 *      <voxel-list-descr>
 *        description
 *      </voxel-list-descr>
 *    </li>
 * </voxel-list>
 *
 * @example Exemplo de lista de definição / Definition list example
 * <voxel-list>
 *   <dl voxelListDefinition>
 *     <voxel-list-descr>
 *       definition
 *     </voxel-list-descr>
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *   </dl>
 * </voxel-list>
 *
 * @example Exemplo de lista de definição horizontal / Example of horizontal definition list
 * <voxel-list voxelHorizontalList>
 *   <dl voxelListDefinition>
 *     <voxel-list-descr>
 *       definition
 *     </voxel-list-descr>
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *   </dl>
 * </voxel-list>
 *
 * @example Exemplo de lista simples com ícone / Simple list example with icon
 * <voxel-list>
 *   <li voxelListSimple>
 *     <voxel-icon>
 *       inovacao_outline
 *     </voxel-icon>
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista simples com ícone e descrição / Example of simple list with icon and description
 * <voxel-list>
 *   <li voxelListSimple>
 *     <voxel-icon>
 *       inovacao_outline
 *     </voxel-icon>
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *     <voxel-list-descr>
 *       description
 *     </voxel-list-descr>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista de informação complementar / Example of complementary information list
 * <voxel-list>
 *   <li voxelListInfo>
 *    <voxel-icon>
 *      inovacao_outline
 *    </voxel-icon>
 *    <voxel-list-information>
 *      lorem ipsum dolor sit
 *    </voxel-list-information>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista de ação (button) / Action list example (button)
 * <voxel-list>
 *   <li voxelListAction
 *     (click)="onClick()"
 *   >
 *     <voxel-list-text>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *     <voxel-icon>
 *       seta_direita
 *     </voxel-icon>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista de ação com descrição (button) / Example action list with description (button)
 * <voxel-list>
 *   <li voxelListAction
 *     (click)="onClick()"
 *   >
 *     <voxel-list-text>
 *       <voxel-icon>
 *        inovacao_outline
 *       </voxel-icon>
 *       lorem ipsum dolor sit
 *     </voxel-list-text>
 *     <voxel-icon>
 *       seta_direita
 *     </voxel-icon>
 *   </li>
 * </voxel-list>
 *
 * @example Exemplo de lista em colunas / Column list example
 * <voxel-list>
 *  <li voxelListColumn>
 *    <voxel-list-text>
 *      lorem ipsum dolor
 *    </voxel-list-text>
 *    <voxel-list-descr>
 *      descrption
 *    </voxel-list-descr>
 *    <voxel-list-text>
 *      R$ 320,00
 *    </voxel-list-text>
 *    <voxel-list-detail>
 *      detail
 *    </voxel-list-detail>
 *  </li>
 * </voxel-list>
 *
 * @example Exemplo de lista com big numbers / List example with big number
 * <voxel-list>
 *  <li voxelListColumn>
 *    <voxel-list-text>
 *      lorem ipsum dolor sit
 *    </voxel-list-text>
 *    <voxel-list-number>
 *      100
 *    </voxel-list-number>
 *  </li>
 * </voxel-list>
 *
 * @example Exemplo de lista com avatar / example list with avatar
 * <voxel-list>
 *  <li voxelListSimple>
 *    <img src="image.png" alt="texto alternativo" />
 *    <voxel-list-text>
 *      lorem ipsum dolor
 *    </voxel-list-text>
 *    <voxel-list-descr>
 *      description
 *    </voxel-list-descr>
 *  </li>
 * </voxel-list>
 *
 *
 */
class VoxelListComponent {
    constructor() {
        this.listId = `voxel-list-${NEXT_ID$5++}`;
        /**
         * @internal
         */
        this._voxelHorizontalList = false;
    }
    /**
     * @internal
     */
    set voxelHorizontalList(value) {
        this._voxelHorizontalList = enforceBoolean(value);
    }
}
VoxelListComponent.ɵfac = function VoxelListComponent_Factory(t) { return new (t || VoxelListComponent)(); };
VoxelListComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelListComponent, selectors: [["voxel-list"]], contentQueries: function VoxelListComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelListDefinitionComponent, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.definitionList = _t);
    } }, hostVars: 2, hostBindings: function VoxelListComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("horizontal-list", ctx._voxelHorizontalList);
    } }, inputs: { listId: "listId", voxelHorizontalList: "voxelHorizontalList" }, ngContentSelectors: _c40, decls: 2, vars: 2, consts: [["role", "list", "class", "voxel-list simple-list", 4, "ngIf"], ["class", "voxel-list defition-list", 4, "ngIf"], ["role", "list", 1, "voxel-list", "simple-list"], [1, "voxel-list", "defition-list"]], template: function VoxelListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c39);
        ɵngcc0.ɵɵtemplate(0, VoxelListComponent_ul_0_Template, 2, 1, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, VoxelListComponent_div_1_Template, 2, 1, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.definitionList.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.definitionList.length);
    } }, directives: [ɵngcc1.NgIf], styles: [":host{display:inline}.voxel-list{background-color:var(--ids_color_bg_base)}.voxel-list__content-simple,.voxel-list__content-action,.voxel-list__content-info,.voxel-list__content-column,.voxel-list__content-row,.voxel-list__content-switch{border-bottom:var(--ids_size_border_small) solid var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;padding:.5rem .5rem .5rem 0;word-break:normal}@media (max-width: 32.5rem){.voxel-list__content-simple,.voxel-list__content-action,.voxel-list__content-info,.voxel-list__content-column,.voxel-list__content-row,.voxel-list__content-switch{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft)}}.voxel-list__content-simple voxel-icon,.voxel-list__content-action voxel-icon,.voxel-list__content-info voxel-icon,.voxel-list__content-column voxel-icon,.voxel-list__content-row voxel-icon,.voxel-list__content-switch voxel-icon{display:-webkit-box;display:-ms-flexbox;display:flex;height:3rem;width:3rem}.voxel-list__content-simple div{-ms-flex-item-align:center;align-self:center}.voxel-list__content-simple img{border-radius:100%;height:2rem;margin:0 1rem;vertical-align:middle;width:2rem}.voxel-list__content-simple--no-border{border-bottom:none}.voxel-list__content-action{background-color:var(--ids_color_bg_base);border:none;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:var(--ids_size_general_64x);width:100%}.voxel-list__content-action voxel-list-icon{-ms-flex-item-align:center;align-self:center;margin-right:.75rem}.voxel-list__content-action--double-line{min-height:var(--ids_size_general_84x)}.voxel-list__content-action:hover,.voxel-list__content-action:focus{background-color:var(--ids_color_action_neutral_base_soft)}.voxel-list__content-action .voxel-list-action__container{-ms-flex-item-align:center;align-self:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}.voxel-list__content-action .voxel-list-action__text{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-list__content-action .voxel-list-action__text .voxel-list-action__description--with-icon voxel-list-descr{margin-left:var(--ids_size_general_48x);margin-top:-1rem}.voxel-list__content-action .voxel-list-action__icon{-ms-flex-item-align:center;align-self:center;margin-left:.5rem}.voxel-list__content-info{border-bottom:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-list__content-info .voxel-icon{color:var(--ids_color_action_neutral_variant)}.voxel-list__content-column{display:grid;padding-left:.5rem;grid-template-areas:\"br first-line\" \"br second-line\";grid-template-columns:0 1fr;overflow:hidden}.voxel-list__content-column span{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-list__content-column span:first-child{grid-area:first-line}.voxel-list__content-column span:last-child{grid-area:second-line}@media (max-width: 32.5rem){.voxel-list__content-column{border-bottom:none}}.voxel-list-text{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--ids_color_action_neutral_variant);display:-webkit-box;display:-ms-flexbox;display:flex;text-align:left}.voxel-list-descr{color:var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875rem;padding-bottom:.375rem;text-align:left}.voxel-list-definition{color:var(--ids_color_action_neutral_base);display:block;font-size:.875rem;padding:.375rem 0}.voxel-list-information{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_neutral_variant);display:-webkit-box;display:-ms-flexbox;display:flex;font-size:1rem}.voxel-list-number{color:var(--ids_color_action_neutral_base);font-size:1.5rem;line-height:3rem}.voxel-list-detail{color:var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875rem}.horizontal-list div{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}.horizontal-list div .voxel-list-definition{text-align:left}.horizontal-list div div{border-bottom:none}@media (max-width: 32.5rem){.horizontal-list div{display:inline-block}}\n"], encapsulation: 2, changeDetection: 0 });
VoxelListComponent.propDecorators = {
    definitionList: [{ type: ContentChildren, args: [VoxelListDefinitionComponent,] }],
    listId: [{ type: Input }],
    _voxelHorizontalList: [{ type: HostBinding, args: ['class.horizontal-list',] }],
    voxelHorizontalList: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-list',
                template: "<ul role=\"list\" [attr.id]=\"listId\" class=\"voxel-list simple-list\" *ngIf=\"!definitionList.length\">\n  <ng-content select=\"\n    li[voxelListSimple],\n    li[voxel-list-simple],\n    li[voxelListAction],\n    li[voxel-list-action],\n    li[voxelListInfo],\n    li[voxel-list-info],\n    li[voxelListColumn],\n    li[voxel-list-column]\"\n  >\n  </ng-content>\n</ul>\n\n<div [attr.id]=\"listId\" class=\"voxel-list defition-list\" *ngIf=\"definitionList.length\">\n  <ng-content select=\"\n    dl[voxelListDefinition],\n    dl[voxel-list-definition]\"\n  >\n  </ng-content>\n</div>\n",
                encapsulation: ViewEncapsulation.None,
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [":host{display:inline}.voxel-list{background-color:var(--ids_color_bg_base)}.voxel-list__content-simple,.voxel-list__content-action,.voxel-list__content-info,.voxel-list__content-column,.voxel-list__content-row,.voxel-list__content-switch{border-bottom:var(--ids_size_border_small) solid var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;padding:.5rem .5rem .5rem 0;word-break:normal}@media (max-width: 32.5rem){.voxel-list__content-simple,.voxel-list__content-action,.voxel-list__content-info,.voxel-list__content-column,.voxel-list__content-row,.voxel-list__content-switch{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft)}}.voxel-list__content-simple voxel-icon,.voxel-list__content-action voxel-icon,.voxel-list__content-info voxel-icon,.voxel-list__content-column voxel-icon,.voxel-list__content-row voxel-icon,.voxel-list__content-switch voxel-icon{display:-webkit-box;display:-ms-flexbox;display:flex;height:3rem;width:3rem}.voxel-list__content-simple div{-ms-flex-item-align:center;align-self:center}.voxel-list__content-simple img{border-radius:100%;height:2rem;margin:0 1rem;vertical-align:middle;width:2rem}.voxel-list__content-simple--no-border{border-bottom:none}.voxel-list__content-action{background-color:var(--ids_color_bg_base);border:none;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;min-height:var(--ids_size_general_64x);width:100%}.voxel-list__content-action voxel-list-icon{-ms-flex-item-align:center;align-self:center;margin-right:.75rem}.voxel-list__content-action--double-line{min-height:var(--ids_size_general_84x)}.voxel-list__content-action:hover,.voxel-list__content-action:focus{background-color:var(--ids_color_action_neutral_base_soft)}.voxel-list__content-action .voxel-list-action__container{-ms-flex-item-align:center;align-self:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%}.voxel-list__content-action .voxel-list-action__text{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-list__content-action .voxel-list-action__text .voxel-list-action__description--with-icon voxel-list-descr{margin-left:var(--ids_size_general_48x);margin-top:-1rem}.voxel-list__content-action .voxel-list-action__icon{-ms-flex-item-align:center;align-self:center;margin-left:.5rem}.voxel-list__content-info{border-bottom:none;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.voxel-list__content-info .voxel-icon{color:var(--ids_color_action_neutral_variant)}.voxel-list__content-column{display:grid;padding-left:.5rem;grid-template-areas:\"br first-line\" \"br second-line\";grid-template-columns:0 1fr;overflow:hidden}.voxel-list__content-column span{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.voxel-list__content-column span:first-child{grid-area:first-line}.voxel-list__content-column span:last-child{grid-area:second-line}@media (max-width: 32.5rem){.voxel-list__content-column{border-bottom:none}}.voxel-list-text{-webkit-box-align:center;-ms-flex-align:center;align-items:center;color:var(--ids_color_action_neutral_variant);display:-webkit-box;display:-ms-flexbox;display:flex;text-align:left}.voxel-list-descr{color:var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875rem;padding-bottom:.375rem;text-align:left}.voxel-list-definition{color:var(--ids_color_action_neutral_base);display:block;font-size:.875rem;padding:.375rem 0}.voxel-list-information{-ms-flex-item-align:center;align-self:center;color:var(--ids_color_action_neutral_variant);display:-webkit-box;display:-ms-flexbox;display:flex;font-size:1rem}.voxel-list-number{color:var(--ids_color_action_neutral_base);font-size:1.5rem;line-height:3rem}.voxel-list-detail{color:var(--ids_color_action_neutral_base);display:-webkit-box;display:-ms-flexbox;display:flex;font-size:.875rem}.horizontal-list div{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-pack:distribute;justify-content:space-around}.horizontal-list div .voxel-list-definition{text-align:left}.horizontal-list div div{border-bottom:none}@media (max-width: 32.5rem){.horizontal-list div{display:inline-block}}\n"]
            }]
    }], function () { return []; }, { listId: [{
            type: Input
        }], _voxelHorizontalList: [{
            type: HostBinding,
            args: ['class.horizontal-list']
        }], voxelHorizontalList: [{
            type: Input
        }], definitionList: [{
            type: ContentChildren,
            args: [VoxelListDefinitionComponent]
        }] }); })();

const listUtils = [
    VoxelListActionComponent,
    VoxelListColumnComponent,
    VoxelListComponent,
    VoxelListDefinitionComponent,
    VoxelListDescrComponent,
    VoxelListDetailComponent,
    VoxelListIconDirective,
    VoxelListInfoComponent,
    VoxelListInformationDirective,
    VoxelListNumberDirective,
    VoxelListSimpleComponent,
    VoxelListTextComponent,
];
class VoxelListModule {
}
VoxelListModule.ɵfac = function VoxelListModule_Factory(t) { return new (t || VoxelListModule)(); };
VoxelListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelListModule });
VoxelListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelListModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                declarations: [listUtils],
                exports: [listUtils]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelListModule, { declarations: function () { return [VoxelListActionComponent, VoxelListColumnComponent, VoxelListComponent, VoxelListDefinitionComponent, VoxelListDescrComponent, VoxelListDetailComponent, VoxelListIconDirective, VoxelListInfoComponent, VoxelListInformationDirective, VoxelListNumberDirective, VoxelListSimpleComponent, VoxelListTextComponent]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [VoxelListActionComponent, VoxelListColumnComponent, VoxelListComponent, VoxelListDefinitionComponent, VoxelListDescrComponent, VoxelListDetailComponent, VoxelListIconDirective, VoxelListInfoComponent, VoxelListInformationDirective, VoxelListNumberDirective, VoxelListSimpleComponent, VoxelListTextComponent]; } }); })();

/**
 * @internal
 */
const VoxelCrescentProgressBar = trigger('crescentAnimation', [
    state('*', style({
        width: '0%',
    })),
    state('true', style({
        width: '{{ filled }}%',
    }), { params: { filled: '0' } }),
    transition('* => true', animate('1000ms ease-out')),
]);
/**
 * @internal
 */
const VoxelDecrescentProgressBar = trigger('decrescentAnimation', [
    state('*', style({
        width: '100%',
    })),
    state('true', style({
        width: '{{ filled }}%',
    }), { params: { filled: '0' } }),
    transition('* => true', animate('1000ms ease-out')),
]);

/**
 * As barras de progresso expressam a evolução de um processo ou valor
 *
 * *Progress bars shows a process or value evolution*
 *
 * **Module:**
 *
 * `import { VoxelProgressBarModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/ids/portfolio/progressbar?componentOnly=true</example-url>
 *
 */
class VoxelProgressBarComponent {
    constructor(_platform) {
        this._platform = _platform;
        this.role = this._platform.ANDROID || this._platform.IOS ? 'progressbar' : 'img';
        this._a11yLabel = '';
        this._decrescent = false;
        this._fill = 0;
        this._gradient = false;
        this._heavy = false;
        this._max = 100;
        this._min = 0;
        this._value = 0;
    }
    /**
     * Define a label acessível para a barra de progresso
     *
     * *Defines accessible label for progress bar*
     */
    set a11yLabel(value) {
        this._a11yLabel = value;
    }
    get a11yLabel() {
        if (!this._a11yLabel) {
            return `O progresso é de ${this.fill}%`;
        }
        return this._a11yLabel;
    }
    /**
     * Define se a barra de progresso é crescente ou decrescente
     *
     * *Defines if progress bar is crescent or decrescent*
     */
    set decrescent(value) {
        this._decrescent = enforceBoolean(value);
    }
    get decrescent() {
        return this._decrescent;
    }
    /**
     * Define a porcentagem preenchida da barra da progresso
     *
     * *Defines the progress bar filled percentage*
     */
    set fill(value) {
        this._fill = enforceNumber(value);
    }
    get fill() {
        if (this._min !== 0 || this._max !== 100) {
            return this.calculateFill();
        }
        return this._fill;
    }
    /**
     * Define se a barra de progresso é gradiente
     *
     * *Defines if progress bar is gradient*
     */
    set gradient(value) {
        this._gradient = enforceBoolean(value);
    }
    get gradient() {
        return this._gradient;
    }
    /**
     * Define se a barra de progresso é espessa
     *
     * *Defines if progress bar is heavy*
     */
    set heavy(value) {
        this._heavy = enforceBoolean(value);
    }
    get heavy() {
        return this._heavy;
    }
    /**
     * Define o máximo da barra
     *
     * *Defines progressbar max*
     */
    set max(value) {
        this._max = enforceNumber(value);
    }
    get max() {
        return this._max;
    }
    /**
     * Define o mínimo da barra
     *
     * *Defines progressbar min*
     */
    set min(value) {
        this._min = enforceNumber(value);
    }
    get min() {
        return this._min;
    }
    /**
     * Define o valor da barra (reflete o aria-valuenow).
     * Quando o min e max não são alterados, é necessário passar apenas o fill (porcentagem)
     *
     * Documentação: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-valuenow
     *
     * *Defines bar value (reflects aria-valuenow).*
     *
     * *Docs: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-valuenow*
     */
    set value(value) {
        this._value = enforceNumber(value);
    }
    get value() {
        if (this._min === 0 && this._max === 100) {
            return this.fill;
        }
        return this._value;
    }
    /** @internal */
    calculateFill() {
        if (this.value <= this.min) {
            return 0;
        }
        if (this.value >= this.max) {
            return 100;
        }
        const proportion = (this.value - this.min) / (this.max - this.min);
        return proportion * 100;
    }
}
VoxelProgressBarComponent.ɵfac = function VoxelProgressBarComponent_Factory(t) { return new (t || VoxelProgressBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Platform)); };
VoxelProgressBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelProgressBarComponent, selectors: [["voxel-progress-bar"]], inputs: { a11yLabel: "a11yLabel", decrescent: "decrescent", fill: "fill", gradient: "gradient", heavy: "heavy", max: "max", min: "min", value: "value" }, decls: 4, vars: 11, consts: [["tabindex", "-1", 1, "voxel-progress-bar"], ["class", "voxel-progress-bar__filled", 4, "ngIf", "ngIfElse"], ["decrescentTemplate", ""], [1, "voxel-progress-bar__filled"]], template: function VoxelProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, VoxelProgressBarComponent_span_1_Template, 1, 5, "span", 1);
        ɵngcc0.ɵɵtemplate(2, VoxelProgressBarComponent_ng_template_2_Template, 1, 5, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵclassProp("voxel-progress-bar--heavy", ctx.heavy)("voxel-progress-bar--gradient", ctx.gradient);
        ɵngcc0.ɵɵattribute("aria-label", ctx.a11yLabel)("aria-valuenow", ctx.value)("aria-valuemin", ctx.min)("aria-valuemax", ctx.max)("role", ctx.role);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.decrescent)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf], styles: ["voxel-progress-bar{width:100%}.voxel-progress-bar{background:var(--ids_color_action_disabled_base);border-radius:var(--ids_size_general_4x);height:var(--ids_size_general_8x)}.voxel-progress-bar__filled{background:var(--ids_color_action_primary_base);border-radius:var(--ids_size_general_4x);display:block;height:100%;overflow:hidden;-webkit-transition-duration:1s;transition-duration:1s}.voxel-progress-bar--gradient .voxel-progress-bar__filled{background:var(--ids_color_bg_brand_gradient)}.voxel-progress-bar--heavy{border-radius:var(--ids_size_general_8x);height:var(--ids_size_general_16x)}.voxel-progress-bar--heavy .voxel-progress-bar__filled{border-radius:var(--ids_size_general_8x)}\n"], encapsulation: 2, data: { animation: [VoxelCrescentProgressBar, VoxelDecrescentProgressBar] } });
VoxelProgressBarComponent.ctorParameters = () => [
    { type: Platform }
];
VoxelProgressBarComponent.propDecorators = {
    a11yLabel: [{ type: Input }],
    decrescent: [{ type: Input }],
    fill: [{ type: Input }],
    gradient: [{ type: Input }],
    heavy: [{ type: Input }],
    max: [{ type: Input }],
    min: [{ type: Input }],
    value: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelProgressBarComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-progress-bar',
                template: "<div class=\"voxel-progress-bar\"\n  [class.voxel-progress-bar--heavy]=\"heavy\"\n  [class.voxel-progress-bar--gradient]=\"gradient\"\n  [attr.aria-label]=\"a11yLabel\"\n  [attr.aria-valuenow]=\"value\"\n  [attr.aria-valuemin]=\"min\"\n  [attr.aria-valuemax]=\"max\"\n  [attr.role]=\"role\"\n  tabindex=\"-1\"\n>\n  <span *ngIf=\"!decrescent; else decrescentTemplate\"\n    class=\"voxel-progress-bar__filled\"\n    [@crescentAnimation]=\"{ value: true, params: { filled: fill } }\">\n  </span>\n\n  <ng-template #decrescentTemplate>\n    <span\n      class=\"voxel-progress-bar__filled\"\n      [@decrescentAnimation]=\"{ value: true, params: { filled: fill } }\">\n    </span>\n  </ng-template>\n</div>\n",
                animations: [VoxelCrescentProgressBar, VoxelDecrescentProgressBar],
                encapsulation: ViewEncapsulation.None,
                styles: ["voxel-progress-bar{width:100%}.voxel-progress-bar{background:var(--ids_color_action_disabled_base);border-radius:var(--ids_size_general_4x);height:var(--ids_size_general_8x)}.voxel-progress-bar__filled{background:var(--ids_color_action_primary_base);border-radius:var(--ids_size_general_4x);display:block;height:100%;overflow:hidden;-webkit-transition-duration:1s;transition-duration:1s}.voxel-progress-bar--gradient .voxel-progress-bar__filled{background:var(--ids_color_bg_brand_gradient)}.voxel-progress-bar--heavy{border-radius:var(--ids_size_general_8x);height:var(--ids_size_general_16x)}.voxel-progress-bar--heavy .voxel-progress-bar__filled{border-radius:var(--ids_size_general_8x)}\n"]
            }]
    }], function () { return [{ type: ɵngcc6.Platform }]; }, { a11yLabel: [{
            type: Input
        }], decrescent: [{
            type: Input
        }], fill: [{
            type: Input
        }], gradient: [{
            type: Input
        }], heavy: [{
            type: Input
        }], max: [{
            type: Input
        }], min: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

class VoxelProgressBarModule {
}
VoxelProgressBarModule.ɵfac = function VoxelProgressBarModule_Factory(t) { return new (t || VoxelProgressBarModule)(); };
VoxelProgressBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelProgressBarModule });
VoxelProgressBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelProgressBarModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelProgressBarComponent],
                exports: [VoxelProgressBarComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelProgressBarModule, { declarations: function () { return [VoxelProgressBarComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelProgressBarComponent]; } }); })();

/**
 * Diretiva para utilização do RadioButton dentro do componente selector
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelRadioButtonModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/radiobutton?componentOnly=true</example-url>
 *
 * @example RadioButton sem seleção
 * <voxel-form-selection-group>
 *           <voxel-form-selection>
 *             <input type="radio" name="noSelection" formControlName="noSelection" voxelRadioButton />
 *             simples
 *           </voxel-form-selection>
 * </voxel-form-selection-group>
 *
 * @example RadioButton pré selecionado
 * <voxel-form-selection-group>
 *            <voxel-form-selection>
 *              <input type="radio" name="selected" formControlName="selected" voxelRadioButton />
 *              pré selecionado
 *            </voxel-form-selection>
 * </voxel-form-selection-group>
 *
 * @example RadioButton com error, utilizando <voxel-form-status>
 * <voxel-form-selection-group aria-live="polite">
 *             <voxel-form-selection>
 *               <input type="radio" value="15" name="withError" formControlName="withError" voxelRadioButton required />
 *               aceito receber SMS
 *             </voxel-form-selection>
 *             <voxel-form-selection>
 *               <input type="radio" value="16" name="withError" formControlName="withError" voxelRadioButton required />
 *               não aceito SMS
 *             </voxel-form-selection>
 *             <voxel-form-status *ngIf="withError()" [attr.aria-invalid]="withError()">
 *               seleciona uma opção para prosseguir
 *             </voxel-form-status>
 * </voxel-form-selection-group>
 */
class VoxelRadioButtonDirective extends VoxelFormSelectionBase {
    /**
     * @internal
     */
    get selectorType() {
        return 'radio';
    }
    /**
     * @internal
     */
    get icon() {
        return this.nativeElement.checked ? 'radio_button_selected' : 'radio_button_outline';
    }
    /**
     * @internal
     */
    get iconClasses() {
        return {
            'voxel-form-selection__radio': true,
            'voxel-form-selection__radio--checked': this.nativeElement.checked,
            'voxel-form-selection__radio--empty': !this.nativeElement.checked,
            'voxel-form-selection__radio--disabled': this.nativeElement.disabled,
            'voxel-form-selection__radio--focus': this._isFocused,
            'voxel-form-selection__radio--invalid': this.state === 'invalid',
        };
    }
}
VoxelRadioButtonDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelRadioButtonDirective_BaseFactory; return function VoxelRadioButtonDirective_Factory(t) { return (ɵVoxelRadioButtonDirective_BaseFactory || (ɵVoxelRadioButtonDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelRadioButtonDirective)))(t || VoxelRadioButtonDirective); }; }();
VoxelRadioButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelRadioButtonDirective, selectors: [["", "voxelRadioButton", ""]], features: [ɵngcc0.ɵɵProvidersFeature([{ provide: VoxelFormSelectionBase, useExisting: VoxelRadioButtonDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelRadioButtonDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelRadioButton]',
                providers: [{ provide: VoxelFormSelectionBase, useExisting: VoxelRadioButtonDirective }]
            }]
    }], null, null); })();

class VoxelRadioButtonModule {
}
VoxelRadioButtonModule.ɵfac = function VoxelRadioButtonModule_Factory(t) { return new (t || VoxelRadioButtonModule)(); };
VoxelRadioButtonModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelRadioButtonModule });
VoxelRadioButtonModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelRadioButtonModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelRadioButtonDirective],
                exports: [VoxelRadioButtonDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelRadioButtonModule, { declarations: function () { return [VoxelRadioButtonDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelRadioButtonDirective]; } }); })();

const buildValueString = (id, value) => {
    let newVal;
    if (id === null) {
        return `${value}`;
    }
    if (value && typeof value === 'object') {
        newVal = 'Object';
    }
    return `${id}: ${newVal}`.slice(0, 50);
};
/**
 * @internal
 */
let NEXT_ID$4 = 0;
class VoxelNativeSelectDirective extends VoxelFieldMixinBase {
    /** @internal */
    constructor(ngControl, elementRef, renderer) {
        super(ngControl, elementRef) /* istanbul ignore next */;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.renderer = renderer;
        /** @internal */
        this._compareWith = objectIs;
        /** @internal */
        this.optionMap = new Map();
        /** @internal */
        this.idCounter = 0;
        /** @internal */
        this.controlId = `voxel-native-select-${NEXT_ID$4++}`;
        /** @internal */
        this.inputClasses = 'voxel-native-select';
    }
    /** @internal */
    get controlDisabled() {
        return this.disabled || null;
    }
    /** @internal */
    get controlValue() {
        return this.value;
    }
    /** @internal */
    get id() {
        return this.controlId;
    }
    /** @internal */
    controlSelect({ value }) {
        this.value = this.getOptionValue(value);
    }
    /** @internal */
    controlChange() {
        this.formAcessorHandleChange();
    }
    /** @internal */
    controlFocus() {
        this.formAcessorHandleFocus();
    }
    /** @internal */
    controlBlur() {
        this.formAcessorHandleBlur();
    }
    /**
     * Função para comparar os valores das opções com os valores selecionados.
     *
     * *Function to compare the option values with the selected values.*
     *
     * Exemplo:
     * options: IObj[] = [{ val: 1, label: 'Opção 1' },{ val: 2, label: 'Opção 2' }];
     *
     * compareFn(c1: any, c2: any): boolean {
     *   return c1 && c2 ? c1.val === c2.val : c1 === c2;
     * }
     *
     * https://angular.io/api/forms/SelectControlValueAccessor#caveat-option-selection
     */
    get compareWith() {
        return this._compareWith;
    }
    set compareWith(fn) {
        this._compareWith = fn;
    }
    /** @internal */
    ngDoCheck() {
        /* istanbul ignore next */
        if (this.ngControl && this.ngControl.touched && this.ngControl.invalid && !this.active) {
            this.formAcessorHandleBlur();
        }
    }
    /** @internal */
    writeValue(value) {
        this.value = value;
        const id = this.getOptionId(value);
        if (id === null) {
            this.renderer.setProperty(this.elementRef.nativeElement, 'selectedIndex', -1);
        }
        const valueString = buildValueString(id, value);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', valueString);
    }
    /** @internal */
    registerOption() {
        return (this.idCounter++).toString();
    }
    /** @internal */
    getOptionId(value) {
        for (const id of Array.from(this.optionMap.keys())) {
            if (this.compareWith(this.optionMap.get(id), value)) {
                return id;
            }
        }
        return null;
    }
    /** @internal */
    getOptionValue(valueString) {
        const id = this.extractId(valueString);
        return this.optionMap.has(id) ? this.optionMap.get(id) : valueString;
    }
    /** @internal */
    extractId(valueString) {
        return valueString.split(':')[0];
    }
}
VoxelNativeSelectDirective.ɵfac = function VoxelNativeSelectDirective_Factory(t) { return new (t || VoxelNativeSelectDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
VoxelNativeSelectDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelNativeSelectDirective, selectors: [["", "voxelNativeSelect", ""]], hostVars: 4, hostBindings: function VoxelNativeSelectDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function VoxelNativeSelectDirective_change_HostBindingHandler($event) { return ctx.controlSelect($event.target); })("ngModelChange", function VoxelNativeSelectDirective_ngModelChange_HostBindingHandler() { return ctx.controlChange(); })("focus", function VoxelNativeSelectDirective_focus_HostBindingHandler() { return ctx.controlFocus(); })("blur", function VoxelNativeSelectDirective_blur_HostBindingHandler() { return ctx.controlBlur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("class", ctx.inputClasses)("disabled", ctx.controlDisabled)("value", ctx.controlValue)("id", ctx.id);
    } }, inputs: { compareWith: "compareWith" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: VoxelFieldMixinBase,
                useExisting: forwardRef(/* istanbul ignore next */ () => VoxelNativeSelectDirective)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelNativeSelectDirective.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef },
    { type: Renderer2 }
];
VoxelNativeSelectDirective.propDecorators = {
    controlDisabled: [{ type: HostBinding, args: ['attr.disabled',] }],
    controlValue: [{ type: HostBinding, args: ['attr.value',] }],
    id: [{ type: HostBinding, args: ['attr.id',] }],
    inputClasses: [{ type: HostBinding, args: ['attr.class',] }],
    controlSelect: [{ type: HostListener, args: ['change', ['$event.target'],] }],
    controlChange: [{ type: HostListener, args: ['ngModelChange',] }],
    controlFocus: [{ type: HostListener, args: ['focus',] }],
    controlBlur: [{ type: HostListener, args: ['blur',] }],
    compareWith: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelNativeSelectDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelNativeSelect]',
                providers: [
                    {
                        provide: VoxelFieldMixinBase,
                        useExisting: forwardRef(/* istanbul ignore next */ () => VoxelNativeSelectDirective)
                    },
                ]
            }]
    }], function () { return [{ type: ɵngcc4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { inputClasses: [{
            type: HostBinding,
            args: ['attr.class']
        }], controlDisabled: [{
            type: HostBinding,
            args: ['attr.disabled']
        }], controlValue: [{
            type: HostBinding,
            args: ['attr.value']
        }], id: [{
            type: HostBinding,
            args: ['attr.id']
        }], 
    /** @internal */
    controlSelect: [{
            type: HostListener,
            args: ['change', ['$event.target']]
        }], 
    /** @internal */
    controlChange: [{
            type: HostListener,
            args: ['ngModelChange']
        }], 
    /** @internal */
    controlFocus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /** @internal */
    controlBlur: [{
            type: HostListener,
            args: ['blur']
        }], compareWith: [{
            type: Input
        }] }); })();

class VoxelNativeSelectOptionDirective {
    /** @internal */
    constructor(element, renderer, select) {
        this.element = element;
        this.renderer = renderer;
        this.select = select;
        if (this.select) {
            this.id = this.select.registerOption();
        }
    }
    /**
     * Rastreia o valor vinculado ao elemento de opção. Ao contrário da associação de valor(string),
     * `ngValue` oferece suporte à associação de objetos.
     *
     * *Tracks the value bound to the option element. Unlike the value binding,*
     * *`ngValue` supports binding to objects.*
     */
    set ngValue(value) {
        if (this.select === null) {
            return;
        }
        this.select.optionMap.set(this.id, value);
        this.setElementValue(buildValueString(this.id, value));
        this.select.writeValue(this.select.value);
    }
    /**
     * Rastreia valores de string simples vinculados ao elemento de opção.
     * Para objetos, use o parâmetro de entrada `ngValue`.
     *
     * *Tracks simple string values bound to the option element.*
     * *For objects, use the `ngValue` input binding.*
     */
    set value(value) {
        this.setElementValue(value);
        if (this.select) {
            this.select.writeValue(this.select.value);
        }
    }
    /** @internal */
    setElementValue(value) {
        this.renderer.setProperty(this.element.nativeElement, 'value', value);
    }
}
VoxelNativeSelectOptionDirective.ɵfac = function VoxelNativeSelectOptionDirective_Factory(t) { return new (t || VoxelNativeSelectOptionDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(VoxelNativeSelectDirective, 9)); };
VoxelNativeSelectOptionDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelNativeSelectOptionDirective, selectors: [["", "voxelNativeOption", ""]], inputs: { ngValue: "ngValue", value: "value" } });
VoxelNativeSelectOptionDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 },
    { type: VoxelNativeSelectDirective, decorators: [{ type: Optional }, { type: Host }] }
];
VoxelNativeSelectOptionDirective.propDecorators = {
    ngValue: [{ type: Input }],
    value: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelNativeSelectOptionDirective, [{
        type: Directive,
        args: [{ selector: '[voxelNativeOption]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: VoxelNativeSelectDirective, decorators: [{
                type: Optional
            }, {
                type: Host
            }] }]; }, { ngValue: [{
            type: Input
        }], value: [{
            type: Input
        }] }); })();

/**
 * Dados dos eventos da option
 *
 * *Option event data*
 */
class IVoxelOptionEvent {
    /** @internal */
    constructor(option, close) {
        this.option = option;
        this.close = close;
    }
}
/**
 * @internal
 */
let NEXT_ID$3 = 0;
/**
 *  @internal
 *  Componente base para select.
 *
 * *Base component to select.*
 */
class VoxelOptionComponent {
    /** @internal */
    constructor(element) {
        this.element = element;
        /** @internal */
        this._selected = false;
        /** @internal */
        this._disabled = false;
        /** @internal */
        this._destroy = new Subject();
        /**
         *  Identificação única da opção.
         *
         * *Unique option identification.*
         */
        this.optionId = `voxel-option-${NEXT_ID$3++}`;
        /**
         * Evento disparado quando ouver mudança na opção.
         *
         * *Event fired when you hear a change in option.*
         */
        this.change = new EventEmitter();
        /** @internal */
        this.role = 'option';
    }
    /**
     *  Valor da opção no momento do evento.
     *
     * *Option value at the time of the event.*
     */
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
    }
    /**
     * Indica se a opção ficara desabilitato.
     *
     * *Indicates whether the option will be disabled.*
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    /**
     * Indica se a opção esta selecionada.
     *
     * *Indicates whether the option is selected.*
     */
    get selected() {
        return this._selected;
    }
    set selected(value) {
        this._selected = enforceBoolean(value);
    }
    /** @internal */
    get classes() {
        let classNames = 'voxel-option';
        classNames += this.selected ? ' voxel-option--selected' : '';
        classNames += this.disabled ? ' voxel-option--disabled' : '';
        return classNames;
    }
    /** @internal */
    get tabIndex() {
        return this.disabled ? '-1' : '0';
    }
    /** @internal */
    get id() {
        return this.optionId;
    }
    /** @internal */
    get ariaSelected() {
        return this.selected;
    }
    /** @internal */
    get ariaDisabled() {
        return this.disabled;
    }
    /** @internal */
    onClick() {
        this.select(true);
    }
    /** @internal */
    get optionLabel() {
        return (this.element.nativeElement.textContent || '').trim();
    }
    /** @internal */
    select(close = false) {
        if (this.disabled) {
            return;
        }
        this._selected = true;
        this._emitOptionChangeEvent(close);
    }
    /** @internal */
    deselect(emitValue = false) {
        this._selected = false;
        if (emitValue) {
            this._emitOptionChangeEvent();
        }
    }
    /** @internal */
    ngOnDestroy() {
        this._destroy.complete();
    }
    /** @internal */
    _emitOptionChangeEvent(_close) {
        this.change.emit(new IVoxelOptionEvent(this, _close));
    }
}
VoxelOptionComponent.ɵfac = function VoxelOptionComponent_Factory(t) { return new (t || VoxelOptionComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
VoxelOptionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelOptionComponent, selectors: [["voxel-option"]], hostVars: 6, hostBindings: function VoxelOptionComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function VoxelOptionComponent_click_HostBindingHandler() { return ctx.onClick(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role)("class", ctx.classes)("tabindex", ctx.tabIndex)("id", ctx.id)("aria-selected", ctx.ariaSelected)("aria-disabled", ctx.ariaDisabled);
    } }, inputs: { optionId: "optionId", value: "value", disabled: "disabled", selected: "selected" }, outputs: { change: "change" }, ngContentSelectors: _c1, decls: 2, vars: 0, consts: [[1, "voxel-option__text"]], template: function VoxelOptionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [".voxel-option[_ngcontent-%COMP%]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_bg_base);color:var(--ids_color_text_body_01);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_48x);padding:0 var(--ids_size_general_24x)}.voxel-option[_ngcontent-%COMP%]:hover:not(.voxel-option--selected){background-color:var(--ids_color_bg_variant_01)}.voxel-option--selected[_ngcontent-%COMP%]{background-color:var(--ids_color_bg_variant_01);border-left:var(--ids_size_border_large) solid var(--ids_color_action_primary_base);padding-left:var(--ids_size_general_20x)}.voxel-option--disabled[_ngcontent-%COMP%]{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-option--hide[_ngcontent-%COMP%]{display:none}.voxel-option__text[_ngcontent-%COMP%]{font:var(--ids_textStyle_body_01_regular);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}"] });
VoxelOptionComponent.ctorParameters = () => [
    { type: ElementRef }
];
VoxelOptionComponent.propDecorators = {
    optionId: [{ type: Input }],
    value: [{ type: Input }],
    disabled: [{ type: Input }],
    selected: [{ type: Input }],
    change: [{ type: Output }],
    classes: [{ type: HostBinding, args: ['attr.class',] }],
    tabIndex: [{ type: HostBinding, args: ['attr.tabindex',] }],
    id: [{ type: HostBinding, args: ['attr.id',] }],
    ariaSelected: [{ type: HostBinding, args: ['attr.aria-selected',] }],
    ariaDisabled: [{ type: HostBinding, args: ['attr.aria-disabled',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    onClick: [{ type: HostListener, args: ['click',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelOptionComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-option',
                template: "<span class=\"voxel-option__text\">\n  <ng-content></ng-content>\n</span>\n",
                styles: [".voxel-option{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_bg_base);color:var(--ids_color_text_body_01);cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;height:var(--ids_size_general_48x);padding:0 var(--ids_size_general_24x)}.voxel-option:hover:not(.voxel-option--selected){background-color:var(--ids_color_bg_variant_01)}.voxel-option--selected{background-color:var(--ids_color_bg_variant_01);border-left:var(--ids_size_border_large) solid var(--ids_color_action_primary_base);padding-left:var(--ids_size_general_20x)}.voxel-option--disabled{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-option--hide{display:none}.voxel-option__text{font:var(--ids_textStyle_body_01_regular);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { optionId: [{
            type: Input
        }], change: [{
            type: Output
        }], role: [{
            type: HostBinding,
            args: ['attr.role']
        }], value: [{
            type: Input
        }], disabled: [{
            type: Input
        }], selected: [{
            type: Input
        }], classes: [{
            type: HostBinding,
            args: ['attr.class']
        }], tabIndex: [{
            type: HostBinding,
            args: ['attr.tabindex']
        }], id: [{
            type: HostBinding,
            args: ['attr.id']
        }], ariaSelected: [{
            type: HostBinding,
            args: ['attr.aria-selected']
        }], ariaDisabled: [{
            type: HostBinding,
            args: ['attr.aria-disabled']
        }], 
    /** @internal */
    onClick: [{
            type: HostListener,
            args: ['click']
        }] }); })();

/**
 * Dados dos eventos do select
 *
 * *Select event data*
 */
class IVoxelSelectEvent {
    /** @internal */
    constructor(source, value) {
        this.source = source;
        this.value = value;
    }
}
/**
 * @internal
 */
let NEXT_ID$2 = 0;
/**
 * Select é um tipo de input utilizado em formulários, no qual o usuário tem a possibilidade de fazer uma escolha dentre
 * uma lista de opções, que são exibidas após o click no componente.
 *
 * *Select is a type of input used in forms, in which the user has the possibility to make a choice from a list of*
 * *options, which are displayed after clicking on the component.*
 *
 * **Module:**
 *
 * `import { VoxelSelectModule, VoxelFormFieldModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/select?componentOnly=true</example-url>
 *
 */
class VoxelSelectComponent extends VoxelFieldMixinBase {
    constructor(liveAnnouncer, document, renderer, ngControl, elementRef, platform, overlay) {
        super(ngControl, elementRef) /* istanbul ignore next */;
        this.liveAnnouncer = liveAnnouncer;
        this.document = document;
        this.renderer = renderer;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.platform = platform;
        this.overlay = overlay;
        /** @internal */
        this._compareWith = objectIs;
        /** @internal */
        this._panelOpen = false;
        /** @internal */
        this._destroy = new Subject();
        /** @internal */
        this._clearSearchString = new Subject();
        /** @internal */
        this.panelId = `voxel-select__panel-options-${NEXT_ID$2}`;
        /** @internal */
        this.labelId = `voxel-select-label-${NEXT_ID$2}`;
        /** @internal */
        this.valueId = `voxel-select-value-${NEXT_ID$2}`;
        /** @internal */
        this.searchString = '';
        /** @internal */
        this._positions = [];
        /** @internal */
        this.isMobile = this.platform.ANDROID || this.platform.IOS;
        /**
         *  Identificação única do select.
         *
         *  *Unique select identification.*
         */
        this.controlId = `voxel-select-${NEXT_ID$2++}`;
        /**
         * Placeholder do select.
         *
         *  *Select placeholder.*
         */
        this.placeholder = '';
        /**
         *  Define a quantidade de option no visível scroll.
         *  visibleOptions = 8; (default)
         *
         * *Sets the amount of option in the visible scroll.*
         *  *visibleOptions = 8; (default)*
         */
        this.visibleOptions = 8;
        /**
         * Define a posição de abertura da lista de opções
         *
         * *Defines the opening position of the options list*
         */
        this.position = 'auto';
        /**
         * Evento disparado com a mudança no select.
         *
         * *Event triggered with the change in the select.*
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado com o focus no select.
         *
         * *Event triggered with focus on select.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado com o blur no select.
         *
         * *Event triggered with blur on select.*
         */
        this.blur = new EventEmitter();
        /**
         * Evento disparado quando select é aberto.
         *
         * *Event fired when select is opened.*
         */
        this.selectOpen = new EventEmitter();
        /**
         * Evento disparado quando o select é fechado.
         *
         * *Event fired when the select is closed.*
         */
        this.selectClose = new EventEmitter();
        /** @internal */
        this.optionSelectionChanges = defer(() => {
            const options = this.options;
            return options === null || options === void 0 ? void 0 : options.changes.pipe(startWith(options), switchMap(() => merge(...options.map((option) => option.change))));
        });
    }
    /** @internal */
    get panelOpen() {
        return this._panelOpen;
    }
    /** @internal */
    get selectWidth() {
        return this._selectWidth;
    }
    /** @internal */
    get optionSelected() {
        return this._lastOptionSelected;
    }
    /** @internal */
    get arrayOption() {
        return this.options.toArray();
    }
    /** @internal */
    get enableOption() {
        return this.arrayOption.filter((item) => !item.disabled);
    }
    /** @internal */
    get optionTextValue() {
        return this.optionSelected ? this.optionSelected.optionLabel : this.placeholder;
    }
    /** @internal */
    get tabindex() {
        return this.disabled ? '-1' : '0';
    }
    /**
     * Indica se o select é obrigatório.
     *
     * *Indicates whether select is mandatory.*
     */
    set required(value) {
        this._required = enforceBoolean(value);
    }
    get required() {
        return this._required;
    }
    /**
     * Função para comparar os valores das opções com os valores selecionados.
     *
     * *Function to compare the option values with the selected values.*
     *
     * Exemplo:
     * options: IObj[] = [{ val: 1, label: 'Opção 1' },{ val: 2, label: 'Opção 2' }];
     *
     * compareFn(c1: any, c2: any): boolean {
     *   return c1 && c2 ? c1.val === c2.val : c1 === c2;
     * }
     *
     * https://angular.io/api/forms/SelectControlValueAccessor#caveat-option-selection
     */
    get compareWith() {
        return this._compareWith;
    }
    set compareWith(fn) {
        this._compareWith = fn;
    }
    /** @internal */
    ngOnInit() {
        this.defineOpeningPosition();
    }
    /** @internal */
    defineOpeningPosition() {
        const bottom = {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        };
        const top = {
            originX: 'start',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'bottom',
        };
        const setPosition = {
            top: () => this._positions.push(top),
            bottom: () => this._positions.push(bottom),
            auto: () => this._positions.push(bottom, top),
        };
        return setPosition[this.position]();
    }
    /** @internal */
    ngAfterContentInit() {
        this.options.changes.pipe(startWith(null), takeUntil(this._destroy)).subscribe(() => {
            this.resetOptions();
        });
        this.initializeSelection();
    }
    /** @internal */
    resetOptions() {
        const changedOrDestroyed = merge(this.options.changes, this._destroy);
        this.optionSelectionChanges.pipe(takeUntil(changedOrDestroyed)).subscribe((event) => {
            this.selectOption(event.option, event.close);
        });
    }
    /** @internal */
    ngOnDestroy() {
        this._destroy.complete();
    }
    /** @internal */
    ngDoCheck() {
        if (this.ngControl && this.ngControl.touched && this.ngControl.invalid && !this.active) {
            this.formAcessorHandleBlur();
        }
        if ((this.value === '' && !this.optionSelected) ||
            (this.optionSelected && this.value === this.optionSelected.value)) {
            return;
        }
        this.resetSelect();
    }
    /** @internal */
    initializeSelection() {
        Promise.resolve().then(() => {
            const value = this.ngControl ? this.ngControl.value : this.value;
            const optionSelected = this.enableOption.find((opt) => this.compareWith(opt.value, value));
            const initialSelect = this.arrayOption.filter((opt) => opt.selected);
            if (initialSelect.length > 0 && (!optionSelected || value === '')) {
                this.selectOption(initialSelect[initialSelect.length - 1]);
                return;
            }
            if (!optionSelected) {
                return;
            }
            optionSelected.select();
            this.selectOption(optionSelected);
        });
    }
    /** @internal */
    resetSelect() {
        if (!this.options || this.options.length < 0) {
            return;
        }
        /* istanbul ignore next */
        Promise.resolve().then(() => {
            const value = this.ngControl ? this.ngControl.value : this.value;
            const optionSelected = this.enableOption.find((opt) => this.compareWith(opt.value, value));
            if (optionSelected) {
                optionSelected.select();
                this.selectOption(optionSelected);
                return;
            }
            if (this.optionSelected) {
                this.optionSelected.deselect(true);
            }
            this.value = '';
            this._lastOptionSelected = null;
        });
    }
    /** @internal */
    onFocus() {
        this.formAcessorHandleFocus();
        this.focus.emit(new IVoxelSelectEvent(this, this.value));
    }
    /** @internal */
    onBlur() {
        this.formAcessorHandleBlur();
        this.blur.emit(new IVoxelSelectEvent(this, this.value));
    }
    /** @internal */
    toggle() {
        if (this.panelOpen) {
            this.dettach();
            return;
        }
        this.open();
    }
    /** @internal */
    open() {
        this._panelOpen = true;
        this._selectWidth = this.select.nativeElement.offsetWidth;
        if (this.arrayOption.length > 0 && !this.optionSelected) {
            this.enableOption[0].select();
        }
        this.selectOpen.emit(new IVoxelSelectEvent(this, this.value));
    }
    /** @internal */
    attach() {
        if (this.isMobile) {
            const positionStrategy = this.overlay
                .position()
                .global()
                .centerHorizontally()
                .centerVertically();
            const sizeConfig = { maxHeight: '80%' };
            this.overlayDir.overlayRef.updateScrollStrategy(this.overlay.scrollStrategies.block());
            this.overlayDir.overlayRef.updateSize(sizeConfig);
            this.overlayDir.overlayRef.updatePositionStrategy(positionStrategy);
            this.overlayDir.overlayRef.updatePosition();
            this.hideBodyElements(true);
            this.panel.changes.pipe(take(1)).subscribe(() => {
                if (!this.optionSelected) {
                    return;
                }
                if (this.platform.IOS && this.platform.SAFARI) {
                    // Had to do this to make VO focus on the selected option
                    setTimeout(() => {
                        var _a;
                        (_a = this.optionSelected) === null || _a === void 0 ? void 0 : _a.element.nativeElement.focus();
                    });
                }
                this.setScrollPosition(this.optionSelected);
            });
            return;
        }
        this.overlayDir.positionChange.pipe(take(1)).subscribe(() => {
            if (this.optionSelected) {
                this.setScrollPosition(this.optionSelected);
            }
        });
    }
    /** @internal */
    dettach() {
        this._panelOpen = false;
        if (this.isMobile) {
            this.hideBodyElements(false);
        }
        this.select.nativeElement.focus();
        this.selectClose.emit(new IVoxelSelectEvent(this, this.value));
    }
    /** @internal */
    hideBodyElements(hide) {
        this.document.body.querySelectorAll('*').forEach((el) => {
            if (el.tagName === 'VOXEL-SELECT' ||
                el.tagName === 'SCRIPT' ||
                el.classList.toString().includes('voxel-option') ||
                el.classList.toString().includes('voxel-select') ||
                el.classList.toString().includes('cdk-overlay') ||
                el.classList.contains('cdk-global-overlay-wrapper') ||
                el.classList.contains('cdk-live-announcer-element')) {
                return;
            }
            if (hide) {
                if (el.hasAttribute('aria-hidden') && el.getAttribute('aria-hidden') === 'true') {
                    el.setAttribute('already-hidden', 'true');
                    return;
                }
                this.renderer.setAttribute(el, 'aria-hidden', 'true');
                return;
            }
            const attribute = el.hasAttribute('already-hidden') ? 'already-hidden' : 'aria-hidden';
            this.renderer.removeAttribute(el, attribute);
        });
    }
    /** @internal */
    updateValueSelect(selectOption) {
        if (!this._lastOptionSelected || !(this._lastOptionSelected.value === selectOption.value)) {
            this.value = selectOption.value;
        }
        this._emitSelectChangeEvent();
        this._lastOptionSelected = selectOption;
    }
    /** @internal */
    selectOption(selectOption, close) {
        if (this.optionSelected && !(this.optionSelected.value === selectOption.value)) {
            this.optionSelected.deselect();
        }
        if (close) {
            this.dettach();
        }
        this.updateValueSelect(selectOption);
        this.setScrollPosition(selectOption);
    }
    /** @internal */
    setSelectOptionByIndex(index = 1) {
        const optionSelected = this._lastOptionSelected
            ? this.enableOption.findIndex((opt) => opt.selected)
            : 0;
        if (this.enableOption[optionSelected + index]) {
            this.enableOption[optionSelected + index].select();
        }
    }
    /** @internal */
    handleKeydown(_event) {
        if (this.panelOpen) {
            this.handleOpenKeydown(_event);
            return;
        }
        this.handleClosedKeydown(_event);
    }
    /** @internal */
    handleClosedKeydown(_event) {
        const isOpenKey = _event.code === 'Enter' || _event.code === 'NumpadEnter' || _event.code === 'Space';
        const isArrowKey = _event.code === 'ArrowUp' || _event.code === 'ArrowDown';
        if (isOpenKey || (_event.altKey && isArrowKey)) {
            _event.preventDefault();
            this.open();
        }
        if (_event.code === 'Home') {
            _event.preventDefault();
            this.enableOption[0].select();
            this.announceValue(this.optionTextValue);
        }
        if (_event.code === 'End') {
            _event.preventDefault();
            this.enableOption[this.enableOption.length - 1].select();
            this.announceValue(this.optionTextValue);
        }
        if ((_event.code === 'ArrowUp' || _event.code === 'ArrowLeft') && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(-1);
            this.announceValue(this.optionTextValue);
        }
        if ((_event.code === 'ArrowDown' || _event.code === 'ArrowRight') && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(1);
            this.announceValue(this.optionTextValue);
        }
        return;
    }
    /** @internal */
    announceValue(text) {
        this.liveAnnouncer.announce(text, 'assertive');
    }
    /** @internal */
    handleOpenKeydown(_event) {
        const isEnterKey = _event.code === 'Enter' || _event.code === 'NumpadEnter';
        const isArrowKey = _event.code === 'ArrowUp' || _event.code === 'ArrowDown';
        const announceValue = this.platform.SAFARI; // VO on SAFARI does not announce the new value selected when navigating through keyboard
        /* istanbul ignore next */
        if (_event.shiftKey && !this.focused) {
            this.select.nativeElement.focus();
        }
        if (isEnterKey ||
            _event.code === 'Tab' ||
            _event.code === 'Escape' ||
            (isArrowKey && _event.altKey) ||
            (_event.code === 'Space' && this.searchString === '')) {
            _event.preventDefault();
            this.dettach();
        }
        if (_event.code === 'Home') {
            _event.preventDefault();
            this.selectOption(this.enableOption[0]);
            if (announceValue) {
                this.announceValue(this.optionTextValue);
            }
        }
        if (_event.code === 'End') {
            _event.preventDefault();
            this.selectOption(this.enableOption[this.enableOption.length - 1]);
            if (announceValue) {
                this.announceValue(this.optionTextValue);
            }
        }
        if (_event.code === 'ArrowUp' && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(-1);
            if (announceValue) {
                this.announceValue(this.optionTextValue);
            }
        }
        if (_event.code === 'ArrowDown' && !_event.altKey) {
            _event.preventDefault();
            this.setSelectOptionByIndex(1);
            if (announceValue) {
                this.announceValue(this.optionTextValue);
            }
        }
        this.filterAndSelectOption(_event);
        return;
    }
    /**
     *
     * @internal
     */
    filterAndSelectOption(_event) {
        var _a;
        const startsWithSpace = this.searchString === '' && _event.code === 'Space';
        if (!/[a-zA-Z0-9-_ ]/.test(_event.key) || _event.key.length > 1 || startsWithSpace) {
            return;
        }
        _event.preventDefault();
        this.searchString += _event.key;
        (_a = this.arrayOption
            .find((o) => { var _a; return this.normalizeText((_a = o.optionLabel) !== null && _a !== void 0 ? _a : '').includes(this.searchString) && !o.disabled; })) === null || _a === void 0 ? void 0 : _a.select();
        if (this._clearSearchString.observers.length === 0) {
            this.initializeSearchStringObserver();
        }
        this._clearSearchString.next();
    }
    /** @internal */
    initializeSearchStringObserver() {
        this._clearSearchString.pipe(debounceTime(1000), takeUntil(this._destroy)).subscribe(() => {
            this.searchString = '';
        });
    }
    /** @internal */
    normalizeText(text) {
        return text
            .normalize('NFKD')
            .replace(/[\u0080-\uF8FF]/g, '')
            .toLocaleLowerCase();
    }
    /** @internal */
    setScrollPosition(option) {
        /* istanbul ignore next */
        if (option && this.panel.first) {
            const positionScroll = option.element.nativeElement.offsetTop - this.panel.first.nativeElement.scrollTop;
            if (positionScroll >= this.panel.first.nativeElement.offsetHeight - 9) {
                option.element.nativeElement.scrollIntoView(false);
            }
            if (positionScroll < 0) {
                option.element.nativeElement.scrollIntoView(true);
            }
        }
        return;
    }
    /** @internal */
    getAriaActiveDescendant() {
        if (this.panelOpen && this.optionSelected) {
            return this.optionSelected.optionId;
        }
        return null;
    }
    /** @internal */
    _emitSelectChangeEvent() {
        this.change.emit(new IVoxelSelectEvent(this, this.value));
    }
}
VoxelSelectComponent.ɵfac = function VoxelSelectComponent_Factory(t) { return new (t || VoxelSelectComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.LiveAnnouncer), ɵngcc0.ɵɵdirectiveInject(DOCUMENT), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc4.NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Platform), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay)); };
VoxelSelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelSelectComponent, selectors: [["voxel-select"]], contentQueries: function VoxelSelectComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelOptionComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.options = _t);
    } }, viewQuery: function VoxelSelectComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c42, 7);
        ɵngcc0.ɵɵviewQuery(CdkConnectedOverlay, 7);
        ɵngcc0.ɵɵviewQuery(_c43, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.select = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.overlayDir = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panel = _t);
    } }, inputs: { controlId: "controlId", placeholder: "placeholder", visibleOptions: "visibleOptions", position: "position", required: "required", compareWith: "compareWith" }, outputs: { change: "change", focus: "focus", blur: "blur", selectOpen: "selectOpen", selectClose: "selectClose" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: VoxelFieldMixinBase,
                useExisting: forwardRef(/* istanbul ignore next */ () => VoxelSelectComponent)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c47, decls: 8, vars: 24, consts: [["cdkOverlayOrigin", "", "role", "combobox", "aria-haspopup", "listbox", 1, "voxel-select", 3, "id", "ngClass", "tabindex", "click", "keydown", "focus", "blur"], ["select", "", "origin", "cdkOverlayOrigin"], [1, "voxel-select__text", 3, "id"], [3, "ngClass"], ["cdkConnectedOverlay", "", "cdkConnectedOverlayLockPosition", "", "cdkConnectedOverlayHasBackdrop", "", 3, "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "cdkConnectedOverlayPositions", "cdkConnectedOverlayWidth", "backdropClick", "attach"], ["role", "listbox", "tabindex", "-1", 1, "voxel-select__panel-options", 3, "id", "keydown"], ["panel", ""]], template: function VoxelSelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c44);
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵlistener("click", function VoxelSelectComponent_Template_div_click_0_listener() { return ctx.toggle(); })("keydown", function VoxelSelectComponent_Template_div_keydown_0_listener($event) { return ctx.handleKeydown($event); })("focus", function VoxelSelectComponent_Template_div_focus_0_listener() { return ctx.onFocus(); })("blur", function VoxelSelectComponent_Template_div_blur_0_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "voxel-icon", 3);
        ɵngcc0.ɵɵtext(6, " seta_baixo\n");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, VoxelSelectComponent_ng_template_7_Template, 3, 5, "ng-template", 4);
        ɵngcc0.ɵɵlistener("backdropClick", function VoxelSelectComponent_Template_ng_template_backdropClick_7_listener() { return ctx.dettach(); })("attach", function VoxelSelectComponent_Template_ng_template_attach_7_listener() { return ctx.attach(); });
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("id", ctx.controlId)("ngClass", ɵngcc0.ɵɵpureFunction1(19, _c45, ctx.disabled))("tabindex", ctx.tabindex);
        ɵngcc0.ɵɵattribute("aria-disabled", ctx.disabled)("aria-expanded", ctx.panelOpen)("aria-describedby", ctx.controlDescribedBy)("aria-labelledby", ctx.labelId + " " + ctx.valueId)("aria-invalid", ctx.controlAriaInvalid)("aria-activedescendant", ctx.getAriaActiveDescendant())("aria-controls", ctx.panelId)("aria-required", ctx.required);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("id", ctx.valueId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.optionTextValue, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(21, _c46, ctx.disabled, ctx.panelOpen));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayBackdropClass", !ctx.isMobile ? "cdk-overlay-transparent-backdrop" : "")("cdkConnectedOverlayOrigin", _r1)("cdkConnectedOverlayOpen", ctx.panelOpen)("cdkConnectedOverlayPositions", ctx._positions)("cdkConnectedOverlayWidth", ctx.selectWidth);
    } }, directives: [ɵngcc2.CdkOverlayOrigin, ɵngcc1.NgClass, VoxelIconComponent, ɵngcc2.CdkConnectedOverlay], styles: ["[_nghost-%COMP%]{display:block;width:100%}.voxel-select[_ngcontent-%COMP%]{cursor:pointer;padding-bottom:var(--ids_size_general_8x);position:relative}.voxel-select--disabled[_ngcontent-%COMP%]{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-select__text[_ngcontent-%COMP%]{font:var(--ids_textStyle_label_medium_regular);font-size:1.125rem;line-height:1.75rem;min-height:var(--ids_size_general_28x);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.voxel-select__icon[_ngcontent-%COMP%]{color:var(--ids_color_action_disabled_base);padding-top:var(--ids_size_general_5x);pointer-events:none;position:absolute;right:0;top:0;-webkit-transition:-webkit-transform .2s linear;transition:-webkit-transform .2s linear;transition:transform .2s linear;transition:transform .2s linear,-webkit-transform .2s linear}.voxel-select__icon--open[_ngcontent-%COMP%]{-webkit-transform:rotateX(180deg);transform:rotateX(180deg)}.voxel-select__icon[_ngcontent-%COMP%]:not(.voxel-select__icon--disabled){color:var(--ids_color_action_primary_base)}.voxel-select__panel-options[_ngcontent-%COMP%]{background-color:var(--ids_color_bg_base);border-radius:0 0 var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01);-webkit-box-shadow:0 0 .125rem 0 rgba(86,80,76,.16),0 .125rem .5rem 0 rgba(86,80,76,.16);box-shadow:0 0 .125rem rgba(86,80,76,.16),0 .125rem .5rem rgba(86,80,76,.16);margin:var(--ids_size_general_2x) 0;overflow-y:auto;width:100%}"] });
VoxelSelectComponent.ctorParameters = () => [
    { type: LiveAnnouncer },
    { type: Document, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Renderer2 },
    { type: NgControl, decorators: [{ type: Self }, { type: Optional }] },
    { type: ElementRef },
    { type: Platform },
    { type: Overlay }
];
VoxelSelectComponent.propDecorators = {
    controlId: [{ type: Input }],
    placeholder: [{ type: Input }],
    visibleOptions: [{ type: Input }],
    position: [{ type: Input }],
    required: [{ type: Input }],
    compareWith: [{ type: Input }],
    change: [{ type: Output }],
    focus: [{ type: Output }],
    blur: [{ type: Output }],
    selectOpen: [{ type: Output }],
    selectClose: [{ type: Output }],
    options: [{ type: ContentChildren, args: [VoxelOptionComponent, { descendants: true },] }],
    select: [{ type: ViewChild, args: ['select', { static: true },] }],
    panel: [{ type: ViewChildren, args: ['panel',] }],
    overlayDir: [{ type: ViewChild, args: [CdkConnectedOverlay, { static: true },] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSelectComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-select',
                template: "<div\n  #select\n  cdkOverlayOrigin\n  #origin=\"cdkOverlayOrigin\"\n  role=\"combobox\"\n  [id]=\"controlId\"\n  class=\"voxel-select\"\n  [ngClass]=\"{\n    'voxel-select--disabled': disabled\n  }\"\n  (click)=\"toggle()\"\n  (keydown)=\"handleKeydown($event)\"\n  [attr.aria-disabled]=\"disabled\"\n  [attr.aria-expanded]=\"panelOpen\"\n  [attr.aria-describedby]=\"controlDescribedBy\"\n  [attr.aria-labelledby]=\"labelId + ' ' + valueId\"\n  [attr.aria-invalid]=\"controlAriaInvalid\"\n  [attr.aria-activedescendant]=\"getAriaActiveDescendant()\"\n  [attr.aria-controls]=\"panelId\"\n  [attr.aria-required]=\"required\"\n  aria-haspopup=\"listbox\"\n  [tabindex]=\"tabindex\"\n  (focus)=\"onFocus()\"\n  (blur)=\"onBlur()\"\n>\n  <div\n    [id]=\"valueId\"\n    class=\"voxel-select__text\">\n    {{ optionTextValue }}\n  </div>\n</div>\n\n<voxel-icon\n  [ngClass]=\"{\n    'voxel-select__icon': true,\n    'voxel-select__icon--disabled': disabled,\n    'voxel-select__icon--open': panelOpen\n  }\"\n>\n  seta_baixo\n</voxel-icon>\n\n<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayLockPosition\n  cdkConnectedOverlayHasBackdrop\n  [cdkConnectedOverlayBackdropClass]=\"!isMobile ? 'cdk-overlay-transparent-backdrop' : ''\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"panelOpen\"\n  [cdkConnectedOverlayPositions]=\"_positions\"\n  [cdkConnectedOverlayWidth] = \"selectWidth\"\n  (backdropClick)=\"dettach()\"\n  (attach)=\"attach()\"\n>\n  <div\n    #panel\n    role=\"listbox\"\n    tabindex=\"-1\"\n    [id]=\"panelId\"\n    class=\"voxel-select__panel-options\"\n    (keydown)=\"handleKeydown($event)\"\n    [attr.aria-labelledby]=\"labelId\"\n    [attr.aria-hidden]=\"!panelOpen\"\n    [style.maxHeight.rem]=\"!isMobile ? visibleOptions * 3 : ''\"\n  >\n    <ng-content select=\"voxel-option\"></ng-content>\n  </div>\n</ng-template>\n",
                providers: [
                    {
                        provide: VoxelFieldMixinBase,
                        useExisting: forwardRef(/* istanbul ignore next */ () => VoxelSelectComponent)
                    },
                ],
                styles: [":host{display:block;width:100%}.voxel-select{cursor:pointer;padding-bottom:var(--ids_size_general_8x);position:relative}.voxel-select--disabled{color:var(--ids_color_action_disabled_base);pointer-events:none}.voxel-select__text{font:var(--ids_textStyle_label_medium_regular);font-size:1.125rem;line-height:1.75rem;min-height:var(--ids_size_general_28x);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:100%}.voxel-select__icon{color:var(--ids_color_action_disabled_base);padding-top:var(--ids_size_general_5x);pointer-events:none;position:absolute;right:0;top:0;-webkit-transition:-webkit-transform .2s linear;transition:-webkit-transform .2s linear;transition:transform .2s linear;transition:transform .2s linear,-webkit-transform .2s linear}.voxel-select__icon--open{-webkit-transform:rotateX(180deg);transform:rotateX(180deg)}.voxel-select__icon:not(.voxel-select__icon--disabled){color:var(--ids_color_action_primary_base)}.voxel-select__panel-options{background-color:var(--ids_color_bg_base);border-radius:0 0 var(--ids_size_cornerRadius_tags_01) var(--ids_size_cornerRadius_tags_01);-webkit-box-shadow:0 0 .125rem 0 rgba(86,80,76,.16),0 .125rem .5rem 0 rgba(86,80,76,.16);box-shadow:0 0 .125rem rgba(86,80,76,.16),0 .125rem .5rem rgba(86,80,76,.16);margin:var(--ids_size_general_2x) 0;overflow-y:auto;width:100%}\n"]
            }]
    }], function () { return [{ type: ɵngcc3.LiveAnnouncer }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc4.NgControl, decorators: [{
                type: Self
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }, { type: ɵngcc6.Platform }, { type: ɵngcc2.Overlay }]; }, { controlId: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], visibleOptions: [{
            type: Input
        }], position: [{
            type: Input
        }], change: [{
            type: Output
        }], focus: [{
            type: Output
        }], blur: [{
            type: Output
        }], selectOpen: [{
            type: Output
        }], selectClose: [{
            type: Output
        }], required: [{
            type: Input
        }], compareWith: [{
            type: Input
        }], options: [{
            type: ContentChildren,
            args: [VoxelOptionComponent, { descendants: true }]
        }], select: [{
            type: ViewChild,
            args: ['select', { static: true }]
        }], panel: [{
            type: ViewChildren,
            args: ['panel']
        }], overlayDir: [{
            type: ViewChild,
            args: [CdkConnectedOverlay, { static: true }]
        }] }); })();

class VoxelSelectModule {
}
VoxelSelectModule.ɵfac = function VoxelSelectModule_Factory(t) { return new (t || VoxelSelectModule)(); };
VoxelSelectModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelSelectModule });
VoxelSelectModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, OverlayModule, FormsModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSelectModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, OverlayModule, FormsModule, VoxelIconModule],
                declarations: [
                    VoxelSelectComponent,
                    VoxelOptionComponent,
                    VoxelNativeSelectDirective,
                    VoxelNativeSelectOptionDirective,
                ],
                exports: [
                    VoxelSelectComponent,
                    VoxelOptionComponent,
                    VoxelNativeSelectDirective,
                    VoxelNativeSelectOptionDirective,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelSelectModule, { declarations: function () { return [VoxelSelectComponent, VoxelOptionComponent, VoxelNativeSelectDirective, VoxelNativeSelectOptionDirective]; }, imports: function () { return [CommonModule, OverlayModule, FormsModule, VoxelIconModule]; }, exports: function () { return [VoxelSelectComponent, VoxelOptionComponent, VoxelNativeSelectDirective, VoxelNativeSelectOptionDirective]; } }); })();

class VoxelShimmerComponent {
    constructor(la) {
        this.la = la;
        /**
         * Define o valor do atributo aria-live.
         *
         * *Sets the value of the aria-live attribute.*
         */
        this.ariaLive = 'assertive';
        /**
         * Título do shimmer enquanto está carregando
         *
         * *Shimmer title while charging*
         */
        this.loadingTitle = 'carregando';
        /**
         * Título do shimmer quando carregado
         *
         * *Shimmer title when loaded*
         */
        this.loadedTitle = 'carregado';
        this._show = true;
        this._contrast = null;
        /**
         * Valor do atributo aria-live
         *
         * *Aria-live attribute value*
         */
        this.ariaLiveHost = null;
    }
    /**
     * Mostrar shimmer
     *
     * *Show shimmer*
     */
    get show() {
        return this._show;
    }
    set show(value) {
        this._show = enforceBoolean(value);
        if (this._show) {
            this.announceValue(this.loadingTitle);
        }
        else {
            this.announceValue(this.loadedTitle);
        }
    }
    /**
     * Contrast do shimmer com dark ou light
     *
     * *Shimmer contrast with dark or light*
     */
    get contrast() {
        return this._contrast;
    }
    set contrast(value) {
        this._contrast = value;
    }
    /**
     * @internal
     */
    get classes() {
        return {
            'voxel-shimmer': this.show,
            'voxel-shimmer--on-dark': this.show && this.contrast === 'dark',
            'voxel-shimmer--on-light': this.show && this.contrast === 'light',
        };
    }
    /** @internal */
    announceValue(text) {
        this.la.announce(text, this.ariaLive);
    }
}
VoxelShimmerComponent.ɵfac = function VoxelShimmerComponent_Factory(t) { return new (t || VoxelShimmerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.LiveAnnouncer)); };
VoxelShimmerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelShimmerComponent, selectors: [["voxel-shimmer"]], hostVars: 7, hostBindings: function VoxelShimmerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-live", ctx.ariaLiveHost);
        ɵngcc0.ɵɵclassMap(ctx.classes);
        ɵngcc0.ɵɵstyleProp("width", ctx.width)("height", ctx.height);
    } }, inputs: { ariaLive: ["aria-live", "ariaLive"], loadingTitle: "loadingTitle", loadedTitle: "loadedTitle", show: "show", contrast: "contrast", width: "width", height: "height" }, ngContentSelectors: _c1, decls: 1, vars: 0, template: function VoxelShimmerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, styles: [".voxel-sr-only-a11y{clip:rect(0,0,0,0);pointer-events:none;position:fixed}.voxel-shimmer{-webkit-animation:shimmer 1s ease infinite;animation:shimmer 1s ease infinite;background-image:var(--ids_color_bg_shimmer_gradient);background-size:200%;border-radius:var(--ids_size_general_8x);display:block;overflow:hidden;position:relative}.voxel-shimmer--on-dark{background-image:var(--ids_color_bg_shimmer_gradient_onDark)}.voxel-shimmer--on-light{background-image:var(--ids_color_bg_shimmer_gradient_onLight)}.voxel-shimmer>*{visibility:hidden}@-webkit-keyframes shimmer{0%{background-position-x:200%}to{background-position-x:0%}}@keyframes shimmer{0%{background-position-x:200%}to{background-position-x:0%}}\n"], encapsulation: 2 });
VoxelShimmerComponent.ctorParameters = () => [
    { type: LiveAnnouncer }
];
VoxelShimmerComponent.propDecorators = {
    ariaLive: [{ type: Input, args: ['aria-live',] }],
    loadingTitle: [{ type: Input }],
    loadedTitle: [{ type: Input }],
    show: [{ type: Input }],
    contrast: [{ type: Input }],
    ariaLiveHost: [{ type: HostBinding, args: ['attr.aria-live',] }],
    width: [{ type: Input }, { type: HostBinding, args: ['style.width',] }],
    height: [{ type: Input }, { type: HostBinding, args: ['style.height',] }],
    classes: [{ type: HostBinding, args: ['class',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelShimmerComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-shimmer',
                template: '<ng-content></ng-content>',
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-sr-only-a11y{clip:rect(0,0,0,0);pointer-events:none;position:fixed}.voxel-shimmer{-webkit-animation:shimmer 1s ease infinite;animation:shimmer 1s ease infinite;background-image:var(--ids_color_bg_shimmer_gradient);background-size:200%;border-radius:var(--ids_size_general_8x);display:block;overflow:hidden;position:relative}.voxel-shimmer--on-dark{background-image:var(--ids_color_bg_shimmer_gradient_onDark)}.voxel-shimmer--on-light{background-image:var(--ids_color_bg_shimmer_gradient_onLight)}.voxel-shimmer>*{visibility:hidden}@-webkit-keyframes shimmer{0%{background-position-x:200%}to{background-position-x:0%}}@keyframes shimmer{0%{background-position-x:200%}to{background-position-x:0%}}\n"]
            }]
    }], function () { return [{ type: ɵngcc3.LiveAnnouncer }]; }, { ariaLive: [{
            type: Input,
            args: ['aria-live']
        }], loadingTitle: [{
            type: Input
        }], loadedTitle: [{
            type: Input
        }], ariaLiveHost: [{
            type: HostBinding,
            args: ['attr.aria-live']
        }], show: [{
            type: Input
        }], contrast: [{
            type: Input
        }], classes: [{
            type: HostBinding,
            args: ['class']
        }], width: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['style.width']
        }], height: [{
            type: Input
        }, {
            type: HostBinding,
            args: ['style.height']
        }] }); })();

class VoxelShimmerModule {
}
VoxelShimmerModule.ɵfac = function VoxelShimmerModule_Factory(t) { return new (t || VoxelShimmerModule)(); };
VoxelShimmerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelShimmerModule });
VoxelShimmerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelShimmerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                ],
                declarations: [
                    VoxelShimmerComponent,
                ],
                exports: [
                    VoxelShimmerComponent,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelShimmerModule, { declarations: function () { return [VoxelShimmerComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelShimmerComponent]; } }); })();

/**
 * Diretiva para utilização do Checkbox dentro do componente form selection
 *
 * **Module:**
 *
 * `import { VoxelFormSelectionModule, VoxelSwitchModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/switch?componentOnly=true</example-url>
 *
 * @example Switch simples
 * <voxel-form-selection>
 *            <input type="checkbox" formControlName="simple" voxelSwitch />
 *            simples
 * </voxel-form-selection>
 *
 * @example Switch pré selecionado
 *  <voxel-form-selection>
 *             <input type="checkbox" formControlName="selected" voxelSwitch checked />
 *             selecionado
 *  </voxel-form-selection>
 *
 */
class VoxelSwitchDirective extends VoxelFormSelectionBase {
    constructor() {
        super(...arguments);
        // Essa configuração é necessária para que não ocorra foco duplo no ambiente iOS/VO
        // Decidimos fazer a mesma configuração para todos os ambientes
        this._rtlDirection = true;
        this._ariaHiddenLabel = true;
        this.role = 'button';
    }
    /**
     * @internal
     */
    get selectorType() {
        return 'switch';
    }
    /**
     * @internal
     */
    get classes() {
        return {
            'voxel-form-selection__switch': true,
            'voxel-form-selection__switch--checked': this.nativeElement.checked,
            'voxel-form-selection__switch--disabled': this.nativeElement.disabled,
            'voxel-form-selection__switch--on-dark': this._onDark,
        };
    }
    get ariaLabelledBy() {
        return this.labelId;
    }
    get ariaSelected() {
        return this.nativeElement.checked;
    }
}
VoxelSwitchDirective.ɵfac = /*@__PURE__*/ function () { let ɵVoxelSwitchDirective_BaseFactory; return function VoxelSwitchDirective_Factory(t) { return (ɵVoxelSwitchDirective_BaseFactory || (ɵVoxelSwitchDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(VoxelSwitchDirective)))(t || VoxelSwitchDirective); }; }();
VoxelSwitchDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelSwitchDirective, selectors: [["", "voxelSwitch", ""]], hostVars: 5, hostBindings: function VoxelSwitchDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("role", ctx.role)("aria-labelledby", ctx.ariaLabelledBy)("aria-pressed", ctx.ariaSelected);
        ɵngcc0.ɵɵclassMap(ctx.classes);
    } }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: VoxelFormSelectionBase, useExisting: VoxelSwitchDirective }]), ɵngcc0.ɵɵInheritDefinitionFeature] });
VoxelSwitchDirective.propDecorators = {
    classes: [{ type: HostBinding, args: ['class',] }],
    ariaLabelledBy: [{ type: HostBinding, args: ['attr.aria-labelledby',] }],
    role: [{ type: HostBinding, args: ['attr.role',] }],
    ariaSelected: [{ type: HostBinding, args: ['attr.aria-pressed',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSwitchDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelSwitch]',
                providers: [{ provide: VoxelFormSelectionBase, useExisting: VoxelSwitchDirective }]
            }]
    }], null, { role: [{
            type: HostBinding,
            args: ['attr.role']
        }], classes: [{
            type: HostBinding,
            args: ['class']
        }], ariaLabelledBy: [{
            type: HostBinding,
            args: ['attr.aria-labelledby']
        }], ariaSelected: [{
            type: HostBinding,
            args: ['attr.aria-pressed']
        }] }); })();

class VoxelSwitchModule {
}
VoxelSwitchModule.ɵfac = function VoxelSwitchModule_Factory(t) { return new (t || VoxelSwitchModule)(); };
VoxelSwitchModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelSwitchModule });
VoxelSwitchModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelSwitchModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelSwitchDirective],
                exports: [VoxelSwitchDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelSwitchModule, { declarations: function () { return [VoxelSwitchDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelSwitchDirective]; } }); })();

let NEXT_ID$1 = 0;
class VoxelTabsPanelDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
VoxelTabsPanelDirective.ɵfac = function VoxelTabsPanelDirective_Factory(t) { return new (t || VoxelTabsPanelDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
VoxelTabsPanelDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelTabsPanelDirective, selectors: [["", "voxelTabsPanel", ""]] });
VoxelTabsPanelDirective.ctorParameters = () => [
    { type: TemplateRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTabsPanelDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelTabsPanel]'
            }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, null); })();
/**
 * As abas são uma maneira fácil de organizar o conteúdo, agrupando informações semelhantes na mesma página.
 *
 * *Tabs are an easy way to organize content, grouping similar information on the same page.*
 *
 * **Module:**
 *
 * `import { VoxelTabsModule } from '@voxel/components/ids';`
 */
class VoxelTabsComponent {
    constructor(_renderer, _la) {
        this._renderer = _renderer;
        this._la = _la;
        /**
         * Recebe um ID customizado para os tabs.
         *
         * *Receives a custom ID for the tabs.*
         */
        this.id = `voxel-tabs-${NEXT_ID$1++}`;
        /**
         * Informa o tom de fundo em que o tabs será posicionado. Padrão: branco.
         *
         * *Informs the background tone in which the tabs will be positioned. Default: white.*
         */
        this.contrast = null;
        /**
         * Palavra a ser anunciada pelo VoiceOver quando o foco for perdido e uma nova tab selecionada.
         * Quando o foco se perde, o item selecionado não é anunciado. Por esse motivo, é necessário
         * fazer o anúncio manualmente.
         *
         * *Word to be announced by VoiceOver when focus is lost and a new tab is selected. When focus*
         * *is lost, the selected item is not announced. For this reason, it is necessary to make*
         * *the announcement manually.*
         */
        this.selectedTabLiteral = 'selecionado';
        /**
         * Evento disparado ao selecionar uma aba.
         *
         * *Event triggered when selecting a tab.*
         */
        this.change = new EventEmitter();
        this.hostId = null;
    }
    get panelId() {
        return `${this.id}-panel-${this._selectedTabIndex + 1}`;
    }
    get isIOS() {
        return platform.os === 'IOS';
    }
    /**
     * Recebe um array de objetos contendo as configurações do tabs:
     *
     * interface ITab {
     *   name: string;
     *   selected?: boolean;
     *   disabled?: boolean;
     * }
     *
     * *Receives an array of objects containing tabs settings*
     */
    get tabs() {
        return this._tabs;
    }
    set tabs(value) {
        this._tabs = value;
        this._selectedTabIndex = this._tabs.findIndex((item) => item.selected);
    }
    ngAfterContentInit() {
        this._createSelectedTabPanel();
    }
    ngAfterViewChecked() {
        if (!this.tabListEl.nativeElement.scrollWidth > this.tabListEl.nativeElement.offsetWidth) {
            return;
        }
        const selectedTabEl = this.tabElList.get(this._selectedTabIndex);
        if (!selectedTabEl) {
            return;
        }
        // Verificação para garantir que o item selecionado está corretamente centralizado
        // dentro da rolagem do componente. Às vezes, caso algum estilo ou fonte demore para
        // carregar, a largura da tab selecionada pode ser alterada após a inicialização
        // do componente. Nesse caso, centralizamos manualmente.
        if (this._previousSelectedTabItemSize &&
            this._selectedTabIndex === this._previousSelectedTabIndex &&
            this._previousSelectedTabItemSize !== selectedTabEl.nativeElement.offsetWidth) {
            this.scrollIntoView(selectedTabEl.nativeElement);
        }
        this._previousSelectedTabItemSize = selectedTabEl.nativeElement.offsetWidth;
        this._previousSelectedTabIndex = this._selectedTabIndex;
    }
    _createSelectedTabPanel() {
        var _a;
        const selectedTabTemplateRef = (_a = this.tabPanels.get(this._selectedTabIndex)) === null || _a === void 0 ? void 0 : _a.templateRef;
        if (selectedTabTemplateRef) {
            if (this._view) {
                this.viewContainer.remove(0);
            }
            this._view = this.viewContainer.createEmbeddedView(selectedTabTemplateRef);
            const rootEl = this._view.rootNodes[0];
            this._renderer.setAttribute(rootEl, 'role', 'tabpanel');
            this._renderer.setAttribute(rootEl, 'id', this.panelId);
        }
    }
    // Esta função é necessária para setar o foco no item selecionado quando o
    // VoiceOver estiver sendo utilizado, já que ele se perde e foca em itens
    // errados aleatoriamente.
    _focusOnCorrectTab(target, selected = true) {
        setTimeout(() => {
            setVoiceOverFocus(target);
            // Quando o foco se perde, o item selecionado não é anunciado.
            // Por esse motivo, é necessário fazer o anúncio manualmente.
            if (selected) {
                this._la.announce(this.selectedTabLiteral, 1000);
            }
        }, 100);
    }
    selectTab(event, index) {
        const element = event.target;
        if (this.tabs[index].disabled) {
            if (this.isIOS) {
                this._focusOnCorrectTab(element, false);
            }
            return;
        }
        this.tabs.forEach((item) => (item.selected = false));
        this.tabs[index].selected = true;
        this._selectedTabIndex = index;
        this.change.emit(event);
        this._createSelectedTabPanel();
        if (this.isIOS) {
            this._focusOnCorrectTab(element);
        }
    }
    onKeyDown(event, index) {
        const element = event.target;
        if (event.code === 'ArrowRight' || event.code === 'ArrowDown') {
            event.preventDefault();
            const nextTab = element.nextElementSibling;
            if (nextTab && nextTab.tagName === 'BUTTON') {
                nextTab.focus();
                return;
            }
            element.focus();
            return;
        }
        if (event.code === 'ArrowLeft' || event.code === 'ArrowUp') {
            event.preventDefault();
            const previousTab = element.previousElementSibling;
            if (previousTab && previousTab.tagName === 'BUTTON') {
                previousTab.focus();
                return;
            }
            element.focus();
            return;
        }
        if (event.code === 'Enter') {
            if (this.tabs[index].disabled) {
                return;
            }
            event.preventDefault();
            this.selectTab(event, index);
            return;
        }
    }
    scrollIntoView(element) {
        const containerElement = this.tabListEl.nativeElement;
        const scroll = element.offsetLeft - (containerElement.clientWidth - element.offsetWidth) / 2;
        const scrollBehavior = this.isIOS || platform.os === 'MacOS' ? 'auto' : 'smooth';
        containerElement.scrollTo({
            left: scroll,
            behavior: scrollBehavior,
        });
    }
}
VoxelTabsComponent.ɵfac = function VoxelTabsComponent_Factory(t) { return new (t || VoxelTabsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.LiveAnnouncer)); };
VoxelTabsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelTabsComponent, selectors: [["voxel-tabs"]], contentQueries: function VoxelTabsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, VoxelTabsPanelDirective, 4);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabPanels = _t);
    } }, viewQuery: function VoxelTabsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c48, 7, ViewContainerRef);
        ɵngcc0.ɵɵviewQuery(_c49, 5);
        ɵngcc0.ɵɵviewQuery(_c50, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.viewContainer = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabListEl = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabElList = _t);
    } }, hostVars: 1, hostBindings: function VoxelTabsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("id", ctx.hostId);
    } }, inputs: { id: "id", contrast: "contrast", selectedTabLiteral: "selectedTabLiteral", tabs: "tabs" }, outputs: { change: "change" }, decls: 5, vars: 4, consts: [["role", "tablist", 1, "voxel-tabs", 3, "id"], ["tabListEl", ""], ["role", "tab", "class", "voxel-tabs__item", 3, "id", "voxel-tabs__item--selected", "focus", "keydown", "mousedown", 4, "ngFor", "ngForOf"], ["viewContainer", ""], ["role", "tab", 1, "voxel-tabs__item", 3, "id", "focus", "keydown", "mousedown"], ["tabEl", ""]], template: function VoxelTabsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, VoxelTabsComponent_button_2_Template, 3, 7, "button", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementContainer(3, null, 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-tabs--on-dark", ctx.contrast === "dark");
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tabs);
    } }, directives: [ɵngcc1.NgForOf], styles: [".voxel-tabs[_ngcontent-%COMP%]{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:var(--ids_size_general_56x);overflow-x:scroll;position:relative;-ms-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory;scrollbar-width:none}.voxel-tabs[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}.voxel-tabs[_ngcontent-%COMP%]:after{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);content:\"\";width:100%}.voxel-tabs__item[_ngcontent-%COMP%]{background-color:var(--ids_opacity_empty);border:none;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);color:var(--ids_color_action_neutral_base);cursor:pointer;font:var(--ids_textStyle_label_medium_regular);padding:0 var(--ids_size_general_12x);scroll-snap-align:center;white-space:nowrap}.voxel-tabs__item[aria-disabled=true][_ngcontent-%COMP%]{color:var(--ids_color_action_disabled_variant);pointer-events:none}.voxel-tabs__item[_ngcontent-%COMP%]:hover{background-color:var(--ids_color_action_neutral_base_soft)}.voxel-tabs__item--selected[_ngcontent-%COMP%]{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);font:var(--ids_textStyle_label_medium_bold)}.voxel-tabs--on-dark[_ngcontent-%COMP%]:after{border-bottom:var(--ids_size_border_small) solid var(--ids_color_contrast_onDark_medium)}.voxel-tabs--on-dark[_ngcontent-%COMP%]   .voxel-tabs__item[_ngcontent-%COMP%]{border-bottom:var(--ids_size_border_small) solid var(--ids_color_contrast_onDark_medium);color:var(--ids_color_contrast_onDark)}.voxel-tabs--on-dark[_ngcontent-%COMP%]   .voxel-tabs__item[aria-disabled=true][_ngcontent-%COMP%]{color:var(--ids_color_contrast_onDark_medium)}.voxel-tabs--on-dark[_ngcontent-%COMP%]   .voxel-tabs__item[_ngcontent-%COMP%]:hover{background-color:var(--ids_color_contrast_onDark_soft)}.voxel-tabs--on-dark[_ngcontent-%COMP%]   .voxel-tabs__item--selected[_ngcontent-%COMP%]{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_contrast_onDark_medium)}"] });
VoxelTabsComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: LiveAnnouncer }
];
VoxelTabsComponent.propDecorators = {
    id: [{ type: Input }],
    tabs: [{ type: Input }],
    contrast: [{ type: Input }],
    selectedTabLiteral: [{ type: Input }],
    change: [{ type: Output }],
    hostId: [{ type: HostBinding, args: ['attr.id',] }],
    tabPanels: [{ type: ContentChildren, args: [VoxelTabsPanelDirective,] }],
    viewContainer: [{ type: ViewChild, args: ['viewContainer', { read: ViewContainerRef, static: true },] }],
    tabListEl: [{ type: ViewChild, args: ['tabListEl',] }],
    tabElList: [{ type: ViewChildren, args: ['tabEl',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTabsComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-tabs',
                template: "<div\n  #tabListEl\n  class=\"voxel-tabs\"\n  [class.voxel-tabs--on-dark]=\"contrast === 'dark'\"\n  [id]=\"id\"\n  role=\"tablist\"\n>\n  <button\n    #tabEl\n    *ngFor=\"let tab of tabs; index as index\"\n    [id]=\"id + '-' + (index + 1)\"\n    role=\"tab\"\n    class=\"voxel-tabs__item\"\n    [class.voxel-tabs__item--selected]=\"tab.selected\"\n    [attr.aria-selected]=\"tab.selected\"\n    [attr.aria-controls]=\"tab.selected ? panelId : null \"\n    [attr.aria-disabled]=\"tab.disabled || null\"\n    (focus)=\"scrollIntoView(tabEl)\"\n    (keydown)=\"onKeyDown($event, index)\"\n    (mousedown)=\"selectTab($event, index)\"\n  >\n    {{ tab.name }}\n  </button>\n</div>\n\n<ng-container #viewContainer></ng-container>",
                styles: [".voxel-tabs{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:var(--ids_size_general_56x);overflow-x:scroll;position:relative;-ms-scroll-snap-type:x mandatory;scroll-snap-type:x mandatory;scrollbar-width:none}.voxel-tabs::-webkit-scrollbar{display:none}.voxel-tabs:after{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);content:\"\";width:100%}.voxel-tabs__item{background-color:var(--ids_opacity_empty);border:none;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);color:var(--ids_color_action_neutral_base);cursor:pointer;font:var(--ids_textStyle_label_medium_regular);padding:0 var(--ids_size_general_12x);scroll-snap-align:center;white-space:nowrap}.voxel-tabs__item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);pointer-events:none}.voxel-tabs__item:hover{background-color:var(--ids_color_action_neutral_base_soft)}.voxel-tabs__item--selected{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);font:var(--ids_textStyle_label_medium_bold)}.voxel-tabs--on-dark:after{border-bottom:var(--ids_size_border_small) solid var(--ids_color_contrast_onDark_medium)}.voxel-tabs--on-dark .voxel-tabs__item{border-bottom:var(--ids_size_border_small) solid var(--ids_color_contrast_onDark_medium);color:var(--ids_color_contrast_onDark)}.voxel-tabs--on-dark .voxel-tabs__item[aria-disabled=true]{color:var(--ids_color_contrast_onDark_medium)}.voxel-tabs--on-dark .voxel-tabs__item:hover{background-color:var(--ids_color_contrast_onDark_soft)}.voxel-tabs--on-dark .voxel-tabs__item--selected{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_contrast_onDark_medium)}\n"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc3.LiveAnnouncer }]; }, { id: [{
            type: Input
        }], contrast: [{
            type: Input
        }], selectedTabLiteral: [{
            type: Input
        }], change: [{
            type: Output
        }], hostId: [{
            type: HostBinding,
            args: ['attr.id']
        }], tabs: [{
            type: Input
        }], tabPanels: [{
            type: ContentChildren,
            args: [VoxelTabsPanelDirective]
        }], viewContainer: [{
            type: ViewChild,
            args: ['viewContainer', { read: ViewContainerRef, static: true }]
        }], tabListEl: [{
            type: ViewChild,
            args: ['tabListEl']
        }], tabElList: [{
            type: ViewChildren,
            args: ['tabEl']
        }] }); })();

class VoxelTabsModule {
}
VoxelTabsModule.ɵfac = function VoxelTabsModule_Factory(t) { return new (t || VoxelTabsModule)(); };
VoxelTabsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelTabsModule });
VoxelTabsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTabsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [VoxelTabsPanelDirective, VoxelTabsComponent],
                exports: [VoxelTabsPanelDirective, VoxelTabsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelTabsModule, { declarations: function () { return [VoxelTabsPanelDirective, VoxelTabsComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [VoxelTabsPanelDirective, VoxelTabsComponent]; } }); })();

/**
 * @internal
 */
let NEXT_ID = 0;
/**
 * Tooltip é um componente de interface que permite ao usuário expandir um pop-up com pequenas informações complementares
 *
 * Tooltip is an interface component that allows the user to expand a pop-up with small supplementary information
 *
 * *  **Module:**
 *
 * `import { VoxelTooltipModule } from '@voxel/components/ids';`
 *
 * <example-url>../../demo/index.html#/portfolio/tooltip?componentOnly=true</example-url>
 *
 */
class VoxelTooltipComponent {
    constructor() {
        this.verticalMargin = 0;
        /**
         * @internal
         */
        this.tooltipId = `voxel-tooltip-${NEXT_ID++}`;
        /**
         * Input que recebe o texto que vai aparecer dentro do tooltip
         *
         * Input that receives the text that will appear inside the tooltip
         */
        this.text = '';
    }
    onResize() {
        this.resizeControl();
    }
    ngOnInit() {
        this.resizeControl();
    }
    resizeControl() {
        if (this.tooltipPosition === 'bottom') {
            return;
        }
        if ((this.tooltipPosition === 'left' || this.tooltipPosition === 'right') &&
            this.tooltipArrow !== 'end') {
            return;
        }
        this.verticalMargin = window.innerHeight - document.documentElement.clientHeight;
    }
}
VoxelTooltipComponent.ɵfac = function VoxelTooltipComponent_Factory(t) { return new (t || VoxelTooltipComponent)(); };
VoxelTooltipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: VoxelTooltipComponent, selectors: [["voxel-tooltip"]], hostBindings: function VoxelTooltipComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function VoxelTooltipComponent_resize_HostBindingHandler() { return ctx.onResize(); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { text: "text", tooltipType: "tooltipType", tooltipIcon: "tooltipIcon", tooltipPosition: "tooltipPosition", tooltipArrow: "tooltipArrow", hideArrow: "hideArrow" }, decls: 5, vars: 26, consts: [["role", "tooltip", 1, "voxel-tooltip", 3, "id", "ngStyle"], [1, "voxel-tooltip__arrow"], [1, "voxel-tooltip__text"], ["class", "voxel-tooltip__icon", 4, "ngIf"], [1, "voxel-tooltip__icon"]], template: function VoxelTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, VoxelTooltipComponent_voxel_icon_3_Template, 2, 1, "voxel-icon", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("voxel-tooltip--tip", ctx.tooltipType === "tip")("voxel-tooltip--info", ctx.tooltipType === "info")("voxel-tooltip--top", ctx.tooltipPosition === "top")("voxel-tooltip--right", ctx.tooltipPosition === "right")("voxel-tooltip--bottom", ctx.tooltipPosition === "bottom")("voxel-tooltip--left", ctx.tooltipPosition === "left")("voxel-tooltip--start", ctx.tooltipArrow === "start")("voxel-tooltip--middle", ctx.tooltipArrow === "middle")("voxel-tooltip--end", ctx.tooltipArrow === "end");
        ɵngcc0.ɵɵproperty("id", ctx.tooltipId)("ngStyle", ɵngcc0.ɵɵpureFunction1(24, _c51, "translateY(-" + ctx.verticalMargin + "px)"));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("voxel-tooltip__arrow--hide", ctx.hideArrow);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tooltipIcon);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.text, " ");
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgIf, VoxelIconComponent], styles: [".voxel-tooltip{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:left}.voxel-tooltip .voxel-icon{color:var(--ids_color_contrast_onDark);margin-right:.9375rem;margin-top:var(--ids_size_general_8x)}.voxel-tooltip__text{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_feedback_information);border-radius:var(--ids_size_cornerRadius_tooltip);color:var(--ids_color_contrast_onDark);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);line-height:1.09375rem;max-width:13.25rem;padding:var(--ids_size_general_12x)}@media (min-width: 64rem){.voxel-tooltip__text{max-width:19rem}}.voxel-tooltip__arrow{border:var(--ids_size_general_8x) solid transparent;border-top-color:var(--ids_color_feedback_information);margin:0 var(--ids_size_general_5x)}.voxel-tooltip__arrow--hide{border-width:var(--ids_size_general_4x);opacity:var(--ids_opacity_empty)}.voxel-tooltip--info .voxel-tooltip__text{background-color:var(--ids_color_feedback_neutral);color:var(--ids_color_contrast_onDark)}.voxel-tooltip--info .voxel-tooltip__arrow{border-top-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--bottom{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.voxel-tooltip--bottom .voxel-tooltip__arrow{border-color:transparent;border-bottom-color:var(--ids_color_feedback_information)}.voxel-tooltip--left{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.voxel-tooltip--left .voxel-tooltip__arrow{border-color:transparent;border-left-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.voxel-tooltip--right{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.voxel-tooltip--right .voxel-tooltip__arrow{border-color:transparent;border-right-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.voxel-tooltip--right.voxel-tooltip--info .voxel-tooltip__arrow{border-right-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--bottom.voxel-tooltip--info .voxel-tooltip__arrow{border-bottom-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--left.voxel-tooltip--info .voxel-tooltip__arrow{border-left-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--start{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.voxel-tooltip--end{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}\n"], encapsulation: 2 });
VoxelTooltipComponent.propDecorators = {
    tooltipType: [{ type: Input }],
    text: [{ type: Input }],
    tooltipIcon: [{ type: Input }],
    tooltipPosition: [{ type: Input }],
    tooltipArrow: [{ type: Input }],
    hideArrow: [{ type: Input }],
    onResize: [{ type: HostListener, args: ['window:resize',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTooltipComponent, [{
        type: Component,
        args: [{
                selector: 'voxel-tooltip',
                template: "<div\n  role=\"tooltip\"\n  class=\"voxel-tooltip\"\n  [class.voxel-tooltip--tip] = \"tooltipType === 'tip'\"\n  [class.voxel-tooltip--info] = \"tooltipType === 'info'\"\n  [class.voxel-tooltip--top] = \"tooltipPosition === 'top'\"\n  [class.voxel-tooltip--right] = \"tooltipPosition === 'right'\"\n  [class.voxel-tooltip--bottom] = \"tooltipPosition === 'bottom'\"\n  [class.voxel-tooltip--left] = \"tooltipPosition === 'left'\"\n  [class.voxel-tooltip--start] = \"tooltipArrow === 'start'\"\n  [class.voxel-tooltip--middle] = \"tooltipArrow === 'middle'\"\n  [class.voxel-tooltip--end] = \"tooltipArrow === 'end'\"\n  [id]=\"tooltipId\"\n  [ngStyle]=\"{ 'transform': 'translateY(-' + verticalMargin + 'px)' }\"\n>\n  <div\n    class=\"voxel-tooltip__arrow\"\n    [class.voxel-tooltip__arrow--hide]=\"hideArrow\"\n  ></div>\n  <div class=\"voxel-tooltip__text\">\n    <voxel-icon class=\"voxel-tooltip__icon\" *ngIf=\"tooltipIcon\">\n      {{ tooltipIcon }}\n    </voxel-icon>\n    {{ text }}\n  </div>\n</div>\n\n",
                encapsulation: ViewEncapsulation.None,
                styles: [".voxel-tooltip{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:left}.voxel-tooltip .voxel-icon{color:var(--ids_color_contrast_onDark);margin-right:.9375rem;margin-top:var(--ids_size_general_8x)}.voxel-tooltip__text{-webkit-box-align:center;-ms-flex-align:center;align-items:center;background-color:var(--ids_color_feedback_information);border-radius:var(--ids_size_cornerRadius_tooltip);color:var(--ids_color_contrast_onDark);display:-webkit-box;display:-ms-flexbox;display:flex;font:var(--ids_textStyle_label_small_regular);line-height:1.09375rem;max-width:13.25rem;padding:var(--ids_size_general_12x)}@media (min-width: 64rem){.voxel-tooltip__text{max-width:19rem}}.voxel-tooltip__arrow{border:var(--ids_size_general_8x) solid transparent;border-top-color:var(--ids_color_feedback_information);margin:0 var(--ids_size_general_5x)}.voxel-tooltip__arrow--hide{border-width:var(--ids_size_general_4x);opacity:var(--ids_opacity_empty)}.voxel-tooltip--info .voxel-tooltip__text{background-color:var(--ids_color_feedback_neutral);color:var(--ids_color_contrast_onDark)}.voxel-tooltip--info .voxel-tooltip__arrow{border-top-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--bottom{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.voxel-tooltip--bottom .voxel-tooltip__arrow{border-color:transparent;border-bottom-color:var(--ids_color_feedback_information)}.voxel-tooltip--left{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.voxel-tooltip--left .voxel-tooltip__arrow{border-color:transparent;border-left-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.voxel-tooltip--right{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row}.voxel-tooltip--right .voxel-tooltip__arrow{border-color:transparent;border-right-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.voxel-tooltip--right.voxel-tooltip--info .voxel-tooltip__arrow{border-right-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--bottom.voxel-tooltip--info .voxel-tooltip__arrow{border-bottom-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--left.voxel-tooltip--info .voxel-tooltip__arrow{border-left-color:var(--ids_color_feedback_neutral)}.voxel-tooltip--start{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.voxel-tooltip--end{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}\n"]
            }]
    }], function () { return []; }, { text: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize']
        }], tooltipType: [{
            type: Input
        }], tooltipIcon: [{
            type: Input
        }], tooltipPosition: [{
            type: Input
        }], tooltipArrow: [{
            type: Input
        }], hideArrow: [{
            type: Input
        }] }); })();

class VoxelTooltipDirective {
    constructor(overlayPositionBuilder, _scrollDispatcher, _overlayContainer, elementRef, renderer, overlay, la) {
        this.overlayPositionBuilder = overlayPositionBuilder;
        this._scrollDispatcher = _scrollDispatcher;
        this._overlayContainer = _overlayContainer;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.overlay = overlay;
        this.la = la;
        /** @internal */
        this._hideArrow = false;
        /** @internal */
        this.toolTipShowing = false;
        /** @internal */
        this.positionsToolTip = {
            top: {
                originY: 'top',
                overlayY: 'bottom',
            },
            bottom: {
                originY: 'bottom',
                overlayY: 'top',
            },
            left: {
                originX: 'start',
                overlayX: 'end',
            },
            right: {
                originX: 'end',
                overlayX: 'start',
            },
        };
        /** @internal */
        this.positionsArrow = {
            start: {
                originX: 'start',
                overlayX: 'start',
                originY: 'top',
                overlayY: 'top',
            },
            middle: {
                originX: 'center',
                overlayX: 'center',
                originY: 'center',
                overlayY: 'center',
            },
            end: {
                originX: 'end',
                overlayX: 'end',
                originY: 'bottom',
                overlayY: 'bottom',
            },
        };
        /**
         * Input que recebe o texto que irá aparecer dentro do tooltip
         *
         * Input that receives the text that will appear inside the tooltip
         */
        this.tooltipText = '';
        /**
         * input que recebe a maneira como o tooltip vai funcionar, 'hover'
         * para exibir ao receber foco e 'click', para exibir ao clicar
         *
         * input that gets the way the tooltip will work, 'hover'
         * to display on focus and 'click' to display on click
         */
        this.voxelTooltip = 'hover';
        /**
         * recebe a posição que o tooltip irá aparecer
         * em relação ao elemento que ele se relaciona, com os valores 'top','bottom','left' e 'right'
         *
         * receives the position that the tooltip will appear
         * in relation to the element it relates to, with the values 'top','bottom','left' e 'right'
         */
        this.tooltipPosition = 'top';
        /**
         * recebe a posição que a seta vai ficar no tooltip sendo os valores 'start', 'middle' e 'end'
         *
         * gets the position that the arrow will be in the tooltip being the values 'start', 'middle' and 'end'
         */
        this.tooltipArrow = 'middle';
        /**
         * começa a leitura do component quando criado
         *
         * starts reading the component when created
         */
        this.tooltipAriaLive = 'polite';
        /**
         * recebe o texto personalizado para aria label
         *
         * receive custom text for aria label
         */
        this.tooltipAriaLabel = 'informações adicionais';
        /**
         * define como o tooltip se comporta com rolagem
         *
         * *set the behavior of the tooltip on scroll*
         */
        this.tooltipScrollStrategy = 'reposition';
        /**
         * define novo valor para a propriedade z-index. Importante: o valor é definido apenas quando o tooltip
         * não é utilizado dentro do Modal ou Dialog. Nesses casos, ele recebe o z-index padrão de 1000 definido pelo
         * CDK Overlay
         *
         * *sets new value for z-index property. Important: the value is defined only when the tooltip*
         * *is not used within Modal or Dialog. In such cases it gets the default z-index*
         * *of 1000 set by CDK Overlay*
         */
        this.zIndex = 999;
        /** @internal */
        this.click = () => (this.toolTipShowing ? this.hide() : this.show());
    }
    /**
     * Define se a seta (tooltipArrow) está visível
     *
     * *hideArrow = true*
     *
     * *Defines if the arrow (Arrow tooltip) is visible*
     *
     * *hideArrow = true*
     */
    set hideArrow(value) {
        this._hideArrow = enforceBoolean(value);
    }
    get hideArrow() {
        return this._hideArrow;
    }
    /**
     * adiciona um rótulo acessível ao elemento
     *
     * add an accessible label to the element
     */
    get controlAriaLabel() {
        return this.voxelTooltip === 'hover' ? this.tooltipText : this.tooltipAriaLabel;
    }
    /** @internal */
    get tooltipType() {
        return this.voxelTooltip === 'hover' ? 'info' : 'tip';
    }
    /** @internal */
    mouseenter() {
        if (this.voxelTooltip === 'hover') {
            this.show();
        }
    }
    /** @internal */
    focus() {
        if (this.voxelTooltip === 'hover') {
            this.show();
        }
    }
    bindTooltipMouseLeave() {
        this.mouseLeaveSubscription = fromEvent(this.overlayRef.overlayElement, 'mouseleave').subscribe(this.hide.bind(this));
    }
    /** @internal */
    mouseleave(event) {
        var _a;
        if (this.voxelTooltip !== 'hover') {
            return;
        }
        if ((_a = event.relatedTarget) === null || _a === void 0 ? void 0 : _a.className.includes('voxel-tooltip')) {
            this.bindTooltipMouseLeave();
            return;
        }
        this.hide();
    }
    /** @internal */
    blur() {
        if (this.voxelTooltip === 'hover') {
            this.hide();
        }
    }
    ngOnInit() {
        if (this.voxelTooltip === 'click') {
            this.controlAriaExpanded = false;
        }
    }
    /** @internal */
    subscribeDomClick() {
        this.documentClickSubscription = fromEvent(document, 'click').subscribe((event) => {
            var _a, _b;
            const target = event.target;
            const clickedOnTooltip = (_b = (_a = target.className) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, 'voxel-tooltip');
            const clickedOnOpenButton = event.composedPath().includes(this.elementRef.nativeElement);
            /* istanbul ignore next */
            if (clickedOnTooltip || clickedOnOpenButton) {
                return;
            }
            this.hide();
        });
    }
    /** @internal */
    subscribeKeyPress() {
        this.keyPressSubscription = fromEvent(document, 'keydown').subscribe((event) => {
            const keyClick = event;
            const escPressed = keyClick.code === 'Escape';
            if (this.toolTipShowing && escPressed) {
                this.hide();
            }
        });
    }
    /** @internal */
    announce() {
        if (this.voxelTooltip !== 'click') {
            return;
        }
        this.controlAriaExpanded = true;
        this.la.announce(this.tooltipText, 1000);
        this.createA11yToolTip();
    }
    /**
     * nessa função é criada uma instância do componente tooltip e passada para o componente
     * os valores que são recebidos nessa diretiva
     *
     * In this function an instance of the tooltip component is created and passed to the component
     * the values that are received in this directive
     */
    show() {
        if (this.toolTipShowing) {
            return;
        }
        this.createToolTip();
        this.toolTipShowing = true;
        this.subscribeKeyPress();
        this.subscribeDomClick();
        this.announce();
    }
    /** @internal */
    unsubscribeAll() {
        if (this.mouseLeaveSubscription) {
            this.mouseLeaveSubscription.unsubscribe();
        }
        if (this.keyPressSubscription) {
            this.keyPressSubscription.unsubscribe();
        }
        if (this.documentClickSubscription) {
            this.documentClickSubscription.unsubscribe();
        }
    }
    /** @internal */
    removeClickTooltip() {
        if (this.voxelTooltip === 'click') {
            this.controlAriaExpanded = false;
            this.removeA11Y();
        }
    }
    /** @internal */
    hide() {
        var _a;
        if (!this.toolTipShowing) {
            return;
        }
        if ((_a = this === null || this === void 0 ? void 0 : this.overlayRef) === null || _a === void 0 ? void 0 : _a.detach) {
            this.overlayRef.detach();
        }
        this.toolTipShowing = false;
        this.unsubscribeAll();
        this.removeClickTooltip();
    }
    removeA11Y() {
        var _a, _b, _c, _d, _e;
        (_b = (_a = this.a11yToolTip) === null || _a === void 0 ? void 0 : _a.remove) === null || _b === void 0 ? void 0 : _b.call(_a);
        (_e = (_d = (_c = this.a11yToolTip) === null || _c === void 0 ? void 0 : _c.parentNode) === null || _d === void 0 ? void 0 : _d.removeChild) === null || _e === void 0 ? void 0 : _e.call(_d, this.a11yToolTip);
    }
    /** @internal */
    createToolTip() {
        const scrollStrategy = this.overlay.scrollStrategies[this.tooltipScrollStrategy]();
        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withPositions([this.positions]);
        const setLowerZIndex = document.querySelectorAll('.cdk-overlay-pane').length === 0;
        this.overlayRef = this.overlay.create({ positionStrategy, scrollStrategy });
        const tooltipRef = this.overlayRef.attach(new ComponentPortal(VoxelTooltipComponent));
        tooltipRef.instance.text = this.tooltipText;
        tooltipRef.instance.tooltipType = this.tooltipType;
        tooltipRef.instance.tooltipPosition = this.tooltipPosition;
        tooltipRef.instance.tooltipArrow = this.tooltipArrow;
        tooltipRef.instance.hideArrow = this.hideArrow;
        tooltipRef.instance.tooltipIcon = this.tooltipIcon;
        const panel = this._overlayContainer.getContainerElement();
        if (setLowerZIndex) {
            this.renderer.setStyle(panel, 'z-index', this.zIndex);
        }
        panel.setAttribute('aria-hidden', 'true');
        this.overlayRef.detachments().subscribe(() => {
            if (setLowerZIndex) {
                this.renderer.removeStyle(panel, 'z-index');
            }
            this.hide();
        });
    }
    /**
     * recebe a posição passada pelo usuário e passa os valores necessários para colocar o tooltip na posição desejada
     *
     * receives the position passed by the user and passes the necessary values to place the tooltip in the desired position
     */
    get positions() {
        return Object.assign(Object.assign({}, this.positionsArrow[this.tooltipArrow]), this.positionsToolTip[this.tooltipPosition]);
    }
    /** @internal */
    createA11yToolTip() {
        this.a11yToolTip = document.createElement('div');
        this.a11yToolTip.classList.add('voxel-sr-only-a11y', 'voxel-tooltip__text');
        this.a11yToolTip.setAttribute('role', 'tooltip');
        this.a11yToolTip.textContent = this.tooltipText;
        const tooltipA11y = this.elementRef.nativeElement.insertAdjacentElement('afterend', this.a11yToolTip);
        setTimeout(() => this.setPositionTooltipA11y(tooltipA11y));
        this._scrollDispatcher.scrolled(0).subscribe(() => this.setPositionTooltipA11y(tooltipA11y));
    }
    setPositionTooltipA11y(tooltip) {
        Promise.resolve().then(() => {
            const positionOverlay = this.overlayRef.overlayElement.getBoundingClientRect();
            const difference = {
                x: this.tooltipPosition === 'right' ? 10 : 0,
                y: this.tooltipPosition === 'bottom' ? 10 : 0,
                width: this.tooltipPosition === 'left' || this.tooltipPosition === 'right' ? -10 : 0,
                height: this.tooltipPosition === 'top' || this.tooltipPosition === 'bottom' ? -10 : 0,
            };
            if (this.tooltipIcon) {
                difference.x += 24;
                difference.width -= 24;
            }
            this.renderer.setStyle(tooltip, 'top', positionOverlay.top + difference.y + 'px');
            this.renderer.setStyle(tooltip, 'right', positionOverlay.right + difference.x + 'px');
            this.renderer.setStyle(tooltip, 'bottom', positionOverlay.bottom + difference.y + 'px');
            this.renderer.setStyle(tooltip, 'left', positionOverlay.left + difference.x + 'px');
            this.renderer.setStyle(tooltip, 'height', positionOverlay.height + difference.height + 'px');
            this.renderer.setStyle(tooltip, 'width', positionOverlay.width + difference.width + 'px');
        });
    }
}
VoxelTooltipDirective.ɵfac = function VoxelTooltipDirective_Factory(t) { return new (t || VoxelTooltipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.OverlayPositionBuilder), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.ScrollDispatcher), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.OverlayContainer), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.Overlay), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.LiveAnnouncer)); };
VoxelTooltipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: VoxelTooltipDirective, selectors: [["", "voxelTooltip", ""]], hostVars: 2, hostBindings: function VoxelTooltipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function VoxelTooltipDirective_click_HostBindingHandler() { return ctx.click(); })("mouseenter", function VoxelTooltipDirective_mouseenter_HostBindingHandler() { return ctx.mouseenter(); })("focus", function VoxelTooltipDirective_focus_HostBindingHandler() { return ctx.focus(); })("mouseleave", function VoxelTooltipDirective_mouseleave_HostBindingHandler($event) { return ctx.mouseleave($event); })("blur", function VoxelTooltipDirective_blur_HostBindingHandler() { return ctx.blur(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-label", ctx.controlAriaLabel)("aria-expanded", ctx.controlAriaExpanded);
    } }, inputs: { tooltipText: "tooltipText", voxelTooltip: "voxelTooltip", tooltipPosition: "tooltipPosition", tooltipArrow: "tooltipArrow", tooltipAriaLive: "tooltipAriaLive", tooltipAriaLabel: "tooltipAriaLabel", tooltipScrollStrategy: "tooltipScrollStrategy", zIndex: "zIndex", hideArrow: "hideArrow", tooltipIcon: "tooltipIcon" } });
VoxelTooltipDirective.ctorParameters = () => [
    { type: OverlayPositionBuilder },
    { type: ScrollDispatcher },
    { type: OverlayContainer },
    { type: ElementRef },
    { type: Renderer2 },
    { type: Overlay },
    { type: LiveAnnouncer }
];
VoxelTooltipDirective.propDecorators = {
    tooltipText: [{ type: Input }],
    voxelTooltip: [{ type: Input }],
    tooltipIcon: [{ type: Input }],
    tooltipPosition: [{ type: Input }],
    tooltipArrow: [{ type: Input }],
    hideArrow: [{ type: Input }],
    tooltipAriaLive: [{ type: Input }],
    tooltipAriaLabel: [{ type: Input }],
    tooltipScrollStrategy: [{ type: Input }],
    zIndex: [{ type: Input }],
    controlAriaLabel: [{ type: HostBinding, args: ['attr.aria-label',] }],
    controlAriaExpanded: [{ type: HostBinding, args: ['attr.aria-expanded',] }],
    mouseenter: [{ type: HostListener, args: ['mouseenter',] }],
    focus: [{ type: HostListener, args: ['focus',] }],
    click: [{ type: HostListener, args: ['click',] }],
    mouseleave: [{ type: HostListener, args: ['mouseleave', ['$event'],] }],
    blur: [{ type: HostListener, args: ['blur',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTooltipDirective, [{
        type: Directive,
        args: [{
                selector: '[voxelTooltip]'
            }]
    }], function () { return [{ type: ɵngcc2.OverlayPositionBuilder }, { type: ɵngcc2.ScrollDispatcher }, { type: ɵngcc2.OverlayContainer }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc2.Overlay }, { type: ɵngcc3.LiveAnnouncer }]; }, { tooltipText: [{
            type: Input
        }], voxelTooltip: [{
            type: Input
        }], tooltipPosition: [{
            type: Input
        }], tooltipArrow: [{
            type: Input
        }], tooltipAriaLive: [{
            type: Input
        }], tooltipAriaLabel: [{
            type: Input
        }], tooltipScrollStrategy: [{
            type: Input
        }], zIndex: [{
            type: Input
        }], click: [{
            type: HostListener,
            args: ['click']
        }], hideArrow: [{
            type: Input
        }], controlAriaLabel: [{
            type: HostBinding,
            args: ['attr.aria-label']
        }], 
    /** @internal */
    mouseenter: [{
            type: HostListener,
            args: ['mouseenter']
        }], 
    /** @internal */
    focus: [{
            type: HostListener,
            args: ['focus']
        }], 
    /** @internal */
    mouseleave: [{
            type: HostListener,
            args: ['mouseleave', ['$event']]
        }], 
    /** @internal */
    blur: [{
            type: HostListener,
            args: ['blur']
        }], controlAriaExpanded: [{
            type: HostBinding,
            args: ['attr.aria-expanded']
        }], tooltipIcon: [{
            type: Input
        }] }); })();

class VoxelTooltipModule {
}
VoxelTooltipModule.ɵfac = function VoxelTooltipModule_Factory(t) { return new (t || VoxelTooltipModule)(); };
VoxelTooltipModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: VoxelTooltipModule });
VoxelTooltipModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule, OverlayModule, VoxelIconModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VoxelTooltipModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule, OverlayModule, VoxelIconModule],
                declarations: [VoxelTooltipDirective, VoxelTooltipComponent],
                exports: [VoxelTooltipDirective, VoxelTooltipComponent],
                entryComponents: [VoxelTooltipComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(VoxelTooltipModule, { declarations: function () { return [VoxelTooltipDirective, VoxelTooltipComponent]; }, imports: function () { return [CommonModule, FormsModule, OverlayModule, VoxelIconModule]; }, exports: function () { return [VoxelTooltipDirective, VoxelTooltipComponent]; } }); })();

/*
 * Public API Surface of voxel
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IVoxelOptionEvent, IVoxelSelectEvent, LIKERT_OPTIONS_DEFAULT, VoxelAccordionComponent, VoxelAccordionGroupComponent, VoxelAccordionModule, VoxelActionSheetComponent, VoxelActionSheetFooterDirective, VoxelActionSheetModule, VoxelActionSheetPresentationDirective, VoxelAvatarComponent, VoxelAvatarModule, VoxelButtonComponent, VoxelButtonModule, VoxelCheckboxDirective, VoxelCheckboxModule, VoxelChipsComponent, VoxelChipsModule, VoxelDotIndicatorComponent, VoxelDotIndicatorModule, VoxelErrorMessageComponent, VoxelFavoriteComponent, VoxelFavoriteModule, VoxelFieldMixinBase, VoxelFormFieldComponent, VoxelFormFieldModule, VoxelFormSelectionBase, VoxelFormSelectionComponent, VoxelFormSelectionGroupComponent, VoxelFormSelectionModule, VoxelFormStatusComponent, VoxelFormStatusModule, VoxelHeaderActionContentDirective, VoxelHeaderComponent, VoxelHeaderControlsContentDirective, VoxelHeaderModule, VoxelHeaderPresentationContentDirective, VoxelHintFieldDirective, VoxelIconComponent, VoxelIconModule, VoxelIndicatorComponent, VoxelIndicatorModule, VoxelInputDirective, VoxelInputModule, VoxelLikertComponent, VoxelLikertModule, VoxelListActionComponent, VoxelListColumnComponent, VoxelListComponent, VoxelListDefinitionComponent, VoxelListDescrComponent, VoxelListDetailComponent, VoxelListIconDirective, VoxelListInfoComponent, VoxelListInformationDirective, VoxelListModule, VoxelListNumberDirective, VoxelListSimpleComponent, VoxelListTextComponent, VoxelLoadingCircleComponent, VoxelLoadingCircleModule, VoxelNumberBadgeComponent, VoxelNumberBadgeModule, VoxelOptionComponent, VoxelOverlayOriginDirective, VoxelPrefixDirective, VoxelProgressBarComponent, VoxelProgressBarModule, VoxelRadioButtonDirective, VoxelRadioButtonModule, VoxelSelectComponent, VoxelSelectModule, VoxelShimmerComponent, VoxelShimmerModule, VoxelSuffixDirective, VoxelSwitchDirective, VoxelSwitchModule, VoxelTabsComponent, VoxelTabsModule, VoxelTabsPanelDirective, VoxelTooltipComponent, VoxelTooltipModule, VoxelCrescentProgressBar as ɵa, VoxelDecrescentProgressBar as ɵb, VoxelNativeSelectDirective as ɵc, VoxelNativeSelectOptionDirective as ɵd, VoxelTooltipDirective as ɵe };

